webpackJsonp([2],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(233);
	module.exports = __webpack_require__(174);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ravenJs = __webpack_require__(169);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function captureException(e, options) {
	    _ravenJs2.default.captureException(e, options);
	}
	
	function captureMessage(msg, options) {
	    _ravenJs2.default.captureMessage(msg, options);
	}
	
	function captureMessageWithUrl(msg) {
	    captureMessage(msg, { extra: { url: window.location.toString() } });
	}
	
	function setExtraContext(data) {
	    _ravenJs2.default.setExtraContext(data);
	}
	
	function captureBreadcrumb(crumb) {
	    _ravenJs2.default.captureBreadcrumb(crumb);
	}
	
	function captureBreadcrumbWithUrl(crumb) {
	    var data = Object.assign(crumb.data || {}, { 'url': window.location.toString() });
	    crumb = Object.assign({}, crumb, { data: data });
	    captureBreadcrumb(crumb);
	}
	
	exports.default = { captureMessage: captureMessage, captureException: captureException, setExtraContext: setExtraContext, captureBreadcrumbWithUrl: captureBreadcrumbWithUrl, captureBreadcrumb: captureBreadcrumb, captureMessageWithUrl: captureMessageWithUrl };

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.XHRQueue = exports.fetch = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _binaryStrings = __webpack_require__(50);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function successIfStatus200(xhr) {
	    return xhr.status >= 200 && xhr.status <= 299;
	}
	
	function retryIfNetworkErrorOrServerError(xhr) {
	    return xhr.status === 0 || xhr.status >= 500;
	}
	
	var XMLHttpRequestPromiseError = function (_Error) {
	    _inherits(XMLHttpRequestPromiseError, _Error);
	
	    function XMLHttpRequestPromiseError(xhr) {
	        _classCallCheck(this, XMLHttpRequestPromiseError);
	
	        var _this = _possibleConstructorReturn(this, (XMLHttpRequestPromiseError.__proto__ || Object.getPrototypeOf(XMLHttpRequestPromiseError)).call(this));
	
	        _this.xhr = xhr;
	        _this.name = 'XMLHttpRequestPromiseError';
	
	        _this.message = xhr.status === 0 ? 'network error' : 'server response is ' + xhr.status;
	        return _this;
	    }
	
	    return XMLHttpRequestPromiseError;
	}(Error);
	
	var XMLHttpRequestPromise = function () {
	    function XMLHttpRequestPromise(url) {
	        var _this2 = this;
	
	        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	            _ref$method = _ref.method,
	            method = _ref$method === undefined ? 'GET' : _ref$method,
	            _ref$data = _ref.data,
	            data = _ref$data === undefined ? null : _ref$data,
	            _ref$responseType = _ref.responseType,
	            responseType = _ref$responseType === undefined ? '' : _ref$responseType,
	            _ref$timeout = _ref.timeout,
	            timeout = _ref$timeout === undefined ? 30000 : _ref$timeout,
	            _ref$maxTries = _ref.maxTries,
	            maxTries = _ref$maxTries === undefined ? 3 : _ref$maxTries,
	            _ref$retryTimeWait = _ref.retryTimeWait,
	            retryTimeWait = _ref$retryTimeWait === undefined ? 500 : _ref$retryTimeWait,
	            _ref$isResponseSucces = _ref.isResponseSuccess,
	            isResponseSuccess = _ref$isResponseSucces === undefined ? successIfStatus200 : _ref$isResponseSucces,
	            _ref$responseNeedsRet = _ref.responseNeedsRetry,
	            responseNeedsRetry = _ref$responseNeedsRet === undefined ? retryIfNetworkErrorOrServerError : _ref$responseNeedsRet,
	            _ref$headers = _ref.headers,
	            headers = _ref$headers === undefined ? null : _ref$headers;
	
	        _classCallCheck(this, XMLHttpRequestPromise);
	
	        // console.log('promise constructor', url);
	        var promise = new Promise(function (resolve, reject) {
	            _this2._resolve = resolve;
	            _this2._reject = reject;
	        });
	        this.then = promise.then.bind(promise);
	        this.catch = promise.catch.bind(promise);
	        this.method = method;
	        this.url = url;
	        this.responseType = responseType;
	        this.postData = data;
	        this._isResponseSuccess = isResponseSuccess;
	        this._responseNeedsRetry = responseNeedsRetry;
	        this._retryTimeWait = retryTimeWait;
	        this.triesLeft = maxTries;
	
	        var xhr = this.xhr = new XMLHttpRequest();
	        xhr.onreadystatechange = function () {
	            return _this2._onreadystatechange();
	        };
	        this._open();
	        xhr.timeout = timeout;
	        if (responseType === 'binarystring') {
	            xhr.responseType = 'arraybuffer';
	        } else {
	            xhr.responseType = responseType;
	        }
	        if (headers) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _step$value = _slicedToArray(_step.value, 2),
	                        k = _step$value[0],
	                        v = _step$value[1];
	
	                    xhr.setRequestHeader(k, v);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }
	
	    _createClass(XMLHttpRequestPromise, [{
	        key: '_open',
	        value: function _open() {
	            // console.log('open', this.url);
	            this.xhr.open(this.method, this.url);
	        }
	    }, {
	        key: '_onreadystatechange',
	        value: function _onreadystatechange() {
	            var _this3 = this;
	
	            var xhr = this.xhr;
	            if (xhr.readyState === 4 && !this._aborted) {
	                // console.log('ready state 4', this.url);
	                xhr.responseBinaryText = '';
	                if (this.responseType === 'binarystring' && xhr.response && xhr.response.byteLength) {
	                    xhr.responseBinaryText = (0, _binaryStrings.arrayBufferToString)(xhr.response);
	                }
	                // IE doesnot support responseType=json
	                if (this.responseType === 'json' && typeof xhr.response === 'string') {
	                    try {
	                        // xhr.response is readonly
	                        xhr.responseJSON = JSON.parse(xhr.response);
	                    } catch (e) {}
	                } else {
	                    xhr.responseJSON = xhr.response;
	                }
	                if (this._isResponseSuccess(xhr)) {
	                    // console.log('success', this.url);
	                    this._resolve(xhr);
	                } else {
	                    if (this.triesLeft > 0 && this._responseNeedsRetry(xhr)) {
	                        // console.log('retry', this.url);
	                        this._open();
	                        this._timerId = setTimeout(function () {
	                            return _this3.send();
	                        }, this._retryTimeWait);
	                    } else {
	                        // console.log('failed', this.url);
	                        this._reject(new XMLHttpRequestPromiseError(xhr));
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'abort',
	        value: function abort() {
	            // console.log('abort', this.url);
	            this._aborted = true;
	            clearTimeout(this._timerId);
	            this.xhr.abort();
	        }
	    }, {
	        key: 'send',
	        value: function send() {
	            // console.log('send', this.url);
	            this.triesLeft -= 1;
	            this.xhr.send(this.postData);
	        }
	    }]);
	
	    return XMLHttpRequestPromise;
	}();
	
	var XHRQueue = function () {
	    function XHRQueue() {
	        var maxSimultaneousRequests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
	
	        _classCallCheck(this, XHRQueue);
	
	        this._maxConnections = maxSimultaneousRequests;
	        this._queue = [];
	        this._activeCount = 0;
	    }
	
	    _createClass(XHRQueue, [{
	        key: 'put',
	        value: function put(url, options) {
	            var _this4 = this;
	
	            var promise = new XMLHttpRequestPromise(url, options);
	            promise._originalAbort = promise.abort;
	            promise.abort = function () {
	                return _this4._abortPromise(promise);
	            };
	            this._queue.push(promise);
	            this._processQueue();
	            return promise;
	        }
	    }, {
	        key: '_abortPromise',
	        value: function _abortPromise(promise) {
	            var _this5 = this;
	
	            var i = this._queue.indexOf(promise);
	            if (i > -1) {
	                // console.log('ABORT IN QUEUE');
	                this._queue.splice(i, 1);
	            } else {
	                if (promise.xhr.readyState === 4) {
	                    // console.log('ABORT COMPLETED');
	                } else {
	                    // console.log('ABORT ACTIVE');
	                    promise._originalAbort();
	                    this._activeCount -= 1;
	                    setTimeout(function () {
	                        return _this5._processQueue();
	                    }, 0);
	                }
	            }
	        }
	    }, {
	        key: '_processQueue',
	        value: function _processQueue() {
	            var _this6 = this;
	
	            if (this._activeCount >= this._maxConnections || this._queue.length === 0) {
	                return;
	            }
	            var promise = this._queue.shift();
	            promise.catch(function () {}).then(function () {
	                return _this6._onRequestReady(promise);
	            });
	            this._activeCount += 1;
	            promise.send();
	        }
	    }, {
	        key: '_onRequestReady',
	        value: function _onRequestReady(promise) {
	            var _this7 = this;
	
	            if (!promise._aborted) {
	                this._activeCount -= 1;
	            }
	            setTimeout(function () {
	                return _this7._processQueue();
	            }, 0);
	        }
	    }]);
	
	    return XHRQueue;
	}();
	
	function fetch(url, options) {
	    // console.log('fetch', url);
	    var promise = new XMLHttpRequestPromise(url, options);
	    promise.send();
	    return promise;
	}
	
	exports.fetch = fetch;
	exports.XHRQueue = XHRQueue;

/***/ },
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.include({
	    _stopContainerEvents: function _stopContainerEvents() {
	        var container = this._container;
	        _leaflet2.default.DomEvent.disableClickPropagation(container);
	        _leaflet2.default.DomEvent.disableScrollPropagation(container);
	        _leaflet2.default.DomEvent.on(container, 'mousemove contextmenu', _leaflet2.default.DomEvent.stop);
	    }
	});

/***/ },
/* 32 */,
/* 33 */,
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _secrets = __webpack_require__(231);
	
	var _secrets2 = _interopRequireDefault(_secrets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = Object.assign({
	    email: 'nakarte@nakarte.tk',
	    googleApiUrl: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDleuw7YtJifzC1OI2nSah74KJfGiziHXY#v=3',
	    westraDataBaseUrl: 'http://nakarte.tk/westraPasses/',
	    CORSProxyUrl: 'http://proxy.nakarte.tk/',
	    elevationsServer: 'http://elevation.nakarte.tk/',
	    newsUrl: 'http://about.nakarte.tk',
	    wikimediaCommonsCoverageUrl: 'http://tiles.nakarte.tk/wikimedia_commons_images/{z}/{x}/{y}'
	}, _secrets2.default);

/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function notify(message, level) {
	    setTimeout(function () {
	        return window.alert(message);
	    }, 0);
	}
	
	function prompt(message, value) {
	    return window.prompt(message, value);
	}
	
	exports.notify = notify;
	exports.prompt = prompt;

/***/ },
/* 36 */,
/* 37 */,
/* 38 */
437,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function arrayBufferToString(arBuf) {
	    var arr = new Uint8Array(arBuf),
	        s = [];
	    for (var i = 0; i < arr.length; i += 4096) {
	        var chunk = arr.subarray(i, i + 4096);
	        chunk = String.fromCharCode.apply(null, chunk);
	        s.push(chunk);
	    }
	    return s.join('');
	}
	
	function stringToArrayBuffer(s) {
	    var length = s.length,
	        buf = new ArrayBuffer(length),
	        arr = new Uint8Array(buf);
	    for (var i = 0; i < length; i++) {
	        arr[i] = s.charCodeAt(i);
	    }
	    return buf;
	}
	
	function blobFromString(s) {
	    var arr = stringToArrayBuffer(s);
	    return new Blob([arr]);
	}
	
	exports.arrayBufferToString = arrayBufferToString;
	exports.blobFromString = blobFromString;
	exports.stringToArrayBuffer = stringToArrayBuffer;

/***/ },
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(443);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	    items = [
	        {text: 'Hello', disabled: true},
	        '-',
	        {text: 'World', callback: fn},
	        {text: 'section', separator: true},
	    ]
	 */
	
	function isDescendant(parent, child) {
	    if (!parent) {
	        return false;
	    }
	    while (child) {
	        if (child === parent) {
	            return true;
	        }
	        child = child.parentNode;
	    }
	}
	
	var Contextmenu = function () {
	    function Contextmenu(items) {
	        var _this = this;
	
	        _classCallCheck(this, Contextmenu);
	
	        this.onKeyDown = function (e) {
	            if (e.keyCode === 27) {
	                _this.hide();
	            }
	        };
	
	        this.onMouseDown = function (e) {
	            if (!isDescendant(_this._container, e.target)) {
	                _this.hide();
	            }
	        };
	
	        this.items = items;
	    }
	
	    _createClass(Contextmenu, [{
	        key: 'show',
	        value: function show(e) {
	            if (this._container) {
	                return;
	            }
	            if (e.originalEvent) {
	                e = e.originalEvent;
	            }
	            if (e.preventDefault) {
	                e.preventDefault();
	            } else {
	                e.returnValue = false;
	            }
	
	            var _e = e,
	                x = _e.clientX,
	                y = _e.clientY;
	
	
	            var container = this._container = document.createElement('div');
	            document.body.appendChild(container);
	            container.className = 'contextmenu';
	            container.style.zIndex = 10000;
	
	            window.addEventListener('keydown', this.onKeyDown, true);
	            window.addEventListener('mousedown', this.onMouseDown, true);
	            window.addEventListener('touchstart', this.onMouseDown, true);
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.createItems()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var item = _step.value;
	
	                    container.appendChild(item);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.setPosition(x, y);
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            if (!this._container) {
	                return;
	            }
	            document.body.removeChild(this._container);
	            this._container = null;
	
	            window.removeEventListener('keydown', this.onKeyDown, true);
	            window.removeEventListener('mousedown', this.onMouseDown, true);
	            window.removeEventListener('touchstart', this.onMouseDown, true);
	        }
	    }, {
	        key: 'setPosition',
	        value: function setPosition(x, y) {
	            var window_width = window.innerWidth,
	                window_height = window.innerHeight,
	                menu_width = this._container.offsetWidth,
	                menu_height = this._container.offsetHeight;
	            if (x + menu_width >= window_width) {
	                x -= menu_width;
	            }
	            if (y + menu_height >= window_height) {
	                y -= menu_height;
	            }
	            this._container.style.left = x + 'px';
	            this._container.style.top = y + 'px';
	        }
	    }, {
	        key: 'createItems',
	        value: /*#__PURE__*/regeneratorRuntime.mark(function createItems() {
	            var items, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, itemOptions;
	
	            return regeneratorRuntime.wrap(function createItems$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            items = this.items;
	
	                            if (typeof items === 'function') {
	                                items = items();
	                            }
	                            _iteratorNormalCompletion2 = true;
	                            _didIteratorError2 = false;
	                            _iteratorError2 = undefined;
	                            _context.prev = 5;
	                            _iterator2 = items[Symbol.iterator]();
	
	                        case 7:
	                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            itemOptions = _step2.value;
	
	                            if (typeof itemOptions === 'function') {
	                                itemOptions = itemOptions();
	                            }
	
	                            if (!(itemOptions === '-' || itemOptions.separator)) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            _context.next = 13;
	                            return this.createSeparator(itemOptions);
	
	                        case 13:
	                            _context.next = 17;
	                            break;
	
	                        case 15:
	                            _context.next = 17;
	                            return this.createItem(itemOptions);
	
	                        case 17:
	                            _iteratorNormalCompletion2 = true;
	                            _context.next = 7;
	                            break;
	
	                        case 20:
	                            _context.next = 26;
	                            break;
	
	                        case 22:
	                            _context.prev = 22;
	                            _context.t0 = _context['catch'](5);
	                            _didIteratorError2 = true;
	                            _iteratorError2 = _context.t0;
	
	                        case 26:
	                            _context.prev = 26;
	                            _context.prev = 27;
	
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	
	                        case 29:
	                            _context.prev = 29;
	
	                            if (!_didIteratorError2) {
	                                _context.next = 32;
	                                break;
	                            }
	
	                            throw _iteratorError2;
	
	                        case 32:
	                            return _context.finish(29);
	
	                        case 33:
	                            return _context.finish(26);
	
	                        case 34:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, createItems, this, [[5, 22, 26, 34], [27,, 29, 33]]);
	        })
	    }, {
	        key: 'createItem',
	        value: function createItem(itemOptions) {
	            var el = document.createElement('a');
	            var className = 'item';
	            if (itemOptions.disabled) {
	                className += ' disabled';
	            }
	            if (itemOptions.header) {
	                className += ' header';
	            }
	            el.className = className;
	            el.innerHTML = itemOptions.text;
	
	            var callback = itemOptions.callback;
	            if (callback && !itemOptions.disabled) {
	                el.addEventListener('click', this.onItemClick.bind(this, callback));
	            }
	            return el;
	        }
	    }, {
	        key: 'onItemClick',
	        value: function onItemClick(callback, e) {
	            e.stopPropagation();
	            e.preventDefault();
	            this.hide();
	            callback(e);
	        }
	    }, {
	        key: 'createSeparator',
	        value: function createSeparator(itemOptions) {
	            var el = document.createElement('div');
	            el.className = 'separator';
	            if (itemOptions.text) {
	                el.innerHTML = '<span>' + itemOptions.text + '</span>';
	            }
	            return el;
	        }
	    }]);
	
	    return Contextmenu;
	}();
	
	exports.default = Contextmenu;

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = urlViaCorsProxy;
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function urlViaCorsProxy(url) {
	    return _config2.default.CORSProxyUrl + url.replace(/^(https?):\/\//, '$1/');
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _hashState = __webpack_require__(117);
	
	var _hashState2 = _interopRequireDefault(_hashState);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Mixin.HashState = {
	    enableHashState: function enableHashState(key) {
	        var _this = this;
	
	        var defaultInitialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        this._hashStateKey = key;
	        var eventSource = this.stateChangeEventsSource ? this[this.stateChangeEventsSource] : this;
	
	        // setup event listeners
	        if (this.stateChangeEvents) {
	            this.stateChangeEvents.forEach(function (event) {
	                eventSource.on(event, _this._onControlStateChanged, _this);
	            });
	        }
	
	        _hashState2.default.addEventListener(key, function (state) {
	            return _this._onExternalStateChanged(state);
	        });
	
	        // initialize control state from hash
	
	        var state = _hashState2.default.getState(key) || defaultInitialState;
	        this._ignoreStateChange = true;
	        if (!this.unserializeState(state) && !this.unserializeState(defaultInitialState)) {
	            // state from hash is invalid, update hash from default state
	            _hashState2.default.updateState(key, this.serializeState());
	        }
	        _hashState2.default.updateState(this._hashStateKey, this.serializeState());
	        this._ignoreStateChange = false;
	
	        return this;
	    },
	
	    _onControlStateChanged: function _onControlStateChanged() {
	        if (this._ignoreStateChange) {
	            return;
	        }
	        var state = this.serializeState();
	        _hashState2.default.updateState(this._hashStateKey, state);
	    },
	
	    _onExternalStateChanged: function _onExternalStateChanged(state) {
	        this._ignoreStateChange = true;
	        if (!this.unserializeState(state)) {
	            // state from hash is invalid, update hash from component state
	            _logging2.default.captureMessageWithUrl('Invalid state in hash string (key "' + this._hashStateKey + '")');
	            _hashState2.default.updateState(this._hashStateKey, this.serializeState());
	        }
	        this._ignoreStateChange = false;
	    }
	
	    // TODO: disableHashState
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(464);
	
	var _rbush = __webpack_require__(488);
	
	var _rbush2 = _interopRequireDefault(_rbush);
	
	var _imagePromise = __webpack_require__(471);
	
	var _imagePromise2 = _interopRequireDefault(_imagePromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/*
	 Marker definition:
	 {
	 latlng: L.Latlng,
	 icon: {url: string, center: [x, y]} or function(marker) returning icon,
	 label: string or function,
	 tooltip: string or function,
	 any other fields
	 }
	 */
	
	function calcIntersectionSum(rect, rects) {
	    var sum = 0,
	        left = void 0,
	        right = void 0,
	        top = void 0,
	        bottom = void 0,
	        rect2 = void 0;
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            rect2 = _step.value;
	
	            left = Math.max(rect.minX, rect2.minX);
	            right = Math.min(rect.maxX, rect2.maxX);
	            top = Math.max(rect.minY, rect2.minY);
	            bottom = Math.min(rect.maxY, rect2.maxY);
	            if (top < bottom && left < right) {
	                sum += (right - left) * (bottom - top);
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return sum;
	}
	
	_leaflet2.default.Layer.CanvasMarkers = _leaflet2.default.GridLayer.extend({
	    options: {
	        async: true,
	        labelFontName: 'Verdana, Arial, sans-serif',
	        labelFontSize: 10,
	        iconScale: 1,
	        pane: 'rasterMarker',
	        updateWhenZooming: !_leaflet2.default.Browser.mobile,
	        iconsOpacity: 1
	    },
	
	    initialize: function initialize(markers, options) {
	        _leaflet2.default.GridLayer.prototype.initialize.call(this, options);
	        this.rtree = (0, _rbush2.default)(9, ['.latlng.lng', '.latlng.lat', '.latlng.lng', '.latlng.lat']);
	        this._regions = (0, _rbush2.default)();
	        this._iconPositions = {};
	        this._labelPositions = {};
	        this._labelPositionsZoom = null;
	        this.addMarkers(markers);
	        this._images = {};
	        this._tileQueue = [];
	        this._hoverMarker = null;
	        this.on('markerenter', this.onMarkerEnter, this);
	        this.on('markerleave', this.onMarkerLeave, this);
	    },
	
	    addMarkers: function addMarkers(markers) {
	        var _this = this;
	
	        if (markers) {
	            this.rtree.load(markers);
	            this.resetLabels();
	            setTimeout(function () {
	                return _this.redraw();
	            }, 0);
	        }
	    },
	
	    addMarker: function addMarker(marker) {
	        var _this2 = this;
	
	        // FIXME: adding existing marker must be be noop
	        this.rtree.insert(marker);
	        this.resetLabels();
	        setTimeout(function () {
	            return _this2.redraw();
	        }, 0);
	    },
	
	    removeMarker: function removeMarker(marker) {
	        this.removeMarkers([marker]);
	    },
	
	    removeMarkers: function removeMarkers(markers) {
	        var _this3 = this;
	
	        markers.forEach(function (marker) {
	            return _this3.rtree.remove(marker);
	        });
	        this.resetLabels();
	        setTimeout(function () {
	            return _this3.redraw();
	        }, 0);
	    },
	
	    updateMarkers: function updateMarkers(markers) {
	        this.removeMarkers(markers);
	        this.addMarkers(markers);
	    },
	
	    updateMarker: function updateMarker(marker) {
	        this.updateMarkers([marker]);
	    },
	
	    setMarkerPosition: function setMarkerPosition(marker, latlng) {
	        this.removeMarker(marker);
	        marker.latlng = latlng;
	        this.addMarker(marker);
	    },
	
	    getMarkers: function getMarkers() {
	        return this.rtree.all();
	    },
	
	    findLabelPosition: function findLabelPosition(iconCenter, iconSize, textWidth, textHeight, pixelExtents) {
	        var verticalPadding = 0,
	            xPositions = [iconCenter[0] + iconSize[0] / 2 + 2, iconCenter[0] - iconSize[0] / 2 - textWidth - 2],
	            yPositions = [iconCenter[1] - textHeight / 2 + verticalPadding, iconCenter[1] - textHeight * .75 - iconSize[1] / 4 + verticalPadding, iconCenter[1] - textHeight / 4 + iconSize[1] / 4 + verticalPadding, iconCenter[1] - textHeight - iconSize[1] / 2 + verticalPadding, iconCenter[1] + iconSize[1] / 2 + verticalPadding];
	
	        var minIntersectionSum = +Infinity;
	        var bestX = xPositions[0],
	            bestY = yPositions[0];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = xPositions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var x = _step2.value;
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                    for (var _iterator3 = yPositions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                        var y = _step3.value;
	
	                        var rect = { minX: x, minY: y, maxX: x + textWidth, maxY: y + textHeight };
	                        if (pixelExtents && (rect.minX < pixelExtents.tileW || rect.maxX > pixelExtents.tileE || rect.minY < pixelExtents.tileN || rect.maxY > pixelExtents.tileS)) {
	                            continue;
	                        }
	                        var intersectionSum = calcIntersectionSum(rect, this._regions.search(rect));
	                        if (intersectionSum < minIntersectionSum) {
	                            minIntersectionSum = intersectionSum;
	                            bestX = x;
	                            bestY = y;
	                            if (minIntersectionSum === 0) {
	                                break;
	                            }
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError3 = true;
	                    _iteratorError3 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                            _iterator3.return();
	                        }
	                    } finally {
	                        if (_didIteratorError3) {
	                            throw _iteratorError3;
	                        }
	                    }
	                }
	
	                if (minIntersectionSum === 0) {
	                    break;
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        return [bestX, bestY];
	    },
	
	    preloadIcons: function preloadIcons(urls) {
	        var _this4 = this;
	
	        var newUrls = urls.filter(function (url) {
	            return !(url in _this4._images);
	        });
	        if (newUrls.length) {
	            return (0, _imagePromise2.default)(newUrls).then(function (images) {
	                var _iteratorNormalCompletion4 = true;
	                var _didIteratorError4 = false;
	                var _iteratorError4 = undefined;
	
	                try {
	                    for (var _iterator4 = images[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                        var image = _step4.value;
	
	                        _this4._images[image.src] = image;
	                    }
	                } catch (err) {
	                    _didIteratorError4 = true;
	                    _iteratorError4 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                            _iterator4.return();
	                        }
	                    } finally {
	                        if (_didIteratorError4) {
	                            throw _iteratorError4;
	                        }
	                    }
	                }
	            });
	        } else {
	            return Promise.resolve();
	        }
	    },
	
	    createTile: function createTile(coords, done) {
	        var _this5 = this;
	
	        var canvas = _leaflet2.default.DomUtil.create('canvas', 'leaflet-tile');
	        canvas.width = this.options.tileSize;
	        canvas.height = this.options.tileSize;
	        _leaflet2.default.Util.requestAnimFrame(function () {
	            _this5.drawTile(canvas, coords).then(function () {
	                return done(null, canvas);
	            });
	        });
	        return canvas;
	    },
	
	    selectMarkersForDraw: function selectMarkersForDraw(_ref, zoom, withoutPadding) {
	        var tileN = _ref.tileN,
	            tileS = _ref.tileS,
	            tileE = _ref.tileE,
	            tileW = _ref.tileW;
	
	        // FIXME: padding should depend on options.iconScale and fontSize
	        if (!this._map) {
	            return {};
	        }
	        var iconsHorPad = withoutPadding ? 0 : 520,
	            iconsVertPad = withoutPadding ? 0 : 50,
	            labelsHorPad = withoutPadding ? 0 : 256,
	            labelsVertPad = withoutPadding ? 0 : 20;
	        var iconsBounds = _leaflet2.default.latLngBounds(this._map.unproject(_leaflet2.default.point(tileW - iconsHorPad, tileS + iconsHorPad), zoom), this._map.unproject(_leaflet2.default.point(tileE + iconsHorPad, tileN - iconsVertPad), zoom)),
	            labelsBounds = _leaflet2.default.latLngBounds(this._map.unproject(_leaflet2.default.point(tileW - labelsHorPad, tileS + labelsHorPad), zoom), this._map.unproject(_leaflet2.default.point(tileE + labelsHorPad, tileN - labelsVertPad), zoom));
	        var iconUrls = [],
	            markerJobs = {};
	
	        // used only to preload icons
	        var pointsForMarkers = this.rtree.search({
	            minX: iconsBounds.getWest(),
	            minY: iconsBounds.getSouth(),
	            maxX: iconsBounds.getEast(),
	            maxY: iconsBounds.getNorth()
	        });
	
	        // used to place labels
	        var pointsForLabels = this.rtree.search({
	            minX: labelsBounds.getWest(), minY: labelsBounds.getSouth(),
	            maxX: labelsBounds.getEast(), maxY: labelsBounds.getNorth()
	        });
	
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	            for (var _iterator5 = pointsForMarkers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                var marker = _step5.value;
	
	                var p = this._map.project(marker.latlng, zoom);
	                var icon = marker.icon;
	                if (typeof icon === 'function') {
	                    icon = icon(marker);
	                }
	                iconUrls.push(icon.url);
	                var markerId = _leaflet2.default.stamp(marker);
	                markerJobs[markerId] = { marker: marker, icon: icon, projectedXY: p };
	            }
	        } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                    _iterator5.return();
	                }
	            } finally {
	                if (_didIteratorError5) {
	                    throw _iteratorError5;
	                }
	            }
	        }
	
	        return { iconUrls: iconUrls, markerJobs: markerJobs, pointsForLabels: pointsForLabels };
	    },
	
	    drawSelectedMarkers: function drawSelectedMarkers(canvas, pixelExtents, markerJobs, pointsForLabels, zoom, limitLabelsToImage) {
	        var tileN = pixelExtents.tileN,
	            tileW = pixelExtents.tileW,
	            tileS = pixelExtents.tileS,
	            tileE = pixelExtents.tileE;
	
	        var textHeight = this.options.labelFontSize * this.options.iconScale;
	        if (this._labelPositionsZoom !== zoom) {
	            this._labelPositionsZoom = zoom;
	            this.resetLabels();
	        }
	        var ctx = canvas.getContext('2d');
	        ctx.font = _leaflet2.default.Util.template('bold {size}px {name}', { 'name': this.options.labelFontName, 'size': this.options.labelFontSize * this.options.iconScale });
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	            for (var _iterator6 = Object.entries(markerJobs)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                var _step6$value = _slicedToArray(_step6.value, 2),
	                    markerId = _step6$value[0],
	                    job = _step6$value[1];
	
	                var img = this._images[job.icon.url];
	                job.img = img;
	                var imgW = Math.round(img.width * this.options.iconScale);
	                var imgH = Math.round(img.height * this.options.iconScale);
	                if (!(markerId in this._iconPositions)) {
	                    var _x = job.projectedXY.x - job.icon.center[0] * this.options.iconScale;
	                    var _y = job.projectedXY.y - job.icon.center[1] * this.options.iconScale;
	                    _x = Math.round(_x);
	                    _y = Math.round(_y);
	                    this._iconPositions[markerId] = [_x, _y];
	                    this._regions.insert({
	                        minX: _x, minY: _y, maxX: _x + imgW, maxY: _y + imgH,
	                        marker: job.marker, isLabel: false
	                    });
	                }
	
	                var _iconPositions$marker = _slicedToArray(this._iconPositions[markerId], 2),
	                    x = _iconPositions$marker[0],
	                    y = _iconPositions$marker[1];
	
	                job.iconCenter = [x + imgW / 2, y + imgH / 2];
	                job.iconSize = [imgW, imgH];
	            }
	        } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                    _iterator6.return();
	                }
	            } finally {
	                if (_didIteratorError6) {
	                    throw _iteratorError6;
	                }
	            }
	        }
	
	        var _iteratorNormalCompletion7 = true;
	        var _didIteratorError7 = false;
	        var _iteratorError7 = undefined;
	
	        try {
	            for (var _iterator7 = pointsForLabels[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                var marker = _step7.value;
	
	                var markerId = _leaflet2.default.stamp(marker);
	                var job = markerJobs[markerId];
	                var label = job.marker.label;
	                if (label) {
	                    if (typeof label === 'function') {
	                        label = label(job.marker);
	                    }
	                    job.label = label;
	                    if (!(markerId in this._labelPositions)) {
	                        var textWidth = ctx.measureText(label).width;
	                        var p = this.findLabelPosition(job.iconCenter, job.iconSize, textWidth, textHeight, limitLabelsToImage ? pixelExtents : null);
	                        this._labelPositions[markerId] = p;
	
	                        var _p = _slicedToArray(p, 2),
	                            x = _p[0],
	                            y = _p[1];
	
	                        this._regions.insert({
	                            minX: x, minY: y, maxX: x + textWidth, maxY: y + textHeight,
	                            marker: job.marker, isLabel: true
	                        });
	                    }
	                } else {
	                    this._labelPositions[markerId] = null;
	                }
	            }
	        } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                    _iterator7.return();
	                }
	            } finally {
	                if (_didIteratorError7) {
	                    throw _iteratorError7;
	                }
	            }
	        }
	
	        var regionsInTile = this._regions.search({ minX: tileW, minY: tileN, maxX: tileE, maxY: tileS });
	        // draw labels
	        var _iteratorNormalCompletion8 = true;
	        var _didIteratorError8 = false;
	        var _iteratorError8 = undefined;
	
	        try {
	            for (var _iterator8 = regionsInTile[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                var region = _step8.value;
	
	                if (region.isLabel) {
	                    //TODO: set font name ant size in options
	                    var _markerId = _leaflet2.default.stamp(region.marker);
	                    var _job = markerJobs[_markerId];
	                    var _p2 = this._labelPositions[_markerId];
	                    var _x2 = _p2[0] - tileW;
	                    var _y2 = _p2[1] - tileN;
	                    ctx.textBaseline = 'bottom';
	                    ctx.shadowColor = '#fff';
	                    ctx.strokeStyle = '#fff';
	                    ctx.fillStyle = '#000';
	                    ctx.lineWidth = 1.2 * this.options.iconScale;
	                    ctx.shadowBlur = 1 * this.options.iconScale;
	                    ctx.strokeText(_job.label, _x2, _y2 + textHeight);
	                    ctx.shadowBlur = 0;
	                    ctx.fillText(_job.label, _x2, _y2 + textHeight);
	                }
	            }
	        } catch (err) {
	            _didIteratorError8 = true;
	            _iteratorError8 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                    _iterator8.return();
	                }
	            } finally {
	                if (_didIteratorError8) {
	                    throw _iteratorError8;
	                }
	            }
	        }
	
	        ctx.globalAlpha = this.options.iconsOpacity;
	        // draw icons
	        var _iteratorNormalCompletion9 = true;
	        var _didIteratorError9 = false;
	        var _iteratorError9 = undefined;
	
	        try {
	            for (var _iterator9 = regionsInTile[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	                var _region = _step9.value;
	
	                if (!_region.isLabel) {
	                    var _markerId2 = _leaflet2.default.stamp(_region.marker);
	                    var _job2 = markerJobs[_markerId2];
	                    var _p3 = this._iconPositions[_markerId2];
	                    var _x3 = _p3[0] - tileW;
	                    var _y3 = _p3[1] - tileN;
	                    ctx.drawImage(_job2.img, _x3, _y3, _job2.iconSize[0], _job2.iconSize[1]);
	                }
	            }
	        } catch (err) {
	            _didIteratorError9 = true;
	            _iteratorError9 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                    _iterator9.return();
	                }
	            } finally {
	                if (_didIteratorError9) {
	                    throw _iteratorError9;
	                }
	            }
	        }
	
	        ctx.globalAlpha = 1;
	    },
	
	    drawTile: function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(canvas, coords) {
	            var zoom, tileSize, tileN, tileW, tileS, tileE, pixelExtents, _selectMarkersForDraw, iconUrls, markerJobs, pointsForLabels;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            zoom = coords.z, tileSize = this.options.tileSize, tileN = coords.y * tileSize, tileW = coords.x * tileSize, tileS = tileN + tileSize, tileE = tileW + tileSize;
	                            pixelExtents = { tileN: tileN, tileS: tileS, tileE: tileE, tileW: tileW };
	                            _selectMarkersForDraw = this.selectMarkersForDraw(pixelExtents, zoom), iconUrls = _selectMarkersForDraw.iconUrls, markerJobs = _selectMarkersForDraw.markerJobs, pointsForLabels = _selectMarkersForDraw.pointsForLabels;
	
	                            if (markerJobs) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 5:
	                            _context.next = 7;
	                            return this.preloadIcons(iconUrls);
	
	                        case 7:
	                            this.drawSelectedMarkers(canvas, pixelExtents, markerJobs, pointsForLabels, zoom);
	
	                        case 8:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	
	        function drawTile(_x4, _x5) {
	            return _ref2.apply(this, arguments);
	        }
	
	        return drawTile;
	    }(),
	
	    resetLabels: function resetLabels() {
	        this._iconPositions = {};
	        this._labelPositions = {};
	        this._regions.clear();
	    },
	
	    findMarkerFromMouseEvent: function findMarkerFromMouseEvent(e) {
	        var p = this._map.project(e.latlng),
	            region = this._regions.search({ minX: p.x, minY: p.y, maxX: p.x, maxY: p.y })[0];
	        var marker = void 0;
	        if (region) {
	            marker = region.marker;
	        } else {
	            marker = null;
	        }
	        return marker;
	    },
	
	    onMouseMove: function onMouseMove(e) {
	        var marker = this.findMarkerFromMouseEvent(e);
	        if (this._hoverMarker !== marker) {
	            if (this._hoverMarker) {
	                this.fire('markerleave', { marker: this._hoverMarker });
	            }
	            if (marker) {
	                this.fire('markerenter', { marker: marker });
	            }
	            this._hoverMarker = marker;
	        }
	    },
	
	    showTooltip: function showTooltip(e) {
	        if (!e.marker.tooltip) {
	            return;
	        }
	        var text = e.marker.tooltip;
	        if (typeof text === 'function') {
	            text = text(e.marker);
	            if (!e.marker.tooltip) {
	                return;
	            }
	        }
	        this.toolTip.innerHTML = text;
	        var p = this._map.latLngToLayerPoint(e.marker.latlng);
	        _leaflet2.default.DomUtil.setPosition(this.toolTip, p);
	        _leaflet2.default.DomUtil.addClass(this.toolTip, 'canvas-marker-tooltip-on');
	    },
	
	    onMarkerEnter: function onMarkerEnter(e) {
	        this._map._container.style.cursor = 'pointer';
	        this.showTooltip(e);
	    },
	
	    onMarkerLeave: function onMarkerLeave() {
	        this._map._container.style.cursor = '';
	        _leaflet2.default.DomUtil.removeClass(this.toolTip, 'canvas-marker-tooltip-on');
	    },
	
	    onMouseOut: function onMouseOut() {
	        if (this._hoverMarker) {
	            this._hoverMarker = null;
	            this.fire('markerleave', { marker: this._hoverMarker });
	        }
	    },
	
	    onClick: function onClick(e) {
	        if (this._map.clickLocked) {
	            return;
	        }
	        var marker = this.findMarkerFromMouseEvent(e);
	        if (marker) {
	            _leaflet2.default.extend(e, { marker: marker });
	            this.fire('markerclick', e);
	        }
	    },
	
	    onRightClick: function onRightClick(e) {
	        var marker = this.findMarkerFromMouseEvent(e);
	        if (marker) {
	            _leaflet2.default.extend(e, { marker: marker });
	            this.fire('markercontextmenu', e);
	        }
	    },
	
	    onAdd: function onAdd(map) {
	        if (this.options.pane === 'rasterMarker' && !map.getPane('rasterMarker')) {
	            map.createPane('rasterMarker').style.zIndex = 550;
	        }
	        _leaflet2.default.GridLayer.prototype.onAdd.call(this, map);
	        map.on('mousemove', this.onMouseMove, this);
	        map.on('mouseout', this.onMouseOut, this);
	        map.on('click', this.onClick, this);
	        map.on('contextmenu', this.onRightClick, this);
	        this.toolTip = _leaflet2.default.DomUtil.create('div', 'canvas-marker-tooltip', this._map.getPanes().markerPane);
	    },
	
	    onRemove: function onRemove(map) {
	        this._map.off('mousemove', this.onMouseMove, this);
	        this._map.off('mouseout', this.onMouseOut, this);
	        this._map.off('click', this.onClick, this);
	        this._map.off('contextmenu', this.onRightClick, this);
	        if (this._hoverMarker) {
	            this._hoverMarker = null;
	            this.fire('markerleave', { marker: this._hoverMarker });
	        }
	        this._map.getPanes().markerPane.removeChild(this.toolTip);
	        _leaflet2.default.GridLayer.prototype.onRemove.call(this, map);
	    }
	});

/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function localStorageWorks() {
	    try {
	        window.localStorage.setItem('_testDummy', 'TEST');
	        return window.localStorage.getItem('_testDummy') === 'TEST';
	    } catch (e) {
	        return false;
	    }
	}
	
	var storage = void 0;
	
	if (localStorageWorks()) {
	    storage = window.localStorage;
	} else {
	    var _storage = {};
	    storage = {
	        length: 0,
	
	        key: function key(n) {
	            return Object.keys(_storage)[n];
	        },
	
	        removeItem: function removeItem(key) {
	            delete _storage[key];
	        },
	
	        getItem: function getItem(key) {
	            return storage[key];
	        },
	
	        setItem: function setItem(key, value) {
	            storage[key] = value;
	        },
	
	        clear: function clear() {
	            _storage = {};
	        }
	    };
	}
	
	exports.default = storage;

/***/ },
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(442);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function showNotification(message, mouseEvent) {
	    var el = document.createElement('div');
	    el.innerHTML = message;
	    el.className = 'copy-clipboard-notification';
	    document.body.appendChild(el);
	    var w = el.offsetWidth,
	        h = el.offsetHeight,
	        x = mouseEvent.clientX - w - 8,
	        y = mouseEvent.clientY - h / 2;
	    if (x < 0) {
	        x = 0;
	    }
	    if (y < 0) {
	        y = 0;
	    }
	    el.style.top = y + 'px';
	    el.style.left = x + 'px';
	    setTimeout(function () {
	        document.body.removeChild(el);
	    }, 1000);
	}
	
	function copyToClipboard(s, mouseEvent) {
	    try {
	        var ta = document.createElement('textarea');
	        ta.value = s;
	        document.body.appendChild(ta);
	        ta.select();
	        document.execCommand('copy');
	        showNotification('Copied', mouseEvent);
	    } catch (e) {
	        _logging2.default.captureException(e, { extra: { description: 'clipborad to copy failed' } });
	        prompt("Copy to clipboard: Ctrl+C, Enter", s);
	    } finally {
	        document.body.removeChild(ta);
	    }
	}
	
	exports.default = copyToClipboard;

/***/ },
/* 80 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PrintStaticLayer = function () {
	    function PrintStaticLayer() {
	        _classCallCheck(this, PrintStaticLayer);
	
	        this._layerDummy = true;
	        this._printProgressWeight = 0.01;
	    }
	
	    _createClass(PrintStaticLayer, [{
	        key: "cloneForPrint",
	        value: function cloneForPrint() {
	            return this;
	        }
	    }, {
	        key: "getTilesInfo",
	
	
	        // printOptions = {
	        //     xhrOptions,
	        //     pixelBounds,
	        //     latLngBounds,
	        //     destPixelSize,
	        //     resolution,
	        //     scale,
	        //     zoom
	        // }
	        value: function () {
	            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(printOptions) {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                return _context2.abrupt("return", {
	                                    iterateTilePromises: /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                                        var _this = this;
	
	                                        return regeneratorRuntime.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        _context.next = 2;
	                                                        return {
	                                                            tilePromise: Promise.resolve({
	                                                                draw: function draw(canvas) {
	                                                                    return _this._drawRaster(canvas, printOptions);
	                                                                },
	                                                                isOverlay: true,
	                                                                overlaySolid: this.overlaySolid
	                                                            }),
	                                                            abortLoading: function abortLoading() {}
	                                                        };
	
	                                                    case 2:
	                                                    case "end":
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, this);
	                                    }).bind(this),
	                                    count: 1
	                                });
	
	                            case 1:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function getTilesInfo(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return getTilesInfo;
	        }()
	    }, {
	        key: "_drawRaster",
	        value: function _drawRaster(canvas, printOptions) {
	            return;
	        }
	    }]);
	
	    return PrintStaticLayer;
	}();
	
	exports.PrintStaticLayer = PrintStaticLayer;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseGeoFile = undefined;
	
	var _jsUnzip = __webpack_require__(476);
	
	var _jsUnzip2 = _interopRequireDefault(_jsUnzip);
	
	var _rawinflate = __webpack_require__(477);
	
	var _rawinflate2 = _interopRequireDefault(_rawinflate);
	
	var _stripBom = __webpack_require__(230);
	
	var _stripBom2 = _interopRequireDefault(_stripBom);
	
	var _utf = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function xmlGetNodeText(node) {
	    if (node) {
	        return Array.prototype.slice.call(node.childNodes).map(function (node) {
	            return node.nodeValue;
	        }).join('');
	    }
	}
	
	function parseGpx(txt, name, preferNameFromFile) {
	    var error;
	
	    function getSegmentPoints(segment_element) {
	        var points_elements = segment_element.getElementsByTagName('trkpt');
	        var points = [];
	        for (var i = 0; i < points_elements.length; i++) {
	            var point_element = points_elements[i];
	            var lat = parseFloat(point_element.getAttribute('lat'));
	            var lng = parseFloat(point_element.getAttribute('lon'));
	            if (isNaN(lat) || isNaN(lng)) {
	                error = 'CORRUPT';
	                break;
	            }
	            points.push({ lat: lat, lng: lng });
	        }
	        return points;
	    }
	
	    var getTrackSegments = function getTrackSegments(xml) {
	        var segments = [];
	        var segments_elements = xml.getElementsByTagName('trkseg');
	        for (var i = 0; i < segments_elements.length; i++) {
	            var segment_points = getSegmentPoints(segments_elements[i]);
	            if (segment_points.length) {
	                segments.push(segment_points);
	            }
	        }
	        return segments;
	    };
	
	    var getWaypoints = function getWaypoints(xml) {
	        var waypoint_elements = xml.getElementsByTagName('wpt');
	        var waypoints = [];
	        for (var i = 0; i < waypoint_elements.length; i++) {
	            var waypoint_element = waypoint_elements[i];
	            var waypoint = {};
	            waypoint.lat = parseFloat(waypoint_element.getAttribute('lat'));
	            waypoint.lng = parseFloat(waypoint_element.getAttribute('lon'));
	            if (isNaN(waypoint.lat) || isNaN(waypoint.lng)) {
	                error = 'CORRUPT';
	                continue;
	            }
	            try {
	                waypoint.name = (0, _utf.decode)(xmlGetNodeText(waypoint_element.getElementsByTagName('name')[0]));
	            } catch (e) {
	                error = 'CORRUPT';
	                continue;
	            }
	            waypoint.symbol_name = xmlGetNodeText(waypoint_element.getElementsByTagName('sym')[0]);
	            waypoints.push(waypoint);
	        }
	        return waypoints;
	    };
	
	    txt = (0, _stripBom2.default)(txt);
	    // remove namespaces
	    txt = txt.replace(/<([^ >]+):([^ >]+)/g, '<$1_$2');
	    try {
	        var dom = new DOMParser().parseFromString(txt, "text/xml");
	    } catch (e) {
	        return null;
	    }
	    if (dom.documentElement.nodeName === 'parsererror') {
	        return null;
	    }
	    if (dom.getElementsByTagName('gpx').length === 0) {
	        return null;
	    }
	    if (preferNameFromFile) {
	        var _arr = [].concat(_toConsumableArray(dom.getElementsByTagName('trk')));
	
	        for (var _i = 0; _i < _arr.length; _i++) {
	            var trk = _arr[_i];
	            var trkName = trk.getElementsByTagName('name')[0];
	            if (trkName) {
	                trkName = (0, _utf.decode)(xmlGetNodeText(trkName));
	                if (trkName.length) {
	                    name = trkName;
	                    break;
	                }
	            }
	        }
	    }
	    return [{
	        name: name,
	        tracks: getTrackSegments(dom),
	        points: getWaypoints(dom),
	        error: error
	    }];
	}
	
	function parseOziPlt(txt, name) {
	    var error;
	    var segments = [];
	    var lines = txt.split('\n');
	    if (lines[0].indexOf('OziExplorer Track Point File') !== 0) {
	        return null;
	    }
	    var expected_points_num = parseInt(lines[5], 10);
	    var current_segment = [];
	    var total_points_num = 0;
	    for (var i = 6; i < lines.length; i++) {
	        var line = lines[i].trim();
	        if (!line) {
	            continue;
	        }
	        var fields = line.split(',');
	        var lat = parseFloat(fields[0]);
	        var lon = parseFloat(fields[1]);
	        var is_start_of_segment = parseInt(fields[2], 10);
	        if (isNaN(lat) || isNaN(lon) || isNaN(is_start_of_segment)) {
	            error = 'CORRUPT';
	            break;
	        }
	        if (is_start_of_segment) {
	            current_segment = [];
	        }
	        if (!current_segment.length) {
	            segments.push(current_segment);
	        }
	        current_segment.push({ lat: lat, lng: lon });
	        total_points_num += 1;
	    }
	    if (isNaN(expected_points_num) || expected_points_num !== total_points_num) {
	        error = 'CORRUPT';
	    }
	    return [{ name: name, tracks: segments, error: error }];
	}
	
	function decodeCP1251(s) {
	    var c,
	        i,
	        s2 = [];
	    for (i = 0; i < s.length; i++) {
	        c = s.charCodeAt(i);
	        if (c >= 192 && c <= 255) {
	            c += 0x410 - 192;
	        } else if (c === 168) {
	            c = 0x0401;
	        } else if (c === 184) {
	            c = 0x0451;
	        }
	        s2.push(String.fromCharCode(c));
	    }
	    return s2.join('');
	}
	
	function parseOziWpt(txt, name) {
	    var points = [],
	        error,
	        lines,
	        line,
	        i,
	        lat,
	        lng,
	        pointName,
	        fields;
	    lines = txt.split('\n');
	    if (lines[0].indexOf('OziExplorer Waypoint File') !== 0) {
	        return null;
	    }
	    for (i = 4; i < lines.length; i++) {
	        line = lines[i].trim();
	        if (!line) {
	            continue;
	        }
	        fields = line.split(',');
	        lat = parseFloat(fields[2]);
	        lng = parseFloat(fields[3]);
	        pointName = decodeCP1251(fields[1]).trim();
	        if (isNaN(lat) || isNaN(lng)) {
	            error = 'CORRUPT';
	            break;
	        }
	        points.push({
	            lat: lat,
	            lng: lng,
	            name: pointName
	        });
	    }
	    return [{ name: name, points: points, error: error }];
	}
	
	function parseKml(txt, name) {
	    var error;
	    var getSegmentPoints = function getSegmentPoints(coordinates_element) {
	        // convert multiline text value of tag to single line
	        var coordinates_string = xmlGetNodeText(coordinates_element);
	        var points_strings = coordinates_string.split(/\s+/);
	        var points = [];
	        for (var i = 0; i < points_strings.length; i++) {
	            if (points_strings[i].length) {
	                var point = points_strings[i].split(',');
	                var lat = parseFloat(point[1]);
	                var lng = parseFloat(point[0]);
	                if (isNaN(lat) || isNaN(lng)) {
	                    error = 'CORRUPT';
	                    break;
	                }
	                points.push({ lat: lat, lng: lng });
	            }
	        }
	        return points;
	    };
	
	    var getTrackSegments = function getTrackSegments(xml) {
	        var segments_elements = xml.getElementsByTagName('LineString');
	        var segments = [];
	        for (var i = 0; i < segments_elements.length; i++) {
	            var coordinates_element = segments_elements[i].getElementsByTagName('coordinates');
	            if (coordinates_element.length) {
	                var segment_points = getSegmentPoints(coordinates_element[0]);
	                if (segment_points.length) {
	                    segments.push(segment_points);
	                }
	            }
	        }
	        return segments;
	    };
	
	    function getPoints(dom) {
	        var points = [],
	            placemarks,
	            i,
	            coord,
	            name,
	            lat,
	            lng,
	            pointObjs;
	        placemarks = dom.getElementsByTagName('Placemark');
	        for (i = 0; i < placemarks.length; i++) {
	            pointObjs = placemarks[i].getElementsByTagName('Point');
	            if (pointObjs.length === 0) {
	                continue;
	            } else if (pointObjs.length > 1) {
	                error = 'CORRUPT';
	                break;
	            }
	            coord = pointObjs[0].getElementsByTagName('coordinates');
	            if (coord.length !== 1) {
	                error = 'CORRUPT';
	                break;
	            }
	            coord = xmlGetNodeText(coord[0]);
	            coord = coord.split(',');
	            lat = parseFloat(coord[1]);
	            lng = parseFloat(coord[0]);
	            if (isNaN(lat) || isNaN(lng)) {
	                error = 'CORRUPT';
	                break;
	            }
	            name = placemarks[i].getElementsByTagName('name');
	            if (name.length !== 1) {
	                error = 'CORRUPT';
	                break;
	            }
	            try {
	                name = (0, _utf.decode)(xmlGetNodeText(name[0]).trim());
	            } catch (e) {
	                error = 'CORRUPT';
	                break;
	            }
	            points.push({
	                name: name,
	                lat: lat,
	                lng: lng
	            });
	        }
	        return points;
	    }
	
	    txt = (0, _stripBom2.default)(txt);
	    txt = txt.replace(/<([^ >]+):([^ >]+)/g, '<$1_$2');
	    try {
	        var dom = new DOMParser().parseFromString(txt, "text/xml");
	    } catch (e) {
	        return null;
	    }
	    if (dom.documentElement.nodeName === 'parsererror') {
	        return null;
	    }
	    if (dom.getElementsByTagName('kml').length === 0) {
	        return null;
	    }
	
	    return [{ name: name, tracks: getTrackSegments(dom), points: getPoints(dom), error: error }];
	}
	
	function parseKmz(txt, name) {
	    var uncompressed;
	    try {
	        var unzipper = new _jsUnzip2.default(txt);
	    } catch (e) {
	        return null;
	    }
	    var tracks = [],
	        points = [],
	        geodata,
	        error;
	    var hasDocKml = false;
	    if (!unzipper.isZipFile()) {
	        return null;
	    }
	    try {
	        unzipper.readEntries();
	    } catch (e) {
	        return null;
	    }
	    var i, entry;
	    for (i = 0; i < unzipper.entries.length; i++) {
	        entry = unzipper.entries[i];
	        if (entry.fileName === 'doc.kml') {
	            hasDocKml = true;
	            break;
	        }
	    }
	    if (!hasDocKml) {
	        return null;
	    }
	
	    for (i = 0; i < unzipper.entries.length; i++) {
	        entry = unzipper.entries[i];
	        if (entry.fileName.match(/\.kml$/i)) {
	            if (entry.compressionMethod === 0) {
	                uncompressed = entry.data;
	            } else if (entry.compressionMethod === 8) {
	                uncompressed = _rawinflate2.default.inflate(entry.data);
	            } else {
	                return null;
	            }
	            geodata = parseKml(uncompressed, 'dummmy');
	            if (geodata) {
	                error = error || geodata.error;
	                tracks.push.apply(tracks, geodata[0].tracks);
	                points.push.apply(points, geodata[0].points);
	            }
	        }
	    }
	
	    geodata = [{ name: name, error: error, tracks: tracks, points: points }];
	    return geodata;
	}
	
	function parseYandexRulerString(s) {
	    var last_lat = 0;
	    var last_lng = 0;
	    var error;
	    var points = [];
	    s = s.replace(/%2C/ig, ',');
	    var points_str = s.split('~');
	    for (var i = 0; i < points_str.length; i++) {
	        var point = points_str[i].split(',');
	        var lng = parseFloat(point[0]);
	        var lat = parseFloat(point[1]);
	        if (isNaN(lat) || isNaN(lng)) {
	            error = 'CORRUPT';
	            break;
	        }
	        last_lng += lng;
	        last_lat += lat;
	        points.push({ lat: last_lat, lng: last_lng });
	    }
	    return { error: error, points: points };
	}
	
	function parseYandexRulerUrl(s) {
	    var re = /yandex\..+[?&]rl=([^&]+)/;
	    var m = re.exec(s);
	    if (!m) {
	        return null;
	    }
	    var res = parseYandexRulerString(m[1]);
	    return [{ name: 'Yandex ruler', error: res.error, tracks: [res.points] }];
	}
	
	function parseZip(txt, name) {
	    try {
	        var unzipper = new _jsUnzip2.default(txt);
	    } catch (e) {
	        return null;
	    }
	    if (!unzipper.isZipFile()) {
	        return null;
	    }
	    try {
	        unzipper.readEntries();
	    } catch (e) {
	        return null;
	    }
	    var geodata_array = [];
	    for (var i = 0; i < unzipper.entries.length; i++) {
	        var entry = unzipper.entries[i];
	        var uncompressed;
	        if (entry.compressionMethod === 0) {
	            uncompressed = entry.data;
	        } else if (entry.compressionMethod === 8) {
	            uncompressed = _rawinflate2.default.inflate(entry.data);
	        } else {
	            return null;
	        }
	        var file_name = name + '/' + entry.fileName;
	        var geodata = parseGeoFile(file_name, uncompressed);
	        geodata_array.push.apply(geodata_array, geodata);
	    }
	    return geodata_array;
	}
	
	// function parseYandexMap(txt) {
	//     var start_tag = '<script id="vpage" type="application/json">';
	//     var json_start = txt.indexOf(start_tag);
	//     if (json_start === -1) {
	//         return null;
	//     }
	//     json_start += start_tag.length;
	//     var json_end = txt.indexOf('</script>', json_start);
	//     if (json_end === -1) {
	//         return null;
	//     }
	//     var map_data = txt.substring(json_start, json_end);
	//     map_data = JSON.parse(map_data);
	//     console.log(map_data);
	//     if (!('request' in map_data)) {
	//         return null;
	//     }
	//     var name = 'YandexMap';
	//     var segments = [];
	//     var error;
	//     if (map_data.vpage && map_data.vpage.data && map_data.vpage.data.objects && map_data.vpage.data.objects.length) {
	//         var mapName = ('' + (map_data.vpage.data.name || '')).trim();
	//         if (mapName.length > 3) {
	//             name = '';
	//         } else if (mapName.length) {
	//             name += ': ';
	//         }
	//         name += fileutils.decodeUTF8(mapName);
	//         map_data.vpage.data.objects.forEach(function(obj){
	//             if (obj.pts && obj.pts.length) {
	//                 var segment = [];
	//                 for (var i=0; i< obj.pts.length; i++) {
	//                     var pt = obj.pts[i];
	//                     var lng = parseFloat(pt[0]);
	//                     var lat = parseFloat(pt[1]);
	//                     if (isNaN(lat) || isNaN(lng)) {
	//                         error = 'CORRUPT';
	//                         break;
	//                     }
	//                     segment.push({lat: lat, lng:lng});
	//                 }
	//                 if (segment.length) {
	//                     segments.push(segment);
	//                 }
	//             }
	//         });
	//     }
	//     if (map_data.request.args && map_data.request.args.rl) {
	//         var res = parseYandexRulerString(map_data.request.args.rl);
	//         error = error || res.error;
	//         if (res.points && res.points.length) {
	//             segments.push(res.points);
	//         }
	//     }
	//     return [{name: name, error: error, tracks: segments}];
	// }
	
	function decodeUrlSafeBase64(s) {
	    var decoded;
	    s = s.replace(/[\n\r \t]/g, '').replace(/-/g, '+').replace(/_/g, '/');
	    try {
	        decoded = atob(s);
	    } catch (e) {}
	    if (decoded && decoded.length) {
	        return decoded;
	    }
	    return null;
	}
	
	function unpackNumber(s, position) {
	    var x,
	        n = 0;
	    x = s.charCodeAt(position);
	    if (isNaN(x)) {
	        throw new Error('Unexpected end of line while unpacking number');
	    }
	    if (x < 128) {
	        n = x - 64;
	        return [n, 1];
	    }
	    n = x & 0x7f;
	    x = s.charCodeAt(position + 1);
	    if (isNaN(x)) {
	        throw new Error('Unexpected end of line while unpacking number');
	    }
	    if (x < 128) {
	        n |= x << 7;
	        n -= 8192;
	        return [n, 2];
	    }
	    n |= (x & 0x7f) << 7;
	    x = s.charCodeAt(position + 2);
	    if (isNaN(x)) {
	        throw new Error('Unexpected end of line while unpacking number');
	    }
	    if (x < 128) {
	        n |= x << 14;
	        n -= 1048576;
	        return [n, 3];
	    }
	    n |= (x & 0x7f) << 14;
	    x = s.charCodeAt(position + 3);
	    if (isNaN(x)) {
	        throw new Error('Unexpected end of line while unpacking number');
	    }
	    n |= x << 21;
	    n -= 268435456;
	    return [n, 4];
	}
	
	function PackedStreamReader(s) {
	    this._string = s;
	    this.position = 0;
	}
	
	PackedStreamReader.prototype.readNumber = function () {
	    var n = unpackNumber(this._string, this.position);
	    this.position += n[1];
	    return n[0];
	};
	
	PackedStreamReader.prototype.readString = function (size) {
	    var s = this._string.slice(this.position, this.position + size);
	    this.position += size;
	    return s;
	};
	
	function parseStringified(s, oldVersion) {
	    var name,
	        n,
	        segments = [],
	        segment,
	        segmentsCount,
	        pointsCount,
	        arcUnit = ((1 << 24) - 1) / 360,
	        x,
	        y,
	        error,
	        version,
	        midX,
	        midY,
	        /*symbol,*/waypointName,
	        wayPoints = [],
	        color,
	        measureTicksShown,
	        trackHidden = false;
	    s = decodeUrlSafeBase64(s);
	    if (!s) {
	        return [{ name: 'Text encoded track', error: ['CORRUPT'] }];
	    }
	    s = new PackedStreamReader(s);
	    try {
	        if (oldVersion) {
	            version = 0;
	        } else {
	            version = s.readNumber();
	        }
	        if (version !== 0 && version !== 1 && version !== 2 && version !== 3) {
	            return [{ name: 'Text encoded track', error: ['CORRUPT'] }];
	        }
	        n = s.readNumber();
	        name = s.readString(n);
	        name = (0, _utf.decode)(name);
	        segmentsCount = s.readNumber();
	        for (; segmentsCount--;) {
	            segment = [];
	            pointsCount = s.readNumber();
	            x = 0;
	            y = 0;
	            for (; pointsCount--;) {
	                x += s.readNumber();
	                y += s.readNumber();
	                segment.push({ lng: x / arcUnit, lat: y / arcUnit });
	            }
	            segments.push(segment);
	            segment = null;
	        }
	    } catch (e) {
	        if (e.message.match('Unexpected end of line while unpacking number')) {
	            error = ['CORRUPT'];
	            if (segment) {
	                segments.push(segment);
	            }
	        } else {
	            throw e;
	        }
	    }
	    try {
	        color = s.readNumber();
	        measureTicksShown = s.readNumber();
	    } catch (e) {
	        if (e.message.match('Unexpected end of line while unpacking number')) {
	            color = 0;
	            measureTicksShown = 0;
	            if (version > 0) {
	                error = ['CORRUPT'];
	            }
	        } else {
	            throw e;
	        }
	    }
	    if (version >= 3) {
	        try {
	            trackHidden = !!s.readNumber();
	        } catch (e) {
	            if (e.message.match('Unexpected end of line while unpacking number')) {
	                error = ['CORRUPT'];
	            } else {
	                throw e;
	            }
	        }
	    }
	    if (version >= 2) {
	        try {
	            pointsCount = s.readNumber();
	            if (pointsCount) {
	                midX = s.readNumber();
	                midY = s.readNumber();
	            }
	            for (; pointsCount--;) {
	                n = s.readNumber();
	                waypointName = s.readString(n);
	                waypointName = (0, _utf.decode)(waypointName);
	
	                // let symbol = s.readNumber();
	                s.readNumber();
	
	                x = s.readNumber() + midX;
	                y = s.readNumber() + midY;
	                wayPoints.push({
	                    name: waypointName,
	                    lat: y / arcUnit,
	                    lng: x / arcUnit
	
	                });
	            }
	        } catch (e) {
	            if (e.message.match('Unexpected end of line while unpacking number')) {
	                error = ['CORRUPT'];
	            } else {
	                throw e;
	            }
	        }
	    }
	    var geoData = {
	        name: name || "Text encoded track",
	        tracks: segments,
	        error: error,
	        points: wayPoints,
	        color: color,
	        measureTicksShown: measureTicksShown,
	        trackHidden: trackHidden
	    };
	    return [geoData];
	}
	
	function parseTrackUrl(s) {
	    var i = s.indexOf('track://');
	    if (i === -1) {
	        return null;
	    }
	    return parseStringified(s.substring(i + 8), true);
	}
	
	function parseNakarteUrl(s) {
	    var i = s.indexOf('#');
	    if (i === -1) {
	        return null;
	    }
	    i = s.indexOf('nktk=', i + 1);
	    if (i === -1) {
	        return null;
	    }
	    s = s.substring(i + 5).split('/');
	    var geodataArray = [];
	    for (i = 0; i < s.length; i++) {
	        if (s[i]) {
	            geodataArray.push.apply(geodataArray, parseStringified(s[i]));
	        }
	    }
	    return geodataArray;
	}
	
	function parseGeoFile(name, data, preferNameFromFile) {
	    var parsers = [parseTrackUrl, parseNakarteUrl, parseKmz, parseZip, parseGpx, parseOziPlt, parseOziWpt, parseKml, parseYandexRulerUrl];
	    for (var i = 0; i < parsers.length; i++) {
	        var parsed = parsers[i](data, name, preferNameFromFile);
	        if (parsed !== null) {
	            return parsed;
	        }
	    }
	    return [{ name: name, error: 'UNSUPPORTED' }];
	}
	
	exports.parseGeoFile = parseGeoFile;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _knockout = __webpack_require__(51);
	
	var _knockout2 = _interopRequireDefault(_knockout);
	
	var _contextmenu = __webpack_require__(56);
	
	var _contextmenu2 = _interopRequireDefault(_contextmenu);
	
	__webpack_require__(113);
	
	__webpack_require__(461);
	
	var _fileRead = __webpack_require__(177);
	
	var _geo_file_formats = __webpack_require__(81);
	
	var _CORSProxy = __webpack_require__(60);
	
	var _CORSProxy2 = _interopRequireDefault(_CORSProxy);
	
	var _xhrPromise = __webpack_require__(24);
	
	var _geo_file_exporters = __webpack_require__(208);
	
	var _geo_file_exporters2 = _interopRequireDefault(_geo_file_exporters);
	
	var _clipboardCopy = __webpack_require__(79);
	
	var _clipboardCopy2 = _interopRequireDefault(_clipboardCopy);
	
	var _browserFilesaver = __webpack_require__(64);
	
	__webpack_require__(62);
	
	__webpack_require__(228);
	
	var _iconFromBackgroundImage = __webpack_require__(112);
	
	var _iconFromBackgroundImage2 = _interopRequireDefault(_iconFromBackgroundImage);
	
	__webpack_require__(38);
	
	var _leafletControl = __webpack_require__(114);
	
	__webpack_require__(31);
	
	var _binaryStrings = __webpack_require__(50);
	
	__webpack_require__(229);
	
	__webpack_require__(126);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	var _notifications = __webpack_require__(35);
	
	var _gpsies = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrackSegment = _leaflet2.default.MeasuredLine.extend({
	    includes: _leaflet2.default.Polyline.EditMixin,
	
	    options: {
	        weight: 6,
	        lineCap: 'butt',
	        opacity: 0.5
	
	    }
	});
	TrackSegment.mergeOptions(_leaflet2.default.Polyline.EditMixinOptions);
	
	_leaflet2.default.Control.TrackList = _leaflet2.default.Control.extend({
	    options: { position: 'bottomright' },
	    includes: _leaflet2.default.Mixin.Events,
	
	    colors: ['#77f', '#f95', '#0ff', '#f77', '#f7f', '#ee5'],
	
	    initialize: function initialize() {
	        _leaflet2.default.Control.prototype.initialize.call(this);
	        this.tracks = _knockout2.default.observableArray();
	        this.url = _knockout2.default.observable('');
	        this.readingFiles = _knockout2.default.observable(false);
	        this.readProgressRange = _knockout2.default.observable();
	        this.readProgressDone = _knockout2.default.observable();
	        this._lastTrackColor = 0;
	        this.trackListHeight = _knockout2.default.observable(0);
	        this.isPlacingPoint = false;
	        this.trackAddingPoint = _knockout2.default.observable(null);
	    },
	
	    onAdd: function onAdd(map) {
	        var _this = this;
	
	        this.map = map;
	        this.tracks.removeAll();
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control leaflet-control-tracklist');
	        this._stopContainerEvents();
	
	        container.innerHTML = '\n                <div class="leaflet-control-button-toggle" data-bind="click: setExpanded"\n                 title="Load, edit and save tracks"></div>\n                <div class="leaflet-control-content">\n                <div class="header">\n                    <div class="hint">\n                        GPX Ozi GoogleEarth ZIP YandexMaps GPSies\n                    </div>\n                    <div class="button-minimize" data-bind="click: setMinimized"></div>\n                </div>\n                <div class="inputs-row" data-bind="visible: !readingFiles()">\n                    <a class="button add-track" title="New track" data-bind="click: function(){this.addNewTrack()}"></a\n                    ><a class="button open-file" title="Open file" data-bind="click: loadFilesFromDisk"></a\n                    ><input type="text" class="input-url" placeholder="Track URL"\n                        data-bind="textInput: url, event: {keypress: onEnterPressedInInput, contextmenu: onFileInputRightClick}"\n                    ><a class="button download-url" title="Download URL" data-bind="click: loadFilesFromUrl"></a\n                    ><a class="button menu-icon" data-bind="click: function(_,e){this.showMenu(e)}" title="Menu"></a>\n                </div>\n                <div style="text-align: center">\n                    <div data-bind="\n                        component: {\n                        name: \'progress-indicator\',\n                        params: {progressRange: readProgressRange, progressDone: readProgressDone}\n                        },\n                        visible: readingFiles"></div>\n                </div>\n                <div class="tracks-rows-wrapper" data-bind="style: {maxHeight: trackListHeight}">\n                <table class="tracks-rows"><tbody data-bind="foreach: {data: tracks, as: \'track\'}">\n                    <tr data-bind="event: {contextmenu: $parent.showTrackMenu.bind($parent)}">\n                        <td><input type="checkbox" class="visibility-switch" data-bind="checked: track.visible"></td>\n                        <td><div class="color-sample" data-bind="style: {backgroundColor: $parent.colors[track.color()]}, click: $parent.onColorSelectorClicked.bind($parent)"></div></td>\n                        <td><div class="track-name-wrapper"><div class="track-name" data-bind="text: track.name, attr: {title: track.name}, click: $parent.setViewToTrack.bind($parent)"></div></div></td>\n                        <td><div class="button-length" data-bind="text: $parent.formatLength(track.length()), css: {\'ticks-enabled\': track.measureTicksShown}, click: $parent.switchMeasureTicksVisibility.bind($parent)"></div></td>\n                        <td><div class="button-add-track" title="Add track segment" data-bind="click: $parent.addSegmentAndEdit.bind($parent, track)"></div></td>\n                        <td><div class="button-add-point" title="Add point" data-bind="click: $parent.onAddPointClicked.bind($parent, track), css: {active: $parent.trackAddingPoint() === track}"></div></td>\n                        <td><a class="track-text-button" title="Actions" data-bind="click: $parent.showTrackMenu.bind($parent)">&hellip;</a></td>\n                    </tr>\n                </tbody></table>\n                </div>\n                </div>\n            ';
	
	        _knockout2.default.applyBindings(this, container);
	        // FIXME: add onRemove method and unsubscribe
	        _leaflet2.default.DomEvent.addListener(map.getContainer(), 'drop', this.onFileDragDrop, this);
	        _leaflet2.default.DomEvent.addListener(map.getContainer(), 'dragover', this.onFileDraging, this);
	        this.menu = new _contextmenu2.default([{ text: 'Copy all tracks to clipboard', callback: this.copyAllTracks.bind(this) }, { text: 'Copy visible tracks to clipboard', callback: this.copyVisibleTracks.bind(this) }, '-', { text: 'Delete all tracks', callback: this.deleteAllTracks.bind(this) }, { text: 'Delete hidden tracks', callback: this.deleteHiddenTracks.bind(this) }]);
	        this._markerLayer = new _leaflet2.default.Layer.CanvasMarkers(null, {
	            print: true,
	            scaleDependent: true,
	            zIndex: 1000,
	            printTransparent: true
	        }).addTo(map);
	        this._markerLayer.on('markerclick markercontextmenu', this.onMarkerClick, this);
	        map.on('resize', this._setAdaptiveHeight, this);
	        setTimeout(function () {
	            return _this._setAdaptiveHeight();
	        }, 0);
	        return container;
	    },
	
	    onFileInputRightClick: function onFileInputRightClick(_, e) {
	        _leaflet2.default.DomEvent.stopPropagation(e);
	        return true;
	    },
	
	    _setAdaptiveHeight: function _setAdaptiveHeight() {
	        var mapHeight = this._map.getSize().y;
	        var maxHeight = void 0;
	        maxHeight = mapHeight - this._container.offsetTop // controls above
	        - (this._container.parentNode.offsetHeight - this._container.offsetTop - this._container.offsetHeight) //controls below
	        - 105; // margin
	        this.trackListHeight(maxHeight + 'px');
	    },
	
	    setExpanded: function setExpanded() {
	        _leaflet2.default.DomUtil.removeClass(this._container, 'minimized');
	    },
	
	    setMinimized: function setMinimized() {
	        _leaflet2.default.DomUtil.addClass(this._container, 'minimized');
	    },
	
	    onFileDraging: function onFileDraging(e) {
	        _leaflet2.default.DomEvent.stopPropagation(e);
	        _leaflet2.default.DomEvent.preventDefault(e);
	        e.dataTransfer.dropEffect = 'copy';
	    },
	
	    onFileDragDrop: function onFileDragDrop(e) {
	        _leaflet2.default.DomEvent.stopPropagation(e);
	        _leaflet2.default.DomEvent.preventDefault(e);
	        var files = e.dataTransfer.files;
	        if (files && files.length) {
	            this.loadFilesFromFilesObject(files);
	        }
	    },
	
	    onEnterPressedInInput: function onEnterPressedInInput(this_, e) {
	        if (e.keyCode === 13) {
	            this_.loadFilesFromUrl();
	            _leaflet2.default.DomEvent.stop(e);
	        } else {
	            return true;
	        }
	    },
	
	    getTrackPolylines: function getTrackPolylines(track) {
	        return track.feature.getLayers().filter(function (layer) {
	            return layer instanceof _leaflet2.default.Polyline;
	        });
	    },
	
	    getTrackPoints: function getTrackPoints(track) {
	        return track.markers;
	    },
	
	    addNewTrack: function addNewTrack(name) {
	        if (!name) {
	            name = this.url().slice(0, 50);
	            if (!name.length) {
	                name = 'New track';
	            } else {
	                this.url('');
	            }
	        }
	        var track = this.addTrack({ name: name }),
	            line = this.addTrackSegment(track);
	        this.startEditTrackSegement(track, line);
	        line.startDrawingLine();
	        return track;
	    },
	
	    loadFilesFromFilesObject: function loadFilesFromFilesObject(files) {
	        this.readProgressDone(undefined);
	        this.readProgressRange(1);
	        this.readingFiles(true);
	
	        (0, _fileRead.readFiles)(files).then(function (fileDataArray) {
	            var geodataArray = fileDataArray.map(function (fileData) {
	                return (0, _geo_file_formats.parseGeoFile)(fileData.filename, fileData.data);
	            }).reduce(function (prev, next) {
	                Array.prototype.push.apply(prev, next);
	                return prev;
	            }, []);
	            this.addTracksFromGeodataArray(geodataArray);
	        }.bind(this));
	    },
	
	    loadFilesFromDisk: function loadFilesFromDisk() {
	        _logging2.default.captureBreadcrumb({ message: 'load track from disk' });
	        (0, _fileRead.selectFiles)(true).then(this.loadFilesFromFilesObject.bind(this));
	    },
	
	    loadFilesFromUrl: function loadFilesFromUrl() {
	        var url = this.url().trim();
	        _logging2.default.captureBreadcrumb({ message: 'load track from url', data: { url: url } });
	        try {
	            url = decodeURIComponent(url);
	        } catch (e) {}
	        var geodata;
	        if (url.length > 0) {
	            this.readingFiles(true);
	            this.readProgressDone(undefined);
	            this.readProgressRange(1);
	            geodata = (0, _geo_file_formats.parseGeoFile)('', url);
	            if (geodata.length === 0 || geodata.length > 1 || geodata[0].error !== 'UNSUPPORTED') {
	                this.addTracksFromGeodataArray(geodata);
	            } else {
	                var name = url.split('#')[0].split('?')[0].replace(/\/*$/, '').split('/').pop();
	                var url_for_request = void 0,
	                    xhrOptions = void 0,
	                    preferNameFromFile = void 0;
	                if ((0, _gpsies.isGpsiesUrl)(url)) {
	                    var _gpsiesXhrOptions = (0, _gpsies.gpsiesXhrOptions)(url);
	
	                    var _gpsiesXhrOptions2 = _slicedToArray(_gpsiesXhrOptions, 2);
	
	                    url_for_request = _gpsiesXhrOptions2[0];
	                    xhrOptions = _gpsiesXhrOptions2[1];
	
	                    preferNameFromFile = true;
	                } else {
	                    url_for_request = (0, _CORSProxy2.default)(url);
	                    xhrOptions = { responseType: 'binarystring' };
	                    preferNameFromFile = false;
	                }
	                (0, _xhrPromise.fetch)(url_for_request, xhrOptions).then(function (xhr) {
	                    var geodata = (0, _geo_file_formats.parseGeoFile)(name, xhr.responseBinaryText, preferNameFromFile);
	                    this.addTracksFromGeodataArray(geodata);
	                }.bind(this), function () {
	                    var geodata = [{ name: url, error: 'NETWORK' }];
	                    this.addTracksFromGeodataArray(geodata);
	                }.bind(this));
	            }
	        }
	        this.url('');
	    },
	
	    addTracksFromGeodataArray: function addTracksFromGeodataArray(geodata_array) {
	        var hasData = false;
	        var messages = [];
	        if (geodata_array.length === 0) {
	            messages.push('No tracks loaded');
	        }
	        geodata_array.forEach(function (geodata) {
	            var data_empty = !(geodata.tracks && geodata.tracks.length || geodata.points && geodata.points.length);
	
	            if (!data_empty) {
	                if (geodata.tracks) {
	                    geodata.tracks = geodata.tracks.map(function (line) {
	                        return _leaflet2.default.LineUtil.simplifyLatlngs(line, 360 / (1 << 24));
	                    });
	                }
	                hasData = true;
	                this.addTrack(geodata);
	            }
	            var error_messages = {
	                'CORRUPT': 'File "{name}" is corrupt',
	                'UNSUPPORTED': 'File "{name}" has unsupported format or is badly corrupt',
	                'NETWORK': 'Could not download file from url "{name}"'
	            };
	            var message;
	            if (geodata.error) {
	                message = error_messages[geodata.error] || geodata.error;
	                if (data_empty) {
	                    message += ', no data could be loaded';
	                } else {
	                    message += ', loaded data can be invalid or incomplete';
	                }
	            }
	            if (message) {
	                message = _leaflet2.default.Util.template(message, { name: geodata.name });
	                messages.push(message);
	            }
	        }.bind(this));
	        this.readingFiles(false);
	        if (messages.length) {
	            _logging2.default.captureMessage('errors in loaded tracks', { extra: { message: messages.join('\n') } });
	            (0, _notifications.notify)(messages.join('\n'));
	        }
	        return hasData;
	    },
	
	    onTrackColorChanged: function onTrackColorChanged(track) {
	        var color = this.colors[track.color()];
	        this.getTrackPolylines(track).forEach(function (polyline) {
	            polyline.setStyle({ color: color });
	        });
	        var markers = this.getTrackPoints(track);
	        markers.forEach(this.setMarkerIcon.bind(this));
	        this._markerLayer.updateMarkers(markers);
	    },
	
	    onTrackVisibilityChanged: function onTrackVisibilityChanged(track) {
	        if (track.visible()) {
	            this.map.addLayer(track.feature);
	            this._markerLayer.addMarkers(track.markers);
	        } else {
	            this.map.removeLayer(track.feature);
	            this.stopPlacingPoint();
	            this._markerLayer.removeMarkers(track.markers);
	        }
	    },
	
	    onTrackLengthChanged: function onTrackLengthChanged(track) {
	        var lines = this.getTrackPolylines(track);
	        var length = 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var line = _step.value;
	
	                length += line.getLength();
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        track.length(length);
	    },
	
	    formatLength: function formatLength(x) {
	        var digits = 0;
	        if (x < 10000) {
	            digits = 2;
	        } else if (x < 100000) {
	            digits = 1;
	        }
	        return (x / 1000).toFixed(digits) + ' km';
	    },
	
	    setTrackMeasureTicksVisibility: function setTrackMeasureTicksVisibility(track) {
	        var visible = track.measureTicksShown(),
	            lines = this.getTrackPolylines(track);
	        lines.forEach(function (line) {
	            return line.setMeasureTicksVisible(visible);
	        });
	    },
	
	    switchMeasureTicksVisibility: function switchMeasureTicksVisibility(track) {
	        track.measureTicksShown(!track.measureTicksShown());
	    },
	
	    onColorSelectorClicked: function onColorSelectorClicked(track, e) {
	        track._contextmenu.show(e);
	    },
	
	    setViewToTrack: function setViewToTrack(track) {
	        var lines = this.getTrackPolylines(track);
	        var points = this.getTrackPoints(track);
	        if (lines.length || points.length) {
	            var bounds = _leaflet2.default.latLngBounds([]);
	            lines.forEach(function (l) {
	                if (l.getLatLngs().length > 1) {
	                    bounds.extend(l.getBounds());
	                }
	            });
	            points.forEach(function (p) {
	                bounds.extend([p.latlng.lat, p.latlng.lng]);
	            });
	            if (bounds.isValid()) {
	                if (_leaflet2.default.Browser.mobile) {
	                    this.map.fitBounds(bounds);
	                } else {
	                    this.map.flyToBounds(bounds);
	                }
	            }
	        }
	    },
	
	    attachColorSelector: function attachColorSelector(track) {
	        var items = this.colors.map(function (color, index) {
	            return {
	                text: '<div style="display: inline-block; vertical-align: middle; width: 50px; height: 0; border-top: 4px solid ' + color + '"></div>',
	                callback: track.color.bind(null, index)
	            };
	        });
	        track._contextmenu = new _contextmenu2.default(items);
	    },
	
	    attachActionsMenu: function attachActionsMenu(track) {
	        var items = [function () {
	            return { text: '' + track.name(), header: true };
	        }, '-', { text: 'Rename', callback: this.renameTrack.bind(this, track) }, { text: 'Duplicate', callback: this.duplicateTrack.bind(this, track) }, { text: 'Reverse', callback: this.reverseTrack.bind(this, track) }, { text: 'Show elevation profile', callback: this.showElevationProfileForTrack.bind(this, track) }, '-', { text: 'Delete', callback: this.removeTrack.bind(this, track) }, '-', { text: 'Save as GPX', callback: this.saveTrackAsFile.bind(this, track, _geo_file_exporters2.default.saveGpx, '.gpx') }, { text: 'Save as KML', callback: this.saveTrackAsFile.bind(this, track, _geo_file_exporters2.default.saveKml, '.kml') }, { text: 'Copy link to clipboard', callback: this.copyLinkToClipboard.bind(this, track) }];
	        track._actionsMenu = new _contextmenu2.default(items);
	    },
	
	    addSegmentAndEdit: function addSegmentAndEdit(track) {
	        if (!track.visible()) {
	            return;
	        }
	        this.stopPlacingPoint();
	        var polyline = this.addTrackSegment(track, []);
	        this.startEditTrackSegement(track, polyline);
	        polyline.startDrawingLine(1);
	    },
	
	    duplicateTrack: function duplicateTrack(track) {
	        var segments = [],
	            segment,
	            line,
	            lines = this.getTrackPolylines(track);
	        for (var i = 0; i < lines.length; i++) {
	            segment = [];
	            line = lines[i].getLatLngs();
	            for (var j = 0; j < line.length; j++) {
	                segment.push([line[j].lat, line[j].lng]);
	            }
	            segments.push(segment);
	        }
	        this.addTrack({ name: track.name(), tracks: segments });
	    },
	
	    reverseTrackSegment: function reverseTrackSegment(trackSegment) {
	        trackSegment.stopDrawingLine();
	        var latlngs = trackSegment.getLatLngs();
	        latlngs = latlngs.map(function (ll) {
	            return [ll.lat, ll.lng];
	        });
	        latlngs.reverse();
	        var isEdited = this._editedLine === trackSegment;
	        this.deleteTrackSegment(trackSegment);
	        var newTrackSegment = this.addTrackSegment(trackSegment._parentTrack, latlngs);
	        if (isEdited) {
	            this.startEditTrackSegement(trackSegment._parentTrack, newTrackSegment);
	        }
	    },
	
	    reverseTrack: function reverseTrack(track) {
	        var self = this;
	        this.getTrackPolylines(track).forEach(function (trackSegment) {
	            self.reverseTrackSegment(trackSegment);
	        });
	    },
	
	    copyLinkToClipboard: function copyLinkToClipboard(track, mouseEvent) {
	        this.stopActiveDraw();
	        var s = this.trackToString(track, true);
	        var url = window.location + '&nktk=' + s;
	        (0, _clipboardCopy2.default)(url, mouseEvent);
	    },
	
	    saveTrackAsFile: function saveTrackAsFile(track, exporter, extension) {
	        this.stopActiveDraw();
	        var lines = this.getTrackPolylines(track).map(function (line) {
	            return line.getLatLngs();
	        });
	        var points = this.getTrackPoints(track);
	        var name = track.name(),
	            i = name.lastIndexOf('.');
	        if (i > -1 && i >= name.length - 5) {
	            name = name.slice(0, i);
	        }
	
	        if (lines.length === 0 && points.length === 0) {
	            (0, _notifications.notify)('Track is empty, nothing to save');
	            return;
	        }
	
	        var fileText = exporter(lines, name, points);
	        var filename = name + extension;
	        (0, _browserFilesaver.saveAs)((0, _binaryStrings.blobFromString)(fileText), filename, true);
	    },
	
	    renameTrack: function renameTrack(track) {
	        var newName = prompt('Enter new name', track.name());
	        if (newName && newName.length) {
	            track.name(newName);
	        }
	    },
	
	    showTrackMenu: function showTrackMenu(track, e) {
	        track._actionsMenu.show(e);
	    },
	
	    showMenu: function showMenu(e) {
	        this.menu.show(e);
	    },
	
	    stopActiveDraw: function stopActiveDraw() {
	        if (this._editedLine) {
	            this._editedLine.stopDrawingLine();
	        }
	    },
	
	    stopEditLine: function stopEditLine() {
	        if (this._editedLine) {
	            this.stopLineJoinSelection();
	            this._editedLine.stopEdit();
	            this._editedLine = null;
	        }
	    },
	
	    onTrackSegmentClick: function onTrackSegmentClick(track, trackSegment, e) {
	        if (this.isPlacingPoint) {
	            return;
	        }
	        if (this._lineJoinCursor) {
	            _leaflet2.default.DomEvent.stopPropagation(e);
	            this.joinTrackSegments(trackSegment);
	        } else {
	            this.startEditTrackSegement(track, trackSegment);
	            _leaflet2.default.DomEvent.stopPropagation(e);
	        }
	    },
	
	    startEditTrackSegement: function startEditTrackSegement(track, polyline) {
	        if (this._editedLine && this._editedLine !== polyline) {
	            this.stopEditLine();
	        }
	        polyline.startEdit();
	        this._editedLine = polyline;
	        polyline.once('editend', function (e) {
	            setTimeout(this.onLineEditEnd.bind(this, e, track, polyline), 0);
	        }.bind(this));
	        this.fire('startedit');
	    },
	
	    onAddPointClicked: function onAddPointClicked(track) {
	        if (this.trackAddingPoint() === track) {
	            this.stopPlacingPoint();
	        } else {
	            this.beginPointCreate(track);
	        }
	    },
	
	    _beginPointEdit: function _beginPointEdit() {
	        this.stopPlacingPoint();
	        this.stopEditLine();
	        _leaflet2.default.DomUtil.addClass(this._map._container, 'leaflet-point-placing');
	        this.isPlacingPoint = true;
	        _leaflet2.default.DomEvent.on(document, 'keydown', this.stopPlacingPointOnEscPressed, this);
	        this.fire('startedit');
	    },
	
	    beginPointMove: function beginPointMove(marker) {
	        this._beginPointEdit();
	        this._movingMarker = marker;
	        this.map.on('click', this.movePoint, this);
	    },
	
	    beginPointCreate: function beginPointCreate(track) {
	        this._beginPointEdit();
	        this.map.on('click', this.createNewPoint, this);
	        this.trackAddingPoint(track);
	    },
	
	    movePoint: function movePoint(e) {
	        var marker = this._movingMarker;
	        this._markerLayer.setMarkerPosition(marker, e.latlng);
	        this.stopPlacingPoint();
	    },
	
	    createNewPoint: function createNewPoint(e) {
	        var _this2 = this;
	
	        if (!this.isPlacingPoint) {
	            return;
	        }
	        var parentTrack = this.trackAddingPoint();
	        parentTrack._pointAutoInc += 1;
	        var name = parentTrack._pointAutoInc.toString();
	        while (name.length < 3) {
	            name = '0' + name;
	        }
	        var marker = this.addPoint(parentTrack, { name: name, lat: e.latlng.lat, lng: e.latlng.lng });
	        this._markerLayer.addMarker(marker);
	        // we need to show prompt after marker is dispalyed;
	        // grid layer is updated in setTimout(..., 0)after adding marker
	        // it is better to do it on 'load' event but when it is fired marker is not yet displayed
	        setTimeout(function () {
	            _this2.renamePoint(marker);
	            _this2.beginPointCreate(parentTrack);
	        }, 10);
	    },
	
	    stopPlacingPointOnEscPressed: function stopPlacingPointOnEscPressed(e) {
	        if (e.keyCode === 27) {
	            this.stopPlacingPoint();
	        }
	    },
	
	    stopPlacingPoint: function stopPlacingPoint() {
	        this.isPlacingPoint = false;
	        this.trackAddingPoint(null);
	        _leaflet2.default.DomUtil.removeClass(this._map._container, 'leaflet-point-placing');
	        _leaflet2.default.DomEvent.off(document, 'keydown', this.stopPlacingPointOnEscPressed, this);
	        this.map.off('click', this.createNewPoint, this);
	        this.map.off('click', this.movePoint, this);
	    },
	
	    joinTrackSegments: function joinTrackSegments(newSegment) {
	        this.stopLineJoinSelection();
	        var originalSegment = this._editedLine;
	        var latlngs = originalSegment.getLatLngs(),
	            latngs2 = newSegment.getLatLngs();
	        if (this._lineJoinToStart === this._lineJoinFromStart) {
	            latngs2.reverse();
	        }
	        if (this._lineJoinFromStart) {
	            latlngs.unshift.apply(latlngs, latngs2);
	        } else {
	            latlngs.push.apply(latlngs, latngs2);
	        }
	        latlngs = latlngs.map(function (ll) {
	            return [ll.lat, ll.lng];
	        });
	        this.deleteTrackSegment(originalSegment);
	        if (originalSegment._parentTrack === newSegment._parentTrack) {
	            this.deleteTrackSegment(newSegment);
	        }
	        this.addTrackSegment(originalSegment._parentTrack, latlngs);
	    },
	
	    onLineEditEnd: function onLineEditEnd(e, track, polyline) {
	        if (polyline.getLatLngs().length < 2) {
	            track.feature.removeLayer(polyline);
	        }
	        this.onTrackLengthChanged(track);
	        if (this._editedLine === polyline) {
	            this._editedLine = null;
	        }
	        if (!this.getTrackPolylines(track).length && !this.getTrackPoints(track).length && e.userCancelled) {
	            this.removeTrack(track);
	        }
	    },
	
	    addTrackSegment: function addTrackSegment(track, sourcePoints) {
	        var polyline = new TrackSegment(sourcePoints || [], {
	            color: this.colors[track.color()],
	            print: true
	        });
	        polyline._parentTrack = track;
	        polyline.setMeasureTicksVisible(track.measureTicksShown());
	        polyline.on('click', this.onTrackSegmentClick.bind(this, track, polyline));
	        polyline.on('nodeschanged', this.onTrackLengthChanged.bind(this, track));
	        polyline.on('noderightclick', this.onNodeRightClickShowMenu, this);
	        polyline.on('segmentrightclick', this.onSegmentRightClickShowMenu, this);
	        polyline.on('mousemove', this.onMouseMoveOnSegmentUpdateLineJoinCursor, this);
	
	        //polyline.on('editingstart', polyline.setMeasureTicksVisible.bind(polyline, false));
	        //polyline.on('editingend', this.setTrackMeasureTicksVisibility.bind(this, track));
	        track.feature.addLayer(polyline);
	        return polyline;
	    },
	
	    onNodeRightClickShowMenu: function onNodeRightClickShowMenu(e) {
	        var items = [];
	        if (e.nodeIndex > 0 && e.nodeIndex < e.line.getLatLngs().length - 1) {
	            items.push({
	                text: 'Cut',
	                callback: this.splitTrackSegment.bind(this, e.line, e.nodeIndex, null)
	            });
	        }
	        if (e.nodeIndex === 0 || e.nodeIndex === e.line.getLatLngs().length - 1) {
	            items.push({ text: 'Join', callback: this.startLineJoinSelection.bind(this, e) });
	        }
	        items.push({ text: 'Reverse', callback: this.reverseTrackSegment.bind(this, e.line) });
	        items.push({ text: 'Delete segment', callback: this.deleteTrackSegment.bind(this, e.line) });
	        items.push({ text: 'New track from segment', callback: this.newTrackFromSegment.bind(this, e.line) });
	        items.push({
	            text: 'Show elevation profile for segment',
	            callback: this.showElevationProfileForSegment.bind(this, e.line)
	        });
	
	        var menu = new _contextmenu2.default(items);
	        menu.show(e.mouseEvent);
	    },
	
	    onSegmentRightClickShowMenu: function onSegmentRightClickShowMenu(e) {
	        var menu = new _contextmenu2.default([{
	            text: 'Cut',
	            callback: this.splitTrackSegment.bind(this, e.line, e.nodeIndex, e.mouseEvent.latlng)
	        }, { text: 'Reverse', callback: this.reverseTrackSegment.bind(this, e.line) }, { text: 'Delete segment', callback: this.deleteTrackSegment.bind(this, e.line) }, { text: 'New track from segment', callback: this.newTrackFromSegment.bind(this, e.line) }, {
	            text: 'Show elevation profile for segment',
	            callback: this.showElevationProfileForSegment.bind(this, e.line)
	        }]);
	        menu.show(e.mouseEvent);
	    },
	
	    startLineJoinSelection: function startLineJoinSelection(e) {
	        this.stopLineJoinSelection();
	        this._editedLine.stopDrawingLine();
	        this._lineJoinFromStart = e.nodeIndex === 0;
	        var p = this._editedLine.getLatLngs()[e.nodeIndex];
	        p = [p.lat, p.lng];
	        this._lineJoinCursor = _leaflet2.default.polyline([p, e.mouseEvent.latlng], {
	            interactive: false,
	            color: 'red',
	            weight: 1.5,
	            opacity: 1,
	            dashArray: '7,7'
	        }).addTo(this.map);
	        this.map.on('mousemove', this.onMouseMoveUpdateLineJoinCursor, this);
	        this.map.on('click', this.stopLineJoinSelection, this);
	        _leaflet2.default.DomUtil.addClass(this.map.getContainer(), 'join-line-selecting');
	        _leaflet2.default.DomEvent.on(document, 'keyup', this.onEscPressedStopLineJoinSelection, this);
	        var self = this;
	        setTimeout(function () {
	            self._editedLine.preventStopEdit = true;
	        }, 0);
	    },
	
	    onMouseMoveUpdateLineJoinCursor: function onMouseMoveUpdateLineJoinCursor(e) {
	        if (this._lineJoinCursor) {
	            this._lineJoinCursor.getLatLngs().splice(1, 1, e.latlng);
	            this._lineJoinCursor.redraw();
	            this._lineJoinCursor.setStyle({ color: 'red' });
	        }
	    },
	
	    onMouseMoveOnSegmentUpdateLineJoinCursor: function onMouseMoveOnSegmentUpdateLineJoinCursor(e) {
	        if (!this._lineJoinCursor) {
	            return;
	        }
	        var trackSegment = e.target,
	            latlngs = trackSegment.getLatLngs(),
	            distToStart = e.latlng.distanceTo(latlngs[0]),
	            distToEnd = e.latlng.distanceTo(latlngs[latlngs.length - 1]);
	        this._lineJoinToStart = distToStart < distToEnd;
	        var cursorEnd = this._lineJoinToStart ? latlngs[0] : latlngs[latlngs.length - 1];
	        this._lineJoinCursor.setStyle({ color: 'green' });
	        this._lineJoinCursor.getLatLngs().splice(1, 1, cursorEnd);
	        this._lineJoinCursor.redraw();
	        _leaflet2.default.DomEvent.stopPropagation(e);
	    },
	
	    onEscPressedStopLineJoinSelection: function onEscPressedStopLineJoinSelection(e) {
	        if ('input' === e.target.tagName.toLowerCase()) {
	            return;
	        }
	        switch (e.keyCode) {
	            case 27:
	            case 13:
	                this.stopLineJoinSelection();
	                _leaflet2.default.DomEvent.stop(e);
	                break;
	            default:
	        }
	    },
	
	    stopLineJoinSelection: function stopLineJoinSelection() {
	        if (this._lineJoinCursor) {
	            this.map.off('mousemove', this.onMouseMoveUpdateLineJoinCursor, this);
	            this.map.off('click', this.stopLineJoinSelection, this);
	            _leaflet2.default.DomUtil.removeClass(this.map.getContainer(), 'join-line-selecting');
	            _leaflet2.default.DomEvent.off(document, 'keyup', this.onEscPressedStopLineJoinSelection, this);
	            this.map.removeLayer(this._lineJoinCursor);
	            this._lineJoinCursor = null;
	            var self = this;
	            setTimeout(function () {
	                self._editedLine.preventStopEdit = false;
	            }, 0);
	        }
	    },
	
	    splitTrackSegment: function splitTrackSegment(trackSegment, nodeIndex, latlng) {
	        var latlngs = trackSegment.getLatLngs();
	        latlngs = latlngs.map(function (ll) {
	            return [ll.lat, ll.lng];
	        });
	        var latlngs1 = latlngs.slice(0, nodeIndex + 1),
	            latlngs2 = latlngs.slice(nodeIndex + 1);
	        if (latlng) {
	            var p = this.map.project(latlng),
	                p1 = this.map.project(latlngs[nodeIndex]),
	                p2 = this.map.project(latlngs[nodeIndex + 1]),
	                pnew = _leaflet2.default.LineUtil.closestPointOnSegment(p, p1, p2);
	            latlng = this.map.unproject(pnew);
	            latlngs1.push(latlng);
	            latlng = [latlng.lat, latlng.lng];
	        } else {
	            latlng = latlngs[nodeIndex];
	        }
	        latlngs2.unshift(latlng);
	        this.deleteTrackSegment(trackSegment);
	        var segment1 = this.addTrackSegment(trackSegment._parentTrack, latlngs1);
	        this.addTrackSegment(trackSegment._parentTrack, latlngs2);
	        this.startEditTrackSegement(trackSegment._parentTrack, segment1);
	    },
	
	    deleteTrackSegment: function deleteTrackSegment(trackSegment) {
	        trackSegment._parentTrack.feature.removeLayer(trackSegment);
	    },
	
	    newTrackFromSegment: function newTrackFromSegment(trackSegment) {
	        var srcNodes = trackSegment.getLatLngs(),
	            newNodes = [],
	            i;
	        for (i = 0; i < srcNodes.length; i++) {
	            newNodes.push([srcNodes[i].lat, srcNodes[i].lng]);
	        }
	        this.addTrack({ name: "New track", tracks: [newNodes] });
	    },
	
	    addTrack: function addTrack(geodata) {
	        var color;
	        color = geodata.color;
	        if (!(color >= 0 && color < this.colors.length)) {
	            color = this._lastTrackColor;
	            this._lastTrackColor = (this._lastTrackColor + 1) % this.colors.length;
	        }
	        var track = {
	            name: _knockout2.default.observable(geodata.name),
	            color: _knockout2.default.observable(color),
	            visible: _knockout2.default.observable(!geodata.trackHidden),
	            length: _knockout2.default.observable('empty'),
	            measureTicksShown: _knockout2.default.observable(geodata.measureTicksShown || false),
	            feature: _leaflet2.default.featureGroup([]),
	            _pointAutoInc: 0,
	            markers: []
	        };
	        (geodata.tracks || []).forEach(this.addTrackSegment.bind(this, track));
	        (geodata.points || []).forEach(this.addPoint.bind(this, track));
	
	        this.tracks.push(track);
	
	        track.visible.subscribe(this.onTrackVisibilityChanged.bind(this, track));
	        track.measureTicksShown.subscribe(this.setTrackMeasureTicksVisibility.bind(this, track));
	        track.color.subscribe(this.onTrackColorChanged.bind(this, track));
	
	        //this.onTrackColorChanged(track);
	        this.onTrackVisibilityChanged(track);
	        this.attachColorSelector(track);
	        this.attachActionsMenu(track);
	        this.onTrackLengthChanged(track);
	        return track;
	    },
	
	    setMarkerIcon: function setMarkerIcon(marker) {
	        var symbol = 'marker',
	            colorInd = marker._parentTrack.color() + 1,
	            className = 'symbol-' + symbol + '-' + colorInd;
	        marker.icon = (0, _iconFromBackgroundImage2.default)('track-waypoint ' + className);
	    },
	
	    setMarkerLabel: function setMarkerLabel(marker, label) {
	        if (label.match(/\d{3,}/)) {
	            var n = parseInt(label, 10);
	            marker._parentTrack._pointAutoInc = Math.max(n, marker._parentTrack._pointAutoInc | 0);
	        }
	        marker.label = label;
	    },
	
	    addPoint: function addPoint(track, srcPoint) {
	        var marker = {
	            latlng: _leaflet2.default.latLng([srcPoint.lat, srcPoint.lng]),
	            _parentTrack: track
	        };
	        this.setMarkerIcon(marker);
	        this.setMarkerLabel(marker, srcPoint.name);
	        track.markers.push(marker);
	        marker._parentTrack = track;
	        return marker;
	    },
	
	    onMarkerClick: function onMarkerClick(e) {
	        new _contextmenu2.default([{ text: 'Rename', callback: this.renamePoint.bind(this, e.marker) }, { text: 'Move', callback: this.beginPointMove.bind(this, e.marker) }, { text: 'Delete', callback: this.removePoint.bind(this, e.marker) }]).show(e);
	    },
	
	    removePoint: function removePoint(marker) {
	        this.stopPlacingPoint();
	        this._markerLayer.removeMarker(marker);
	        var markers = marker._parentTrack.markers;
	        var i = markers.indexOf(marker);
	        markers.splice(i, 1);
	    },
	
	    renamePoint: function renamePoint(marker) {
	        this.stopPlacingPoint();
	        var newLabel = prompt('New point name', marker.label);
	        if (newLabel !== null) {
	            this.setMarkerLabel(marker, newLabel);
	            this._markerLayer.updateMarker(marker);
	        }
	    },
	
	    removeTrack: function removeTrack(track) {
	        track.visible(false);
	        this.tracks.remove(track);
	        this.stopPlacingPoint();
	    },
	
	    deleteAllTracks: function deleteAllTracks() {
	        var tracks = this.tracks().slice(0),
	            i;
	        for (i = 0; i < tracks.length; i++) {
	            this.removeTrack(tracks[i]);
	        }
	    },
	
	    deleteHiddenTracks: function deleteHiddenTracks() {
	        var tracks = this.tracks().slice(0),
	            i,
	            track;
	        for (i = 0; i < tracks.length; i++) {
	            track = tracks[i];
	            if (!track.visible()) {
	                this.removeTrack(tracks[i]);
	            }
	        }
	    },
	
	    trackToString: function trackToString(track, forceVisible) {
	        var lines = this.getTrackPolylines(track).map(function (line) {
	            var points = line.getLatLngs();
	            points = _leaflet2.default.LineUtil.simplifyLatlngs(points, 360 / (1 << 24));
	            return points;
	        });
	        return _geo_file_exporters2.default.saveToString(lines, track.name(), track.color(), track.measureTicksShown(), this.getTrackPoints(track), forceVisible ? false : !track.visible());
	    },
	
	    copyAllTracks: function copyAllTracks(mouseEvent) {
	        this.stopActiveDraw();
	        var tracks = this.tracks(),
	            serialized = [],
	            i,
	            track,
	            s;
	        for (i = 0; i < tracks.length; i++) {
	            track = tracks[i];
	            s = this.trackToString(track);
	            serialized.push(s);
	        }
	        var url = window.location + '&nktk=' + serialized.join('/');
	        (0, _clipboardCopy2.default)(url, mouseEvent);
	    },
	
	    copyVisibleTracks: function copyVisibleTracks(mouseEvent) {
	        this.stopActiveDraw();
	        var tracks = this.tracks(),
	            serialized = [],
	            i,
	            track,
	            s;
	        for (i = 0; i < tracks.length; i++) {
	            track = tracks[i];
	            if (track.visible()) {
	                s = this.trackToString(track);
	                serialized.push(s);
	            }
	        }
	        var url = window.location + '&nktk=' + serialized.join('/');
	        (0, _clipboardCopy2.default)(url, mouseEvent);
	    },
	
	    exportTracks: function exportTracks(minTicksIntervalMeters) {
	        var self = this;
	        return this.tracks().filter(function (track) {
	            return self.getTrackPolylines(track).length;
	        }).map(function (track) {
	            var capturedTrack = track.feature.getLayers().map(function (pl) {
	                return pl.getLatLngs().map(function (ll) {
	                    return [ll.lat, ll.lng];
	                });
	            });
	            var bounds = track.feature.getBounds();
	            var capturedBounds = [[bounds.getSouth(), bounds.getWest()], [bounds.getNorth(), bounds.getEast()]];
	            return {
	                color: track.color(),
	                visible: track.visible(),
	                segments: capturedTrack,
	                bounds: capturedBounds,
	                measureTicksShown: track.measureTicksShown(),
	                measureTicks: [].concat.apply([], track.feature.getLayers().map(function (pl) {
	                    return pl.getTicksPositions(minTicksIntervalMeters);
	                }))
	            };
	        });
	    },
	
	    showElevationProfileForSegment: function showElevationProfileForSegment(line) {
	        this.hideElevationProfile();
	        this.stopEditLine();
	        this._elevationControl = new _leafletControl.ElevationProfile(this._map, line.getLatLngs(), {
	            samplingInterval: (0, _leafletControl.calcSamplingInterval)(line.getLength())
	        });
	        this.fire('elevation-shown');
	    },
	
	    showElevationProfileForTrack: function showElevationProfileForTrack(track) {
	        var lines = this.getTrackPolylines(track),
	            path = [],
	            i;
	        for (i = 0; i < lines.length; i++) {
	            if (lines[i] === this._editedLine) {
	                this.stopEditLine();
	            }
	            path = path.concat(lines[i].getLatLngs());
	        }
	        this.hideElevationProfile();
	        this._elevationControl = new _leafletControl.ElevationProfile(this._map, path, {
	            samplingInterval: (0, _leafletControl.calcSamplingInterval)(new _leaflet2.default.MeasuredLine(path).getLength())
	        });
	        this.fire('elevation-shown');
	    },
	
	    hideElevationProfile: function hideElevationProfile() {
	        if (this._elevationControl) {
	            this._elevationControl.removeFrom(this._map);
	        }
	        this._elevationControl = null;
	    },
	
	    hasTracks: function hasTracks() {
	        return !!this.tracks().length;
	    }
	});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TiledDataLoader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cache = __webpack_require__(176);
	
	var _xhrPromise = __webpack_require__(24);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TiledDataLoader = function () {
	    function TiledDataLoader() {
	        var cacheSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
	
	        _classCallCheck(this, TiledDataLoader);
	
	        this._cache = new _cache.Cache(cacheSize);
	        this._pendingRequests = {};
	        this._xhrQueue = new _xhrPromise.XHRQueue();
	    }
	
	    _createClass(TiledDataLoader, [{
	        key: 'makeTileKey',
	        value: function makeTileKey(coords) {
	            return coords.x + ':' + coords.y + ':' + coords.z;
	        }
	    }, {
	        key: 'getFromCache',
	        value: function getFromCache(dataTileCoords) {
	            var key = this.makeTileKey(dataTileCoords);
	            var res = this._cache.get(key);
	            res['coords'] = dataTileCoords;
	            return res;
	        }
	    }, {
	        key: 'layerTileToDataTileCoords',
	        value: function layerTileToDataTileCoords(layerTileCoords) {
	            return Object.assign({}, layerTileCoords);
	        }
	    }, {
	        key: 'makeRequestData',
	        value: function makeRequestData(dataTileCoords) {
	            throw new Error('Not implemented');
	            // return {
	            //     url,
	            //     options
	            // }
	        }
	    }, {
	        key: 'processResponse',
	        value: function processResponse(xhr, originalDataTileCoords) {
	            throw new Error('Not implemented');
	            // return {
	            //     tileData,
	            //     coords
	            // }
	        }
	    }, {
	        key: 'calcAdjustment',
	        value: function calcAdjustment(layerTileCoords, dataTileCoords) {
	            if (layerTileCoords.x === dataTileCoords.x && layerTileCoords.y === dataTileCoords.y && layerTileCoords.z === dataTileCoords.z) {
	                return null;
	            }
	            if (dataTileCoords.z > layerTileCoords.z) {
	                var multiplier = 1 << dataTileCoords.z - layerTileCoords.z;
	                return { multiplier: 1 / multiplier, offsetX: 0, offsetY: 0 };
	            } else {
	                var _multiplier = 1 << layerTileCoords.z - dataTileCoords.z;
	                return {
	                    multiplier: _multiplier,
	                    offsetX: layerTileCoords.x - dataTileCoords.x * _multiplier,
	                    offsetY: layerTileCoords.y - dataTileCoords.y * _multiplier
	                };
	            }
	        }
	    }, {
	        key: 'requestTileData',
	        value: function requestTileData(layerTileCoords) {
	            var _this = this;
	
	            var dataTileCoords = this.layerTileToDataTileCoords(layerTileCoords);
	            var res = this.getFromCache(dataTileCoords);
	            if (res.found) {
	                return {
	                    dataPromise: Promise.resolve({
	                        coords: res.coords,
	                        tileData: res.value,
	                        adjustment: this.calcAdjustment(layerTileCoords, res.coords)
	                    }),
	                    abortLoading: function abortLoading() {}
	                };
	            }
	
	            var dataTileKey = this.makeTileKey(dataTileCoords);
	            if (!(dataTileKey in this._pendingRequests)) {
	                var _makeRequestData = this.makeRequestData(dataTileCoords),
	                    url = _makeRequestData.url,
	                    options = _makeRequestData.options;
	
	                var fetchPromise = this._xhrQueue.put(url, options);
	                // TODO: handle errors
	                var dataPromise = fetchPromise.then(function (xhr) {
	                    return _this.processResponse(xhr, dataTileCoords);
	                }).then(function (_ref) {
	                    var tileData = _ref.tileData,
	                        coords = _ref.coords;
	
	                    _this._cache.put(_this.makeTileKey(coords), tileData);
	                    delete _this._pendingRequests[dataTileKey];
	                    return {
	                        tileData: tileData,
	                        coords: coords
	                    };
	                });
	                var _pendingRequest = this._pendingRequests[dataTileKey] = {
	                    dataPromise: dataPromise,
	                    refCount: 0
	                };
	                _pendingRequest.abortLoading = function () {
	                    _pendingRequest.refCount -= 1;
	                    if (_pendingRequest.refCount < 1) {
	                        fetchPromise.abort();
	                        delete _this._pendingRequests[dataTileKey];
	                    }
	                };
	            }
	
	            var pendingRequest = this._pendingRequests[dataTileKey];
	            pendingRequest.refCount += 1;
	
	            return {
	                dataPromise: pendingRequest.dataPromise.then(function (data) {
	                    return {
	                        coords: data.coords,
	                        tileData: data.tileData,
	                        adjustment: _this.calcAdjustment(layerTileCoords, data.coords)
	                    };
	                }),
	                abortLoading: function abortLoading() {
	                    return pendingRequest.abortLoading();
	                }
	            };
	        }
	    }]);
	
	    return TiledDataLoader;
	}();
	
	exports.TiledDataLoader = TiledDataLoader;

/***/ },
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loadScript = __webpack_require__(478);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _google = null;
	var _pending = null;
	
	function getGoogle() {
	    if (_google) {
	        return Promise.resolve(_google);
	    }
	    if (!_pending) {
	        _pending = new Promise(function (resolve, reject) {
	            (0, _loadScript2.default)(_config2.default.googleApiUrl, function (error) {
	                if (error) {
	                    reject(error);
	                }
	                _google = window.google;
	                resolve(_google);
	            });
	        });
	    }
	    return _pending;
	}
	
	exports.default = getGoogle;

/***/ },
/* 112 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function cached(f) {
	    var cache = {};
	    return function (arg) {
	        if (!(arg in cache)) {
	            cache[arg] = f(arg);
	        }
	        return cache[arg];
	    };
	}
	
	function iconFromBackgroundImage(className) {
	    var container = document.createElement('div');
	    container.style.position = 'absolute';
	    document.body.appendChild(container);
	    var el = document.createElement('div');
	    el.className = className;
	    container.appendChild(el);
	    var st = window.getComputedStyle(el),
	        url = st.backgroundImage.replace(/^url\("?/, '').replace(/"?\)$/, '');
	    var icon = { 'url': url, 'center': [-el.offsetLeft, -el.offsetTop] };
	    document.body.removeChild(container);
	    container.removeChild(el);
	    return icon;
	}
	
	exports.default = cached(iconFromBackgroundImage);

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _knockout = __webpack_require__(51);
	
	var _knockout2 = _interopRequireDefault(_knockout);
	
	__webpack_require__(444);
	
	__webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_knockout2.default.components.register('progress-indicator', {
	    template: '\n        <div class="ko-progress-unknown icon-spinner-nuclear" data-bind="visible: progress() === undefined"></div>\n        <div class="ko-progress" data-bind="visible: progress() !== undefined">\n            <div class="ko-progress-bkg">\n                <div class="ko-progress-bar"  data-bind="style: {width: progress() + \'%\'}"></div>\n            </div>\n        </div>',
	    viewModel: function viewModel(params) {
	        this.progress = _knockout2.default.pureComputed(function () {
	            var range = params.progressRange(),
	                done = params.progressDone();
	            return done === undefined ? undefined : done * 100 / range;
	        });
	    }
	});

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.calcSamplingInterval = exports.ElevationProfile = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(448);
	
	var _xhrPromise = __webpack_require__(24);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(31);
	
	var _notifications = __webpack_require__(35);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcSamplingInterval(length) {
	    var targetPointsN = 2000;
	    var maxPointsN = 9999;
	    var samplingIntgerval = length / targetPointsN;
	    if (samplingIntgerval < 10) {
	        samplingIntgerval = 10;
	    }
	    if (samplingIntgerval > 50) {
	        samplingIntgerval = 50;
	    }
	    if (length / samplingIntgerval > maxPointsN) {
	        samplingIntgerval = length / maxPointsN;
	    }
	    return samplingIntgerval;
	}
	
	function createSvg(tagName, attributes, parent) {
	    var element = document.createElementNS('http://www.w3.org/2000/svg', tagName);
	    if (attributes) {
	        var keys = Object.keys(attributes),
	            key,
	            value;
	        for (var i = 0; i < keys.length; i++) {
	            key = keys[i];
	            value = attributes[key];
	            element.setAttribute(key, value);
	        }
	    }
	    if (parent) {
	        parent.appendChild(element);
	    }
	    return element;
	}
	
	function pointOnSegmentAtDistance(p1, p2, dist) {
	    //FIXME: we should place markers along projected line to avoid transformation distortions
	    var q = dist / p1.distanceTo(p2),
	        x = p1.lng + (p2.lng - p1.lng) * q,
	        y = p1.lat + (p2.lat - p1.lat) * q;
	    return _leaflet2.default.latLng(y, x);
	}
	
	function gradientToAngle(g) {
	    return Math.round(Math.atan(g) * 180 / Math.PI);
	}
	
	function pathRegularSamples(latlngs, step) {
	    if (!latlngs.length) {
	        return [];
	    }
	    var samples = [],
	        lastSampleDist = 0,
	        lastPointDistance = 0,
	        nextPointDistance = 0,
	        segmentLength,
	        i;
	
	    samples.push(latlngs[0]);
	    for (i = 1; i < latlngs.length; i++) {
	        segmentLength = latlngs[i].distanceTo(latlngs[i - 1]);
	        nextPointDistance = lastPointDistance + segmentLength;
	        if (nextPointDistance >= lastSampleDist + step) {
	            while (lastSampleDist + step <= nextPointDistance) {
	                lastSampleDist += step;
	                samples.push(pointOnSegmentAtDistance(latlngs[i - 1], latlngs[i], lastSampleDist - lastPointDistance));
	            }
	        }
	        lastPointDistance = nextPointDistance;
	    }
	    if (samples.length < 2) {
	        samples.push(latlngs[latlngs.length - 1]);
	    }
	    return samples;
	}
	
	function offestFromEvent(e) {
	    if (e.offsetX === undefined) {
	        var rect = e.target.getBoundingClientRect();
	        return {
	            offsetX: e.clientX - rect.left,
	            offestY: e.clientY - rect.top
	        };
	    } else {
	        return {
	            offsetX: e.offsetX,
	            offestY: e.offsetY
	        };
	    }
	}
	
	function movementFromEvents(e1, e2) {
	    return {
	        movementX: e2.clientX - e1.clientX,
	        movementY: e2.clientY - e1.clientY
	    };
	}
	
	var DragEvents = _leaflet2.default.Class.extend({
	    options: {
	        dragTolerance: 2,
	        dragButtons: [0]
	    },
	
	    includes: _leaflet2.default.Mixin.Events,
	
	    initialize: function initialize(eventsSource, eventsTarget, options) {
	        options = _leaflet2.default.setOptions(this, options);
	        if (eventsTarget) {
	            this.eventsTarget = eventsTarget;
	        } else {
	            this.eventsTarget = this;
	        }
	        this.dragStartPos = [];
	        this.prevEvent = [];
	        this.isDragging = [];
	
	        _leaflet2.default.DomEvent.on(eventsSource, 'mousemove', this.onMouseMove, this);
	        _leaflet2.default.DomEvent.on(eventsSource, 'mouseup', this.onMouseUp, this);
	        _leaflet2.default.DomEvent.on(eventsSource, 'mousedown', this.onMouseDown, this);
	        _leaflet2.default.DomEvent.on(eventsSource, 'mouseleave', this.onMouseLeave, this);
	    },
	
	    onMouseDown: function onMouseDown(e) {
	        if (this.options.dragButtons.includes(e.button)) {
	            e._offset = offestFromEvent(e);
	            this.dragStartPos[e.button] = e;
	            this.prevEvent[e.button] = e;
	            _leaflet2.default.DomUtil.disableImageDrag();
	            _leaflet2.default.DomUtil.disableTextSelection();
	        }
	    },
	
	    onMouseUp: function onMouseUp(e) {
	        _leaflet2.default.DomUtil.enableImageDrag();
	        _leaflet2.default.DomUtil.enableTextSelection();
	
	        if (this.options.dragButtons.includes(e.button)) {
	            this.dragStartPos[e.button] = null;
	            if (this.isDragging[e.button]) {
	                this.isDragging[e.button] = false;
	                this.fire('dragend', _leaflet2.default.extend({ dragButton: e.button, origEvent: e }, offestFromEvent(e), movementFromEvents(this.prevEvent[e.button], e)));
	            } else {
	                this.fire('click', _leaflet2.default.extend({ dragButton: e.button, origEvent: e }, offestFromEvent(e)));
	            }
	        }
	    },
	
	    onMouseMove: function onMouseMove(e) {
	        var i,
	            button,
	            self = this;
	
	        function exceedsTolerance(button) {
	            var tolerance = self.options.dragTolerance;
	            return Math.abs(e.clientX - self.dragStartPos[button].clientX) > tolerance || Math.abs(e.clientY - self.dragStartPos[button].clientY) > tolerance;
	        }
	
	        var dragButtons = this.options.dragButtons;
	        for (i = 0; i < dragButtons.length; i++) {
	            button = dragButtons[i];
	            if (this.isDragging[button]) {
	                this.eventsTarget.fire('drag', _leaflet2.default.extend({ dragButton: button, origEvent: e }, offestFromEvent(e), movementFromEvents(this.prevEvent[button], e)));
	            } else if (this.dragStartPos[button] && exceedsTolerance(button)) {
	                this.isDragging[button] = true;
	                this.eventsTarget.fire('dragstart', _leaflet2.default.extend({ dragButton: button, origEvent: this.dragStartPos[button] }, this.dragStartPos[button]._offset));
	                this.eventsTarget.fire('drag', _leaflet2.default.extend({
	                    dragButton: button,
	                    origEvent: e,
	                    startEvent: self.dragStartPos[button]
	                }, offestFromEvent(e), movementFromEvents(this.prevEvent[button], e)));
	            }
	            this.prevEvent[button] = e;
	        }
	    },
	
	    onMouseLeave: function onMouseLeave(e) {
	        var i, button;
	        var dragButtons = this.options.dragButtons;
	        for (i = 0; i < dragButtons.length; i++) {
	            button = dragButtons[i];
	            if (this.isDragging[button]) {
	                this.isDragging[button] = false;
	                this.fire('dragend', _leaflet2.default.extend({ dragButton: button, origEvent: e }, offestFromEvent(e), movementFromEvents(this.prevEvent[button], e)));
	            }
	        }
	        this.dragStartPos = {};
	    }
	});
	
	var ElevationProfile = _leaflet2.default.Class.extend({
	    options: {
	        elevationsServer: _config2.default.elevationsServer,
	        samplingInterval: 50,
	        sightLine: false
	    },
	
	    includes: _leaflet2.default.Mixin.Events,
	
	    initialize: function initialize(map, latlngs, options) {
	        _leaflet2.default.setOptions(this, options);
	        this.path = latlngs;
	        var samples = this.samples = pathRegularSamples(this.path, this.options.samplingInterval);
	        if (!samples.length) {
	            (0, _notifications.notify)('Track is empty');
	            return;
	        }
	        var self = this;
	        this.horizZoom = 1;
	        this.dragStart = null;
	        this._getElevation(samples).then(function (values) {
	            self.values = values;
	            self._addTo(map);
	        }).catch(function (e) {
	            _logging2.default.captureException(e, { extra: { description: 'while getting elevation' } });
	            (0, _notifications.notify)('Failed to get elevation data: ' + e.message);
	            self._addTo(map);
	        });
	        this.values = null;
	    },
	
	    _addTo: function _addTo(map) {
	        this._map = map;
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'elevation-profile-container');
	        _leaflet2.default.Control.prototype._stopContainerEvents.call(this);
	        this._map._controlContainer.appendChild(container);
	        this.setupContainerLayout();
	        this.updateGraph();
	        this.trackMarker = _leaflet2.default.marker([1000, 0], { clickable: false, icon: _leaflet2.default.divIcon() });
	        this.polyline = _leaflet2.default.polyline(this.path, { weight: 30, opacity: 0 }).addTo(map);
	        this.polyline.on('mousemove', this.onLineMouseMove, this);
	        this.polyline.on('mouseover', this.onLineMouseEnter, this);
	        this.polyline.on('mouseout', this.onLineMouseLeave, this);
	        this.polyLineSelection = _leaflet2.default.polyline([], { weight: 20, opacity: .5, color: 'yellow', lineCap: 'butt' });
	        return this;
	    },
	
	    setupContainerLayout: function setupContainerLayout() {
	        var horizZoom = this.horizZoom = 1;
	        var container = this._container;
	        this.propsContainer = _leaflet2.default.DomUtil.create('div', 'elevation-profile-properties', container);
	        this.leftAxisLables = _leaflet2.default.DomUtil.create('div', 'elevation-profile-left-axis', container);
	        this.closeButton = _leaflet2.default.DomUtil.create('div', 'elevation-profile-close', container);
	        _leaflet2.default.DomEvent.on(this.closeButton, 'click', this.onCloseButtonClick, this);
	        this.drawingContainer = _leaflet2.default.DomUtil.create('div', 'elevation-profile-drawingContainer', container);
	        this.graphCursor = _leaflet2.default.DomUtil.create('div', 'elevation-profile-cursor elevation-profile-cursor-hidden', this.drawingContainer);
	        this.graphCursorLabel = _leaflet2.default.DomUtil.create('div', 'elevation-profile-cursor-label elevation-profile-cursor-hidden', this.drawingContainer);
	        this.graphSelection = _leaflet2.default.DomUtil.create('div', 'elevation-profile-selection elevation-profile-cursor-hidden', this.drawingContainer);
	        var svgWidth = this.svgWidth = this.drawingContainer.clientWidth * horizZoom,
	            svgHeight = this.svgHeight = this.drawingContainer.clientHeight;
	        var svg = this.svg = createSvg('svg', { width: svgWidth, height: svgHeight }, this.drawingContainer);
	        _leaflet2.default.DomEvent.on(svg, 'mousemove', this.onSvgMouseMove, this);
	        _leaflet2.default.DomEvent.on(svg, 'mouseenter', this.onSvgEnter, this);
	        _leaflet2.default.DomEvent.on(svg, 'mouseleave', this.onSvgLeave, this);
	        _leaflet2.default.DomEvent.on(svg, 'mousewheel', this.onSvgMouseWheel, this);
	        this.svgDragEvents = new DragEvents(this.drawingContainer, null, { dragButtons: [0, 2] });
	        this.svgDragEvents.on('dragstart', this.onSvgDragStart, this);
	        this.svgDragEvents.on('dragend', this.onSvgDragEnd, this);
	        this.svgDragEvents.on('drag', this.onSvgDrag, this);
	        this.svgDragEvents.on('click', this.onSvgClick, this);
	        _leaflet2.default.DomEvent.on(svg, 'dblclick', this.onSvgDblClick, this);
	    },
	
	    removeFrom: function removeFrom(map) {
	        if (this.abortLoading) {
	            this.abortLoading();
	        }
	        if (!this._map) {
	            return;
	        }
	        this._map._controlContainer.removeChild(this._container);
	        map.removeLayer(this.polyline);
	        map.removeLayer(this.trackMarker);
	        map.removeLayer(this.polyLineSelection);
	        this._map = null;
	        this.fire('remove');
	        return this;
	    },
	
	    onSvgDragStart: function onSvgDragStart(e) {
	        if (e.dragButton === 0) {
	            // FIXME: restore hiding when we make display of selection on map
	            // this.cursorHide();
	            this.polyLineSelection.addTo(this._map).bringToBack();
	            this.dragStart = e.offsetX;
	        }
	    },
	
	    xToIndex: function xToIndex(x) {
	        return x / (this.svgWidth - 1) * (this.values.length - 1);
	    },
	
	    updateGraphSelection: function updateGraphSelection(e) {
	        if (this.dragStart === null) {
	            return;
	        }
	        var selStart, selEnd;
	        if (e) {
	            var x = e.offsetX;
	            selStart = Math.min(x, this.dragStart);
	            selEnd = Math.max(x, this.dragStart);
	            this.selStartInd = Math.round(this.xToIndex(selStart));
	            this.selEndInd = Math.round(this.xToIndex(selEnd));
	
	            if (this.selStartInd < 0) {
	                this.selStartInd = 0;
	            }
	            if (this.selEndInd > this.values.length - 1) {
	                this.selEndInd = this.values.length - 1;
	            }
	        } else {
	            selStart = this.selStartInd * (this.svgWidth - 1) / (this.values.length - 1);
	            selEnd = this.selEndInd * (this.svgWidth - 1) / (this.values.length - 1);
	        }
	        this.graphSelection.style.left = selStart + 'px';
	        this.graphSelection.style.width = selEnd - selStart + 'px';
	        _leaflet2.default.DomUtil.removeClass(this.graphSelection, 'elevation-profile-cursor-hidden');
	    },
	
	    onSvgDragEnd: function onSvgDragEnd(e) {
	        if (e.dragButton === 0) {
	            this.cursorShow();
	            this.updateGraphSelection(e);
	            var stats = this.calcProfileStats(this.values.slice(this.selStartInd, this.selEndInd + 1), true);
	            this.updatePropsDisplay(stats);
	            _leaflet2.default.DomUtil.addClass(this.propsContainer, 'elevation-profile-properties-selected');
	        }
	        if (e.dragButton === 2) {
	            this.drawingContainer.scrollLeft -= e.movementX;
	        }
	    },
	
	    onSvgDrag: function onSvgDrag(e) {
	        if (e.dragButton === 0) {
	            this.updateGraphSelection(e);
	            this.polyLineSelection.setLatLngs(this.samples.slice(this.selStartInd, this.selEndInd + 1));
	        }
	        if (e.dragButton === 2) {
	            this.drawingContainer.scrollLeft -= e.movementX;
	        }
	    },
	
	    onSvgClick: function onSvgClick(e) {
	        if (e.dragButton === 0) {
	            this.dragStart = null;
	            _leaflet2.default.DomUtil.addClass(this.graphSelection, 'elevation-profile-cursor-hidden');
	            _leaflet2.default.DomUtil.removeClass(this.propsContainer, 'elevation-profile-properties-selected');
	            this._map.removeLayer(this.polyLineSelection);
	            if (this.stats) {
	                this.updatePropsDisplay(this.stats);
	            }
	        }
	        if (e.dragButton === 2) {
	            this.setMapPositionAtIndex(Math.round(this.xToIndex(e.offsetX)));
	        }
	    },
	
	    onSvgDblClick: function onSvgDblClick(e) {
	        this.setMapPositionAtIndex(Math.round(this.xToIndex(e.offsetX)));
	    },
	
	    setMapPositionAtIndex: function setMapPositionAtIndex(ind) {
	        var latlng = this.samples[ind];
	        if (latlng) {
	            this._map.panTo(latlng);
	        }
	    },
	
	    onSvgMouseWheel: function onSvgMouseWheel(e) {
	        var oldHorizZoom = this.horizZoom;
	        this.horizZoom += _leaflet2.default.DomEvent.getWheelDelta(e) > 0 ? 1 : -1;
	        if (this.horizZoom < 1) {
	            this.horizZoom = 1;
	        }
	        if (this.horizZoom > 10) {
	            this.horizZoom = 10;
	        }
	
	        var x = offestFromEvent(e).offsetX;
	        var ind = this.xToIndex(x);
	
	        var newScrollLeft = this.drawingContainer.scrollLeft + offestFromEvent(e).offsetX * (this.horizZoom / oldHorizZoom - 1);
	        if (newScrollLeft < 0) {
	            newScrollLeft = 0;
	        }
	
	        this.svgWidth = this.drawingContainer.clientWidth * this.horizZoom;
	        this.svg.setAttribute('width', this.svgWidth + 'px');
	        this.setupGraph();
	        if (newScrollLeft > this.svgWidth - this.drawingContainer.clientWidth) {
	            newScrollLeft = this.svgWidth - this.drawingContainer.clientWidth;
	        }
	        this.drawingContainer.scrollLeft = newScrollLeft;
	
	        this.cursorHide();
	        this.setCursorPosition(ind);
	        this.cursorShow();
	        this.updateGraphSelection();
	    },
	
	    updateGraph: function updateGraph() {
	        if (!this._map || !this.values) {
	            return;
	        }
	
	        this.stats = this.calcProfileStats(this.values);
	        this.updatePropsDisplay(this.stats);
	        this.setupGraph();
	    },
	
	    updatePropsDisplay: function updatePropsDisplay(stats) {
	        if (!this._map) {
	            return;
	        }
	        this.propsContainer.innerHTML = '';
	        var ascentAngleStr = isNaN(stats.angleAvgAscent) ? '-' : _leaflet2.default.Util.template('{avg} / {max}&deg;', { avg: stats.angleAvgAscent, max: stats.angleMaxAscent });
	        var descentAngleStr = isNaN(stats.angleAvgDescent) ? '-' : _leaflet2.default.Util.template('{avg} / {max}&deg;', { avg: stats.angleAvgDescent, max: stats.angleMaxDescent });
	
	        this.propsContainer.innerHTML = '<table>' + '<tr><td>Max elevation:</td><td>' + Math.round(stats.max) + '</td></tr>' + '<tr><td>Min elevation:</td><td>' + Math.round(stats.min) + '</td></tr>' + '<tr class="start-group"><td>Start elevation:</td><td>' + Math.round(stats.start) + '</td></tr>' + '<tr><td>Finish elevation:</td><td>' + Math.round(stats.end) + '</td></tr>' + '<tr><td>Start to finish elevation change:</td><td>' + Math.round(stats.finalAscent) + '</td></tr>' + '<tr class="start-group"><td>Avg / Max ascent inclination:</td><td>' + ascentAngleStr + '</td></tr>' + '<tr><td>Avg / Max descent inclination:</td><td>' + descentAngleStr + '</td></tr>' + '<tr class="start-group"><td>Total ascent:</td><td>' + Math.round(stats.ascent) + '</td></tr>' + '<tr><td>Total descent:</td><td>' + Math.round(stats.descent) + '</td></tr>' + '<tr class="start-group"><td>Distance:</td><td>' + (stats.distance / 1000).toFixed(1) + ' km</td></tr>' + '</table>';
	    },
	
	    calcGridValues: function calcGridValues(minValue, maxValue) {
	        var ticksNs = [3, 4, 5],
	            tickSteps = [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000],
	            ticks = [],
	            i,
	            j,
	            k,
	            ticksN,
	            tickStep,
	            tick1,
	            tick2,
	            matchFound = false;
	
	        for (i = 0; i < tickSteps.length; i++) {
	            tickStep = tickSteps[i];
	            for (j = 0; j < ticksNs.length; j++) {
	                ticksN = ticksNs[j];
	                tick1 = Math.floor(minValue / tickStep);
	                tick2 = Math.ceil(maxValue / tickStep);
	                if (tick2 - tick1 < ticksN) {
	                    matchFound = true;
	                    break;
	                }
	            }
	            if (matchFound) {
	                break;
	            }
	        }
	        for (k = tick1; k < tick1 + ticksN; k++) {
	            ticks.push(k * tickStep);
	        }
	        return ticks;
	    },
	
	    filterElevations: function filterElevations(values, tolerance) {
	        var filtered = values.slice(0);
	        if (filtered.length < 3) {
	            return filtered;
	        }
	        var scanStart, scanEnd, job, linearValue, linearDelta, maxError, maxErrorInd, i, error;
	        var queue = [[0, filtered.length - 1]];
	        while (queue.length) {
	            job = queue.pop();
	            scanStart = job[0];
	            scanEnd = job[1];
	            linearValue = filtered[scanStart];
	            linearDelta = (filtered[scanEnd] - filtered[scanStart]) / (scanEnd - scanStart);
	            maxError = null;
	            maxErrorInd = null;
	            for (i = scanStart + 1; i < scanEnd; i++) {
	                linearValue += linearDelta;
	                error = Math.abs(filtered[i] - linearValue);
	                if (error === null || error > maxError) {
	                    maxError = error;
	                    maxErrorInd = i;
	                }
	            }
	            if (maxError > tolerance) {
	                if (scanEnd > scanStart + 2) {
	                    queue.push([scanStart, maxErrorInd]);
	                    queue.push([maxErrorInd, scanEnd]);
	                }
	            } else {
	                filtered.splice(scanStart + 1, scanEnd - scanStart - 1);
	            }
	        }
	        return filtered;
	    },
	
	    calcProfileStats: function calcProfileStats(values, partial) {
	        var stats = {},
	            gradient,
	            i;
	        stats.min = Math.min.apply(null, values);
	        stats.max = Math.max.apply(null, values);
	        stats.finalAscent = values[values.length - 1] - values[0];
	        var ascents = [],
	            descents = [];
	        for (i = 1; i < values.length; i++) {
	            gradient = values[i] - values[i - 1];
	            if (gradient > 0) {
	                ascents.push(gradient);
	            } else if (gradient < 0) {
	                descents.push(-gradient);
	            }
	        }
	        function sum(a, b) {
	            return a + b;
	        }
	
	        stats.gradientAvgAscent = ascents.reduce(sum, 0) / ascents.length / this.options.samplingInterval;
	        stats.gradientMinAscent = Math.min.apply(null, ascents) / this.options.samplingInterval;
	        stats.gradientMaxAscent = Math.max.apply(null, ascents) / this.options.samplingInterval;
	        stats.gradientAvgDescent = descents.reduce(sum, 0) / descents.length / this.options.samplingInterval;
	        stats.gradientMinDescent = Math.min.apply(null, descents) / this.options.samplingInterval;
	        stats.gradientMaxDescent = Math.max.apply(null, descents) / this.options.samplingInterval;
	
	        stats.angleAvgAscent = gradientToAngle(stats.gradientAvgAscent);
	        stats.angleMinAscent = gradientToAngle(stats.gradientMinAscent);
	        stats.angleMaxAscent = gradientToAngle(stats.gradientMaxAscent);
	        stats.angleAvgDescent = gradientToAngle(stats.gradientAvgDescent);
	        stats.angleMinDescent = gradientToAngle(stats.gradientMinDescent);
	        stats.angleMaxDescent = gradientToAngle(stats.gradientMaxDescent);
	
	        stats.start = values[0];
	        stats.end = values[values.length - 1];
	        stats.distance = (values.length - 1) * this.options.samplingInterval;
	
	        var filterTolerance = 5;
	        var filtered = this.filterElevations(values, filterTolerance);
	        var ascent = 0,
	            descent = 0,
	            delta;
	        for (i = 1; i < filtered.length; i++) {
	            delta = filtered[i] - filtered[i - 1];
	            if (delta < 0) {
	                descent += -delta;
	            } else {
	                ascent += delta;
	            }
	        }
	        stats.ascent = ascent;
	        stats.descent = descent;
	
	        return stats;
	    },
	
	    setCursorPosition: function setCursorPosition(ind) {
	        if (!this._map || !this.values) {
	            return;
	        }
	        var distance = this.options.samplingInterval * ind;
	        distance = (distance / 1000).toFixed(2);
	        var gradient = (this.values[Math.ceil(ind)] - this.values[Math.floor(ind)]) / this.options.samplingInterval;
	        var angle = Math.round(Math.atan(gradient) * 180 / Math.PI);
	        gradient = Math.round(gradient * 100);
	
	        var x = Math.round(ind / (this.values.length - 1) * (this.svgWidth - 1));
	        var indInt = Math.round(ind);
	        var elevation = this.values[indInt];
	        this.graphCursorLabel.innerHTML = _leaflet2.default.Util.template('{ele} m<br>{dist} km<br>{angle}&deg;', { ele: Math.round(elevation), dist: distance, grad: gradient, angle: angle });
	
	        this.graphCursor.style.left = x + 'px';
	        this.graphCursorLabel.style.left = x + 'px';
	        if (this.drawingContainer.getBoundingClientRect().left - this.drawingContainer.scrollLeft + x + this.graphCursorLabel.offsetWidth >= this._container.getBoundingClientRect().right) {
	            _leaflet2.default.DomUtil.addClass(this.graphCursorLabel, 'elevation-profile-cursor-label-left');
	        } else {
	            _leaflet2.default.DomUtil.removeClass(this.graphCursorLabel, 'elevation-profile-cursor-label-left');
	        }
	
	        var markerPos;
	        if (ind <= 0) {
	            markerPos = this.samples[0];
	        } else if (ind >= this.samples.length - 1) {
	            markerPos = this.samples[this.samples.length - 1];
	        } else {
	            var p1 = this.samples[Math.floor(ind)],
	                p2 = this.samples[Math.ceil(ind)],
	                indFrac = ind - Math.floor(ind);
	            markerPos = [p1.lat + (p2.lat - p1.lat) * indFrac, p1.lng + (p2.lng - p1.lng) * indFrac];
	        }
	        this.trackMarker.setLatLng(markerPos);
	        var label = _leaflet2.default.Util.template('{ele} m<br>{dist} km<br>{angle}&deg;', { ele: Math.round(elevation), dist: distance, grad: gradient, angle: angle });
	        var icon = _leaflet2.default.divIcon({
	            className: 'elevation-profile-marker',
	            html: '<div class="elevation-profile-marker-icon"></div><div class="elevation-profile-marker-label">' + label + '</div>'
	        });
	        this.trackMarker.setIcon(icon);
	    },
	
	    onSvgMouseMove: function onSvgMouseMove(e) {
	        if (!this.values) {
	            return;
	        }
	        var x = offestFromEvent(e).offsetX;
	        var ind = x / (this.svgWidth - 1) * (this.values.length - 1);
	        this.setCursorPosition(ind);
	    },
	
	    cursorShow: function cursorShow() {
	        _leaflet2.default.DomUtil.removeClass(this.graphCursor, 'elevation-profile-cursor-hidden');
	        _leaflet2.default.DomUtil.removeClass(this.graphCursorLabel, 'elevation-profile-cursor-hidden');
	        this._map.addLayer(this.trackMarker);
	    },
	
	    cursorHide: function cursorHide() {
	        _leaflet2.default.DomUtil.addClass(this.graphCursor, 'elevation-profile-cursor-hidden');
	        _leaflet2.default.DomUtil.addClass(this.graphCursorLabel, 'elevation-profile-cursor-hidden');
	        this._map.removeLayer(this.trackMarker);
	    },
	
	    onSvgEnter: function onSvgEnter() {
	        this.cursorShow();
	    },
	
	    onSvgLeave: function onSvgLeave() {
	        this.cursorHide();
	    },
	
	    onLineMouseEnter: function onLineMouseEnter() {
	        this.cursorShow();
	    },
	
	    onLineMouseLeave: function onLineMouseLeave() {
	        this.cursorHide();
	    },
	
	    onLineMouseMove: function onLineMouseMove(e) {
	        function sqrDist(latlng1, latlng2) {
	            var dx = latlng1.lng - latlng2.lng;
	            var dy = latlng1.lat - latlng2.lat;
	            return dx * dx + dy * dy;
	        }
	
	        var nearestInd = null,
	            ind,
	            minDist = null,
	            mouseLatlng = e.latlng,
	            i,
	            sampleLatlng,
	            dist,
	            di;
	        for (i = 0; i < this.samples.length; i++) {
	            sampleLatlng = this.samples[i];
	            dist = sqrDist(sampleLatlng, mouseLatlng);
	            if (nearestInd === null || dist < minDist) {
	                nearestInd = i;
	                minDist = dist;
	            }
	        }
	
	        if (nearestInd !== null) {
	            ind = nearestInd;
	            if (nearestInd > 0) {
	                var prevDist = sqrDist(mouseLatlng, this.samples[nearestInd - 1]),
	                    prevSampleDist = sqrDist(this.samples[nearestInd], this.samples[nearestInd - 1]);
	            }
	            if (nearestInd < this.samples.length - 1) {
	                var nextDist = sqrDist(mouseLatlng, this.samples[nearestInd + 1]),
	                    nextSampleDist = sqrDist(this.samples[nearestInd], this.samples[nearestInd + 1]);
	            }
	
	            if (nearestInd === 0) {
	                if (nextDist < minDist + nextSampleDist) {
	                    di = (minDist - nextDist) / 2 / nextSampleDist + 1 / 2;
	                } else {
	                    di = .001;
	                }
	            } else if (nearestInd === this.samples.length - 1) {
	                if (prevDist < minDist + prevSampleDist) {
	                    di = -((minDist - prevDist) / 2 / prevSampleDist + 1 / 2);
	                } else {
	                    di = -0.001;
	                }
	            } else {
	                if (prevDist < nextDist) {
	                    di = -((minDist - prevDist) / 2 / prevSampleDist + 1 / 2);
	                } else {
	                    di = (minDist - nextDist) / 2 / nextSampleDist + 1 / 2;
	                }
	            }
	            if (di < -1) {
	                di = -1;
	            }
	            if (di > 1) {
	                di = 1;
	            }
	            this.setCursorPosition(ind + di);
	        }
	    },
	
	    setupGraph: function setupGraph() {
	        var _this = this;
	
	        if (!this._map || !this.values) {
	            return;
	        }
	
	        while (this.svg.hasChildNodes()) {
	            this.svg.removeChild(this.svg.lastChild);
	        }
	        while (this.leftAxisLables.hasChildNodes()) {
	            this.leftAxisLables.removeChild(this.leftAxisLables.lastChild);
	        }
	
	        var maxValue = Math.max.apply(null, this.values),
	            minValue = Math.min.apply(null, this.values),
	            svg = this.svg,
	            path,
	            i,
	            horizStep,
	            verticalMultiplier,
	            x,
	            y,
	            gridValues,
	            label;
	
	        var paddingBottom = 8 + 16,
	            paddingTop = 8;
	
	        gridValues = this.calcGridValues(minValue, maxValue);
	        var gridStep = (this.svgHeight - paddingBottom - paddingTop) / (gridValues.length - 1);
	        for (i = 0; i < gridValues.length; i++) {
	            y = Math.round(i * gridStep - 0.5) + 0.5 + paddingTop;
	            path = _leaflet2.default.Util.template('M{x1} {y} L{x2} {y}', { x1: 0, x2: this.svgWidth * this.horizZoom, y: y });
	            createSvg('path', { d: path, 'stroke-width': '1px', stroke: 'green', fill: 'none', 'stroke-opacity': '0.5' }, svg);
	
	            label = _leaflet2.default.DomUtil.create('div', 'elevation-profile-grid-label', this.leftAxisLables);
	            label.innerHTML = gridValues[gridValues.length - i - 1];
	            label.style.top = gridStep * i + paddingTop + 'px';
	        }
	
	        horizStep = this.svgWidth / (this.values.length - 1);
	        verticalMultiplier = (this.svgHeight - paddingTop - paddingBottom) / (gridValues[gridValues.length - 1] - gridValues[0]);
	
	        path = [];
	        var valueToSvgCoord = function valueToSvgCoord(el) {
	            var y = (el - gridValues[0]) * verticalMultiplier;
	            return _this.svgHeight - y - paddingBottom;
	        };
	
	        var startNewSegment = true;
	        for (i = 0; i < this.values.length; i++) {
	            var value = this.values[i];
	            if (value === null) {
	                startNewSegment = true;
	                continue;
	            }
	            path.push(startNewSegment ? 'M' : 'L');
	            x = i * horizStep;
	            y = valueToSvgCoord(value);
	            path.push(x + ' ' + y + ' ');
	            startNewSegment = false;
	        }
	        path = path.join('');
	        createSvg('path', { d: path, 'stroke-width': '1px', stroke: 'brown', fill: 'none' }, svg);
	        // sightline
	        if (this.options.sightLine) {
	            path = _leaflet2.default.Util.template('M{x1} {y1} L{x2} {y2}', {
	                x1: 0, x2: this.svgWidth * this.horizZoom,
	                y1: valueToSvgCoord(this.values[0]),
	                y2: valueToSvgCoord(this.values[this.values.length - 1])
	            });
	            createSvg('path', { d: path, 'stroke-width': '3px', stroke: '#94b1ff', fill: 'none', 'stroke-opacity': '0.5' }, svg);
	        }
	    },
	
	    _getElevation: function _getElevation(latlngs) {
	        function parseResponse(s) {
	            var values = [],
	                v;
	            s = s.split('\n');
	            for (var i = 0; i < s.length; i++) {
	                if (s[i]) {
	                    if (s[i] === 'NULL') {
	                        v = null;
	                    } else {
	                        v = parseFloat(s[i]);
	                    }
	                    values.push(v);
	                }
	            }
	            return values;
	        }
	
	        var req = [];
	        for (var i = 0; i < latlngs.length; i++) {
	            req.push(latlngs[i].lat.toFixed(6) + ' ' + latlngs[i].lng.toFixed(5));
	        }
	        req = req.join('\n');
	        var xhrPromise = (0, _xhrPromise.fetch)(this.options.elevationsServer, { method: 'POST', data: req });
	        this.abortLoading = xhrPromise.abort.bind(xhrPromise);
	        return xhrPromise.then(function (xhr) {
	            return parseResponse(xhr.responseText);
	        });
	    },
	    onCloseButtonClick: function onCloseButtonClick() {
	        this.removeFrom(this._map);
	    }
	});
	
	exports.ElevationProfile = ElevationProfile;
	exports.calcSamplingInterval = calcSamplingInterval;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function extendLayerName(name, layer) {
	    if (layer.options) {
	        var code = layer.options.code;
	        if (code && code.length === 1) {
	            name += '<span class="layers-control-hotkey">' + code + '</span>';
	        }
	    }
	    return name;
	}
	
	function enableHotKeys(control) {
	    var originalOnAdd = control.onAdd;
	    var originalOnRemove = control.onRemove;
	    var originalAddItem = control._addItem;
	
	    if (control._hotKeysEnabled) {
	        return control;
	    }
	
	    _leaflet2.default.Util.extend(control, {
	        _hotKeysEnabled: true,
	
	        _addItem: function _addItem(obj) {
	            obj = _leaflet2.default.Util.extend({}, obj);
	            obj.name = extendLayerName(obj.name, obj.layer);
	            return originalAddItem.call(this, obj);
	        },
	
	        onAdd: function onAdd(map) {
	            var result = originalOnAdd.call(this, map);
	            this._addHotketEvents();
	            return result;
	        },
	
	        onRemove: function onRemove(map) {
	            _leaflet2.default.DomEvent.off(document, 'keyup', this._onHotkeyUp, this);
	            _leaflet2.default.DomEvent.off(document, 'keydown', this.onKeyDown, this);
	            originalOnRemove.call(this, map);
	        },
	
	        _addHotKetEvents: function _addHotKetEvents() {
	            _leaflet2.default.DomEvent.on(document, 'keyup', this._onHotkeyUp, this);
	            _leaflet2.default.DomEvent.on(document, 'keydown', this.onKeyDown, this);
	        },
	
	        onKeyDown: function onKeyDown(e) {
	            if (e.altKey || e.ctrlKey || e.shiftKey) {
	                return;
	            }
	            this._keyDown = e.keyCode;
	        },
	
	        _onHotkeyUp: function _onHotkeyUp(e) {
	            var pressedKey = this._keyDown;
	            this._keyDown = null;
	            var targetTag = e.target.tagName.toLowerCase();
	            if ('input' === targetTag && e.target.type === 'text' || 'textarea' === targetTag || pressedKey !== e.keyCode) {
	                return;
	            }
	            var key = String.fromCharCode(e.keyCode);
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this._layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var layer = _step.value;
	
	                    var layerId = _leaflet2.default.stamp(layer.layer);
	                    if (layer.layer.options && layer.layer.options.code && layer.layer.options.code.toUpperCase() === key) {
	                        var inputs = this._form.getElementsByTagName('input');
	
	                        var _arr = [].concat(_toConsumableArray(inputs));
	
	                        for (var _i = 0; _i < _arr.length; _i++) {
	                            var input = _arr[_i];
	                            if (input.layerId === layerId) {
	                                input.click();
	                                break;
	                            }
	                        }
	                        break;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    });
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = control._layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var layer = _step2.value;
	
	            layer.name = extendLayerName(layer.name, layer.layer);
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    control._addHotKetEvents();
	    control._update();
	    return control;
	}
	
	exports.default = enableHotKeys;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(454);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enableTopRow(control) {
	    var originalOnAdd = control.onAdd;
	    if (control._topRowEnabled) {
	        return;
	    }
	
	    _leaflet2.default.Util.extend(control, {
	        _topRowEnabled: true,
	
	        onAdd: function onAdd(map) {
	            var _this = this;
	
	            var container = originalOnAdd.call(this, map);
	            setTimeout(function () {
	                return _this.__injectTopRow();
	            }, 0);
	            return container;
	        },
	
	        __injectTopRow: function __injectTopRow() {
	            this._topRow = _leaflet2.default.DomUtil.create('div', 'leaflet-control-layers-top-row');
	            this._form.parentNode.insertBefore(this._topRow, this._form);
	        }
	
	    });
	    if (control._map) {
	        control.__injectTopRow();
	    }
	}
	
	exports.default = enableTopRow;

/***/ },
/* 117 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function arrayItemsEqual(l1, l2) {
	    if (l1.length !== l2.length) return false;
	    for (var i = 0; i < l1.length; i++) {
	        if (l1[i] !== l2[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	
	var hashState = {
	    _listeners: [],
	    _state: {},
	
	    addEventListener: function addEventListener(key, callback) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this._listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _step$value = _slicedToArray(_step.value, 2),
	                    k = _step$value[0],
	                    c = _step$value[1];
	
	                if (k === key && c === callback) {
	                    return;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        this._listeners.push([key, callback]);
	    },
	
	    removeEventListener: function removeEventListener(key, callback) {
	        var _this = this;
	
	        this._listeners.forEach(function (_ref, i) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                k = _ref2[0],
	                c = _ref2[1];
	
	            if (k === key && c === callback) {
	                _this._listeners.splice(i, 1);
	                return;
	            }
	        });
	    },
	
	    updateState: function updateState(key, values) {
	        if (values) {
	            this._state[key] = values;
	        } else {
	            delete this._state[key];
	        }
	        this._saveStateToHash();
	    },
	
	    getState: function getState(key) {
	        return this._state[key];
	    },
	
	    _parseHash: function _parseHash() {
	        var hash = location.hash;
	        var args = {},
	            i = hash.indexOf('#');
	        if (i >= 0) {
	            hash = hash.substr(i + 1).trim();
	            var m = void 0,
	                key = void 0,
	                value = void 0;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = hash.split('&')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var pair = _step2.value;
	
	                    m = /^([^=]+?)(?:=(.*))?$/.exec(pair);
	                    if (m) {
	                        var _m = m;
	
	                        var _m2 = _slicedToArray(_m, 3);
	
	                        key = _m2[1];
	                        value = _m2[2];
	
	                        if (value) {
	                            value = value.split('/');
	                            value = value.map(decodeURIComponent);
	                        } else {
	                            value = [];
	                        }
	                        args[key] = value;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	        return args;
	    },
	
	    _saveStateToHash: function _saveStateToHash() {
	        var stateItems = [];
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = Object.keys(this._state)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var key = _step3.value;
	
	                if (this._state[key]) {
	                    if (this._state[key].length) {
	                        var values = this._state[key].join('/');
	                        stateItems.push(key + '=' + values);
	                    } else {
	                        stateItems.push(key);
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        location.hash = stateItems.join('&');
	    },
	
	    onHashChanged: function onHashChanged() {
	        var newState = this._parseHash();
	        var changedKeys = {};
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = Object.keys(newState)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var key = _step4.value;
	
	                if (!(key in this._state) || !arrayItemsEqual(newState[key], this._state[key])) {
	                    changedKeys[key] = 1;
	                }
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	            for (var _iterator5 = Object.keys(this._state)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                var _key = _step5.value;
	
	                if (!(_key in newState)) {
	                    changedKeys[_key] = 1;
	                }
	            }
	        } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                    _iterator5.return();
	                }
	            } finally {
	                if (_didIteratorError5) {
	                    throw _iteratorError5;
	                }
	            }
	        }
	
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	            for (var _iterator6 = this._listeners[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                var _step6$value = _slicedToArray(_step6.value, 2),
	                    _key2 = _step6$value[0],
	                    callback = _step6$value[1];
	
	                if (_key2 in changedKeys) {
	                    callback(newState[_key2]);
	                }
	            }
	        } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                    _iterator6.return();
	                }
	            } finally {
	                if (_didIteratorError6) {
	                    throw _iteratorError6;
	                }
	            }
	        }
	
	        this._state = newState;
	    }
	};
	
	window.addEventListener('hashchange', hashState.onHashChanged.bind(hashState));
	hashState.onHashChanged();
	
	exports.default = hashState;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.BingLayer = _leaflet2.default.TileLayer.extend({
	    options: {
	        subdomains: [0, 1, 2, 3],
	        type: 'Aerial',
	        attribution: 'Bing',
	        culture: ''
	    },
	
	    initialize: function initialize(key, options) {
	        _leaflet2.default.Util.setOptions(this, options);
	
	        this._key = key;
	        this._url = null;
	        this._providers = [];
	        this.metaRequested = false;
	    },
	
	    tile2quad: function tile2quad(x, y, z) {
	        var quad = '';
	        for (var i = z; i > 0; i--) {
	            var digit = 0;
	            var mask = 1 << i - 1;
	            if ((x & mask) !== 0) digit += 1;
	            if ((y & mask) !== 0) digit += 2;
	            quad += digit;
	        }
	        return quad;
	    },
	
	    getTileUrl: function getTileUrl(tilePoint) {
	        var zoom = this._getZoomForUrl();
	        var subdomains = this.options.subdomains,
	            s = this.options.subdomains[Math.abs((tilePoint.x + tilePoint.y) % subdomains.length)];
	        return this._url.replace('{subdomain}', s).replace('{quadkey}', this.tile2quad(tilePoint.x, tilePoint.y, zoom)).replace('{culture}', this.options.culture);
	    },
	
	    loadMetadata: function loadMetadata() {
	        if (this.metaRequested) return;
	        this.metaRequested = true;
	        var _this = this;
	        var cbid = '_bing_metadata_' + _leaflet2.default.Util.stamp(this);
	        window[cbid] = function (meta) {
	            window[cbid] = undefined;
	            var e = document.getElementById(cbid);
	            e.parentNode.removeChild(e);
	            if (meta.errorDetails) {
	                throw new Error(meta.errorDetails);
	            }
	            _this.initMetadata(meta);
	        };
	        var urlScheme = document.location.protocol === 'file:' ? 'http' : document.location.protocol.slice(0, -1);
	        var url = urlScheme + '://dev.virtualearth.net/REST/v1/Imagery/Metadata/' + this.options.type + '?include=ImageryProviders&jsonp=' + cbid + '&key=' + this._key + '&UriScheme=' + urlScheme;
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.src = url;
	        script.id = cbid;
	        document.getElementsByTagName('head')[0].appendChild(script);
	    },
	
	    initMetadata: function initMetadata(meta) {
	        var r = meta.resourceSets[0].resources[0];
	        this.options.subdomains = r.imageUrlSubdomains;
	        this._url = r.imageUrl;
	        if (r.imageryProviders) {
	            for (var i = 0; i < r.imageryProviders.length; i++) {
	                var p = r.imageryProviders[i];
	                for (var j = 0; j < p.coverageAreas.length; j++) {
	                    var c = p.coverageAreas[j];
	                    var coverage = { zoomMin: c.zoomMin, zoomMax: c.zoomMax, active: false };
	                    var bounds = new _leaflet2.default.LatLngBounds(new _leaflet2.default.LatLng(c.bbox[0] + 0.01, c.bbox[1] + 0.01), new _leaflet2.default.LatLng(c.bbox[2] - 0.01, c.bbox[3] - 0.01));
	                    coverage.bounds = bounds;
	                    coverage.attrib = p.attribution;
	                    this._providers.push(coverage);
	                }
	            }
	        }
	        this._update();
	    },
	
	    _update: function _update() {
	        if (this._url === null || !this._map) return;
	        this._update_attribution();
	        _leaflet2.default.TileLayer.prototype._update.apply(this, []);
	    },
	
	    _update_attribution: function _update_attribution() {
	        var bounds = _leaflet2.default.latLngBounds(this._map.getBounds().getSouthWest().wrap(), this._map.getBounds().getNorthEast().wrap());
	        var zoom = this._map.getZoom();
	        for (var i = 0; i < this._providers.length; i++) {
	            var p = this._providers[i];
	            if (zoom <= p.zoomMax && zoom >= p.zoomMin && bounds.intersects(p.bounds)) {
	                if (!p.active && this._map.attributionControl) this._map.attributionControl.addAttribution(p.attrib);
	                p.active = true;
	            } else {
	                if (p.active && this._map.attributionControl) this._map.attributionControl.removeAttribution(p.attrib);
	                p.active = false;
	            }
	        }
	    },
	
	    onAdd: function onAdd(map) {
	        this.loadMetadata();
	        _leaflet2.default.TileLayer.prototype.onAdd.apply(this, [map]);
	    },
	
	    onRemove: function onRemove(map) {
	        for (var i = 0; i < this._providers.length; i++) {
	            var p = this._providers[i];
	            if (p.active && this._map.attributionControl) {
	                this._map.attributionControl.removeAttribution(p.attrib);
	                p.active = false;
	            }
	        }
	        _leaflet2.default.TileLayer.prototype.onRemove.apply(this, [map]);
	    }
	});
	
	_leaflet2.default.bingLayer = function (key, options) {
	    return new _leaflet2.default.BingLayer(key, options);
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _googleMapsApi = __webpack_require__(111);
	
	var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	_leaflet2.default.Layer.Google = _leaflet2.default.GridLayer.extend({
	    options: {},
	
	    // Possible types: SATELLITE, ROADMAP, HYBRID, TERRAIN
	    initialize: function initialize(mapType, options) {
	        _leaflet2.default.GridLayer.prototype.initialize.call(this, options);
	        this.mapType = mapType;
	    },
	
	    onAdd: function onAdd(map) {
	        var _this = this;
	
	        this._clearTiles();
	        _leaflet2.default.GridLayer.prototype.onAdd.call(this, map);
	        this._googleMapContainer = _leaflet2.default.DomUtil.create('div', '', map.getContainer());
	        this._googleMapContainer.style.width = '100%';
	        this._googleMapContainer.style.height = '100%';
	        // this._googleMapContainer.style.opacity = 0;
	        this._googleMapContainer.style.visibility = 'hidden';
	        this._googleMapContainer.style.pointerEvents = 'none';
	        (0, _googleMapsApi2.default)().then(function (google) {
	            var zoom = void 0,
	                center = void 0;
	            if (map) {
	                zoom = map.getZoom();
	                center = map.getCenter;
	                center = new google.maps.LatLng(center.lat, center.lng);
	            } else {
	                zoom = 0;
	                center = new google.maps.LatLng(0, 0);
	            }
	            _this.google = google;
	            _this._googleMap = new google.maps.Map(_this._googleMapContainer, {
	                center: center,
	                zoom: zoom,
	                tilt: 0,
	                mapTypeId: google.maps.MapTypeId[_this.mapType],
	                disableDefaultUI: true,
	                keyboardShortcuts: false,
	                draggable: false,
	                disableDoubleClickZoom: true,
	                scrollwheel: false,
	                streetViewControl: false,
	                clickableIcons: false
	            });
	            google.maps.event.addListener(_this._googleMap, 'tilesloaded', _this._onTilesLoaded.bind(_this));
	            setTimeout(_this._syncPosition.bind(_this), 0);
	        });
	        map.on({
	            viewreset: this._syncPosition,
	            resize: this._onResize,
	            move: this._syncPosition,
	            zoomanim: this._onZoom
	        }, this);
	    },
	
	    onRemove: function onRemove(map) {
	        if (this.google) {
	            this.google.maps.event.clearInstanceListeners(this._googleMap);
	        }
	        this._googleMap = null;
	        this._clearTiles();
	        _leaflet2.default.DomUtil.remove(this._googleMapContainer);
	        map.off({
	            viewreset: this._clearTiles,
	            resize: this._onResize,
	            move: this._syncPosition,
	            zoomanim: this._onZoom
	        }, this);
	        _leaflet2.default.GridLayer.prototype.onRemove.call(this, map);
	    },
	
	    _clearTiles: function _clearTiles() {
	        this._pendingTiles = {};
	        this._readyTiles = {};
	    },
	
	    _onResize: function _onResize() {
	        if (!this.google) {
	            return;
	        }
	        this.google.maps.event.trigger(this._googleMap, 'resize');
	    },
	
	    _syncPosition: function _syncPosition() {
	        var _this2 = this;
	
	        if (!this.google || !this._map) {
	            return;
	        }
	        var center = this._map.getCenter();
	        var googleCenter = new this.google.maps.LatLng(center.lat, center.lng);
	        setTimeout(function () {
	            if (!_this2._googleMap) {
	                return;
	            }
	            _this2._googleMap.setCenter(googleCenter);
	            _this2._googleMap.setZoom(_this2._map.getZoom());
	        }, 0);
	    },
	
	    _onZoom: function _onZoom(e) {
	        var _this3 = this;
	
	        if (!this.google) {
	            return;
	        }
	        var center = e.center;
	        var googleCenter = new this.google.maps.LatLng(center.lat, center.lng);
	        setTimeout(function () {
	            if (!_this3._googleMap) {
	                return;
	            }
	            _this3._googleMap.setCenter(googleCenter);
	            _this3._googleMap.setZoom(Math.round(e.zoom));
	        }, 0);
	    },
	
	    _roadRegexp: /!1i(\d+)!2i(\d+)!3i(\d+)!/,
	    _satRegexp: /x=(\d+)&y=(\d+)&z=(\d+)/,
	
	    _onTilesLoaded: function _onTilesLoaded() {
	        this._readyTiles = this._collectMapImageElements();
	        this._fullfillPendingTiles();
	    },
	
	    _collectMapImageElements: function _collectMapImageElements() {
	        var images = this._googleMapContainer.getElementsByTagName('img');
	        var tiles = {};
	
	        var _arr = [].concat(_toConsumableArray(images));
	
	        for (var _i = 0; _i < _arr.length; _i++) {
	            var image = _arr[_i];
	            var url = image.src;
	            var match = void 0,
	                coords = void 0;
	            match = url.match(this._roadRegexp);
	
	            if (match) {
	                coords = { z: match[1], x: match[2], y: match[3] };
	            } else {
	                match = url.match(this._satRegexp);
	                if (match) {
	                    coords = { x: match[1], y: match[2], z: match[3] };
	                }
	            }
	            if (coords) {
	                tiles[this._tileCoordsToKey(coords)] = url;
	            }
	        }
	        return tiles;
	    },
	
	    _fullfillPendingTiles: function _fullfillPendingTiles() {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = Object.keys(this._readyTiles)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var key = _step.value;
	
	                if (key in this._pendingTiles) {
	                    var _iteratorNormalCompletion2 = true;
	                    var _didIteratorError2 = false;
	                    var _iteratorError2 = undefined;
	
	                    try {
	                        for (var _iterator2 = this._pendingTiles[key][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            var _step2$value = _slicedToArray(_step2.value, 2),
	                                img = _step2$value[0],
	                                cb = _step2$value[1];
	
	                            _leaflet2.default.DomEvent.on(img, 'load', _leaflet2.default.bind(this._tileOnLoad, this, cb, img));
	                            _leaflet2.default.DomEvent.on(img, 'error', _leaflet2.default.bind(this._tileOnError, this, cb, img));
	                            img.alt = '';
	                            img.src = this._readyTiles[key];
	                        }
	                    } catch (err) {
	                        _didIteratorError2 = true;
	                        _iteratorError2 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	                        } finally {
	                            if (_didIteratorError2) {
	                                throw _iteratorError2;
	                            }
	                        }
	                    }
	
	                    delete this._pendingTiles[key];
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	
	    _tileOnLoad: function _tileOnLoad(done, tile) {
	        // For https://github.com/Leaflet/Leaflet/issues/3332
	        if (_leaflet2.default.Browser.ielt9) {
	            setTimeout(_leaflet2.default.bind(done, this, null, tile), 0);
	        } else {
	            done(null, tile);
	        }
	    },
	
	    _tileOnError: function _tileOnError(done, tile, e) {
	        done(e, tile);
	    },
	
	    createTile: function createTile(coords, done) {
	        var tile = _leaflet2.default.DomUtil.create('img');
	        var key = this._tileCoordsToKey(coords);
	        if (!(key in this._pendingTiles)) {
	            this._pendingTiles[key] = [];
	        }
	        this._pendingTiles[key].push([tile, done]);
	        setTimeout(this._fullfillPendingTiles.bind(this), 0);
	        return tile;
	    }
	});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	_leaflet2.default.Layer.CanvasMarkers.include({
	    _printProgressWeight: 0.1,
	
	    cloneMarkers: function cloneMarkers() {
	        var markers = this.rtree.all();
	
	        function cloneMarker(marker) {
	            return {
	                latlng: { lat: marker.latlng.lat, lng: marker.latlng.lng },
	                label: marker.label,
	                icon: marker.icon
	            };
	        }
	
	        var markersCopy = markers.map(cloneMarker);
	        return markersCopy;
	    },
	
	    cloneForPrint: function cloneForPrint(options) {
	        options = _leaflet2.default.Util.extend({}, this.options);
	        if (options.printIconsOpacity !== undefined) {
	            options.iconsOpacity = options.printIconsOpacity;
	        }
	        return new _leaflet2.default.Layer.CanvasMarkers(this.cloneMarkers(), options);
	    },
	
	    getTilesInfo: function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(printOptions) {
	            var scale, pixelExtents, crs, dummyMap, zoom, _selectMarkersForDraw, iconUrls, markerJobs, pointsForLabels;
	
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            this.options.iconScale = printOptions.resolution / 90 * 0.75;
	                            scale = printOptions.pixelBounds.getSize().x / printOptions.destPixelSize.x;
	                            pixelExtents = {
	                                tileN: printOptions.pixelBounds.getTopRight().y / scale,
	                                tileS: printOptions.pixelBounds.getBottomLeft().y / scale,
	                                tileE: printOptions.pixelBounds.getTopRight().x / scale,
	                                tileW: printOptions.pixelBounds.getBottomLeft().x / scale
	                            };
	                            crs = _leaflet2.default.CRS.EPSG3857;
	
	                            if (!this._map) {
	                                dummyMap = {
	                                    project: crs.latLngToPoint.bind(crs),
	                                    unproject: crs.pointToLatLng.bind(crs)
	                                };
	
	                                this._map = dummyMap;
	                            }
	                            zoom = crs.zoom(1 / scale * crs.scale(printOptions.zoom));
	                            _selectMarkersForDraw = this.selectMarkersForDraw(pixelExtents, zoom, true), iconUrls = _selectMarkersForDraw.iconUrls, markerJobs = _selectMarkersForDraw.markerJobs, pointsForLabels = _selectMarkersForDraw.pointsForLabels;
	                            _context2.next = 9;
	                            return this.preloadIcons(iconUrls);
	
	                        case 9:
	                            return _context2.abrupt("return", {
	                                iterateTilePromises: /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                                    var _this = this;
	
	                                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                                        while (1) {
	                                            switch (_context.prev = _context.next) {
	                                                case 0:
	                                                    _context.next = 2;
	                                                    return {
	                                                        tilePromise: Promise.resolve({
	                                                            draw: function draw(canvas) {
	                                                                _this.resetLabels();
	                                                                _this.drawSelectedMarkers(canvas, pixelExtents, markerJobs, pointsForLabels, zoom, true);
	                                                            },
	                                                            isOverlay: true,
	                                                            overlaySolid: !this.options.printTransparent
	                                                        }),
	                                                        abortLoading: function abortLoading() {}
	                                                    };
	
	                                                case 2:
	                                                case "end":
	                                                    return _context.stop();
	                                            }
	                                        }
	                                    }, _callee, this);
	                                }).bind(this),
	                                count: 1
	                            });
	
	                        case 10:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function getTilesInfo(_x) {
	            return _ref.apply(this, arguments);
	        }
	
	        return getTilesInfo;
	    }()
	});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CanvasLayerGrabMixin = exports.GridLayerGrabMixin = exports.TileLayerGrabMixin = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _CORSProxy = __webpack_require__(60);
	
	var _CORSProxy2 = _interopRequireDefault(_CORSProxy);
	
	var _imgFromDataString = __webpack_require__(223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var GridLayerGrabMixin = {
	    tileImagePromiseFromCoords: function tileImagePromiseFromCoords(coords) {
	        throw new Error('Method not implemented');
	    },
	
	    waitTilesReadyToGrab: function waitTilesReadyToGrab() {
	        return Promise.resolve(null);
	    },
	
	    getTilesInfo: function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(printOptions) {
	            var pixelBounds, tileRange, topLeft, tilePromiseIterator;
	            return regeneratorRuntime.wrap(function _callee2$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.next = 2;
	                            return this.waitTilesReadyToGrab();
	
	                        case 2:
	                            pixelBounds = printOptions.pixelBounds;
	                            tileRange = this._pxBoundsToTileRange(pixelBounds);
	                            topLeft = pixelBounds.min;
	                            tilePromiseIterator = /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                                var _this = this;
	
	                                var j, _loop, i, _ret;
	
	                                return regeneratorRuntime.wrap(function _callee$(_context2) {
	                                    while (1) {
	                                        switch (_context2.prev = _context2.next) {
	                                            case 0:
	                                                j = tileRange.min.y;
	
	                                            case 1:
	                                                if (!(j <= tileRange.max.y)) {
	                                                    _context2.next = 15;
	                                                    break;
	                                                }
	
	                                                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
	                                                    var coords, tilePos, coordsPlusOne, tilePlusOne, tileSize, latLngBounds, _tileImagePromiseFrom, tilePromise, abortLoading;
	
	                                                    return regeneratorRuntime.wrap(function _loop$(_context) {
	                                                        while (1) {
	                                                            switch (_context.prev = _context.next) {
	                                                                case 0:
	                                                                    coords = new _leaflet2.default.Point(i, j);
	
	                                                                    coords.z = _this._tileZoom;
	
	                                                                    if (_this._isValidTile(coords)) {
	                                                                        _context.next = 4;
	                                                                        break;
	                                                                    }
	
	                                                                    return _context.abrupt('return', 'continue');
	
	                                                                case 4:
	                                                                    tilePos = _this._getTilePos(coords);
	                                                                    coordsPlusOne = coords.add(_leaflet2.default.point(1, 1));
	
	                                                                    coordsPlusOne.z = coords.z;
	                                                                    tilePlusOne = _this._getTilePos(coordsPlusOne);
	                                                                    tileSize = tilePlusOne.subtract(tilePos);
	                                                                    latLngBounds = _leaflet2.default.latLngBounds(_this._map.unproject(tilePos.add(_this._level.origin)), _this._map.unproject(tilePlusOne.add(_this._level.origin)));
	
	                                                                    tilePos = tilePos.add(_this._level.origin).subtract(topLeft);
	                                                                    _tileImagePromiseFrom = _this.tileImagePromiseFromCoords(_this._wrapCoords(coords), printOptions), tilePromise = _tileImagePromiseFrom.tilePromise, abortLoading = _tileImagePromiseFrom.abortLoading;
	                                                                    _context.next = 14;
	                                                                    return {
	                                                                        tilePromise: tilePromise.then(function (image) {
	                                                                            return { image: image, tilePos: tilePos, tileSize: tileSize, latLngBounds: latLngBounds };
	                                                                        }),
	                                                                        abortLoading: abortLoading
	                                                                    };
	
	                                                                case 14:
	                                                                case 'end':
	                                                                    return _context.stop();
	                                                            }
	                                                        }
	                                                    }, _loop, _this);
	                                                });
	                                                i = tileRange.min.x;
	
	                                            case 4:
	                                                if (!(i <= tileRange.max.x)) {
	                                                    _context2.next = 12;
	                                                    break;
	                                                }
	
	                                                return _context2.delegateYield(_loop(i), 't0', 6);
	
	                                            case 6:
	                                                _ret = _context2.t0;
	
	                                                if (!(_ret === 'continue')) {
	                                                    _context2.next = 9;
	                                                    break;
	                                                }
	
	                                                return _context2.abrupt('continue', 9);
	
	                                            case 9:
	                                                i++;
	                                                _context2.next = 4;
	                                                break;
	
	                                            case 12:
	                                                j++;
	                                                _context2.next = 1;
	                                                break;
	
	                                            case 15:
	                                            case 'end':
	                                                return _context2.stop();
	                                        }
	                                    }
	                                }, _callee, this);
	                            }).bind(this);
	                            return _context3.abrupt('return', {
	                                iterateTilePromises: tilePromiseIterator,
	                                count: (tileRange.max.x - tileRange.min.x + 1) * (tileRange.max.y - tileRange.min.y + 1)
	                            });
	
	                        case 7:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function getTilesInfo(_x) {
	            return _ref.apply(this, arguments);
	        }
	
	        return getTilesInfo;
	    }()
	};
	
	var TileLayerGrabMixin = _leaflet2.default.Util.extend({}, GridLayerGrabMixin, {
	    cloneForPrint: function cloneForPrint(options) {
	        return _leaflet2.default.tileLayer(this._url, _leaflet2.default.Util.extend({}, this.options, options));
	    },
	
	    tileImagePromiseFromCoords: function tileImagePromiseFromCoords(coords, printOptions) {
	        var xhrOptions = printOptions.xhrOptions;
	
	        var url = this.getTileUrl(coords);
	        if (!url) {
	            return { tilePromise: Promise.resolve(null), abortLoading: noop };
	        }
	        if (this.options.noCors) {
	            url = (0, _CORSProxy2.default)(url);
	        }
	        var promise = this.options.xhrQueue.put(url, xhrOptions);
	
	        return {
	            tilePromise: printOptions.rawData ? promise : promise.then(_imgFromDataString.imgFromDataString),
	            abortLoading: function abortLoading() {
	                return promise.abort();
	            }
	        };
	    }
	});
	
	function noop() {}
	
	var CanvasLayerGrabMixin = _leaflet2.default.Util.extend({}, GridLayerGrabMixin, {
	    getCanvasFromTile: function getCanvasFromTile(tile) {
	        return tile;
	    },
	
	    tileImagePromiseFromCoords: function tileImagePromiseFromCoords(coords) {
	        var _this2 = this;
	
	        var tilePromise = void 0;
	        if (this.createTile.length < 2) {
	            var tile = this.createTile(coords);
	            tilePromise = Promise.resolve(tile);
	        } else {
	            tilePromise = new Promise(function (resolve) {
	                _this2.createTile(coords, function (_, canvas) {
	                    return resolve(canvas);
	                });
	            });
	        }
	
	        return {
	            tilePromise: tilePromise.then(this.getCanvasFromTile),
	            abortLoading: noop
	        };
	    }
	});
	
	_leaflet2.default.TileLayer.include(TileLayerGrabMixin);
	
	exports.TileLayerGrabMixin = TileLayerGrabMixin;
	exports.GridLayerGrabMixin = GridLayerGrabMixin;
	exports.CanvasLayerGrabMixin = CanvasLayerGrabMixin;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.disposeMap = exports.getTempMap = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(121);
	
	__webpack_require__(218);
	
	__webpack_require__(222);
	
	__webpack_require__(219);
	
	__webpack_require__(221);
	
	__webpack_require__(120);
	
	__webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTempMap(zoom, fullSize, pixelBounds) {
	    var container = _leaflet2.default.DomUtil.create('div', '', document.body);
	    var width = void 0,
	        height = void 0,
	        center = void 0;
	    if (fullSize) {
	        var size = pixelBounds.getSize();
	        width = size.x;
	        height = size.y;
	        center = pixelBounds.min.add(size.divideBy(2));
	        center = _leaflet2.default.CRS.EPSG3857.pointToLatLng(center, zoom);
	    } else {
	        width = 100;
	        height = 100;
	        center = _leaflet2.default.latLng(0, 0);
	    }
	
	    Object.assign(container.style, {
	        width: width + 'px',
	        height: height + 'px',
	        position: 'absolute',
	        left: '0',
	        top: '0',
	        visibility: 'hidden'
	    });
	
	    var map = _leaflet2.default.map(container, { fadeAnimation: false, zoomAnimation: false, inertia: false, maxZoom: 18 });
	    map.setView(center, zoom);
	    return map;
	}
	
	function disposeMap(map) {
	    var container = map._container;
	    map.remove();
	    _leaflet2.default.DomUtil.remove(container);
	}
	
	exports.getTempMap = getTempMap;
	exports.disposeMap = disposeMap;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(466);
	
	__webpack_require__(216);
	
	var _westraPassesMarkers = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Layer.WestraPasses = _leaflet2.default.Layer.extend({
	    options: {
	        fileRegions1: 'westra_regions_geo1.json',
	        fileRegions2: 'westra_regions_geo2.json',
	        scaleDependent: true
	    },
	
	    initialize: function initialize(baseUrl, options) {
	        _leaflet2.default.setOptions(this, options);
	        this.markers = new _westraPassesMarkers.WestraPassesMarkers(baseUrl);
	        this.regions1 = new _leaflet2.default.Layer.GeoJSONAjax(baseUrl + this.options.fileRegions1, {
	            className: 'westra-region-polygon',
	            onEachFeature: this._setRegionLabel.bind(this, 'regions1')
	        });
	        this.regions2 = new _leaflet2.default.Layer.GeoJSONAjax(baseUrl + this.options.fileRegions2, {
	            className: 'westra-region-polygon',
	            onEachFeature: this._setRegionLabel.bind(this, 'regions2')
	        });
	    },
	
	    _setRegionLabel: function _setRegionLabel(layerName, feature, layer) {
	        var latlon = layer.getBounds().getCenter();
	        var icon = _leaflet2.default.divIcon({
	            className: 'westra-region-label',
	            html: '<span>' + feature.properties.name + '</span>'
	        });
	        var labelMarker = _leaflet2.default.marker(latlon, { icon: icon });
	        this[layerName].addLayer(labelMarker);
	        function zoomToRegion() {
	            this._map.fitBounds(layer.getBounds());
	        }
	
	        layer.on('click', zoomToRegion, this);
	        labelMarker.on('click', zoomToRegion, this);
	    },
	
	    setLayersVisibility: function setLayersVisibility(e) {
	        if (!this._map) {
	            return;
	        }
	        var newZoom;
	        var zoomFinished = e ? e.type !== 'zoomanim' : true;
	        if (e && e.zoom !== undefined) {
	            newZoom = e.zoom;
	        } else {
	            newZoom = this._map.getZoom();
	        }
	        if (newZoom < 2) {
	            this._map.removeLayer(this.markers);
	            this._map.removeLayer(this.regions1);
	            this._map.removeLayer(this.regions2);
	        } else if (newZoom < 7) {
	            this._map.removeLayer(this.markers);
	            this._map.addLayer(this.regions1);
	            this._map.removeLayer(this.regions2);
	        } else if (newZoom < 10) {
	            this._map.removeLayer(this.regions1);
	            this._map.addLayer(this.regions2);
	            this._map.removeLayer(this.markers);
	        } else {
	            if (zoomFinished) {
	                this._map.addLayer(this.markers);
	            }
	            this._map.removeLayer(this.regions1);
	            this._map.removeLayer(this.regions2);
	        }
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        this.markers.loadData();
	        this.regions1.loadData();
	        this.regions2.loadData();
	        this.setLayersVisibility();
	        map.on('zoomend', this.setLayersVisibility, this);
	        map.on('zoomanim', this.setLayersVisibility, this);
	    },
	
	    onRemove: function onRemove() {
	        this._map.removeLayer(this.markers);
	        this._map.removeLayer(this.regions1);
	        this._map.removeLayer(this.regions2);
	        this._map.off('zoomend', this.setLayersVisibility, this);
	        this._map.off('zoomanim', this.setLayersVisibility, this);
	        this._map = null;
	    }
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WestraPassesMarkers = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(62);
	
	var _popupWindow = __webpack_require__(128);
	
	var _escapeHtml = __webpack_require__(164);
	
	var _escapeHtml2 = _interopRequireDefault(_escapeHtml);
	
	var _browserFilesaver = __webpack_require__(64);
	
	var _iconFromBackgroundImage = __webpack_require__(112);
	
	var _iconFromBackgroundImage2 = _interopRequireDefault(_iconFromBackgroundImage);
	
	var _xhrPromise = __webpack_require__(24);
	
	var _notifications = __webpack_require__(35);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WestraPassesMarkers = _leaflet2.default.Layer.CanvasMarkers.extend({
	    options: {
	        filePasses: 'westra_passes.json',
	        scaleDependent: true
	    },
	
	    initialize: function initialize(baseUrl, options) {
	        _leaflet2.default.Layer.CanvasMarkers.prototype.initialize.call(this, null, options);
	        this.on('markerclick', this.showPassDescription, this);
	        this._baseUrl = baseUrl;
	        this.url = baseUrl + this.options.filePasses;
	    },
	
	    loadData: function loadData() {
	        var _this = this;
	
	        if (this._downloadStarted) {
	            return;
	        }
	        this._downloadStarted = true;
	        (0, _xhrPromise.fetch)(this.url).then(function (xhr) {
	            return _this._loadMarkers(xhr);
	        }, function (e) {
	            _this._downloadStarted = false;
	            _logging2.default.captureException(e, {
	                extra: {
	                    description: 'failed to get westra passes',
	                    url: _this.url,
	                    status: e.xhr.status
	                }
	            });
	            (0, _notifications.notify)('Failed to get Westra passes data');
	        });
	    },
	
	    onAdd: function onAdd(map) {
	        _leaflet2.default.Layer.CanvasMarkers.prototype.onAdd.call(this, map);
	        this.loadData();
	    },
	
	    _makeTooltip: function _makeTooltip(marker) {
	        var properties = marker.properties,
	            toolTip = properties.grade || '';
	        if (toolTip && properties.elevation) {
	            toolTip += ', ';
	        }
	        toolTip += properties.elevation || '';
	        if (toolTip) {
	            toolTip = ' (' + toolTip + ')';
	        }
	        toolTip = (properties.name || 'без названия') + toolTip;
	        toolTip = (properties.is_summit ? 'Вершина ' : 'Перевал ') + toolTip;
	        return toolTip;
	    },
	
	    _passToGpx: function _passToGpx(marker) {
	        var label = marker.tooltip;
	        if (typeof label === 'function') {
	            label = label(marker);
	        }
	        label = (0, _escapeHtml2.default)(label);
	        var gpx = '\n                <?xml version="1.0" encoding="UTF-8" standalone="no" ?>\n                <gpx xmlns="http://www.topografix.com/GPX/1/1" creator="http://nakarte.tk" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd">\n                    <wpt lat="' + marker.latlng.lat.toFixed(6) + '" lon="' + marker.latlng.lng.toFixed(6) + '">\n                        <name>' + label + '</name>\n                    </wpt>\n                </gpx>\n            ';
	        var filename = marker.properties.name || 'Без названия';
	        (0, _browserFilesaver.saveAs)(new Blob([gpx], { type: 'application/gpx+xml' }), filename + '.gpx', true);
	    },
	
	    _passToKml: function _passToKml(marker) {
	        var label = marker.tooltip;
	        if (typeof label === 'function') {
	            label = label(marker);
	        }
	        label = (0, _escapeHtml2.default)(label);
	        var kml = '\n                <?xml version="1.0" encoding="UTF-8"?>\n                <kml xmlns="http://www.opengis.net/kml/2.2">\n                    <Placemark>\n                        <name>' + label + '</name>\n                        <Point>\n                            <coordinates>\n                                ' + marker.latlng.lng.toFixed(6) + ',' + marker.latlng.lat.toFixed(6) + ',0\n                            </coordinates>\n                        </Point>\n                    </Placemark>\n                </kml>\n            ';
	        var filename = marker.properties.name || 'Без названия';
	        (0, _browserFilesaver.saveAs)(new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' }), filename + '.kml', true);
	    },
	
	    _makeIcon: function _makeIcon(marker) {
	        var className;
	        className = 'westra-pass-marker ';
	        if (marker.properties.is_summit) {
	            className += 'westra-pass-marker-summit';
	        } else {
	            className += 'westra-pass-marker-' + marker.properties.grade_eng;
	        }
	        return (0, _iconFromBackgroundImage2.default)(className);
	    },
	
	    _loadMarkers: function _loadMarkers(xhr) {
	        var markers = [],
	            features = JSON.parse(xhr.response),
	            feature,
	            i,
	            marker;
	        for (i = 0; i < features.length; i++) {
	            feature = features[i];
	            marker = {
	                latlng: {
	                    lat: feature.latlon[0],
	                    lng: feature.latlon[1]
	                },
	                label: feature.name || "",
	                icon: this._makeIcon,
	                tooltip: this._makeTooltip.bind(this),
	                properties: feature
	            };
	            markers.push(marker);
	        }
	        this.addMarkers(markers);
	        this._dataLoaded = true;
	        this.fire('data-loaded');
	    },
	
	    showPassDescription: function showPassDescription(e) {
	        if (!this._map) {
	            return;
	        }
	        var properties = e.marker.properties,
	            latLng = e.marker.latlng,
	            url = 'http://westra.ru/passes/Passes/' + properties.id;
	        var altnames = '',
	            connects = '',
	            comments = '';
	        if (properties.altnames) {
	            altnames = '\n                    <tr>\n                        <td>\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F</td>\n                        <td>' + properties.altnames + '</td>\n                    </tr>';
	        }
	
	        if (!properties.is_summit) {
	            connects = '\n                    <tr>\n                        <td>\u0421\u043E\u0435\u0434\u0438\u043D\u044F\u0435\u0442</td>\n                        <td>' + (properties.connects || "неизвестнo") + '</td>\n                    </tr>';
	        }
	
	        if (properties.comments) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	
	                for (var _iterator = properties.comments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var comment = _step.value;
	
	                    var user = '';
	                    if (comment.user) {
	                        user = '<span class="westra-passes-description-comment-author">' + comment.user + ':</span>';
	                    }
	                    comments += '<p class="westra-passes-description-comment">' + user + comment.content + '</p>';
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            comments = '\n                    <tr>\n                        <td>\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438</td>\n                        <td>' + comments + '</td>\n                    </tr>';
	        }
	
	        var description = '\n                <table class="pass-details">\n                    <tr>\n                        <td>' + (properties.is_summit ? 'Вершина ' : 'Перевал ') + '</td>\n                        <td>' + (properties.name || 'название неизвестно') + '</td>\n                    </tr>\n                    ' + altnames + '\n                    <tr>\n                        <td>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F</td>\n                        <td>' + (properties.grade || "неизвестная") + '</td>\n                    </tr>\n                    <tr>\n                        <td>\u0412\u044B\u0441\u043E\u0442\u0430</td>\n                        <td>' + (properties.elevation ? properties.elevation + ' м' : 'неизвестная') + '</td>\n                    </tr>\n                    ' + connects + '\n                    <tr>\n                        <td>\u0425\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430 \u0441\u043A\u043B\u043E\u043D\u043E\u0432</td>\n                        <td>' + (properties.slopes || "неизвестная") + '</td>\n                    </tr>\n                    <tr>\n                        <td>\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B</td>\n                        <td>\n                            <table class="westra-passes-description-coords">\n                                <tr>\n                                    <td>\u0428\u0438\u0440\u043E\u0442\u0430</td>\n                                    <td>\u0414\u043E\u043B\u0433\u043E\u0442\u0430</td>\n                                </tr>\n                                <tr>\n                                    <td>' + latLng.lat.toFixed(5) + '</td>\n                                    <td>' + latLng.lng.toFixed(5) + '</td>\n                                    <td><a id="westra-pass-gpx" title="\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C">gpx</a></td>\n                                    <td><a id="westra-pass-kml" title="\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C">kml</a></td>\n                                </tr>\n                            </table>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\u041D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0412\u0435\u0441\u0442\u0440\u044B</td>\n                        <td><a id="westra-pass-link" href="' + url + '">' + url + '</a></td></tr>\n                    <tr>\n                        <td>\u0414\u043E\u0431\u0430\u0432\u0438\u043B</td>\n                        <td>' + (properties.author || "неизвестно") + '</td>\n                    </tr>\n                    ' + comments + '\n                </table>';
	        this._map.openPopup(description, latLng, { maxWidth: 500 });
	        document.getElementById('westra-pass-link').onclick = function () {
	            (0, _popupWindow.openPopupWindow)(url, 780, 'westra-details');
	            return false;
	        };
	        document.getElementById('westra-pass-gpx').onclick = function () {
	            this._passToGpx(e.marker);
	            return false;
	        }.bind(this);
	        document.getElementById('westra-pass-kml').onclick = function () {
	            this._passToKml(e.marker);
	            return false;
	        }.bind(this);
	    }
	});
	
	exports.WestraPassesMarkers = WestraPassesMarkers;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var yandexCrs = _leaflet2.default.CRS.EPSG3395;
	
	_leaflet2.default.Layer.Yandex = _leaflet2.default.TileLayer.extend({
	    options: {
	        subdomains: '1234',
	        className: _leaflet2.default.Browser.retina ? '' : 'yandex-tile-layer',
	        yandexScale: _leaflet2.default.Browser.retina ? 2 : 1
	    },
	
	    initialize: function initialize(mapType, options) {
	        var url = void 0;
	        this._mapType = mapType;
	        if (mapType === 'sat') {
	            url = 'https://sat0{s}.maps.yandex.net/tiles?l=sat&x={x}&y={y}&z={z}';
	        } else {
	            url = 'https://vec0{s}.maps.yandex.net/tiles?l=map&x={x}&y={y}&z={z}&scale={yandexScale}';
	        }
	
	        _leaflet2.default.TileLayer.prototype.initialize.call(this, url, options);
	    },
	
	    _getTilePos: function _getTilePos(coords) {
	        var tilePosLatLng = yandexCrs.pointToLatLng(coords.scaleBy(this.getTileSize()), coords.z);
	        return this._map.project(tilePosLatLng, coords.z).subtract(this._level.origin).round();
	    },
	
	    _pxBoundsToTileRange: function _pxBoundsToTileRange(bounds) {
	        var zoom = this._tileZoom;
	        var bounds2 = new _leaflet2.default.Bounds(yandexCrs.latLngToPoint(this._map.unproject(bounds.min, zoom), zoom), yandexCrs.latLngToPoint(this._map.unproject(bounds.max, zoom), zoom));
	        return _leaflet2.default.TileLayer.prototype._pxBoundsToTileRange.call(this, bounds2);
	    },
	
	    createTile: function createTile(coords, done) {
	        var tile = _leaflet2.default.TileLayer.prototype.createTile.call(this, coords, done);
	        var coordsBelow = _leaflet2.default.point(coords).add([0, 1]);
	        coordsBelow.z = coords.z;
	        tile._adjustHeight = this._getTilePos(coordsBelow).y - this._getTilePos(coords).y;
	        return tile;
	    },
	
	    _initTile: function _initTile(tile) {
	        _leaflet2.default.TileLayer.prototype._initTile.call(this, tile);
	        tile.style.height = tile._adjustHeight + 'px';
	    }
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pointOnSegmentAtDistance(p1, p2, dist) {
	    //FIXME: we should place markers along projected line to avoid transformation distortions
	    var q = dist / p1.distanceTo(p2),
	        x = p1.lng + (p2.lng - p1.lng) * q,
	        y = p1.lat + (p2.lat - p1.lat) * q;
	    return _leaflet2.default.latLng(y, x);
	}
	
	function sinCosFromLatLonSegment(segment) {
	    var p1 = _leaflet2.default.CRS.EPSG3857.project(segment[0]),
	        p2 = _leaflet2.default.CRS.EPSG3857.project(segment[1]),
	        dx = p2.x - p1.x,
	        dy = p1.y - p2.y,
	        len = Math.sqrt(dx * dx + dy * dy),
	        sin = dy / len,
	        cos = dx / len;
	    return [sin, cos];
	}
	
	_leaflet2.default.MeasuredLine = _leaflet2.default.Polyline.extend({
	    options: {
	        minTicksIntervalMm: 15
	    },
	
	    onAdd: function onAdd(map) {
	        _leaflet2.default.Polyline.prototype.onAdd.call(this, map);
	        this._ticks = {};
	        this.updateTicks();
	        this._map.on('zoomend', this.updateTicks, this);
	        this._map.on('dragend', this.updateTicks, this);
	        this.on('nodeschanged', this.updateTicksLater, this);
	    },
	
	    updateTicksLater: function updateTicksLater() {
	        setTimeout(this.updateTicks.bind(this), 0);
	    },
	
	    onRemove: function onRemove(map) {
	        this._map.off('zoomend', this.updateTicks, this);
	        this._map.off('dragend', this.updateTicks, this);
	        this.off('nodeschanged', this.updateTicks, this);
	        this._clearTicks();
	        _leaflet2.default.Polyline.prototype.onRemove.call(this, map);
	    },
	
	    _clearTicks: function _clearTicks() {
	        var _this = this;
	
	        if (this._map) {
	            Object.values(this._ticks).forEach(function (tick) {
	                return _this._map.removeLayer(tick);
	            });
	            this._ticks = {};
	        }
	    },
	
	    _addTick: function _addTick(tick, marker) {
	        var transformMatrixString = 'matrix(' + tick.transformMatrix.join(',') + ')';
	        if (marker) {
	            marker._icon.childNodes[0].style.transform = transformMatrixString;
	            marker.setLatLng(tick.position);
	        } else {
	            var labelText = Math.round(tick.distanceValue / 10) / 100 + ' km',
	                icon = _leaflet2.default.divIcon({
	                html: '<div class="measure-tick-icon-text" style="transform:' + transformMatrixString + '">' + labelText + '</div>',
	                className: 'measure-tick-icon'
	            });
	            marker = _leaflet2.default.marker(tick.position, { icon: icon, interactive: false, keyboard: false });
	            marker.addTo(this._map);
	        }
	        this._ticks[tick.distanceValue.toString()] = marker;
	    },
	
	    setMeasureTicksVisible: function setMeasureTicksVisible(visible) {
	        this.options.measureTicksShown = visible;
	        this.updateTicks();
	    },
	
	    getTicksPositions: function getTicksPositions(minTicksIntervalMeters, bounds) {
	        var steps = [500, 1000, 2000, 5000, 10000, 20000, 50000, 100000, 200000, 500000, 1000000];
	        var ticks = [];
	
	        function addTick(position, segment, distanceValue) {
	            if (bounds && !bounds.contains(position)) {
	                return;
	            }
	            var sinCos = sinCosFromLatLonSegment(segment),
	                sin = sinCos[0],
	                cos = sinCos[1],
	                transformMatrix;
	
	            if (sin > 0) {
	                transformMatrix = [sin, -cos, cos, sin, 0, 0];
	            } else {
	                transformMatrix = [-sin, cos, -cos, -sin, 0, 0];
	            }
	            ticks.push({ position: position, distanceValue: distanceValue, transformMatrix: transformMatrix });
	        }
	
	        var step = void 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = steps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                step = _step.value;
	
	                if (step >= minTicksIntervalMeters) {
	                    break;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        var lastTickMeasure = 0,
	            lastPointMeasure = 0,
	            points = this._latlngs,
	            points_n = points.length,
	            nextPointMeasure,
	            segmentLength;
	        if (points_n < 2) {
	            return ticks;
	        }
	
	        for (var i = 1; i < points_n; i++) {
	            segmentLength = points[i].distanceTo(points[i - 1]);
	            nextPointMeasure = lastPointMeasure + segmentLength;
	            if (nextPointMeasure >= lastTickMeasure + step) {
	                while (lastTickMeasure + step <= nextPointMeasure) {
	                    lastTickMeasure += step;
	                    addTick(pointOnSegmentAtDistance(points[i - 1], points[i], lastTickMeasure - lastPointMeasure), [points[i - 1], points[i]], lastTickMeasure);
	                }
	            }
	            lastPointMeasure = nextPointMeasure;
	        }
	        if (lastPointMeasure > minTicksIntervalMeters / 2) {
	            addTick(points[0], [points[0], points[1]], 0);
	            addTick(points[points_n - 1], [points[points_n - 2], points[points_n - 1]], lastPointMeasure);
	        }
	        return ticks;
	    },
	
	    updateTicks: function updateTicks() {
	        var _this2 = this;
	
	        if (!this._map) {
	            return;
	        }
	        if (!this.options.measureTicksShown) {
	            this._clearTicks();
	            return;
	        }
	        var bounds = this._map.getBounds().pad(1),
	            rad = Math.PI / 180,
	            dpi = 96,
	            mercatorMetersPerPixel = 20003931 / this._map.project([180, 0]).x,
	            referencePoint = this.getLatLngs().length ? this.getBounds().getCenter() : this._map.getCenter(),
	            realMetersPerPixel = mercatorMetersPerPixel * Math.cos(referencePoint.lat * rad),
	            mapScale = 1 / dpi * 2.54 / 100 / realMetersPerPixel,
	            minTicksIntervalMeters = this.options.minTicksIntervalMm / mapScale / 1000,
	            ticks = this.getTicksPositions(minTicksIntervalMeters, bounds),
	            oldTicks = this._ticks;
	        this._ticks = {};
	        ticks.forEach(function (tick) {
	            var oldMarker = oldTicks[tick.distanceValue.toString()];
	            this._addTick(tick, oldMarker);
	            if (oldMarker) {
	                delete oldTicks[tick.distanceValue.toString()];
	            }
	        }.bind(this));
	        Object.values(oldTicks).forEach(function (tick) {
	            return _this2._map.removeLayer(tick);
	        });
	    },
	
	    getLength: function getLength() {
	        var points = this._latlngs,
	            points_n = points.length,
	            length = 0;
	
	        for (var i = 1; i < points_n; i++) {
	            length += points[i].distanceTo(points[i - 1]);
	        }
	        return length;
	    }
	});
	
	_leaflet2.default.measuredLine = function (latlngs, options) {
	    return new _leaflet2.default.MeasuredLine(latlngs, options);
	};

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDeclination = undefined;
	
	var _declination = __webpack_require__(473);
	
	var _declination2 = _interopRequireDefault(_declination);
	
	var _binaryStrings = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = void 0;
	
	function mod(x, n) {
	    return (x % n + n) % n;
	}
	
	function loadData() {
	    var ar1 = new Uint8Array((0, _binaryStrings.stringToArrayBuffer)(atob(_declination2.default.array)));
	    var ar2 = new Float32Array(ar1.length);
	    var scale = _declination2.default.valueScale;
	    var offset = _declination2.default.valueOffset;
	    for (var i = 0; i < ar1.length; i++) {
	        ar2[i] = ar1[i] / scale - offset;
	    }
	    return ar2;
	}
	
	function getArrayValue(row, col) {
	    if (row < 0 || col < 0 || col >= _declination2.default.colsCount || row >= _declination2.default.rowsCount) {
	        throw new Error('Invalid col/row value col=' + col + ' row=' + row);
	    }
	    var ind = row * _declination2.default.colsCount + col;
	    if (ind >= data.length) {
	        throw new Error('Index value out of range');
	    }
	    return data[ind];
	}
	
	function getDeclination(lat, lon) {
	    if (lat < _declination2.default.minLat || lat > _declination2.default.maxLat) {
	        return null;
	    }
	    lon = mod(lon + 180, 360) - 180;
	    var row1 = Math.floor((lat - _declination2.default.minLat) / _declination2.default.step);
	    var row2 = row1 + 1;
	    var dlat = (lat - (row1 * _declination2.default.step + _declination2.default.minLat)) / _declination2.default.step;
	    var col1 = Math.floor((lon + 180) / _declination2.default.step);
	    var col2 = col1 + 1;
	    var dlon = (lon - (col1 * _declination2.default.step - 180)) / _declination2.default.step;
	    col1 %= _declination2.default.colsCount;
	    col2 %= _declination2.default.colsCount;
	    var a1 = getArrayValue(row1, col1);
	    var a2 = getArrayValue(row1, col2);
	    var v1 = a1 * (1 - dlon) + a2 * dlon;
	    if (row2 >= _declination2.default.rowsCount) {
	        return v1;
	    }
	    a1 = getArrayValue(row2, col1);
	    a2 = getArrayValue(row2, col2);
	    var v2 = a1 * (1 - dlon) + a2 * dlon;
	    var v = v1 * (1 - dlat) + v2 * dlat;
	    return v;
	}
	
	data = loadData();
	
	exports.getDeclination = getDeclination;

/***/ },
/* 128 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function openPopupWindow(url, width) {
	    var uniqName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    var left,
	        top,
	        height,
	        screenLeft = screen.availLeft || 0,
	        bordersWidth = 8;
	    // if browser window is in the right half of screen, place new window on left half
	    if (window.screenX - screenLeft - bordersWidth * 1.5 > width) {
	        left = window.screenX - width - bordersWidth * 1.5;
	        // if browser window is in the left half of screen, place new window on right half
	    } else if (window.screenX + window.outerWidth + width + bordersWidth * 1.5 < screenLeft + screen.availWidth) {
	        left = window.screenX + window.outerWidth + bordersWidth;
	        // if screen is small or browser window occupies whole screen, place new window on top of current window
	    } else {
	        left = window.screenX + window.outerWidth / 2 - width / 2;
	        if (left < 0) {
	            left = 0;
	        }
	    }
	    top = window.screenY;
	    height = window.innerHeight;
	    var features = 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;
	    features += ',resizable,scrollbars';
	    window.open(url, uniqName, features).focus();
	}
	
	exports.openPopupWindow = openPopupWindow;

/***/ },
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
437,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(438);
	
	__webpack_require__(441);
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(437);
	
	__webpack_require__(200);
	
	__webpack_require__(179);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(180);
	
	var _leafletControlLayers = __webpack_require__(115);
	
	var _leafletControlLayers2 = _interopRequireDefault(_leafletControlLayers);
	
	__webpack_require__(215);
	
	__webpack_require__(214);
	
	var _leaflet3 = __webpack_require__(213);
	
	__webpack_require__(439);
	
	__webpack_require__(191);
	
	__webpack_require__(82);
	
	__webpack_require__(207);
	
	__webpack_require__(210);
	
	__webpack_require__(211);
	
	var _leafletControlLayers3 = __webpack_require__(187);
	
	var _leafletControlLayers4 = _interopRequireDefault(_leafletControlLayers3);
	
	var _leafletControlLayers5 = __webpack_require__(190);
	
	var _leafletControlLayers6 = _interopRequireDefault(_leafletControlLayers5);
	
	var _leafletControlLayers7 = __webpack_require__(188);
	
	var _leafletControlLayers8 = _interopRequireDefault(_leafletControlLayers7);
	
	var _hashState = __webpack_require__(117);
	
	var _hashState2 = _interopRequireDefault(_hashState);
	
	var _leafletControls = __webpack_require__(212);
	
	var _leafletControls2 = _interopRequireDefault(_leafletControls);
	
	var _layers = __webpack_require__(175);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	__webpack_require__(189);
	
	__webpack_require__(183);
	
	__webpack_require__(182);
	
	__webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setUp() {
	    (0, _leaflet3.fixAll)();
	
	    var map = _leaflet2.default.map('map', {
	        zoomControl: false,
	        fadeAnimation: false,
	        attributionControl: false,
	        inertiaMaxSpeed: 1500,
	        worldCopyJump: true,
	        maxZoom: 18
	    });
	    map.enableHashState('m', [10, 55.75185, 37.61856]);
	
	    var tracklist = new _leaflet2.default.Control.TrackList();
	
	    /////////// controls top-left corner
	
	    new _leaflet2.default.Control.Caption('<a href="' + _config2.default.newsUrl + '">News</a> | <a href="mailto:' + _config2.default.email + '">nakarte@nakarte.tk</a>', {
	        position: 'topleft'
	    }).addTo(map);
	
	    new _leaflet2.default.Control.Scale({ imperial: false, position: 'topleft' }).addTo(map);
	
	    _leaflet2.default.control.zoom().addTo(map);
	
	    new _leaflet2.default.Control.TrackList.Ruler(tracklist).addTo(map);
	
	    var panoramas = new _leaflet2.default.Control.Panoramas(document.getElementById('street-view')).addTo(map).enableHashState('n2');
	    _leaflet2.default.Control.Panoramas.hashStateUpgrader(panoramas).enableHashState('n');
	
	    new _leaflet2.default.Control.Coordinates({ position: 'topleft' }).addTo(map);
	
	    var azimuthControl = new _leaflet2.default.Control.Azimuth({ position: 'topleft' }).addTo(map);
	
	    /////////// controls top-right corner
	
	    var layersControl = _leaflet2.default.control.layers(null, null, { collapsed: false }).addTo(map);
	    (0, _leafletControlLayers2.default)(layersControl);
	    (0, _leafletControlLayers4.default)(layersControl);
	    (0, _leafletControlLayers6.default)(layersControl);
	    (0, _leafletControlLayers8.default)(layersControl, (0, _layers2.default)());
	    layersControl.enableHashState('l');
	
	    /////////// controls bottom-left corner
	
	    var printControl = new _leaflet2.default.Control.PrintPages({ position: 'bottomleft' }).addTo(map).enableHashState('p');
	    if (!printControl.hasPages()) {
	        printControl.setMinimized();
	    }
	
	    new _leaflet2.default.Control.JNX(layersControl, { position: 'bottomleft' }).addTo(map).enableHashState('j');
	
	    /////////// controls bottom-right corner
	
	    tracklist.addTo(map);
	    if (!_hashState2.default.getState('nktk')) {
	        tracklist.loadTracksFromStorage();
	    }
	    tracklist.enableHashState('nktk');
	
	    ////////// adaptive layout
	
	    if (_leaflet2.default.Browser.mobile) {
	        layersControl.setMinimized();
	        if (!tracklist.hasTracks()) {
	            tracklist.setMinimized();
	        }
	    }
	
	    if (_leaflet2.default.Browser.mobile) {
	        map.on('mousedown dragstart', function () {
	            return layersControl.setMinimized();
	        });
	    }
	
	    (0, _leafletControls2.default)(map);
	
	    //////////// save state at unload
	
	    _leaflet2.default.DomEvent.on(window, 'beforeunload', function () {
	        return tracklist.saveTracksToStorage();
	    });
	
	    ////////// track list and azimuth measure interaction
	
	    tracklist.on('startedit', function () {
	        return azimuthControl.setEnabled(false);
	    });
	    tracklist.on('elevation-shown', function () {
	        return azimuthControl.hideProfile();
	    });
	    azimuthControl.on('enabled', function () {
	        tracklist.stopEditLine();
	    });
	    azimuthControl.on('elevation-shown', function () {
	        return tracklist.hideElevationProfile();
	    });
	}
	
	exports.default = { setUp: setUp };

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ravenJs = __webpack_require__(169);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	__webpack_require__(440);
	
	var _App = __webpack_require__(173);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-undef */
	if (("production") === 'production' && _config2.default.sentryDSN.length > 0) {
	    _ravenJs2.default.config(_config2.default.sentryDSN, { release: ("2017-10-12_16:20:04-master-a0e3125-dirty\n") }).install();
	    /* eslint-enable no-undef */
	}
	
	var oldOnunhandledrejection = window.onunhandledrejection;
	
	// Not using addEventListener due to https://github.com/zloirock/core-js/issues/205
	window.onunhandledrejection = function (e) {
	    var result = true;
	    if (oldOnunhandledrejection) {
	        result = oldOnunhandledrejection(e);
	    }
	    console.error('Uncaught in promise:', e.reason);
	    var err = e.reason;
	    if (err && err.name) {
	        err.name = 'Uncaught in promise: ' + err.name;
	    }
	    _ravenJs2.default.captureException(err);
	    return result;
	};
	
	/* eslint-disable no-undef */
	console.log('Version:', ("2017-10-12_16:20:04-master-a0e3125-dirty\n"));
	/* eslint-enable no-undef */
	
	_App2.default.setUp();

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = getLayers;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(125);
	
	__webpack_require__(119);
	
	__webpack_require__(118);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(224);
	
	__webpack_require__(123);
	
	__webpack_require__(217);
	
	__webpack_require__(225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLayers() {
	    var layers = [{
	        group: 'Default layers',
	        layers: [{
	            title: 'OpenStreetMap',
	            description: 'OSM default style',
	            order: 10,
	            isOverlay: false,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { code: 'O', scaleDependent: true, print: true, jnx: true })
	        }, {
	            title: 'ESRI Sat',
	            order: 20,
	            isOverlay: false,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { code: 'E', scaleDependent: false, maxNativeZoom: 17, print: true, jnx: true })
	        }, {
	            title: 'Yandex map',
	            order: 30,
	            isOverlay: false,
	            isDefault: true,
	            layer: new _leaflet2.default.Layer.Yandex('map', { scaleDependent: true, code: 'Y', print: true, jnx: true })
	        }, {
	            title: 'Yandex Satellite',
	            order: 40,
	            isOverlay: false,
	            isDefault: true,
	            layer: new _leaflet2.default.Layer.Yandex('sat', { scaleDependent: false, code: 'S', print: true, jnx: true })
	        }, {
	            title: 'Google',
	            order: 50,
	            isOverlay: false,
	            isDefault: true,
	            layer: new _leaflet2.default.Layer.Google('ROADMAP', { code: 'G', scaleDependent: true, print: true, jnx: true })
	        }, {
	            title: 'Google Satellite',
	            order: 60,
	            isOverlay: false,
	            isDefault: true,
	            layer: new _leaflet2.default.Layer.Google('SATELLITE', { code: 'L', scaleDependent: false, print: true, jnx: true })
	        }, {
	            title: 'Google Terrain',
	            order: 65,
	            isOverlay: false,
	            isDefault: true,
	            layer: new _leaflet2.default.Layer.Google('TERRAIN', { code: 'P', scaleDependent: false, print: true, jnx: true })
	        }, {
	            title: 'Bing Sat',
	            order: 70,
	            isOverlay: false,
	            isDefault: true,
	            layer: _leaflet2.default.bingLayer(_config2.default.bingKey, { code: 'I', scaleDependent: false, print: true, jnx: true })
	        }, {
	            title: 'marshruty.ru',
	            order: 80,
	            isOverlay: false,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer('http://maps.marshruty.ru/ml.ashx?x={x}&y={y}&z={z}&i=1&al=1', { code: 'M', maxNativeZoom: 18, noCors: true, scaleDependent: true, print: true, jnx: true })
	        }, {
	            title: 'Topomapper 1km',
	            order: 90,
	            isOverlay: false,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer('http://144.76.234.108/cgi-bin/tapp/tilecache.py/1.0.0/topomapper_v2/{z}/{x}/{y}.jpg', { code: 'T', scaleDependent: false, maxNativeZoom: 13, noCors: true, print: true, jnx: true })
	        }, {
	            title: 'Topo 10km',
	            order: 1010,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/topo001m/{z}/{x}/{y}", { code: 'D', tms: true, scaleDependent: false, maxNativeZoom: 9, print: true, jnx: true })
	        }, {
	            title: 'GGC 2 km',
	            order: 1020,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/ggc2000/{z}/{x}/{y}", { code: 'N', tms: true, scaleDependent: false, maxNativeZoom: 12, print: true, jnx: true })
	        }, {
	            title: 'ArbaletMO',
	            order: 1030,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/ArbaletMO/{z}/{x}/{y}", { code: 'A', tms: true, scaleDependent: false, maxNativeZoom: 13, print: true, jnx: true })
	        }, {
	            title: 'Slazav mountains',
	            order: 1040,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/map_hr/{z}/{x}/{y}", { code: 'Q', tms: true, scaleDependent: false, maxNativeZoom: 13, print: true, jnx: true })
	        }, {
	            title: 'GGC 1km',
	            order: 1050,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/ggc1000/{z}/{x}/{y}", { code: 'J', tms: true, scaleDependent: false, maxNativeZoom: 13, print: true, jnx: true })
	        }, {
	            title: 'Topo 1km',
	            order: 1060,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/topo1000/{z}/{x}/{y}", { code: 'C', tms: true, scaleDependent: false, maxNativeZoom: 13, print: true, jnx: true })
	        }, {
	            title: 'GGC 500m',
	            order: 1070,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/ggc500/{z}/{x}/{y}", { code: 'F', tms: true, scaleDependent: false, maxNativeZoom: 14, print: true, jnx: true })
	        }, {
	            title: 'Topo 500m',
	            order: 1080,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/topo500/{z}/{x}/{y}", { code: 'B', tms: true, scaleDependent: false, maxNativeZoom: 14, print: true, jnx: true })
	        }, {
	            title: 'GGC 250m',
	            order: 1090,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/ggc250/{z}/{x}/{y}", { code: 'K', tms: true, scaleDependent: false, maxNativeZoom: 15, print: true, jnx: true })
	        }, {
	            title: 'Slazav map',
	            order: 1100,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/map_podm/{z}/{x}/{y}", { code: 'Z', tms: true, scaleDependent: false, maxNativeZoom: 14, print: true, jnx: true })
	        }, {
	            title: 'O-sport',
	            order: 1110,
	            isOverlay: true,
	            isDefault: true,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/osport/{z}/{x}/{y}", { code: 'R', tms: true, scaleDependent: false, maxNativeZoom: 17, print: true, jnx: true })
	        }, {
	            title: 'Soviet topo maps grid',
	            order: 1120,
	            isOverlay: true,
	            isDefault: true,
	            layer: new _leaflet2.default.Layer.SovietTopoGrid({ code: 'Ng' })
	        }, {
	            title: 'Wikimapia',
	            order: 1130,
	            isOverlay: true,
	            isDefault: true,
	            layer: new _leaflet2.default.Wikimapia({ code: 'W' })
	        }, {
	            title: 'Mountain passes (Westra)',
	            order: 1140,
	            isOverlay: true,
	            isDefault: true,
	            layer: new _leaflet2.default.Layer.WestraPasses(_config2.default.westraDataBaseUrl, {
	                code: 'Wp',
	                print: true,
	                scaleDependent: true
	            })
	        }]
	    }, {
	        group: 'OpenStreetMap alternatives',
	        layers: [{
	            title: 'OpenTopoMap',
	            order: 11,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', { code: 'Otm', maxNativeZoom: 17, scaleDependent: true, print: true, jnx: true, noCors: true })
	        }, {
	            title: 'OpenCycleMap',
	            description: '<a href="https://www.opencyclemap.org/docs/">(Info and key)</a>',
	            order: 12,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer('http://{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=' + _config2.default.thunderforestKey, { code: 'Ocm', scaleDependent: true, print: true, jnx: true })
	        }, {
	            title: 'OSM Outdoors',
	            order: 13,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer('http://{s}.tile.thunderforest.com/outdoors/{z}/{x}/{y}.png?apikey=' + _config2.default.thunderforestKey, { code: 'Oso', scaleDependent: true, print: true, jnx: true })
	        }]
	    }, {
	        group: 'Topo maps',
	        layers: [{
	            title: 'Eurasia 25km',
	            description: '1975-80',
	            order: 1009,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/eurasia25km/{z}/{x}/{y}", { code: 'E25m', tms: true, maxNativeZoom: 9, print: true, jnx: true, scaleDependent: false })
	        }, {
	            title: 'Caucasus 1km',
	            order: 1061,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/new_gsh_100k/{z}/{x}/{y}", { code: 'NT1', tms: true, maxNativeZoom: 14, print: true, jnx: true, scaleDependent: false })
	        }, {
	            title: 'Caucasus 500m',
	            order: 1081,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/new_gsh_050k/{z}/{x}/{y}", { code: 'NT5', tms: true, maxNativeZoom: 15, print: true, jnx: true, scaleDependent: false })
	        }, {
	            title: 'Topo 250m',
	            order: 1095,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/topo250/{z}/{x}/{y}", { code: 'T25', tms: true, maxNativeZoom: 15, print: true, jnx: true, scaleDependent: false })
	        }, {
	            title: 'Montenegro topo 250m',
	            description: '1970-72',
	            order: 1096,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("http://{s}.tiles.nakarte.tk/montenegro250m/{z}/{x}/{y}", { code: 'MN25', tms: true, maxNativeZoom: 15, print: true, jnx: true, scaleDependent: false })
	        }]
	    }, {
	        group: 'Mountains maps',
	        layers: [{
	            title: 'Mountains by Aleksey Tsvetkov',
	            description: 'Tian Shan, Dzungaria, <a href="http://pereval.g-utka.ru/">http://pereval.g-utka.ru/</a>',
	            order: 1039,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("http://map.g-utka.ru/{z}/{x}/{y}.png",
	            // FIXME: сделать minZoom=5, когда перейдём на версию leaflet с поддержкой minNativeZoom
	            {
	                code: 'Mt',
	                tms: false,
	                minZoom: 7,
	                minNativeZoom: 7,
	                maxNativeZoom: 15,
	                print: true,
	                jnx: true,
	                scaleDependent: false,
	                noCors: true
	            })
	        }]
	    }, {
	        group: 'Norway <a href="https://www.ut.no/kart/">https://www.ut.no/kart/</a>',
	        layers: [{
	            // Вместо 404 отдают 500 для отсутствующих тайлов
	            title: 'Norway UT map',
	            order: 500,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://tilesprod.ut.no/tilestache/ut_topo_light/{z}/{x}/{y}.jpg", { code: 'Nu', tms: false, maxNativeZoom: 16, print: true, jnx: true, scaleDependent: true, noCors: true })
	        }, {
	            title: 'Norway paper map',
	            order: 1031,
	            isOverlay: true,
	            isDefault: false,
	            layer: new _leaflet2.default.TileLayer.Nordeskart('http://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=toporaster3&zoom={z}&x={x}&y={y}&gkt={baatToken}', { code: 'Np', maxNativeZoom: 16, tms: false, print: true, jnx: true, scaleDependent: true })
	        }, {
	            title: 'Norway map',
	            order: 1032,
	            isOverlay: true,
	            isDefault: false,
	            layer: new _leaflet2.default.TileLayer.Nordeskart('http://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=topo2&zoom={z}&x={x}&y={y}&gkt={baatToken}', { code: 'Nm', tms: false, print: true, jnx: true, scaleDependent: true })
	        }, {
	            title: 'Norway summer trails',
	            order: 2000,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://tilesprod.ut.no/tilestache/dnt_sommer/{z}/{x}/{y}.png", { code: 'Ns', tms: false, print: true, jnx: true, scaleDependent: true, noCors: true })
	        }, {
	            title: 'Norway winter trails',
	            order: 2001,
	            isOverlay: true,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://tilesprod.ut.no/tilestache/dnt_vinter/{z}/{x}/{y}.png", { code: 'Nw', tms: false, print: true, jnx: true, scaleDependent: true, noCors: true })
	        }, {
	            // Вместо 404 отдают 500 для отсутствующих тайлов
	            title: 'Norway roads',
	            description: '<a href="http://kart.finn.no/">http://kart.finn.no/</a>',
	            order: 503,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("http://maptiles1.finncdn.no/tileService/1.0.3/normap/{z}/{x}/{y}.png", { code: 'Nr', tms: false, print: true, jnx: true, scaleDependent: true, noCors: true })
	        }]
	    }, {
	        group: 'Czech <a href="http://mapy.cz">http://mapy.cz</a>',
	        layers: [{
	            title: 'Czech basic',
	            order: 504,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://m{s}.mapserver.mapy.cz/base-m/{z}-{x}-{y}", { code: 'Czb', tms: false, print: true, jnx: true, subdomains: '1234', scaleDependent: true })
	        }, {
	            title: 'Czhch tourist',
	            order: 505,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://m{s}.mapserver.mapy.cz/wturist-m/{z}-{x}-{y}", { code: 'Czt', tms: false, print: true, jnx: true, subdomains: '1234', scaleDependent: true })
	        }, {
	            title: 'Czech summer',
	            order: 506,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://m{s}.mapserver.mapy.cz/turist_aquatic-m/{z}-{x}-{y}", { code: 'Czs', tms: false, print: true, jnx: true, subdomains: '1234', scaleDependent: true })
	        }, {
	            title: 'Czech winter',
	            order: 507,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://m{s}.mapserver.mapy.cz/wturist_winter-m/{z}-{x}-{y}", { code: 'Czw', tms: false, print: true, jnx: true, subdomains: '1234', scaleDependent: true })
	        }, {
	            title: 'Czech geographical',
	            order: 508,
	            isOverlay: false,
	            isDefault: false,
	            layer: _leaflet2.default.tileLayer("https://m{s}.mapserver.mapy.cz/zemepis-m/{z}-{x}-{y}", { code: 'Czg', tms: false, print: true, jnx: true, subdomains: '1234', scaleDependent: true })
	        }]
	    }];
	    // TODO: move it to tests
	    var codes = {};
	    var orders = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var group = _step.value;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = group.layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var layer = _step2.value;
	
	                    if (!layer.layer.options) {
	                        throw new Error('Layer without options: ' + layer.title);
	                    }
	                    var code = layer.layer.options.code;
	                    if (!code) {
	                        throw new Error('Layer without code: ' + layer.title);
	                    }
	                    if (code in codes) {
	                        throw new Error('Duplicate layer code "' + code + '"');
	                    }
	                    codes[code] = 1;
	                    var order = layer.order;
	                    if (!order) {
	                        throw new Error('Layer without order: ' + layer.title);
	                    }
	                    if (order in orders) {
	                        throw new Error('Duplicate layer order "' + order + '"');
	                    }
	                    orders[order] = 1;
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return layers;
	}
	// import 'lib/leaflet.layer.tracks-collection';

/***/ },
/* 176 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cache = function () {
	    function Cache(maxSize) {
	        _classCallCheck(this, Cache);
	
	        this._maxSize = maxSize;
	        this._store = {};
	        this._size = 0;
	    }
	
	    _createClass(Cache, [{
	        key: "get",
	        value: function get(key) {
	            if (key in this._store) {
	                var value = this._store[key];
	                delete this._store[key];
	                this._store[key] = value;
	                return { value: value, found: true };
	            }
	            return { found: false };
	        }
	    }, {
	        key: "put",
	        value: function put(key, value) {
	            if (key in this._store) {
	                delete this._store[key];
	            } else {
	                this._size += 1;
	            }
	            this._store[key] = value;
	            if (this._size > this._maxSize) {
	                delete this._store[Object.keys(this._store)[0]];
	                this._size -= 1;
	            }
	        }
	    }]);
	
	    return Cache;
	}();
	
	exports.Cache = Cache;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.readFiles = exports.readFile = exports.selectFiles = undefined;
	
	var _binaryStrings = __webpack_require__(50);
	
	var selectFiles = function () {
	    var fileInput = void 0;
	    return function selectFiles() {
	        var multiple = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (fileInput) {
	            document.body.removeChild(fileInput);
	        }
	        fileInput = document.createElement('input');
	        document.body.appendChild(fileInput);
	        fileInput.type = 'file';
	        fileInput.multiple = !!multiple;
	        fileInput.style.display = 'none';
	
	        var result = new Promise(function (resolve) {
	            fileInput.addEventListener('change', function () {
	                resolve(fileInput.files);
	            });
	        });
	        fileInput.click();
	        return result;
	    };
	}();
	
	function readFile(file) {
	    return new Promise(function (resolve) {
	        var reader = new FileReader();
	        reader.onload = function (e) {
	            resolve({
	                data: (0, _binaryStrings.arrayBufferToString)(e.target.result),
	                filename: file.name
	            });
	        };
	        reader.readAsArrayBuffer(file);
	    });
	}
	
	function readFiles(files) {
	    files = Array.prototype.slice.apply(files);
	    return Promise.all(files.map(readFile));
	}
	
	exports.selectFiles = selectFiles;
	exports.readFile = readFile;
	exports.readFiles = readFiles;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _knockout = __webpack_require__(474);
	
	var _knockout2 = _interopRequireDefault(_knockout);
	
	__webpack_require__(31);
	
	var _control = __webpack_require__(486);
	
	var _control2 = _interopRequireDefault(_control);
	
	__webpack_require__(38);
	
	__webpack_require__(445);
	
	var _magneticDeclination = __webpack_require__(127);
	
	__webpack_require__(232);
	
	var _pointer = __webpack_require__(505);
	
	var _pointer2 = _interopRequireDefault(_pointer);
	
	var _pointerStart = __webpack_require__(504);
	
	var _pointerStart2 = _interopRequireDefault(_pointerStart);
	
	var _pointerEnd = __webpack_require__(503);
	
	var _pointerEnd2 = _interopRequireDefault(_pointerEnd);
	
	var _leafletControl = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function radians(x) {
	    return x / 180 * Math.PI;
	}
	
	function degrees(x) {
	    return x / Math.PI * 180;
	}
	
	function calcAzimuth(latlng1, latlng2) {
	    var lat1 = radians(latlng1.lat);
	    var lat2 = radians(latlng2.lat);
	    var lng1 = radians(latlng1.lng);
	    var lng2 = radians(latlng2.lng);
	
	    var y = Math.sin(lng2 - lng1) * Math.cos(lat2);
	    var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1);
	    var brng = Math.atan2(y, x);
	    brng = degrees(brng);
	    return brng;
	}
	
	function calcAngle(latlng1, latlng2) {
	    var p1 = _leaflet2.default.Projection.SphericalMercator.project(latlng1);
	    var p2 = _leaflet2.default.Projection.SphericalMercator.project(latlng2);
	    var delta = p2.subtract(p1);
	    var angle = Math.atan2(delta.x, delta.y);
	    return degrees(angle);
	}
	
	function roundAzimuth(a) {
	    return (Math.round(a) + 360) % 360;
	}
	
	_leaflet2.default.Control.Azimuth = _leaflet2.default.Control.extend({
	    options: {
	        position: 'bottomleft'
	    },
	
	    includes: _leaflet2.default.Mixin.Events,
	
	    initialize: function initialize(options) {
	        _leaflet2.default.Control.prototype.initialize.call(this, options);
	        this._enabled = _knockout2.default.observable(false);
	        this.trueAzimuth = _knockout2.default.observable(null);
	        this.magneticAzimuth = _knockout2.default.observable(null);
	        this.distance = _knockout2.default.observable(null);
	        this.points = {
	            start: null,
	            end: null
	        };
	        var iconSingle = _leaflet2.default.icon({ iconUrl: _pointer2.default, iconSize: [30, 30] });
	        var iconStart = _leaflet2.default.icon({ iconUrl: _pointerStart2.default, iconSize: [40, 40] });
	        var iconEnd = _leaflet2.default.icon({ iconUrl: _pointerEnd2.default, iconSize: [40, 40] });
	        this.markers = {
	            single: _leaflet2.default.marker([0, 0], { icon: iconSingle, draggable: true, which: 'start' }).on('drag', this.onMarkerDrag, this).on('click', _leaflet2.default.DomEvent.stopPropagation),
	            start: _leaflet2.default.marker([0, 0], { icon: iconStart, draggable: true, which: 'start', rotationOrigin: 'center center' }).on('drag', this.onMarkerDrag, this).on('click', _leaflet2.default.DomEvent.stopPropagation).on('dragend', this.onMarkerDragEnd, this),
	            end: _leaflet2.default.marker([0, 0], { icon: iconEnd, draggable: true, which: 'end', rotationOrigin: 'center center' }).on('drag', this.onMarkerDrag, this).on('click', _leaflet2.default.DomEvent.stopPropagation).on('dragend', this.onMarkerDragEnd, this)
	        };
	        this.azimuthLine = _leaflet2.default.polyline([], { interactive: false, weight: 1.5 });
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control leaflet-control-button leaflet-control-azimuth');
	        this._stopContainerEvents();
	        container.innerHTML = _control2.default;
	        container.title = "Measure bearing, display line of sight";
	        _knockout2.default.applyBindings(this, container);
	        _leaflet2.default.DomEvent.on(container, 'click', this.onClick, this);
	        return container;
	    },
	
	    onClick: function onClick() {
	        this.setExpanded(true);
	    },
	
	    onMinimizeButtonClick: function onMinimizeButtonClick(e) {
	        var _this = this;
	
	        setTimeout(function () {
	            return _this.setExpanded(false);
	        }, 0);
	    },
	
	    onMarkerDrag: function onMarkerDrag(e) {
	        var marker = e.target;
	        this.setPoints(_defineProperty({}, marker.options.which, marker.getLatLng()));
	    },
	
	    onMarkerDragEnd: function onMarkerDragEnd() {
	        if (this.elevationControl) {
	            this.showProfile();
	        }
	    },
	
	    setExpanded: function setExpanded(expanded) {
	        if (!!expanded === this.isExpanded()) {
	            return;
	        }
	        if (expanded) {
	            _leaflet2.default.DomUtil.addClass(this._container, 'expanded');
	        } else {
	            _leaflet2.default.DomUtil.removeClass(this._container, 'expanded');
	            this.hideProfile();
	            this.setPoints({ start: null, end: null });
	        }
	        this.setEnabled(expanded);
	    },
	
	    setEnabled: function setEnabled(enabled) {
	        if (!!enabled === this.isEnabled()) {
	            return;
	        }
	        if (enabled) {
	            _leaflet2.default.DomUtil.addClass(this._map._container, 'azimuth-control-active');
	            this._map.on('click', this.onMapClick, this);
	            this.fire('enabled');
	        } else {
	            _leaflet2.default.DomUtil.removeClass(this._map._container, 'azimuth-control-active');
	            this._map.off('click', this.onMapClick, this);
	        }
	        this._map.clickLocked = enabled;
	        this._enabled(!!enabled);
	    },
	
	    isEnabled: function isEnabled() {
	        return !!this._enabled();
	    },
	
	    onEnableButtonClick: function onEnableButtonClick() {
	        this.setEnabled(!this.isEnabled());
	    },
	
	    isExpanded: function isExpanded() {
	        return _leaflet2.default.DomUtil.hasClass(this._container, 'expanded');
	    },
	
	    setPoints: function setPoints(points) {
	        Object.assign(this.points, points);
	        points = this.points;
	        if (points.start && !points.end) {
	            this.markers.single.setLatLng(points.start).addTo(this._map);
	        } else {
	            this.markers.single.removeFrom(this._map);
	        }
	        if (points.start && points.end) {
	            var angle = calcAngle(points.start, points.end);
	            this.markers.start.setLatLng(points.start).addTo(this._map).setRotationAngle(angle);
	            this.markers.end.setLatLng(points.end).addTo(this._map).setRotationAngle(angle);
	            this.azimuthLine.setLatLngs([[points.start, points.end]]).addTo(this._map);
	        } else {
	            this.markers.start.removeFrom(this._map);
	            this.markers.end.removeFrom(this._map);
	            this.azimuthLine.removeFrom(this._map);
	        }
	        this.updateValuesDisplay();
	    },
	
	    updateValuesDisplay: function updateValuesDisplay() {
	        if (this.points.start && this.points.end) {
	            var points = this.points;
	            var azimuth = calcAzimuth(points.start, points.end);
	            this.trueAzimuth(roundAzimuth(azimuth));
	            var declination = (0, _magneticDeclination.getDeclination)(points.start.lat, points.start.lng);
	            if (declination !== null) {
	                this.magneticAzimuth(roundAzimuth(azimuth - declination));
	            } else {
	                this.magneticAzimuth(null);
	            }
	            this.distance(points.start.distanceTo(points.end));
	        } else {
	            this.distance(null);
	            this.trueAzimuth(null);
	            this.magneticAzimuth(null);
	        }
	    },
	
	    onMapClick: function onMapClick(e) {
	        if (!this.points.start && !this.points.end) {
	            this.setPoints({ start: e.latlng });
	        } else if (this.points.start && !this.points.end) {
	            this.setPoints({ end: e.latlng });
	        } else if (this.points.start && this.points.end) {
	            this.hideProfile();
	            this.setPoints({ start: e.latlng, end: null });
	        }
	    },
	
	    showProfile: function showProfile() {
	        var _this2 = this;
	
	        if (!this.points.end) {
	            return;
	        }
	        if (this.elevationControl) {
	            this.elevationControl.removeFrom(this._map);
	        }
	
	        var dist = this.points.start.distanceTo(this.points.end);
	        this.elevationControl = new _leafletControl.ElevationProfile(this._map, [this.points.start, this.points.end], {
	            samplingInterval: (0, _leafletControl.calcSamplingInterval)(dist),
	            sightLine: true
	        });
	        this.elevationControl.on('remove', function () {
	            return _this2.elevationControl = null;
	        });
	        this.fire('elevation-shown');
	    },
	
	    hideProfile: function hideProfile() {
	        if (this.elevationControl) {
	            this.elevationControl.removeFrom(this._map);
	        }
	        this.elevationControl = null;
	    },
	
	    onProfileButtonClick: function onProfileButtonClick() {
	        this.showProfile();
	    },
	
	    onReverseButtonClick: function onReverseButtonClick() {
	        if (this.points.end && this.points.start) {
	            this.setPoints({ start: this.points.end, end: this.points.start });
	            if (this.elevationControl) {
	                this.showProfile();
	            }
	        }
	    }
	
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(446);
	
	__webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.Caption = _leaflet2.default.Control.extend({
	    options: {
	        position: 'bottomright',
	        className: 'leaflet-control-caption'
	    },
	
	    initialize: function initialize(contents, options) {
	        _leaflet2.default.setOptions(this, options);
	        this._contents = contents;
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        this._container = _leaflet2.default.DomUtil.create('div', this.options.className);
	        this._stopContainerEvents();
	        this._container.innerHTML = this._contents;
	        _leaflet2.default.DomEvent.on(this._container, 'contextmenu', function (e) {
	            _leaflet2.default.DomEvent.stopPropagation(e);
	            e.returnValue = true;
	            return true;
	        });
	        return this._container;
	    },
	
	    setContents: function setContents(contents) {
	        this._contents = contents;
	        if (this._map) {
	            this._container.innerHTML = this._contents;
	        }
	    }
	
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(447);
	
	var _clipboardCopy = __webpack_require__(79);
	
	var _clipboardCopy2 = _interopRequireDefault(_clipboardCopy);
	
	var _contextmenu = __webpack_require__(56);
	
	var _contextmenu2 = _interopRequireDefault(_contextmenu);
	
	__webpack_require__(31);
	
	var _safeLocalstorage = __webpack_require__(63);
	
	var _safeLocalstorage2 = _interopRequireDefault(_safeLocalstorage);
	
	__webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pad(s, n) {
	    var j = s.indexOf('.');
	    if (j === -1) {
	        j = s.length;
	    }
	    var zeroes = n - j;
	    if (zeroes > 0) {
	        s = Array(zeroes + 1).join('0') + s;
	    }
	    return s;
	}
	
	function mod(n, m) {
	    return (n % m + m) % m;
	}
	
	function normalizeLongitude(lng) {
	    return mod(lng + 180, 360) - 180;
	}
	
	_leaflet2.default.Control.Coordinates = _leaflet2.default.Control.extend({
	    options: {
	        position: 'bottomleft'
	    },
	
	    formatNames: {
	        'd': 'ddd.ddddd',
	        'D': 'ddd.ddddd&deg',
	        'DM': 'ddd&deg;mm.mmm\'',
	        'DMS': 'ddd&deg;mm\'ss.s"'
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control leaflet-control-button leaflet-control-coordinates');
	        container.title = "Show coordinates at cursor";
	        this._stopContainerEvents();
	        this._field_lat = _leaflet2.default.DomUtil.create('div', 'leaflet-control-coordinates-text', container);
	        this._field_lon = _leaflet2.default.DomUtil.create('div', 'leaflet-control-coordinates-text', container);
	        _leaflet2.default.DomEvent.on(container, {
	            'click': this.onClick
	        }, this);
	        this.menu = new _contextmenu2.default([{ text: 'Click map to copy coordinates to clipboard', callback: this.prepareForClickOnMap.bind(this) }, '-', { text: '&plusmn;ddd.ddddd', callback: this.onMenuSelect.bind(this, 'd') }, { text: 'ddd.ddddd&deg;', callback: this.onMenuSelect.bind(this, 'D') }, { text: 'ddd&deg;mm.mmm\'', callback: this.onMenuSelect.bind(this, 'DM') }, { text: 'ddd&deg;mm\'ss.s"', callback: this.onMenuSelect.bind(this, 'DMS') }]);
	        this.loadStateFromStorage();
	        this.onMouseMove();
	        _leaflet2.default.DomEvent.on(container, 'contextmenu', this.onRightClick, this);
	        return container;
	    },
	
	    loadStateFromStorage: function loadStateFromStorage() {
	        var active = false,
	            fmt = 'D';
	        active = _safeLocalstorage2.default.leafletCoordinatesActive === '1';
	        fmt = _safeLocalstorage2.default.leafletCoordinatesFmt || fmt;
	        this.setEnabled(active);
	        this.setFormat(fmt);
	    },
	
	    saveStateToStorage: function saveStateToStorage() {
	        _safeLocalstorage2.default.leafletCoordinatesActive = this.isEnabled() ? '1' : '0';
	        _safeLocalstorage2.default.leafletCoordinatesFmt = this.fmt;
	    },
	
	    formatCoodinate: function formatCoodinate(value, isLat, fmt) {
	        if (value === undefined || isNaN(value)) {
	            return '-------';
	        }
	        fmt = fmt || this.fmt;
	        var h, d, m, s;
	        if (isLat) {
	            h = value < 0 ? 'S' : 'N';
	        } else {
	            h = value < 0 ? 'W' : 'E';
	        }
	        if (fmt === 'd') {
	            d = value.toFixed(5);
	            d = pad(d, isLat ? 2 : 3);
	            return d;
	        }
	
	        value = Math.abs(value);
	        if (fmt === 'D') {
	            d = value.toFixed(5);
	            d = pad(d, isLat ? 2 : 3);
	            return h + ' ' + d + '&deg;';
	        }
	        if (fmt === 'DM') {
	            d = Math.floor(value).toString();
	            d = pad(d, isLat ? 2 : 3);
	            m = ((value - d) * 60).toFixed(3);
	            m = pad(m, 2);
	            return h + ' ' + d + '&deg;' + m + '\'';
	        }
	        if (fmt === 'DMS') {
	            d = Math.floor(value).toString();
	            d = pad(d, isLat ? 2 : 3);
	            m = Math.floor((value - d) * 60).toString();
	            m = pad(m, 2);
	            s = ((value - d - m / 60) * 3600).toFixed(2);
	            s = pad(s, 2);
	            return h + ' ' + d + '&deg;' + m + '\'' + s + '"';
	        }
	    },
	
	    onMenuSelect: function onMenuSelect(fmt) {
	        this.setFormat(fmt);
	        this.saveStateToStorage();
	    },
	
	    setFormat: function setFormat(fmt) {
	        this.fmt = fmt;
	        this.onMouseMove();
	    },
	
	    onMouseMove: function onMouseMove(e) {
	        var lat, lng;
	        if (e) {
	            var _e$latlng = e.latlng;
	            lat = _e$latlng.lat;
	            lng = _e$latlng.lng;
	        }
	        lng = normalizeLongitude(lng);
	        this._field_lat.innerHTML = this.formatCoodinate(lat, true);
	        this._field_lon.innerHTML = this.formatCoodinate(lng, false);
	    },
	
	    setEnabled: function setEnabled(enabled) {
	        if (!!enabled === this.isEnabled()) {
	            return;
	        }
	        if (enabled) {
	            _leaflet2.default.DomUtil.addClass(this._container, 'expanded');
	            _leaflet2.default.DomUtil.addClass(this._map._container, 'coordinates-control-active');
	            this._map.on('mousemove', this.onMouseMove, this);
	            this._map.on('contextmenu', this.onMapRightClick, this);
	        } else {
	            _leaflet2.default.DomUtil.removeClass(this._container, 'expanded');
	            _leaflet2.default.DomUtil.removeClass(this._map._container, 'coordinates-control-active');
	            this._map.off('contextmenu', this.onMapRightClick, this);
	            this._map.off('mousemove', this.onMouseMove, this);
	        }
	    },
	
	    onMapRightClick: function onMapRightClick(e) {
	        var _this = this;
	
	        var items = [{ text: '<b>Copy coordinates to clipboard</b>', header: true }, '-'];
	
	        var lat = e.latlng.lat,
	            lng = normalizeLongitude(e.latlng.lng);
	
	        var _arr = ['d', 'D', 'DM', 'DMS'];
	
	        var _loop = function _loop() {
	            var fmt = _arr[_i];
	            var strLat = _this.formatCoodinate(lat, true, fmt);
	            var strLng = _this.formatCoodinate(lng, false, fmt);
	            var s = strLat + ' ' + strLng;
	            items.push({
	                text: s + ' <span class="leaflet-coordinates-menu-fmt">' + _this.formatNames[fmt] + '</span>',
	                callback: function callback() {
	                    (0, _clipboardCopy2.default)(s.replace(/&deg;/g, '°'), e.originalEvent);
	                }
	            });
	        };
	
	        for (var _i = 0; _i < _arr.length; _i++) {
	            _loop();
	        }
	        var menu = new _contextmenu2.default(items);
	        menu.show(e);
	    },
	
	    isEnabled: function isEnabled() {
	        return _leaflet2.default.DomUtil.hasClass(this._container, 'expanded');
	    },
	
	    onClick: function onClick(e) {
	        this.setEnabled(!this.isEnabled());
	        this.saveStateToStorage();
	        this.onMouseMove();
	    },
	
	    onRightClick: function onRightClick(e) {
	        this.menu.show(e);
	    },
	
	    onMapClick: function onMapClick(e) {
	        var s = this.formatCoodinate(e.latlng.lat, true) + ' ' + this.formatCoodinate(e.latlng.lng, false);
	        s = s.replace(/&deg;/g, '°');
	        (0, _clipboardCopy2.default)(s, e.originalEvent);
	    },
	
	    prepareForClickOnMap: function prepareForClickOnMap() {
	        this._map.once('click', this.onMapClick, this);
	    }
	
	    // TODO: onRemove
	
	});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BinStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utf = __webpack_require__(110);
	
	var _utf2 = _interopRequireDefault(_utf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BinStream = function () {
	    function BinStream(size, littlEndian) {
	        _classCallCheck(this, BinStream);
	
	        this.maxSize = 1024;
	        this.dv = new DataView(new ArrayBuffer(this.maxSize));
	        this._pos = 0;
	        this.size = 0;
	        this.littlEndian = littlEndian;
	    }
	
	    _createClass(BinStream, [{
	        key: 'grow',
	        value: function grow() {
	            this.maxSize *= 2;
	            var old_buffer = this.dv.buffer;
	            this.dv = new DataView(new ArrayBuffer(this.maxSize));
	            var newAr = new Uint8Array(this.dv.buffer);
	            var oldAr = new Uint8Array(old_buffer);
	            for (var i = 0; i < oldAr.length; i++) {
	                newAr[i] = oldAr[i];
	            }
	        }
	    }, {
	        key: 'checkSize',
	        value: function checkSize(size) {
	            if (this._pos + size >= this.maxSize) {
	                this.grow();
	            }
	            var newPos = this._pos + size;
	            this.size = newPos > this.size ? newPos : this.size;
	        }
	    }, {
	        key: 'writeUint8',
	        value: function writeUint8(value) {
	            this.checkSize(1);
	            this.dv.setUint8(this._pos, value);
	            this._pos += 1;
	        }
	    }, {
	        key: 'writeInt8',
	        value: function writeInt8(value) {
	            this.checkSize(1);
	            this.dv.setInt8(this._pos, value);
	            this._pos += 1;
	        }
	    }, {
	        key: 'writeInt16',
	        value: function writeInt16(value) {
	            this.checkSize(2);
	            this.dv.setInt16(this._pos, value, this.littlEndian);
	            this._pos += 2;
	        }
	    }, {
	        key: 'writeUint16',
	        value: function writeUint16(value) {
	            this.checkSize(2);
	            this.dv.setUint16(this._pos, value, this.littlEndian);
	            this._pos += 2;
	        }
	    }, {
	        key: 'writeInt32',
	        value: function writeInt32(value) {
	            this.checkSize(4);
	            this.dv.setInt32(this._pos, value, this.littlEndian);
	            this._pos += 4;
	        }
	    }, {
	        key: 'writeUint32',
	        value: function writeUint32(value) {
	            this.checkSize(4);
	            this.dv.setUint32(this._pos, value, this.littlEndian);
	            this._pos += 4;
	        }
	    }, {
	        key: 'writeString',
	        value: function writeString(s, zeroTerminated) {
	            s = _utf2.default.encode(s);
	            for (var i = 0; i < s.length; i++) {
	                this.writeUint8(s.charCodeAt(i));
	            }
	            if (zeroTerminated) {
	                this.writeUint8(0);
	            }
	        }
	    }, {
	        key: 'tell',
	        value: function tell() {
	            return this._pos;
	        }
	    }, {
	        key: 'seek',
	        value: function seek(pos) {
	            this._pos = pos;
	        }
	    }, {
	        key: 'getBuffer',
	        value: function getBuffer() {
	            return this.dv.buffer.slice(0, this.size);
	        }
	    }]);
	
	    return BinStream;
	}();
	
	exports.BinStream = BinStream;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(115);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.JNX.include(_leaflet2.default.Mixin.HashState);
	_leaflet2.default.Control.JNX.include({
	    stateChangeEvents: ['selectionchange'],
	
	    serializeState: function serializeState() {
	        var state = void 0;
	        if (this._selector) {
	            var bounds = this._selector.getBounds();
	            state = [bounds.getSouth().toFixed(5), bounds.getWest().toFixed(5), bounds.getNorth().toFixed(5), bounds.getEast().toFixed(5)];
	        }
	        return state;
	    },
	
	    unserializeState: function unserializeState(values) {
	        function validateFloat(value, min, max) {
	            value = parseFloat(value);
	            if (isNaN(value) || value < min || value > max) {
	                throw new Error('INVALID VALUE');
	            }
	            return value;
	        }
	
	        if (values && values.length === 4) {
	            try {
	                var south = validateFloat(values[0], -86, 86),
	                    west = validateFloat(values[1], -180, 180),
	                    north = validateFloat(values[2], -86, 86),
	                    east = validateFloat(values[3], -180, 180);
	            } catch (e) {
	                if (e.message === 'INVALID VALUE') {
	                    return false;
	                }
	                throw e;
	            }
	            this.removeSelector();
	            this.addSelector([[south, west], [north, east]]);
	            return true;
	        } else {
	            return false;
	        }
	    }
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _knockout = __webpack_require__(51);
	
	var _knockout2 = _interopRequireDefault(_knockout);
	
	__webpack_require__(449);
	
	__webpack_require__(31);
	
	var _selector = __webpack_require__(186);
	
	var _contextmenu = __webpack_require__(56);
	
	var _contextmenu2 = _interopRequireDefault(_contextmenu);
	
	var _jnxMaker = __webpack_require__(185);
	
	var _browserFilesaver = __webpack_require__(64);
	
	var _notifications = __webpack_require__(35);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.JNX = _leaflet2.default.Control.extend({
	    includes: _leaflet2.default.Mixin.Events,
	
	    initialize: function initialize(layersControl, options) {
	        var _this = this;
	
	        _leaflet2.default.Control.prototype.initialize.call(this, options);
	        this._layersControl = layersControl;
	        this.makingJnx = _knockout2.default.observable(false);
	        this.downloadProgressRange = _knockout2.default.observable(1);
	        this.downloadProgressDone = _knockout2.default.observable(0);
	        this.contextMenu = new _contextmenu2.default(function () {
	            return _this.makeMenuItems();
	        });
	    },
	
	    getLayerForJnx: function getLayerForJnx() {
	        var selectedLayer = {};
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this._layersControl._layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var layerRec = _step.value;
	
	                var layer = layerRec.layer;
	                if (this._map.hasLayer(layer) && layer.options && layer.options.jnx) {
	                    selectedLayer = {
	                        layer: layer,
	                        layerName: layerRec.name
	                    };
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return selectedLayer;
	    },
	
	    estimateTilesCount: function estimateTilesCount(maxZoom) {
	        var tilesCount = 0;
	        var bounds = this._selector.getBounds();
	        for (var zoom = (0, _jnxMaker.minZoom)(maxZoom); zoom <= maxZoom; zoom++) {
	            var topLeftTile = this._map.project(bounds.getNorthWest(), zoom).divideBy(256).floor();
	            var bottomRightTile = this._map.project(bounds.getSouthEast(), zoom).divideBy(256).ceil();
	            tilesCount += Math.ceil((bottomRightTile.x - topLeftTile.x) * (bottomRightTile.y - topLeftTile.y));
	        }
	        return tilesCount;
	    },
	
	    makeMenuItems: function makeMenuItems() {
	        var _this2 = this;
	
	        var _getLayerForJnx = this.getLayerForJnx(),
	            layer = _getLayerForJnx.layer,
	            layerName = _getLayerForJnx.layerName;
	
	        if (!layer) {
	            return [{ text: 'No supported layer' }];
	        }
	        var maxLevel = layer.options.maxNativeZoom || layer.options.maxZoom || 18;
	        var minLevel = Math.max(0, maxLevel - 6);
	
	        var equatorLength = 40075016;
	        var lat = this._selector.getBounds().getCenter().lat;
	        var metersPerPixel = equatorLength / Math.pow(2, maxLevel) / 256 * Math.cos(lat / 180 * Math.PI);
	
	        var items = [{ text: layerName, header: true }];
	
	        var _loop = function _loop(zoom) {
	            var tilesCount = _this2.estimateTilesCount(zoom);
	            var fileSizeMb = tilesCount * 0.02;
	            var itemClass = tilesCount > 50000 ? 'jnx-menu-warning' : '';
	            var resolutionString = metersPerPixel.toFixed(2);
	            var sizeString = fileSizeMb.toFixed(fileSizeMb > 1 ? 0 : 1);
	            var item = {
	                text: '<span class="' + itemClass + '">Zoom ' + zoom + ' (' + resolutionString + ' m/pixel) &mdash; ' + tilesCount + ' tiles (~' + sizeString + ' Mb)</span>',
	                callback: function callback() {
	                    return _this2.makeJnx(layer, layerName, zoom);
	                },
	                disabled: _this2.makingJnx()
	            };
	            items.push(item);
	            metersPerPixel *= 2;
	        };
	
	        for (var zoom = maxLevel; zoom >= minLevel; zoom -= 1) {
	            _loop(zoom);
	        }
	        return items;
	    },
	
	    notifyProgress: function notifyProgress(value, maxValue) {
	        this.downloadProgressDone(this.downloadProgressDone() + value);
	        this.downloadProgressRange(maxValue);
	    },
	
	    makeJnx: function makeJnx(layer, layerName, zoom) {
	        var _this3 = this;
	
	        _logging2.default.captureBreadcrumbWithUrl({ message: 'start making jnx' });
	        this.makingJnx(true);
	        this.downloadProgressDone(0);
	
	        var bounds = this._selector.getBounds();
	        var sanitizedLayerName = layerName.toLowerCase().replace(/[ ()]+/, '_');
	        var fileName = 'nakarte.tk_' + sanitizedLayerName + '_z' + zoom + '.jnx';
	        (0, _jnxMaker.makeJnxFromLayer)(layer, layerName, zoom, bounds, this.notifyProgress.bind(this)).then(function (fileData) {
	            return (0, _browserFilesaver.saveAs)(fileData, fileName, true);
	        }).catch(function (e) {
	            _logging2.default.captureException(e);
	            (0, _notifications.notify)('Failed to create JNX: ' + e.message);
	        }).then(function () {
	            return _this3.makingJnx(false);
	        });
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control leaflet-control-jnx');
	        container.innerHTML = '\n                <a class="button" data-bind="visible: !makingJnx(), click: onButtonClicked"\n                 title="Make JNX for Garmin receivers">JNX</a>\n                <div data-bind="\n                    component:{\n                        name: \'progress-indicator\',\n                        params: {progressRange: downloadProgressRange, progressDone: downloadProgressDone}\n                    },\n                    visible: makingJnx()"></div>';
	        _knockout2.default.applyBindings(this, container);
	        this._stopContainerEvents();
	        return container;
	    },
	
	    removeSelector: function removeSelector() {
	        if (this._selector) {
	            this._map.removeLayer(this._selector);
	            this._selector = null;
	            this.fire('selectionchange');
	        }
	    },
	
	    addSelector: function addSelector(bounds) {
	        var _this4 = this;
	
	        if (!bounds) {
	            bounds = this._map.getBounds().pad(-0.25);
	        }
	        this._selector = new _selector.RectangleSelect(bounds).addTo(this._map).on('change', function () {
	            return _this4.fire('selectionchange');
	        }).on('click contextmenu', function (e) {
	            return _this4.contextMenu.show(e);
	        });
	        this.fire('selectionchange');
	    },
	
	    onButtonClicked: function onButtonClicked() {
	        if (this._selector) {
	            if (this._selector.getBounds().intersects(this._map.getBounds().pad(-0.05))) {
	                this.removeSelector();
	            } else {
	                this.removeSelector();
	                this.addSelector();
	            }
	        } else {
	            this.addSelector();
	        }
	    }
	});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.JnxWriter = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _binaryStream = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function jnxCoordinates(extents) {
	    function toJnx(x) {
	        return Math.round(x / 180.0 * 0x7fffffff);
	    }
	
	    return [toJnx(extents.north), toJnx(extents.east), toJnx(extents.south), toJnx(extents.west)];
	}
	
	var JnxWriter = _leaflet2.default.Class.extend({
	    initialize: function initialize(productName, productId, zOrder) {
	        this.tiles = {};
	        this.productName = productName || 'Raster map';
	        this.productId = productId || 0;
	        this.zOrder = zOrder;
	    },
	
	    addTile: function addTile(tileData, level, latLngBounds) {
	        this.tiles[level] = this.tiles[level] || [];
	        tileData = new Blob([tileData]).slice(2);
	        var extents = {
	            west: latLngBounds.getWest(),
	            north: latLngBounds.getNorth(),
	            south: latLngBounds.getSouth(),
	            east: latLngBounds.getEast()
	
	        };
	        this.tiles[level].push({ data: tileData, extents: extents });
	    },
	
	    getJnx: function getJnx() {
	        var HEADER_SIZE = 52,
	            LEVEL_INFO_SIZE = 17,
	            TILE_INFO_SIZE = 28;
	
	        var totalTilesCount = 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = Object.values(this.tiles)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var levelTiles = _step.value;
	
	                totalTilesCount += levelTiles.length;
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        if (totalTilesCount === 0) {
	            throw new Error('No tiles collected, JNX is empty');
	        }
	        if (totalTilesCount > 50000) {
	            throw new Error('Too many tiles found (more then 50000)');
	        }
	
	        var west = 1e10,
	            east = -1e10,
	            north = -1e10,
	            south = 1e10,
	            levels_n = Object.keys(this.tiles).length,
	            level = void 0,
	            tiles = void 0,
	            extents = void 0,
	            i = void 0,
	            tile = void 0;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = Object.values(this.tiles)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _levelTiles = _step2.value;
	                var _iteratorNormalCompletion7 = true;
	                var _didIteratorError7 = false;
	                var _iteratorError7 = undefined;
	
	                try {
	                    for (var _iterator7 = _levelTiles[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                        var _tile = _step7.value;
	
	                        west = west < _tile.extents.west ? west : _tile.extents.west;
	                        east = east > _tile.extents.east ? east : _tile.extents.east;
	                        north = north > _tile.extents.north ? north : _tile.extents.north;
	                        south = south < _tile.extents.south ? south : _tile.extents.south;
	                    }
	                } catch (err) {
	                    _didIteratorError7 = true;
	                    _iteratorError7 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                            _iterator7.return();
	                        }
	                    } finally {
	                        if (_didIteratorError7) {
	                            throw _iteratorError7;
	                        }
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        var stream = new _binaryStream.BinStream(1024, true);
	        // header
	        stream.writeInt32(4); // version
	        stream.writeInt32(0); // device id
	        extents = jnxCoordinates({ south: south, north: north, west: west, east: east });
	        stream.writeInt32(extents[0]); // north
	        stream.writeInt32(extents[1]); // west
	        stream.writeInt32(extents[2]); // south
	        stream.writeInt32(extents[3]); // east
	        stream.writeInt32(levels_n); // number of zoom levels
	        stream.writeInt32(0); //expiration date
	        stream.writeInt32(this.productId);
	        stream.writeInt32(0); // tiles CRC32
	        stream.writeInt32(0); // signature version
	        stream.writeUint32(0); // signature offset
	        stream.writeInt32(this.zOrder);
	        stream.seek(HEADER_SIZE + LEVEL_INFO_SIZE * levels_n);
	        // map description
	        stream.writeInt32(9); // section version
	        stream.writeString('12345678-1234-1234-1234-123456789ABC', true); // GUID
	        stream.writeString(this.productName, true);
	        stream.writeString('', true);
	        stream.writeInt16(this.productId);
	        stream.writeString(this.productName, true);
	        stream.writeInt32(levels_n);
	        // levels descriptions
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = Object.keys(this.tiles)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                level = _step3.value;
	
	                stream.writeString('', true);
	                stream.writeString('', true);
	                stream.writeString('', true);
	                stream.writeInt32(level);
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        var tileDescriptorOffset = stream.tell();
	        // level info
	        var jnxScale = void 0;
	        stream.seek(HEADER_SIZE);
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = Object.keys(this.tiles)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                level = _step4.value;
	
	                level = parseInt(level, 10);
	                stream.writeInt32(this.tiles[level].length);
	                stream.writeUint32(tileDescriptorOffset);
	                //jnxScale = JnxScales[level + 3];
	                jnxScale = 34115555 / Math.pow(2, level) * Math.cos((north + south) / 2 / 180 * Math.PI) / 1.1;
	                stream.writeInt32(jnxScale);
	                stream.writeInt32(2);
	                stream.writeUint8(0);
	                tileDescriptorOffset += TILE_INFO_SIZE * this.tiles[level].length;
	            }
	            // tiles descriptors
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        stream.seek(stream.size);
	        var tileDataOffset = tileDescriptorOffset;
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	            for (var _iterator5 = Object.keys(this.tiles)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                level = _step5.value;
	
	                tiles = this.tiles[level];
	                for (i = 0; i < tiles.length; i++) {
	                    tile = tiles[i];
	                    extents = jnxCoordinates(tile.extents);
	                    stream.writeInt32(extents[0]); // north
	                    stream.writeInt32(extents[1]); // west
	                    stream.writeInt32(extents[2]); // south
	                    stream.writeInt32(extents[3]); // east
	                    stream.writeInt16(256); // width
	                    stream.writeInt16(256); // height
	                    stream.writeInt32(tile.data.size);
	                    stream.writeUint32(tileDataOffset);
	                    tileDataOffset += tile.data.size;
	                }
	            }
	        } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                    _iterator5.return();
	                }
	            } finally {
	                if (_didIteratorError5) {
	                    throw _iteratorError5;
	                }
	            }
	        }
	
	        var blob = [];
	        blob.push(stream.getBuffer());
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	            for (var _iterator6 = Object.keys(this.tiles)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                level = _step6.value;
	
	                tiles = this.tiles[level];
	                for (i = 0; i < tiles.length; i++) {
	                    tile = tiles[i];
	                    blob.push(tile.data);
	                }
	            }
	        } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                    _iterator6.return();
	                }
	            } finally {
	                if (_didIteratorError6) {
	                    throw _iteratorError6;
	                }
	            }
	        }
	
	        blob.push('BirdsEye');
	        return new Blob(blob);
	    }
	});
	
	exports.JnxWriter = JnxWriter;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.minZoom = exports.makeJnxFromLayer = undefined;
	
	var convertToJpeg = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(image) {
	        var canvas, ctx, dataURL, s;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return imageFromarrayBuffer(image);
	
	                    case 3:
	                        image = _context.sent;
	                        _context.next = 9;
	                        break;
	
	                    case 6:
	                        _context.prev = 6;
	                        _context.t0 = _context['catch'](0);
	                        return _context.abrupt('return', null);
	
	                    case 9:
	                        canvas = document.createElement("canvas");
	
	                        canvas.width = image.width;
	                        canvas.height = image.height;
	                        ctx = canvas.getContext("2d");
	
	                        ctx.drawImage(image, 0, 0);
	                        dataURL = canvas.toDataURL("image/jpeg");
	                        s = atob(dataURL.replace(/^data:image\/jpeg;base64,/, ""));
	                        return _context.abrupt('return', (0, _binaryStrings.stringToArrayBuffer)(s));
	
	                    case 17:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[0, 6]]);
	    }));
	
	    return function convertToJpeg(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var makeJnxFromLayer = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(srcLayer, layerName, maxZoomLevel, latLngBounds, progress) {
	        var jnxProductId, jnxZOrder, writer, xhrQueue, doStop, error, minZoomLevel, progressWeight, zoom, pixelBounds, promises, layer, tempMap, _ref3, iterateTilePromises, tilesCount, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, tilePromiseRec, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, tilePromise, imageRec, xhr, image;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        jnxProductId = _leaflet2.default.stamp(srcLayer);
	                        jnxZOrder = Math.min(jnxProductId, 100);
	                        writer = new _jnxEncoder.JnxWriter(layerName, jnxProductId, jnxZOrder);
	                        xhrQueue = new _xhrPromise.XHRQueue();
	                        doStop = false;
	                        error = void 0;
	                        minZoomLevel = minZoom(maxZoomLevel);
	                        progressWeight = 1;
	                        zoom = maxZoomLevel;
	
	                    case 9:
	                        if (!(zoom >= minZoomLevel)) {
	                            _context2.next = 95;
	                            break;
	                        }
	
	                        pixelBounds = _leaflet2.default.bounds(_leaflet2.default.CRS.EPSG3857.latLngToPoint(latLngBounds.getNorthWest(), zoom).round(), _leaflet2.default.CRS.EPSG3857.latLngToPoint(latLngBounds.getSouthEast(), zoom).round());
	                        promises = [];
	                        layer = srcLayer.cloneForPrint({ xhrQueue: xhrQueue });
	                        tempMap = (0, _leafletLayer.getTempMap)(zoom, layer._rasterizeNeedsFullSizeMap, pixelBounds);
	
	                        tempMap.addLayer(layer);
	                        _context2.next = 17;
	                        return layer.getTilesInfo({
	                            xhrOptions: defaultXHROptions,
	                            pixelBounds: pixelBounds,
	                            rawData: true
	                        });
	
	                    case 17:
	                        _ref3 = _context2.sent;
	                        iterateTilePromises = _ref3.iterateTilePromises;
	                        tilesCount = _ref3.count;
	                        _iteratorNormalCompletion = true;
	                        _didIteratorError = false;
	                        _iteratorError = undefined;
	                        _context2.prev = 23;
	
	                        for (_iterator = iterateTilePromises()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            tilePromiseRec = _step.value;
	
	                            promises.push(tilePromiseRec);
	                        }
	                        _context2.next = 31;
	                        break;
	
	                    case 27:
	                        _context2.prev = 27;
	                        _context2.t0 = _context2['catch'](23);
	                        _didIteratorError = true;
	                        _iteratorError = _context2.t0;
	
	                    case 31:
	                        _context2.prev = 31;
	                        _context2.prev = 32;
	
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	
	                    case 34:
	                        _context2.prev = 34;
	
	                        if (!_didIteratorError) {
	                            _context2.next = 37;
	                            break;
	                        }
	
	                        throw _iteratorError;
	
	                    case 37:
	                        return _context2.finish(34);
	
	                    case 38:
	                        return _context2.finish(31);
	
	                    case 39:
	                        _iteratorNormalCompletion2 = true;
	                        _didIteratorError2 = false;
	                        _iteratorError2 = undefined;
	                        _context2.prev = 42;
	                        _iterator2 = promises[Symbol.iterator]();
	
	                    case 44:
	                        if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                            _context2.next = 73;
	                            break;
	                        }
	
	                        tilePromise = _step2.value.tilePromise;
	                        imageRec = void 0;
	                        _context2.prev = 47;
	                        _context2.next = 50;
	                        return tilePromise;
	
	                    case 50:
	                        imageRec = _context2.sent;
	                        _context2.next = 58;
	                        break;
	
	                    case 53:
	                        _context2.prev = 53;
	                        _context2.t1 = _context2['catch'](47);
	
	                        error = _context2.t1;
	                        doStop = true;
	                        return _context2.abrupt('break', 73);
	
	                    case 58:
	                        xhr = imageRec.image;
	
	                        if (!(xhr === null || xhr.status !== 200 || !xhr.response || !xhr.response.byteLength)) {
	                            _context2.next = 61;
	                            break;
	                        }
	
	                        return _context2.abrupt('continue', 70);
	
	                    case 61:
	                        _context2.next = 63;
	                        return ensureImageJpg(xhr.response);
	
	                    case 63:
	                        image = _context2.sent;
	
	                        if (image) {
	                            _context2.next = 68;
	                            break;
	                        }
	
	                        error = new Error('Tile image invalid');
	                        doStop = true;
	                        return _context2.abrupt('break', 73);
	
	                    case 68:
	                        writer.addTile(image, zoom, imageRec.latLngBounds);
	                        progress(progressWeight / tilesCount, 4 / 3);
	
	                    case 70:
	                        _iteratorNormalCompletion2 = true;
	                        _context2.next = 44;
	                        break;
	
	                    case 73:
	                        _context2.next = 79;
	                        break;
	
	                    case 75:
	                        _context2.prev = 75;
	                        _context2.t2 = _context2['catch'](42);
	                        _didIteratorError2 = true;
	                        _iteratorError2 = _context2.t2;
	
	                    case 79:
	                        _context2.prev = 79;
	                        _context2.prev = 80;
	
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	
	                    case 82:
	                        _context2.prev = 82;
	
	                        if (!_didIteratorError2) {
	                            _context2.next = 85;
	                            break;
	                        }
	
	                        throw _iteratorError2;
	
	                    case 85:
	                        return _context2.finish(82);
	
	                    case 86:
	                        return _context2.finish(79);
	
	                    case 87:
	                        (0, _leafletLayer.disposeMap)(tempMap);
	
	                        if (!doStop) {
	                            _context2.next = 91;
	                            break;
	                        }
	
	                        promises.forEach(function (promiseRec) {
	                            return promiseRec.abortLoading();
	                        });
	                        throw error;
	
	                    case 91:
	                        progressWeight /= 4;
	
	                    case 92:
	                        zoom--;
	                        _context2.next = 9;
	                        break;
	
	                    case 95:
	                        return _context2.abrupt('return', writer.getJnx());
	
	                    case 96:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this, [[23, 27, 31, 39], [32,, 34, 38], [42, 75, 79, 87], [47, 53], [80,, 82, 86]]);
	    }));
	
	    return function makeJnxFromLayer(_x2, _x3, _x4, _x5, _x6) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _jnxEncoder = __webpack_require__(184);
	
	var _leafletLayer = __webpack_require__(122);
	
	var _xhrPromise = __webpack_require__(24);
	
	var _binaryStrings = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var defaultXHROptions = {
	    responseType: 'arraybuffer',
	    timeout: 20000,
	    isResponseSuccess: function isResponseSuccess(xhr) {
	        return xhr.status === 200 || xhr.status === 404;
	    }
	};
	
	function minZoom(maxZoom) {
	    return Math.max(maxZoom - 4, 0);
	}
	
	function imageFromarrayBuffer(arr) {
	    var dataUrl = 'data:image/png;base64,' + btoa((0, _binaryStrings.arrayBufferToString)(arr));
	    var image = new Image();
	    return new Promise(function (resolve, reject) {
	        image.onload = function () {
	            return resolve(image);
	        };
	        image.onerror = function () {
	            return reject(new Error('Tile image corrupt'));
	        };
	        image.src = dataUrl;
	    });
	}
	
	function ensureImageJpg(image) {
	    if (!image) {
	        return null;
	    }
	    if ((0, _binaryStrings.arrayBufferToString)(image.slice(0, 4)) === '\x89PNG' && (0, _binaryStrings.arrayBufferToString)(image.slice(-8)) === 'IEND\xae\x42\x60\x82') {
	        return convertToJpeg(image);
	    } else if ((0, _binaryStrings.arrayBufferToString)(image.slice(0, 2)) === '\xff\xd8' && (0, _binaryStrings.arrayBufferToString)(image.slice(-2)) === '\xff\xd9') {
	        return Promise.resolve(image);
	    } else {
	        return null;
	    }
	}
	
	exports.makeJnxFromLayer = makeJnxFromLayer;
	exports.minZoom = minZoom;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RectangleSelect = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RectangleSelect = _leaflet2.default.Rectangle.extend({
	    includes: _leaflet2.default.Mixin.Events,
	
	    options: {
	        opacity: 1,
	        weight: 0.5,
	        fillOpacity: 0.2,
	        color: '#3388ff',
	        fillColor: '#3388ff'
	
	    },
	
	    onAdd: function onAdd(map) {
	        _leaflet2.default.Rectangle.prototype.onAdd.call(this, map);
	        this.markers = [];
	        var _arr = ['top', 'right', 'bottom', 'left'];
	        for (var _i = 0; _i < _arr.length; _i++) {
	            var position = _arr[_i];
	            var marker = _leaflet2.default.marker([0, 0], {
	                icon: _leaflet2.default.divIcon({ className: 'leaflet-rectangle-select-edge edge-' + position }),
	                draggable: true
	            }).addTo(map);
	            marker.on({
	                'drag': this.onMarkerDrag,
	                'dragend': this.onMarkerDragEnd
	            }, this);
	            this.markers[position] = marker;
	        }
	        this.placeMarkers();
	        map.on('zoomend', this.placeMarkers, this);
	    },
	
	    placeMarkers: function placeMarkers() {
	        var bounds = this.getBounds();
	        var topLeftPixel = this._map.project(bounds.getNorthWest());
	        var bottomRightPixel = this._map.project(bounds.getSouthEast());
	        var size = bottomRightPixel.subtract(topLeftPixel);
	        var center = topLeftPixel.add(size.divideBy(2));
	        center = this._map.unproject(center);
	        this.markers['top'].setLatLng([bounds.getNorth(), center.lng]);
	        this.markers['top']._icon.style.width = size.x + 'px';
	        this.markers['top']._icon.style.marginLeft = '-' + size.x / 2 + 'px';
	        this.markers['right'].setLatLng([center.lat, bounds.getEast()]);
	        this.markers['right']._icon.style.height = size.y + 'px';
	        this.markers['right']._icon.style.marginTop = '-' + size.y / 2 + 'px';
	        this.markers['bottom'].setLatLng([bounds.getSouth(), center.lng]);
	        this.markers['bottom']._icon.style.width = size.x + 'px';
	        this.markers['bottom']._icon.style.marginLeft = '-' + size.x / 2 + 'px';
	        this.markers['left'].setLatLng([center.lat, bounds.getWest()]);
	        this.markers['left']._icon.style.height = size.y + 'px';
	        this.markers['left']._icon.style.marginTop = '-' + size.y / 2 + 'px';
	    },
	
	    onRemove: function onRemove(map) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = Object.values(this.markers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var marker = _step.value;
	
	                this._map.removeLayer(marker);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        this.markers = null;
	        map.off('zoomend', this.placeMarkers, this);
	        _leaflet2.default.Rectangle.prototype.onRemove.call(this, map);
	    },
	
	    setBoundsFromMarkers: function setBoundsFromMarkers() {
	        this.setBounds([[this.markers['top'].getLatLng().lat, this.markers['left'].getLatLng().lng], [this.markers['bottom'].getLatLng().lat, this.markers['right'].getLatLng().lng]]);
	    },
	    onMarkerDrag: function onMarkerDrag() {
	        this.setBoundsFromMarkers();
	    },
	
	    onMarkerDragEnd: function onMarkerDragEnd() {
	        this.setBoundsFromMarkers();
	        this.placeMarkers();
	        this.fire('change');
	    }
	});
	
	exports.RectangleSelect = RectangleSelect;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enableAdaptiveHeight(control) {
	    if (control._adaptiveHeightEnabled) {
	        return;
	    }
	    var originalOnAdd = control.onAdd;
	
	    _leaflet2.default.Util.extend(control, {
	        _adaptiveHeightEnabled: true,
	
	        onAdd: function onAdd(map) {
	            var _this = this;
	
	            var result = originalOnAdd.call(this, map);
	            this.__setupResizeEventsHandler();
	            setTimeout(function () {
	                return _this.__setAdaptiveHeight();
	            }, 0);
	            return result;
	        },
	
	        __setupResizeEventsHandler: function __setupResizeEventsHandler() {
	            this._map.on('resize', this.__setAdaptiveHeight, this);
	        },
	
	        __setAdaptiveHeight: function __setAdaptiveHeight() {
	            var mapHeight = this._map.getSize().y;
	            var maxHeight = void 0;
	            maxHeight = mapHeight - this._container.offsetTop // controls above
	            - (this._container.parentNode.offsetHeight - this._container.offsetTop - this._container.offsetHeight) //controls below
	            - 70; // margin
	            this._form.style.maxHeight = maxHeight + 'px';
	        }
	    });
	
	    if (control._map) {
	        control.__setupResizeEventsHandler();
	        setTimeout(function () {
	            return control.__setAdaptiveHeight();
	        }, 0);
	    }
	
	    return control;
	}
	
	exports.default = enableAdaptiveHeight;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(451);
	
	var _leafletControlLayers = __webpack_require__(116);
	
	var _leafletControlLayers2 = _interopRequireDefault(_leafletControlLayers);
	
	var _knockout = __webpack_require__(51);
	
	var _knockout2 = _interopRequireDefault(_knockout);
	
	var _notifications = __webpack_require__(35);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	var _safeLocalstorage = __webpack_require__(63);
	
	var _safeLocalstorage2 = _interopRequireDefault(_safeLocalstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function enableConfig(control, layers) {
	    var _ref;
	
	    var originalOnAdd = control.onAdd;
	    var originalUnserializeState = control.unserializeState;
	    var originalAddItem = control._addItem;
	    if (control._configEnabled) {
	        return;
	    }
	    (0, _leafletControlLayers2.default)(control);
	
	    _leaflet2.default.Util.extend(control, {
	        _configEnabled: true,
	        _allLayersGroups: layers,
	        _allLayers: (_ref = []).concat.apply(_ref, _toConsumableArray(layers.map(function (group) {
	            return group.layers;
	        }))),
	        _customLayers: _knockout2.default.observableArray(),
	
	        onAdd: function onAdd(map) {
	            var container = originalOnAdd.call(this, map);
	            this.__injectConfigButton();
	            return container;
	        },
	
	        __injectConfigButton: function __injectConfigButton() {
	            var configButton = _leaflet2.default.DomUtil.create('div', 'button icon-settings');
	            configButton.title = 'Configure layers';
	            this._topRow.appendChild(configButton);
	            _leaflet2.default.DomEvent.on(configButton, 'click', this._onConfigButtonClick, this);
	
	            var newCustomLayerButton = _leaflet2.default.DomUtil.create('div', 'button icon-edit');
	            newCustomLayerButton.title = 'Add custom layer';
	            this._topRow.appendChild(newCustomLayerButton);
	            _leaflet2.default.DomEvent.on(newCustomLayerButton, 'click', this.onCustomLayerCreateClicked, this);
	        },
	
	        _initializeLayersState: function _initializeLayersState() {
	            var _this = this;
	
	            var storedLayersEnabled = {};
	            var serialized = _safeLocalstorage2.default.getItem('layersEnabled');
	            if (serialized) {
	                try {
	                    storedLayersEnabled = JSON.parse(serialized);
	                } catch (e) {
	                    _logging2.default.captureMessage('Failed to load enabled layers from localstorage - invalid json', {
	                        extra: { "localstorage.layersEnabled": serialized.slice(0, 1000) }
	                    });
	                }
	            }
	            // restore custom layers
	            Object.keys(storedLayersEnabled).forEach(function (code) {
	                return _this.loadCustomLayerFromString(code);
	            });
	
	            var _arr = [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers()));
	
	            for (var _i = 0; _i < _arr.length; _i++) {
	                var layer = _arr[_i];
	                var enabled = storedLayersEnabled[layer.layer.options.code];
	                // if storage is empty enable only default layers
	                // if new default layer appears it will be enabled
	                if (typeof enabled === 'undefined') {
	                    enabled = layer.isDefault;
	                }
	                layer.enabled = enabled;
	                layer.checked = _knockout2.default.observable(enabled);
	                layer.description = layer.description || '';
	            }
	            this.updateEnabledLayers();
	        },
	
	        _onConfigButtonClick: function _onConfigButtonClick() {
	            this.showLayersSelectWindow();
	        },
	
	        _initLayersSelectWindow: function _initLayersSelectWindow() {
	            if (this._configWindow) {
	                return;
	            }
	
	            var container = this._configWindow = _leaflet2.default.DomUtil.create('div', 'leaflet-layers-dialog-wrapper');
	            _leaflet2.default.DomEvent.disableClickPropagation(container).disableScrollPropagation(container);
	            container.innerHTML = '\n<div class="leaflet-layers-select-window">\n    <form>\n        <!-- ko foreach: _allLayersGroups -->\n            <div class="section-header" data-bind="html: group"></div>\n            <!-- ko foreach: layers -->\n                <label>\n                    <input type="checkbox" data-bind="checked: checked"/>\n                    <span data-bind="text: title">\n                    </span><!--  ko if: description -->\n                    <span data-bind="html: description || \'\'"></span>\n                    <!-- /ko -->\n                </label>\n            <!-- /ko -->\n        <!-- /ko -->\n        <div data-bind="if: _customLayers().length" class="section-header">Custom layers</div>\n        <!-- ko foreach: _customLayers -->\n                <label>\n                    <input type="checkbox" data-bind="checked: checked"/>\n                    <span data-bind="text: title"></span>\n                </label>\n        <!-- /ko -->\n    </form>\n    <div class="buttons-row">\n        <div href="#" class="button" data-bind="click: onSelectWindowOkClicked">Ok</div>\n        <div href="#" class="button" data-bind="click: onSelectWindowCancelClicked">Cancel</div>\n        <div href="#" class="button" data-bind="click: onSelectWindowResetClicked">Reset</div>\n    </div>            \n</div>\n                ';
	            _knockout2.default.applyBindings(this, container);
	        },
	
	        showLayersSelectWindow: function showLayersSelectWindow() {
	            if (this._configWindowVisible) {
	                return;
	            }
	            [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers())).forEach(function (layer) {
	                return layer.checked(layer.enabled);
	            });
	            this._initLayersSelectWindow();
	            this._map._controlContainer.appendChild(this._configWindow);
	            this._configWindowVisible = true;
	        },
	
	        hideSelectWindow: function hideSelectWindow() {
	            if (!this._configWindowVisible) {
	                return;
	            }
	            this._map._controlContainer.removeChild(this._configWindow);
	            this._configWindowVisible = false;
	        },
	
	        onSelectWindowCancelClicked: function onSelectWindowCancelClicked() {
	            this.hideSelectWindow();
	        },
	
	        onSelectWindowResetClicked: function onSelectWindowResetClicked() {
	            if (!this._configWindow) {
	                return;
	            }
	            [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers())).forEach(function (layer) {
	                return layer.checked(layer.isDefault);
	            });
	        },
	
	        onSelectWindowOkClicked: function onSelectWindowOkClicked() {
	            [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers())).forEach(function (layer) {
	                return layer.enabled = layer.checked();
	            });
	            this.updateEnabledLayers();
	            this.hideSelectWindow();
	        },
	
	        onCustomLayerCreateClicked: function onCustomLayerCreateClicked() {
	            var _this2 = this;
	
	            this.showCustomLayerForm([{
	                caption: 'Add layer',
	                callback: function callback(fieldValues) {
	                    return _this2.onCustomLayerAddClicked(fieldValues);
	                }
	            }, {
	                caption: 'Cancel',
	                callback: function callback() {
	                    return _this2.onCustomLayerCancelClicked();
	                }
	            }], {
	                name: 'Custom layer',
	                url: '',
	                tms: false,
	                maxZoom: 18,
	                isOverlay: false,
	                scaleDependent: false
	            });
	        },
	
	        updateEnabledLayers: function updateEnabledLayers() {
	            var _this3 = this;
	
	            var disabledLayers = [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers())).filter(function (l) {
	                return !l.enabled;
	            });
	            disabledLayers.forEach(function (l) {
	                return _this3._map.removeLayer(l.layer);
	            });
	            [].concat(_toConsumableArray(this._layers)).forEach(function (l) {
	                return _this3.removeLayer(l.layer);
	            });
	
	            var hasBaselayerOnMap = false;
	            var enabledLayers = [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers())).filter(function (l) {
	                return l.enabled;
	            });
	            enabledLayers.sort(function (l1, l2) {
	                return l1.order - l2.order;
	            });
	            enabledLayers.forEach(function (l) {
	                l.isOverlay ? _this3.addOverlay(l.layer, l.title) : _this3.addBaseLayer(l.layer, l.title);
	                if (!l.isOverlay && _this3._map.hasLayer(l.layer)) {
	                    hasBaselayerOnMap = true;
	                }
	            });
	            // если нет активного базового слоя, включить первый, если он есть
	            if (!hasBaselayerOnMap) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = enabledLayers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var layer = _step.value;
	
	                        if (!layer.isOverlay) {
	                            this._map.addLayer(layer.layer);
	                            break;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	            this.storeEnabledLayers();
	        },
	
	        storeEnabledLayers: function storeEnabledLayers() {
	            var layersState = {};
	
	            var _arr2 = [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers()));
	
	            for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	                var layer = _arr2[_i2];
	                if (layer.isDefault || layer.enabled || layer.isCustom) {
	                    layersState[layer.layer.options.code] = layer.enabled;
	                }
	            }
	            var serialized = JSON.stringify(layersState);
	            _safeLocalstorage2.default.setItem('layersEnabled', serialized);
	        },
	
	        unserializeState: function unserializeState(values) {
	            var _this4 = this;
	
	            if (values) {
	                values = values.map(function (code) {
	                    var newCode = _this4.loadCustomLayerFromString(code);
	                    return newCode || code;
	                });
	
	                var _arr3 = [].concat(_toConsumableArray(this._allLayers), _toConsumableArray(this._customLayers()));
	
	                for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
	                    var layer = _arr3[_i3];
	                    if (layer.layer.options && values.includes(layer.layer.options.code)) {
	                        layer.enabled = true;
	                    }
	                }
	                this.updateEnabledLayers();
	            }
	            this.storeEnabledLayers();
	            return originalUnserializeState.call(this, values);
	        },
	
	        showCustomLayerForm: function showCustomLayerForm(buttons, fieldValues) {
	            if (this._customLayerWindow) {
	                return;
	            }
	            this._customLayerWindow = _leaflet2.default.DomUtil.create('div', 'leaflet-layers-dialog-wrapper', this._map._controlContainer);
	
	            _leaflet2.default.DomEvent.disableClickPropagation(this._customLayerWindow).disableScrollPropagation(this._customLayerWindow);
	
	            var customLayerWindow = _leaflet2.default.DomUtil.create('div', 'custom-layers-window', this._customLayerWindow);
	            var form = _leaflet2.default.DomUtil.create('form', '', customLayerWindow);
	
	            var buttonsHtml = '';
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = buttons.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _step2$value = _slicedToArray(_step2.value, 2),
	                        i = _step2$value[0],
	                        button = _step2$value[1];
	
	                    buttonsHtml += '<a class="button" name="btn-' + i + '">' + button.caption + '</a>';
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            _leaflet2.default.DomEvent.on(form, 'submit', _leaflet2.default.DomEvent.preventDefault);
	            form.innerHTML = '\n<p><a href="http://leafletjs.com/reference-1.0.2.html#tilelayer" target="_blank">See Leaflet TileLayer documentation for url format</a></p>\n<label>Layer name<br/>\n<input name="name"/></label><br/>\n<label>Tile url template<br/>\n<textarea name="url" style="width: 100%"></textarea></label><br/>\n<label><input type="radio" name="overlay" value="no">Base layer</label><br/>\n<label><input type="radio" name="overlay" value="yes">Overlay</label><br/>\n<label><input type="checkbox" name="scaleDependent"/>Content depends on scale(like OSM or Google maps)</label><br/>\n<label><input type="checkbox" name="tms" />TMS rows order</label><br />\n\n<label>Max zoom<br>\n<select name="maxZoom">\n<option value="9">9</option>\n<option value="10">10</option>\n<option value="11">11</option>\n<option value="12">12</option>\n<option value="13">13</option>\n<option value="14">14</option>\n<option value="15">15</option>\n<option value="16">16</option>\n<option value="17">17</option>\n<option value="18" selected>18</option>\n</select></label>\n<br />\n' + buttonsHtml;
	
	            form.name.value = fieldValues.name;
	            form.url.value = fieldValues.url;
	            form.tms.checked = fieldValues.tms;
	            form.scaleDependent.checked = fieldValues.scaleDependent;
	            form.maxZoom.value = fieldValues.maxZoom;
	            form.overlay[fieldValues.isOverlay ? 1 : 0].checked = true;
	
	            function buttonClicked(callback) {
	                var fieldValues = {
	                    name: form.name.value.trim(),
	                    url: form.url.value.trim(),
	                    tms: form.tms.checked,
	                    scaleDependent: form.scaleDependent.checked,
	                    maxZoom: form.maxZoom.value,
	                    isOverlay: form.querySelector('input[name="overlay"]:checked').value === 'yes'
	                };
	                callback(fieldValues);
	            }
	
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = buttons.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var _step3$value = _slicedToArray(_step3.value, 2),
	                        i = _step3$value[0],
	                        button = _step3$value[1];
	
	                    var buttonEl = form.querySelector('[name="btn-' + i + '"]');
	                    _leaflet2.default.DomEvent.on(buttonEl, 'click', buttonClicked.bind(this, button.callback));
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	        },
	
	        _addItem: function _addItem(obj) {
	            var _this5 = this;
	
	            var label = originalAddItem.call(this, obj);
	            if (obj.layer.__customLayer) {
	                var editButton = _leaflet2.default.DomUtil.create('div', 'custom-layer-edit-button icon-edit', label.children[0]);
	                editButton.title = 'Edit layer';
	                _leaflet2.default.DomEvent.on(editButton, 'click', function (e) {
	                    return _this5.onCustomLayerEditClicked(obj.layer.__customLayer, e);
	                });
	            }
	            return label;
	        },
	
	        serializeCustomLayer: function serializeCustomLayer(fieldValues) {
	            var s = JSON.stringify(fieldValues);
	            s = s.replace(/[\u007f-\uffff]/g, function (c) {
	                return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	            });
	
	            function encodeUrlSafeBase64(s) {
	                return btoa(s).replace(/\+/g, '-').replace(/\//g, '_');
	            }
	
	            return '-cs' + encodeUrlSafeBase64(s);
	        },
	
	        customLayerExists: function customLayerExists(fieldValues, ignoreLayer) {
	            var serialized = this.serializeCustomLayer(fieldValues);
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = this._customLayers()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var layer = _step4.value;
	
	                    if (layer !== ignoreLayer && layer.serialized === serialized) {
	                        return layer;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	
	            return false;
	        },
	
	        checkCustomLayerValues: function checkCustomLayerValues(fieldValues) {
	            if (!fieldValues.url) {
	                return { 'error': 'Url is empty' };
	            }
	            if (!fieldValues.name) {
	                return { 'error': 'Name is empty' };
	            }
	            return {};
	        },
	
	        onCustomLayerAddClicked: function onCustomLayerAddClicked(fieldValues) {
	            var error = this.checkCustomLayerValues(fieldValues).error;
	            if (error) {
	                (0, _notifications.notify)(error);
	                return;
	            }
	
	            var duplicateLayer = this.customLayerExists(fieldValues);
	            if (duplicateLayer) {
	                var msg = 'Same layer already exists';
	                if (!duplicateLayer.enabled) {
	                    msg += ' but it is hidden. You can enable it in layers setting.';
	                }
	                (0, _notifications.notify)(msg);
	                return;
	            }
	
	            var layer = this.createCustomLayer(fieldValues);
	            layer.enabled = true;
	            layer.checked = _knockout2.default.observable(true);
	            this._customLayers.push(layer);
	            this.hideCustomLayerForm();
	            this.updateEnabledLayers();
	        },
	
	        createCustomLayer: function createCustomLayer(fieldValues, position, ignoreExists) {
	            var serialized = this.serializeCustomLayer(fieldValues);
	            var tileLayer = _leaflet2.default.tileLayer(fieldValues.url, {
	                tms: fieldValues.tms,
	                maxNativeZoom: fieldValues.maxZoom,
	                scaleDependent: fieldValues.scaleDependent,
	                print: true,
	                jnx: true,
	                code: serialized,
	                noCors: true
	            });
	
	            var customLayer = {
	                title: fieldValues.name,
	                isOverlay: fieldValues.isOverlay,
	                isDefault: false,
	                isCustom: true,
	                serialized: serialized,
	                layer: tileLayer,
	                order: 10000,
	                fieldValues: fieldValues,
	                enabled: true,
	                checked: _knockout2.default.observable(true)
	            };
	            tileLayer.__customLayer = customLayer;
	            return customLayer;
	        },
	
	        onCustomLayerCancelClicked: function onCustomLayerCancelClicked() {
	            this.hideCustomLayerForm();
	        },
	
	        hideCustomLayerForm: function hideCustomLayerForm() {
	            if (!this._customLayerWindow) {
	                return;
	            }
	            this._customLayerWindow.parentNode.removeChild(this._customLayerWindow);
	            this._customLayerWindow = null;
	        },
	
	        onCustomLayerEditClicked: function onCustomLayerEditClicked(layer, e) {
	            var _this6 = this;
	
	            _leaflet2.default.DomEvent.stop(e);
	            this.showCustomLayerForm([{ caption: 'Save', callback: function callback(fieldValues) {
	                    return _this6.onCustomLayerChangeClicked(layer, fieldValues);
	                } }, { caption: 'Delete', callback: function callback(fieldValues) {
	                    return _this6.onCustomLayerDeletelClicked(layer);
	                } }, { caption: 'Cancel', callback: function callback() {
	                    return _this6.onCustomLayerCancelClicked();
	                } }], layer.fieldValues);
	        },
	
	        onCustomLayerChangeClicked: function onCustomLayerChangeClicked(layer, newFieldValues) {
	            var error = this.checkCustomLayerValues(newFieldValues).error;
	            if (error) {
	                (0, _notifications.notify)(error);
	                return;
	            }
	            var duplicateLayer = this.customLayerExists(newFieldValues, layer);
	            if (duplicateLayer) {
	                var msg = 'Same layer already exists';
	                if (!duplicateLayer.enabled) {
	                    msg += ' but it is hidden. You can enable it in layers setting.';
	                }
	                (0, _notifications.notify)(msg);
	                return;
	            }
	
	            var layerPos = this._customLayers.indexOf(layer);
	            this._customLayers.remove(layer);
	
	            var newLayer = this.createCustomLayer(newFieldValues);
	            this._customLayers.splice(layerPos, 0, newLayer);
	            if (this._map.hasLayer(layer.layer) && (!layer.isOverlay || newLayer.isOverlay)) {
	                this._map.addLayer(newLayer.layer);
	            }
	            this._map.removeLayer(layer.layer);
	            this.updateEnabledLayers();
	            this.hideCustomLayerForm();
	        },
	
	        onCustomLayerDeletelClicked: function onCustomLayerDeletelClicked(layer) {
	            this._map.removeLayer(layer.layer);
	            this._customLayers.remove(layer);
	            this.updateEnabledLayers();
	            this.hideCustomLayerForm();
	        },
	
	        loadCustomLayerFromString: function loadCustomLayerFromString(s) {
	            var fieldValues = void 0;
	            var m = s.match(/^-cs(.+)$/);
	            if (m) {
	                s = m[1].replace(/-/g, '+').replace(/_/g, '/');
	                try {
	                    s = atob(s);
	                    fieldValues = JSON.parse(s);
	                } catch (e) {}
	
	                if (fieldValues) {
	                    if (!this.customLayerExists(fieldValues)) {
	                        this._customLayers.push(this.createCustomLayer(fieldValues));
	                    }
	                    return this.serializeCustomLayer(fieldValues);
	                }
	            }
	        }
	
	    });
	    if (control._map) {
	        control.__injectConfigButton();
	    }
	    control._initializeLayersState();
	}
	
	exports.default = enableConfig;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalLayerOnAdd = _leaflet2.default.Control.Layers.prototype.onAdd;
	
	_leaflet2.default.Control.Layers.include({
	    onAdd: function onAdd(map) {
	        var container = originalLayerOnAdd.call(this, map);
	        this._stopContainerEvents();
	        return container;
	    }
	});
	
	var originalZoomOnAdd = _leaflet2.default.Control.Zoom.prototype.onAdd;
	
	_leaflet2.default.Control.Zoom.include({
	    onAdd: function onAdd(map) {
	        var container = originalZoomOnAdd.call(this, map);
	        this._container = container;
	        this._stopContainerEvents();
	        return container;
	    }
	});

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(453);
	
	__webpack_require__(38);
	
	var _leafletControlLayers = __webpack_require__(116);
	
	var _leafletControlLayers2 = _interopRequireDefault(_leafletControlLayers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enableMinimize(control) {
	    var originalOnAdd = control.onAdd;
	    if (control._minimizeEnabled) {
	        return;
	    }
	    (0, _leafletControlLayers2.default)(control);
	
	    _leaflet2.default.Util.extend(control, {
	        _minimizeEnabled: true,
	
	        onAdd: function onAdd(map) {
	            var _this = this;
	
	            var container = originalOnAdd.call(this, map);
	            setTimeout(function () {
	                return _this.__injectMinimizeButtons();
	            }, 0);
	            return container;
	        },
	
	        __injectMinimizeButtons: function __injectMinimizeButtons() {
	            var container = this._container;
	            var contentsWrapper = _leaflet2.default.DomUtil.create('div', 'leaflet-control-content');
	            while (container.childNodes.length) {
	                contentsWrapper.appendChild(container.childNodes[0]);
	            }
	            container.appendChild(contentsWrapper);
	            var minimizeButton = _leaflet2.default.DomUtil.create('div', 'button-minimize');
	            this._topRow.appendChild(minimizeButton);
	            var expandButton = _leaflet2.default.DomUtil.create('div', 'leaflet-control-button-toggle', container);
	            expandButton.title = 'Select layers';
	            _leaflet2.default.DomEvent.on(expandButton, 'click', this.setExpanded, this);
	            _leaflet2.default.DomEvent.on(minimizeButton, 'click', this.setMinimized, this);
	        },
	
	        setExpanded: function setExpanded() {
	            _leaflet2.default.DomUtil.removeClass(this._container, 'minimized');
	        },
	
	        setMinimized: function setMinimized() {
	            _leaflet2.default.DomUtil.addClass(this._container, 'minimized');
	        }
	    });
	    if (control._map) {
	        control.__injectMinimizeButtons();
	    }
	}
	
	exports.default = enableMinimize;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(457);
	
	__webpack_require__(38);
	
	var _knockout = __webpack_require__(51);
	
	var _knockout2 = _interopRequireDefault(_knockout);
	
	var _google = __webpack_require__(192);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _mapillary = __webpack_require__(193);
	
	var _mapillary2 = _interopRequireDefault(_mapillary);
	
	var _wikimedia = __webpack_require__(199);
	
	var _wikimedia2 = _interopRequireDefault(_wikimedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function fireRefreshEventOnWindow() {
	    var evt = document.createEvent("HTMLEvents");
	    evt.initEvent('resize', true, false);
	    window.dispatchEvent(evt);
	}
	
	var PanoMarker = _leaflet2.default.Marker.extend({
	    options: {
	        zIndexOffset: 10000
	    },
	
	    initialize: function initialize() {
	        var icon = _leaflet2.default.divIcon({
	            className: 'leaflet-panorama-marker-wraper',
	            html: '<div class="leaflet-panorama-marker"></div>'
	        });
	        _leaflet2.default.Marker.prototype.initialize.call(this, [0, 0], { icon: icon, interactive: false });
	    },
	
	    getIcon: function getIcon() {
	        var markerIcon = this.getElement();
	        markerIcon = markerIcon.children[0];
	        return markerIcon;
	    },
	
	    setHeading: function setHeading(angle) {
	        var markerIcon = this.getIcon();
	        markerIcon.style.transform = 'rotate(' + (angle || 0) + 'deg)';
	    },
	
	    setType: function setType(markerType) {
	        var className = {
	            'slim': 'leaflet-panorama-marker-circle',
	            'normal': 'leaflet-panorama-marker-binocular' }[markerType];
	        this.getIcon().className = className;
	    }
	});
	
	_leaflet2.default.Control.Panoramas = _leaflet2.default.Control.extend({
	    includes: _leaflet2.default.Mixin.Events,
	
	    options: {
	        position: 'topleft'
	    },
	
	    getProviders: function getProviders() {
	        return [{ name: 'google', title: 'Google street view', provider: _google2.default, layerOptions: { zIndex: 10 },
	            code: 'g',
	            selected: _knockout2.default.observable(true),
	            mapMarkerType: 'normal' }, { name: 'wikimedia', title: 'Wikimedia commons', provider: _wikimedia2.default,
	            layerOptions: { opacity: 0.7, zIndex: 9 },
	            code: 'w',
	            selected: _knockout2.default.observable(false),
	            mapMarkerType: 'slim'
	        }, { name: 'mapillary', title: 'Mapillary', provider: _mapillary2.default,
	            layerOptions: { opacity: 0.7, zIndex: 8 },
	            code: 'm',
	            selected: _knockout2.default.observable(false),
	            mapMarkerType: 'normal' }];
	    },
	
	    initialize: function initialize(panoramaContainer, options) {
	        _leaflet2.default.Control.prototype.initialize.call(this, options);
	        this._panoramaContainer = panoramaContainer;
	        this.providers = this.getProviders();
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this.providers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var provider = _step.value;
	
	                provider.selected.subscribe(this.updateCoverageVisibility, this);
	                provider.container = _leaflet2.default.DomUtil.create('div', 'panorama-container', panoramaContainer);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        this.nearbyPoints = [];
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control leaflet-contol-panoramas');
	        container.innerHTML = '\n                <a name="button" class="panoramas-button leaflet-control-button icon-panoramas" title="Show panoramas"\n                    data-bind="click: onButtonClick"></a>\n                <div class="panoramas-list control-form" data-bind="foreach: providers">\n                    <div><label><input type="checkbox" data-bind="checked: selected"><span data-bind="text: title"></span></label></div>\n                </div>\n            ';
	        this._stopContainerEvents();
	        _knockout2.default.applyBindings(this, container);
	        map.createPane('rasterOverlay').style.zIndex = 300;
	        return container;
	    },
	
	    onButtonClick: function onButtonClick() {
	        if (this.controlEnabled) {
	            this.disableControl();
	        } else {
	            this.enableControl();
	        }
	    },
	
	    enableControl: function enableControl() {
	        if (this.controlEnabled) {
	            return;
	        }
	        this.controlEnabled = true;
	        _leaflet2.default.DomUtil.addClass(this._container, 'enabled');
	        this.updateCoverageVisibility();
	        this._map.on('click', this.onMapClick, this);
	        _leaflet2.default.DomUtil.addClass(this._map._container, 'panoramas-control-active');
	        this.notifyChanged();
	    },
	
	    disableControl: function disableControl() {
	        if (!this.controlEnabled) {
	            return;
	        }
	        this.controlEnabled = false;
	        _leaflet2.default.DomUtil.removeClass(this._container, 'enabled');
	        this.updateCoverageVisibility();
	        this._map.off('click', this.onMapClick, this);
	        this.hidePanoViewer();
	        _leaflet2.default.DomUtil.removeClass(this._map._container, 'panoramas-control-active');
	        this.notifyChanged();
	    },
	
	    updateCoverageVisibility: function updateCoverageVisibility() {
	        if (!this._map) {
	            return;
	        }
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = this.providers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var provider = _step2.value;
	
	                if (this.controlEnabled && provider.selected()) {
	                    if (!provider.coverageLayer) {
	                        var options = _leaflet2.default.extend({ pane: 'rasterOverlay' }, provider.layerOptions);
	                        provider.coverageLayer = provider.provider.getCoverageLayer(options);
	                    }
	                    provider.coverageLayer.addTo(this._map);
	                } else {
	                    if (provider.coverageLayer) {
	                        this._map.removeLayer(provider.coverageLayer);
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        this.notifyChanged();
	    },
	
	    showPanoramaContainer: function showPanoramaContainer() {
	        _leaflet2.default.DomUtil.addClass(this._panoramaContainer, 'enabled');
	        fireRefreshEventOnWindow();
	    },
	
	    panoramaVisible: function panoramaVisible() {
	        if (_leaflet2.default.DomUtil.hasClass(this._panoramaContainer, 'enabled')) {
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = this.providers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var provider = _step3.value;
	
	                    if (_leaflet2.default.DomUtil.hasClass(provider.container, 'enabled')) {
	                        return provider;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	        }
	        return false;
	    },
	
	    setupNearbyPoints: function setupNearbyPoints(points) {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = this.nearbyPoints[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var point = _step4.value;
	
	                this._map.removeLayer(point);
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        this.nearbyPoints = [];
	        if (points) {
	            var icon = _leaflet2.default.divIcon({ className: 'leaflet-panorama-marker-point' });
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	                for (var _iterator5 = points[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                    var latlng = _step5.value;
	
	                    this.nearbyPoints.push(_leaflet2.default.marker(latlng, { icon: icon }).addTo(this._map));
	                }
	            } catch (err) {
	                _didIteratorError5 = true;
	                _iteratorError5 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                        _iterator5.return();
	                    }
	                } finally {
	                    if (_didIteratorError5) {
	                        throw _iteratorError5;
	                    }
	                }
	            }
	        }
	    },
	
	    hidePano: function hidePano(provider) {
	        _leaflet2.default.DomUtil.removeClass(provider.container, 'enabled');
	        if (provider.viewer) {
	            provider.viewer.deactivate();
	        }
	        this.setupNearbyPoints();
	    },
	
	    showPano: function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(provider, data) {
	            var _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, otherProvider;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            this.showPanoramaContainer();
	                            _iteratorNormalCompletion6 = true;
	                            _didIteratorError6 = false;
	                            _iteratorError6 = undefined;
	                            _context.prev = 4;
	                            for (_iterator6 = this.providers[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                                otherProvider = _step6.value;
	
	                                if (otherProvider !== provider) {
	                                    this.hidePano(otherProvider);
	                                }
	                            }
	                            _context.next = 12;
	                            break;
	
	                        case 8:
	                            _context.prev = 8;
	                            _context.t0 = _context['catch'](4);
	                            _didIteratorError6 = true;
	                            _iteratorError6 = _context.t0;
	
	                        case 12:
	                            _context.prev = 12;
	                            _context.prev = 13;
	
	                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                                _iterator6.return();
	                            }
	
	                        case 15:
	                            _context.prev = 15;
	
	                            if (!_didIteratorError6) {
	                                _context.next = 18;
	                                break;
	                            }
	
	                            throw _iteratorError6;
	
	                        case 18:
	                            return _context.finish(15);
	
	                        case 19:
	                            return _context.finish(12);
	
	                        case 20:
	                            _leaflet2.default.DomUtil.addClass(provider.container, 'enabled');
	
	                            if (provider.viewer) {
	                                _context.next = 26;
	                                break;
	                            }
	
	                            _context.next = 24;
	                            return provider.provider.getViewer(provider.container);
	
	                        case 24:
	                            provider.viewer = _context.sent;
	
	                            this.setupViewerEvents(provider);
	
	                        case 26:
	                            if (data) {
	                                // wait for panorama container become of right size, needed for viewer setup
	                                _leaflet2.default.Util.requestAnimFrame(function () {
	                                    return provider.viewer.showPano(data);
	                                });
	                            }
	                            provider.viewer.activate();
	                            this.notifyChanged();
	
	                        case 29:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[4, 8, 12, 20], [13,, 15, 19]]);
	        }));
	
	        function showPano(_x, _x2) {
	            return _ref.apply(this, arguments);
	        }
	
	        return showPano;
	    }(),
	
	    setupViewerEvents: function setupViewerEvents(provider) {
	        provider.viewer.on({
	            'change': this.onPanoramaChangeView.bind(this, provider),
	            'closeclick': this.onPanoramaCloseClick
	        }, this);
	    },
	
	    hidePanoViewer: function hidePanoViewer() {
	        var _iteratorNormalCompletion7 = true;
	        var _didIteratorError7 = false;
	        var _iteratorError7 = undefined;
	
	        try {
	            for (var _iterator7 = this.providers[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                var provider = _step7.value;
	
	                this.hidePano(provider);
	            }
	        } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                    _iterator7.return();
	                }
	            } finally {
	                if (_didIteratorError7) {
	                    throw _iteratorError7;
	                }
	            }
	        }
	
	        _leaflet2.default.DomUtil.removeClass(this._panoramaContainer, 'enabled');
	        this.hideMarker();
	        fireRefreshEventOnWindow();
	        this.notifyChanged();
	    },
	
	    placeMarker: function placeMarker(latlng, heading) {
	        if (!this.panoramaVisible()) {
	            return;
	        }
	        if (!this.marker) {
	            this.marker = new PanoMarker();
	        }
	        this._map.addLayer(this.marker);
	        this.marker.setLatLng(latlng);
	        this.marker.setHeading(heading);
	    },
	
	    hideMarker: function hideMarker() {
	        if (this.marker) {
	            this._map.removeLayer(this.marker);
	        }
	    },
	    notifyChanged: function notifyChanged() {
	        this.fire('panoramachanged');
	    },
	
	    onPanoramaChangeView: function onPanoramaChangeView(provider, e) {
	        if (!this._map.getBounds().pad(-0.05).contains(e.latlng)) {
	            this._map.panTo(e.latlng);
	        }
	        this.placeMarker(e.latlng, e.heading);
	        this.marker.setType(provider.mapMarkerType);
	        this.setupNearbyPoints(e.latlngs);
	        this.notifyChanged();
	    },
	
	    onPanoramaCloseClick: function onPanoramaCloseClick(e) {
	        this.hidePanoViewer();
	    },
	
	    onMapClick: function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
	            var searchRadiusPx, p, searchRadiusMeters, promises, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, provider, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _step9$value, promise, _provider, searchResult;
	
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            searchRadiusPx = 24, p = this._map.project(e.latlng).add([searchRadiusPx, 0]), searchRadiusMeters = e.latlng.distanceTo(this._map.unproject(p)), promises = [];
	                            _iteratorNormalCompletion8 = true;
	                            _didIteratorError8 = false;
	                            _iteratorError8 = undefined;
	                            _context2.prev = 4;
	
	                            for (_iterator8 = this.providers[Symbol.iterator](); !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                                provider = _step8.value;
	
	                                if (provider.selected()) {
	                                    promises.push({
	                                        promise: provider.provider.getPanoramaAtPos(e.latlng, searchRadiusMeters),
	                                        provider: provider
	                                    });
	                                }
	                            }
	
	                            _context2.next = 12;
	                            break;
	
	                        case 8:
	                            _context2.prev = 8;
	                            _context2.t0 = _context2['catch'](4);
	                            _didIteratorError8 = true;
	                            _iteratorError8 = _context2.t0;
	
	                        case 12:
	                            _context2.prev = 12;
	                            _context2.prev = 13;
	
	                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                                _iterator8.return();
	                            }
	
	                        case 15:
	                            _context2.prev = 15;
	
	                            if (!_didIteratorError8) {
	                                _context2.next = 18;
	                                break;
	                            }
	
	                            throw _iteratorError8;
	
	                        case 18:
	                            return _context2.finish(15);
	
	                        case 19:
	                            return _context2.finish(12);
	
	                        case 20:
	                            _iteratorNormalCompletion9 = true;
	                            _didIteratorError9 = false;
	                            _iteratorError9 = undefined;
	                            _context2.prev = 23;
	                            _iterator9 = promises[Symbol.iterator]();
	
	                        case 25:
	                            if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
	                                _context2.next = 36;
	                                break;
	                            }
	
	                            _step9$value = _step9.value, promise = _step9$value.promise, _provider = _step9$value.provider;
	                            _context2.next = 29;
	                            return promise;
	
	                        case 29:
	                            searchResult = _context2.sent;
	
	                            if (!searchResult.found) {
	                                _context2.next = 33;
	                                break;
	                            }
	
	                            this.showPano(_provider, searchResult.data);
	                            return _context2.abrupt('return');
	
	                        case 33:
	                            _iteratorNormalCompletion9 = true;
	                            _context2.next = 25;
	                            break;
	
	                        case 36:
	                            _context2.next = 42;
	                            break;
	
	                        case 38:
	                            _context2.prev = 38;
	                            _context2.t1 = _context2['catch'](23);
	                            _didIteratorError9 = true;
	                            _iteratorError9 = _context2.t1;
	
	                        case 42:
	                            _context2.prev = 42;
	                            _context2.prev = 43;
	
	                            if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                                _iterator9.return();
	                            }
	
	                        case 45:
	                            _context2.prev = 45;
	
	                            if (!_didIteratorError9) {
	                                _context2.next = 48;
	                                break;
	                            }
	
	                            throw _iteratorError9;
	
	                        case 48:
	                            return _context2.finish(45);
	
	                        case 49:
	                            return _context2.finish(42);
	
	                        case 50:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[4, 8, 12, 20], [13,, 15, 19], [23, 38, 42, 50], [43,, 45, 49]]);
	        }));
	
	        function onMapClick(_x3) {
	            return _ref2.apply(this, arguments);
	        }
	
	        return onMapClick;
	    }()
	});
	
	_leaflet2.default.Control.Panoramas.include(_leaflet2.default.Mixin.HashState);
	_leaflet2.default.Control.Panoramas.include({
	    stateChangeEvents: ['panoramachanged'],
	
	    serializeState: function serializeState() {
	        var state = null;
	        if (this.controlEnabled) {
	            state = [];
	            var coverageCode = '_';
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	                for (var _iterator10 = this.providers[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                    var _provider2 = _step10.value;
	
	                    if (_provider2.selected()) {
	                        coverageCode += _provider2.code;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError10 = true;
	                _iteratorError10 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                        _iterator10.return();
	                    }
	                } finally {
	                    if (_didIteratorError10) {
	                        throw _iteratorError10;
	                    }
	                }
	            }
	
	            state.push(coverageCode);
	            var provider = this.panoramaVisible();
	            if (provider && provider.viewer) {
	                var viewerState = provider.viewer.getState();
	                if (viewerState) {
	                    var _state;
	
	                    state.push(provider.code);
	                    (_state = state).push.apply(_state, _toConsumableArray(viewerState));
	                }
	            }
	        }
	        return state;
	    },
	
	    unserializeState: function unserializeState(state) {
	        var _this = this;
	
	        if (!state) {
	            this.disableControl();
	            return true;
	        }
	
	        var coverageCode = state[0];
	        if (!coverageCode || coverageCode[0] !== '_') {
	            return false;
	        }
	        this.enableControl();
	        var _iteratorNormalCompletion11 = true;
	        var _didIteratorError11 = false;
	        var _iteratorError11 = undefined;
	
	        try {
	            for (var _iterator11 = this.providers[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	                var _provider3 = _step11.value;
	
	                _provider3.selected(coverageCode.includes(_provider3.code));
	            }
	        } catch (err) {
	            _didIteratorError11 = true;
	            _iteratorError11 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                    _iterator11.return();
	                }
	            } finally {
	                if (_didIteratorError11) {
	                    throw _iteratorError11;
	                }
	            }
	        }
	
	        if (state.length > 2) {
	            var panoramaVisible = state[1];
	            var _iteratorNormalCompletion12 = true;
	            var _didIteratorError12 = false;
	            var _iteratorError12 = undefined;
	
	            try {
	                var _loop = function _loop() {
	                    var provider = _step12.value;
	
	                    if (panoramaVisible === provider.code) {
	                        _this.showPano(provider).then(function () {
	                            var success = provider.viewer.setState(state.slice(2));
	                            if (!success) {
	                                _this.hidePanoViewer();
	                            }
	                        });
	                        return 'break';
	                    }
	                };
	
	                for (var _iterator12 = this.providers[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	                    var _ret = _loop();
	
	                    if (_ret === 'break') break;
	                }
	            } catch (err) {
	                _didIteratorError12 = true;
	                _iteratorError12 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
	                        _iterator12.return();
	                    }
	                } finally {
	                    if (_didIteratorError12) {
	                        throw _iteratorError12;
	                    }
	                }
	            }
	        }
	        return true;
	    }
	});
	
	_leaflet2.default.Control.Panoramas.hashStateUpgrader = function (panoramasControl) {
	    return _leaflet2.default.Util.extend({}, _leaflet2.default.Mixin.HashState, {
	        unserializeState: function unserializeState(oldState) {
	            if (oldState) {
	                console.log('Upgrading');
	                var upgradedState = ['_g'];
	                if (oldState.length) {
	                    upgradedState.push.apply(upgradedState, ['g'].concat(_toConsumableArray(oldState)));
	                }
	                setTimeout(function () {
	                    return panoramasControl.unserializeState(upgradedState);
	                }, 0);
	            }
	            return false;
	        },
	
	        serializeState: function serializeState() {
	            return null;
	        }
	    });
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var getStreetViewService = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var google;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return (0, _googleMapsApi2.default)();
	
	                    case 2:
	                        google = _context.sent;
	                        return _context.abrupt('return', new google.maps.StreetViewService());
	
	                    case 4:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getStreetViewService() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getPanoramaAtPos = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(latlng, searchRadiusMeters) {
	        var google, service, _ref3, data, status;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return (0, _googleMapsApi2.default)();
	
	                    case 2:
	                        google = _context2.sent;
	                        _context2.next = 5;
	                        return getStreetViewService();
	
	                    case 5:
	                        service = _context2.sent;
	                        _context2.next = 8;
	                        return new Promise(function (resolve) {
	                            service.getPanorama({
	                                location: latlng,
	                                radius: searchRadiusMeters,
	                                preference: google.maps.StreetViewPreference.NEAREST
	                            }, function (data, status) {
	                                return resolve({ data: data, status: status });
	                            });
	                        });
	
	                    case 8:
	                        _ref3 = _context2.sent;
	                        data = _ref3.data;
	                        status = _ref3.status;
	
	                        if (!(status === google.maps.StreetViewStatus.OK)) {
	                            _context2.next = 15;
	                            break;
	                        }
	
	                        return _context2.abrupt('return', { found: true, data: data });
	
	                    case 15:
	                        return _context2.abrupt('return', { found: false });
	
	                    case 16:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getPanoramaAtPos(_x, _x2) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var getViewer = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(container) {
	        var google;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.next = 2;
	                        return (0, _googleMapsApi2.default)();
	
	                    case 2:
	                        google = _context3.sent;
	                        return _context3.abrupt('return', new Viewer(google, container));
	
	                    case 4:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function getViewer(_x3) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _googleMapsApi = __webpack_require__(111);
	
	var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function getCoverageLayer(options) {
	    return _leaflet2.default.tileLayer('https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m8!1e2!2ssvv!4m2!1scb_client!2sapiv3!4m2!1scc!2s*211m3*211e3*212b1*213e2*211m3*211e2*212b1*213e2!3m5!3sUS!12m1!1e40!12m1!1e18!4e0', options);
	}
	
	var Viewer = _leaflet2.default.Evented.extend({
	    initialize: function initialize(google, container) {
	        var _this = this;
	
	        var panorama = this.panorama = new google.maps.StreetViewPanorama(container, {
	            enableCloseButton: true,
	            imageDateControl: true
	        });
	        panorama.addListener('position_changed', function () {
	            return _this.onPanoramaChangeView();
	        });
	        panorama.addListener('pov_changed', function () {
	            return _this.onPanoramaChangeView();
	        });
	        panorama.addListener('closeclick', function () {
	            return _this.onCloseClick();
	        });
	    },
	
	    showPano: function showPano(data) {
	        this.panorama.setPosition(data.location.latLng);
	        this.panorama.setZoom(1);
	    },
	
	    onPanoramaChangeView: function onPanoramaChangeView() {
	        if (!this._active) {
	            return;
	        }
	        var pos = this.panorama.getPosition();
	        pos = _leaflet2.default.latLng(pos.lat(), pos.lng());
	        var pov = this.panorama.getPov();
	        this.fire('change', { latlng: pos, heading: pov.heading, zoom: pov.zoom, pitch: pov.pitch });
	    },
	
	    onCloseClick: function onCloseClick() {
	        this.fire('closeclick');
	    },
	
	    activate: function activate() {
	        this._active = true;
	        this.panorama.setVisible(true);
	    },
	
	    deactivate: function deactivate() {
	        this._active = false;
	        this.panorama.setVisible(false);
	    },
	
	    getState: function getState() {
	        var pos = this.panorama.getPosition();
	        var pov = this.panorama.getPov();
	        if (pos && pov) {
	            return [pos.lat().toFixed(6), pos.lng().toFixed(6), (pov.heading || 0).toFixed(1), (pov.pitch || 0).toFixed(1), (pov.zoom || 1).toFixed(1)];
	        } else {
	            return null;
	        }
	    },
	
	    setState: function setState(state) {
	        var lat = parseFloat(state[0]);
	        var lng = parseFloat(state[1]);
	        var heading = parseFloat(state[2]);
	        var pitch = parseFloat(state[3]);
	        var zoom = parseFloat(state[4]);
	        if (!isNaN(lat) && !isNaN(lng) && !isNaN(heading) && !isNaN(pitch) && !isNaN(zoom)) {
	            this.panorama.setPosition({ lat: lat, lng: lng });
	            this.panorama.setPov({ heading: heading, pitch: pitch, zoom: zoom });
	            return true;
	        }
	        return false;
	    }
	});
	
	exports.default = { getCoverageLayer: getCoverageLayer, getPanoramaAtPos: getPanoramaAtPos, getViewer: getViewer };

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var getPanoramaAtPos = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(latlng, searchRadiusMeters) {
	        var url, resp;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        url = 'https://a.mapillary.com/v3/images?client_id=' + _config2.default.mapillary + '&closeto=' + latlng.lng + ',' + latlng.lat + '&radius=' + searchRadiusMeters;
	                        _context.next = 3;
	                        return (0, _xhrPromise.fetch)(url, { responseType: 'json', timeout: 10000 });
	
	                    case 3:
	                        resp = _context.sent;
	
	                        if (!(resp.status === 200 && resp.responseJSON.features.length)) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return', { found: true, data: resp.responseJSON.features[0].properties.key });
	
	                    case 6:
	                        return _context.abrupt('return', { found: false });
	
	                    case 7:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getPanoramaAtPos(_x, _x2) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getViewer = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(container) {
	        var mapillary;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return getMapillary();
	
	                    case 2:
	                        mapillary = _context2.sent;
	                        return _context2.abrupt('return', new Viewer(mapillary, container));
	
	                    case 4:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function getViewer(_x3) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _mapillaryCoverageLayer = __webpack_require__(194);
	
	var _xhrPromise = __webpack_require__(24);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(455);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function getCoverageLayer(options) {
	    return new _mapillaryCoverageLayer.MapillaryCoverage(options);
	}
	
	function getMapillary() {
	    return new Promise(function (resolve) {
	        __webpack_require__.e/* nsure */(1, function () {
	            __webpack_require__(165);
	            resolve(__webpack_require__(168));
	        });
	    });
	}
	
	function formatDateTime(ts) {
	    var d = new Date(ts);
	    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
	}
	
	var Viewer = _leaflet2.default.Evented.extend({
	    initialize: function initialize(mapillary, container) {
	        var id = 'container-' + _leaflet2.default.stamp(container);
	        container.id = id;
	        var viewer = this.viewer = new mapillary.Viewer(id, _config2.default.mapillary, null, { component: { cover: false, bearing: false } });
	        window.addEventListener('resize', function () {
	            viewer.resize();
	        });
	        viewer.on('nodechanged', this.onNodeChanged.bind(this));
	        viewer.on('bearingchanged', this.onBearingChanged.bind(this));
	        this.dateLabel = _leaflet2.default.DomUtil.create('div', 'mapillary-viewer-date-overlay', container);
	        this.closeButton = _leaflet2.default.DomUtil.create('div', 'photo-viewer-button-close', container);
	        _leaflet2.default.DomEvent.on(this.closeButton, 'click', this.onCloseClick, this);
	        this._bearing = 0;
	        this._zoom = 0;
	        this._center = [0, 0];
	    },
	
	    showPano: function showPano(data) {
	        var _this = this;
	
	        this.deactivate();
	        this.activate();
	        this.viewer.moveToKey(data).then(function () {
	            _this.viewer.setZoom(0);
	            _this.updateZoomAndCenter();
	        });
	    },
	
	    onNodeChanged: function onNodeChanged(node) {
	        if (this._node && node.key === this._node.key) {
	            return;
	        }
	        this._node = node;
	        this.fireChangeEvenet();
	        this.dateLabel.innerHTML = formatDateTime(node.capturedAt);
	    },
	
	    getBearingCorrection: function getBearingCorrection() {
	        if (this._node && 'computedCA' in this._node) {
	            return this._node.computedCA - this._node.originalCA;
	        }
	        return 0;
	    },
	
	    onBearingChanged: function onBearingChanged(bearing) {
	        bearing -= this.getBearingCorrection();
	        if (this._bearing === bearing) {
	            return;
	        }
	        this._bearing = bearing;
	        this.fireChangeEvenet();
	    },
	
	    onCloseClick: function onCloseClick() {
	        this.fire('closeclick');
	    },
	
	    fireChangeEvenet: function fireChangeEvenet() {
	        if (this._node) {
	            var latlon = this._node.originalLatLon;
	            this.fire('change', {
	                latlng: _leaflet2.default.latLng(latlon.lat, latlon.lon),
	                heading: this._bearing,
	                pitch: this._pitch,
	                zoom: this._zoom
	            });
	        }
	    },
	
	    deactivate: function deactivate() {
	        this.viewer.activateCover();
	        if (this._updateHandler) {
	            clearInterval(this._updateHandler);
	            this._updateHandler = null;
	        }
	    },
	
	    updateZoomAndCenter: function updateZoomAndCenter() {
	        var _this2 = this;
	
	        this.viewer.getZoom().then(function (zoom) {
	            _this2._zoom = zoom;
	        });
	        this.viewer.getCenter().then(function (center) {
	            _this2._center = center;
	        });
	        this.viewer.getBearing().then(function (bearing) {
	            _this2.onBearingChanged(bearing);
	        });
	    },
	
	    activate: function activate() {
	        var _this3 = this;
	
	        this.viewer.resize();
	        this.viewer.deactivateCover();
	        if (!this._updateHandler) {
	            this._updateHandler = setInterval(function () {
	                return _this3.updateZoomAndCenter();
	            }, 200);
	        }
	    },
	
	    getState: function getState() {
	        if (!this._node) {
	            return [];
	        }
	        var _node$originalLatLon = this._node.originalLatLon,
	            lat = _node$originalLatLon.lat,
	            lon = _node$originalLatLon.lon;
	
	        return [lat.toFixed(6), lon.toFixed(6), this._center[0].toFixed(4), this._center[1].toFixed(4), this._zoom.toFixed(2)];
	    },
	
	    setState: function setState(state) {
	        var _this4 = this;
	
	        var lat = parseFloat(state[0]);
	        var lng = parseFloat(state[1]);
	        var center0 = parseFloat(state[2]);
	        var center1 = parseFloat(state[3]);
	        var zoom = parseFloat(state[4]);
	        if (!isNaN(lat) && !isNaN(lng) && !isNaN(center0) && !isNaN(center1) && !isNaN(zoom)) {
	            this.viewer.moveCloseTo(lat, lng).then(function () {
	                _this4.viewer.setCenter([center0, center1]);
	                _this4.viewer.setZoom(zoom);
	            });
	            return true;
	        }
	        return false;
	    }
	});
	
	exports.default = { getCoverageLayer: getCoverageLayer, getPanoramaAtPos: getPanoramaAtPos, getViewer: getViewer };

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MapillaryCoverage = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _mapillaryLoader = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapillaryCoverage = _leaflet2.default.GridLayer.extend({
	    options: {
	        tileSize: 1024,
	        updateWhenIdle: true,
	        color: '#00cfb1'
	    },
	
	    initialize: function initialize(options) {
	        _leaflet2.default.GridLayer.prototype.initialize.call(this, options);
	        this.loader = new _mapillaryLoader.MapillaryLoader(this.options.url, 12);
	    },
	
	    onAdd: function onAdd(map) {
	        _leaflet2.default.GridLayer.prototype.onAdd.call(this, map);
	        this.on('tileunload', this.onTileUnload, this);
	    },
	
	    onRemove: function onRemove(map) {
	        _leaflet2.default.GridLayer.prototype.onRemove.call(this, map);
	        this.off('tileunload', this.onTileUnload, this);
	    },
	
	    onTileUnload: function onTileUnload(e) {
	        var tile = e.tile;
	        tile._abortLoading();
	        delete tile._tileData;
	        delete tile._adjustment;
	    },
	
	    drawOverview: function drawOverview(canvas) {
	        var tileData = canvas._tileData;
	        if (!tileData['mapillary-sequence-overview']) {
	            return;
	        }
	        var _canvas$_adjustment = canvas._adjustment,
	            multiplier = _canvas$_adjustment.multiplier,
	            offsetX = _canvas$_adjustment.offsetX,
	            offsetY = _canvas$_adjustment.offsetY;
	
	        var canvasCtx = canvas.getContext('2d');
	        canvasCtx.fillStyle = this.options.color;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = tileData['mapillary-sequence-overview'][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var feature = _step.value;
	
	                if (feature.geometry.type !== 'Point') {
	                    throw new Error('Invalid sequence overview geometry type "' + feature.geometry.type + '"');
	                }
	                canvasCtx.beginPath();
	                var x = feature.geometry.coordinates[0] * multiplier - offsetX;
	                var y = feature.geometry.coordinates[1] * multiplier - offsetY;
	                canvasCtx.arc(x, y, 5, 0, 2 * Math.PI);
	                canvasCtx.fill();
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	
	    drawSequences: function drawSequences(canvas, lineWidth) {
	        var tileData = canvas._tileData,
	            adjustment = canvas._adjustment;
	
	        if (!tileData['mapillary-sequences']) {
	            return;
	        }
	        var canvasCtx = canvas.getContext('2d');
	        canvasCtx.beginPath();
	        canvasCtx.strokeStyle = this.options.color;
	        canvasCtx.lineWidth = lineWidth;
	        // canvasCtx.lineWidth = thinLines ? 1 : 1;
	        canvasCtx.lineCap = "round";
	        canvasCtx.lineJoin = "bevel";
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = tileData['mapillary-sequences'][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var feature = _step2.value;
	
	                if (feature.geometry.type !== 'MultiLineString') {
	                    throw new Error('Invalid sequence geometry type "' + feature.geometry.type + '"');
	                }
	                var multiplier = adjustment.multiplier,
	                    offsetX = adjustment.offsetX,
	                    offsetY = adjustment.offsetY;
	
	
	                var lines = feature.geometry.coordinates;
	                for (var lineI = 0; lineI < lines.length; lineI++) {
	                    var line = lines[lineI];
	                    if (!line.length) {
	                        continue;
	                    }
	                    var x = line[0][0] * multiplier - offsetX;
	                    var y = line[0][1] * multiplier - offsetY;
	                    canvasCtx.moveTo(x, y);
	                    if (line.length === 1) {
	                        canvasCtx.lineTo(x, y);
	                    }
	                    for (var pointI = 0; pointI < line.length; pointI++) {
	                        var _x = line[pointI][0] * multiplier - offsetX;
	                        var _y = line[pointI][1] * multiplier - offsetY;
	                        canvasCtx.lineTo(_x, _y);
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        canvasCtx.stroke();
	    },
	
	    drawImages: function drawImages(canvas) {
	        var tileData = canvas._tileData,
	            adjustment = canvas._adjustment;
	        if (!tileData['mapillary-images']) {
	            return;
	        }
	        var multiplier = adjustment.multiplier,
	            offsetX = adjustment.offsetX,
	            offsetY = adjustment.offsetY;
	
	        var canvasCtx = canvas.getContext('2d');
	        canvasCtx.beginPath();
	        canvasCtx.fillStyle = this.options.color;
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = tileData['mapillary-images'][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var feature = _step3.value;
	
	                if (feature.geometry.type !== 'Point') {
	                    throw new Error('Invalid image geometry type "' + feature.geometry.type + '"');
	                }
	                canvasCtx.beginPath();
	                var x = feature.geometry.coordinates[0] * multiplier - offsetX;
	                var y = feature.geometry.coordinates[1] * multiplier - offsetY;
	                canvasCtx.arc(x, y, 4, 0, 2 * Math.PI);
	                canvasCtx.fill();
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	    },
	
	    drawTile: function drawTile(canvas, coords) {
	        if (!this._map) {
	            return;
	        }
	        if (!canvas._tileData) {
	            return;
	        }
	        if (coords.z < 6 + 2) {
	            this.drawOverview(canvas);
	        } else if (coords.z < 14 + 2) {
	            var width = coords.z < 14 ? 10 : 5;
	            this.drawSequences(canvas, width);
	        } else {
	            this.drawSequences(canvas, 2);
	            this.drawImages(canvas);
	        }
	    },
	
	    createTile: function createTile(coords, done) {
	        var _this = this;
	
	        var canvas = _leaflet2.default.DomUtil.create('canvas', 'leaflet-tile');
	        canvas.width = this.options.tileSize;
	        canvas.height = this.options.tileSize;
	
	        var _loader$requestTileDa = this.loader.requestTileData(coords),
	            dataPromise = _loader$requestTileDa.dataPromise,
	            abortLoading = _loader$requestTileDa.abortLoading;
	
	        dataPromise.then(function (data) {
	            canvas._tileData = data.tileData;
	            canvas._adjustment = data.adjustment || { multiplier: 1, offsetX: 0, offsetY: 0 };
	            setTimeout(function () {
	                _this.drawTile(canvas, coords);
	                done(null, canvas);
	            }, 1);
	        });
	        canvas._abortLoading = abortLoading;
	        return canvas;
	    }
	
	});
	
	exports.MapillaryCoverage = MapillaryCoverage;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MapillaryLoader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _tiledDataLoader = __webpack_require__(83);
	
	var _mvt = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapillaryLoader = function (_TiledDataLoader) {
	    _inherits(MapillaryLoader, _TiledDataLoader);
	
	    function MapillaryLoader() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MapillaryLoader);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapillaryLoader.__proto__ || Object.getPrototypeOf(MapillaryLoader)).call.apply(_ref, [this].concat(args))), _this), _this.url = 'https://d25uarhxywzl1j.cloudfront.net/v0.1/{z}/{x}/{y}.mvt', _this.maxZoom = 14, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MapillaryLoader, [{
	        key: 'getTileUrl',
	        value: function getTileUrl(coords) {
	            var data = {
	                x: coords.x,
	                z: coords.z,
	                y: coords.y
	            };
	            return _leaflet2.default.Util.template(this.url, data);
	        }
	    }, {
	        key: 'layerTileToDataTileCoords',
	        value: function layerTileToDataTileCoords(layerTileCoords) {
	            var z = layerTileCoords.z - 2;
	            var z2 = null;
	            if (z > 6 && z <= 10) {
	                z2 = 6;
	            } else if (z >= 11 && z < 14) {
	                z2 = z - 4;
	            } else if (z < 0) {
	                z2 = 0;
	            } else if (z > this.maxZoom) {
	                z2 = this.maxZoom;
	            } else {
	                return { z: z, x: layerTileCoords.x, y: layerTileCoords.y };
	            }
	
	            var multiplier = 1 << z - z2;
	            return {
	                x: Math.floor(layerTileCoords.x / multiplier),
	                y: Math.floor(layerTileCoords.y / multiplier),
	                z: z2
	            };
	        }
	    }, {
	        key: 'makeRequestData',
	        value: function makeRequestData(dataTileCoords) {
	            return {
	                url: this.getTileUrl(dataTileCoords),
	                options: {
	                    responseType: 'arraybuffer',
	                    timeout: 10000,
	                    isResponseSuccess: function isResponseSuccess(xhr) {
	                        return xhr.status === 200 || xhr.status === 403;
	                    }
	                }
	            };
	        }
	    }, {
	        key: 'calcAdjustment',
	        value: function calcAdjustment(layerTileCoords, dataTileCoords) {
	            var adjustment = _get(MapillaryLoader.prototype.__proto__ || Object.getPrototypeOf(MapillaryLoader.prototype), 'calcAdjustment', this).call(this, { x: layerTileCoords.x, y: layerTileCoords.y, z: layerTileCoords.z - 2 }, dataTileCoords);
	            if (adjustment) {
	                adjustment.offsetX *= 1024;
	                adjustment.offsetY *= 1024;
	            }
	            return adjustment;
	        }
	    }, {
	        key: 'processResponse',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(xhr, originalDataTileCoords) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                return _context.abrupt('return', this._processResponse(xhr, originalDataTileCoords));
	
	                            case 1:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function processResponse(_x, _x2) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return processResponse;
	        }()
	    }, {
	        key: '_processResponse',
	        value: function () {
	            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(xhr, originalDataTileCoords) {
	                var tileData, layers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, layer;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                tileData = void 0;
	
	                                if (!(xhr.status === 200 && xhr.response)) {
	                                    _context2.next = 25;
	                                    break;
	                                }
	
	                                layers = (0, _mvt.decodeMvt)(xhr.response, 1024);
	
	                                tileData = {};
	                                _iteratorNormalCompletion = true;
	                                _didIteratorError = false;
	                                _iteratorError = undefined;
	                                _context2.prev = 7;
	                                for (_iterator = layers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                    layer = _step.value;
	
	                                    tileData[layer.name] = layer.features;
	                                }
	                                _context2.next = 15;
	                                break;
	
	                            case 11:
	                                _context2.prev = 11;
	                                _context2.t0 = _context2['catch'](7);
	                                _didIteratorError = true;
	                                _iteratorError = _context2.t0;
	
	                            case 15:
	                                _context2.prev = 15;
	                                _context2.prev = 16;
	
	                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                    _iterator.return();
	                                }
	
	                            case 18:
	                                _context2.prev = 18;
	
	                                if (!_didIteratorError) {
	                                    _context2.next = 21;
	                                    break;
	                                }
	
	                                throw _iteratorError;
	
	                            case 21:
	                                return _context2.finish(18);
	
	                            case 22:
	                                return _context2.finish(15);
	
	                            case 23:
	                                _context2.next = 26;
	                                break;
	
	                            case 25:
	                                tileData = null;
	
	                            case 26:
	                                return _context2.abrupt('return', {
	                                    tileData: tileData,
	                                    coords: originalDataTileCoords
	                                });
	
	                            case 27:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[7, 11, 15, 23], [16,, 18, 22]]);
	            }));
	
	            function _processResponse(_x3, _x4) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return _processResponse;
	        }()
	    }]);
	
	    return MapillaryLoader;
	}(_tiledDataLoader.TiledDataLoader);
	
	exports.MapillaryLoader = MapillaryLoader;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.decodeMvt = undefined;
	
	var _pbf = __webpack_require__(479);
	
	var _pbf2 = _interopRequireDefault(_pbf);
	
	var _vector_tile_proto = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function decodeCoordinate(x) {
	    return x >> 1 ^ -(x & 1);
	}
	
	function parseGeometry(geometryType, ints, coordinatesScale) {
	    if (geometryType !== _vector_tile_proto.Tile.GeomType.POINT && geometryType !== _vector_tile_proto.Tile.GeomType.LINESTRING && geometryType !== _vector_tile_proto.Tile.GeomType.POLYGON) {
	        throw new Error('Unknown feature geometry type ' + geometryType);
	    }
	    var len = ints.length;
	    var pos = 0;
	    var lineStrings = [];
	    var line = void 0;
	    var x = 0,
	        y = 0;
	    while (pos < len) {
	        var i = ints[pos];
	        var cmd = i & 0x7;
	        var cmdRepeat = i >> 3;
	        switch (cmd) {
	            case 1:
	                // MoveTo
	                if (cmdRepeat !== 1) {
	                    throw new Error('repeat=' + cmdRepeat + ' for command MoveTo');
	                }
	                if (pos + 2 > len) {
	                    throw new Error('Not enough elements for MoveTo arguments');
	                }
	                if (line) {
	                    lineStrings.push(line);
	                }
	                x += decodeCoordinate(ints[pos + 1]);
	                y += decodeCoordinate(ints[pos + 2]);
	                line = [[x * coordinatesScale, y * coordinatesScale]];
	                pos += 3;
	                break;
	            case 2:
	                // LineTo
	                if (cmdRepeat < 1) {
	                    throw new Error('repeat=' + cmdRepeat + ' for command LineTo');
	                }
	                if (!line) {
	                    throw new Error('LineTo with empty linestring');
	                }
	                pos += 1;
	                for (var cmdN = 0; cmdN < cmdRepeat; cmdN++) {
	                    if (pos + 2 > len) {
	                        throw new Error('Not enough elements for LineTo arguments');
	                    }
	                    x += decodeCoordinate(ints[pos]);
	                    y += decodeCoordinate(ints[pos + 1]);
	                    line.push([x * coordinatesScale, y * coordinatesScale]);
	                    pos += 2;
	                }
	                break;
	            case 7:
	                // ClosePath
	                if (geometryType !== _vector_tile_proto.Tile.GeomType.POLYGON) {
	                    throw new Error('ClosePath command for non-polygon type ' + geometryType);
	                }
	                if (!line) {
	                    throw new Error('ClosePath with empty linestring');
	                }
	                if (cmdRepeat !== 1) {
	                    throw new Error('ClosePath repeats ' + cmdRepeat + ' times');
	                }
	                line.push(line[0]);
	                pos += 1;
	                break;
	            default:
	                throw new Error('Unknown command ' + i + ' & 0x7 = ' + cmd);
	        }
	    }
	    if (line) {
	        lineStrings.push(line);
	    }
	    var geometry = {};
	    switch (geometryType) {
	        case _vector_tile_proto.Tile.GeomType.POINT:
	            if (lineStrings.length !== 1 || lineStrings[0].length !== 1) {
	                throw new Error('Invalid coordinates number for point');
	            }
	            geometry.type = 'Point';
	            geometry.coordinates = lineStrings[0][0];
	            break;
	        case _vector_tile_proto.Tile.GeomType.LINESTRING:
	            geometry.type = 'MultiLineString';
	            geometry.coordinates = lineStrings;
	            break;
	        case _vector_tile_proto.Tile.GeomType.POLYGON:
	            geometry.type = 'Polygon';
	            geometry.coordinates = lineStrings;
	            break;
	        default:
	    }
	    return geometry;
	}
	
	function parseFeatures(layer, coordinatesScale) {
	    var features = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = layer.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var feature = _step.value;
	
	            var geometry = parseGeometry(feature.type, feature.geometry, coordinatesScale);
	            features.push({ geometry: geometry });
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return features;
	}
	
	function decodeMvt(ar) {
	    var tileExtent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;
	
	    var pbf = new _pbf2.default(new Uint8Array(ar)),
	        tileData = _vector_tile_proto.Tile.read(pbf);
	    var parsedLayers = [];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = tileData.layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var layer = _step2.value;
	
	            var scale = tileExtent / layer.extent;
	            parsedLayers.push({
	                name: layer.name,
	                features: parseFeatures(layer, scale)
	            });
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return parsedLayers;
	}
	
	exports.decodeMvt = decodeMvt;

/***/ },
/* 197 */
/***/ function(module, exports) {

	"use strict";
	
	// code generated by pbf v3.0.5
	
	// Tile ========================================
	
	var Tile = exports.Tile = {};
	
	Tile.read = function (pbf, end) {
	    return pbf.readFields(Tile._readField, { layers: [] }, end);
	};
	Tile._readField = function (tag, obj, pbf) {
	    if (tag === 3) obj.layers.push(Tile.Layer.read(pbf, pbf.readVarint() + pbf.pos));
	};
	
	Tile.GeomType = {
	    "UNKNOWN": 0,
	    "POINT": 1,
	    "LINESTRING": 2,
	    "POLYGON": 3
	};
	
	// Tile.Feature ========================================
	
	Tile.Feature = {};
	
	Tile.Feature.read = function (pbf, end) {
	    return pbf.readFields(Tile.Feature._readField, { id: 0, tags: [], type: 0, geometry: [] }, end);
	};
	Tile.Feature._readField = function (tag, obj, pbf) {
	    if (tag === 3) obj.type = pbf.readVarint();else if (tag === 4) pbf.readPackedVarint(obj.geometry);
	};
	
	// Tile.Layer ========================================
	
	Tile.Layer = {};
	
	Tile.Layer.read = function (pbf, end) {
	    return pbf.readFields(Tile.Layer._readField, { version: 0, name: "", features: [], keys: [], values: [], extent: 0 }, end);
	};
	Tile.Layer._readField = function (tag, obj, pbf) {
	    if (tag === 15) obj.version = pbf.readVarint();else if (tag === 1) obj.name = pbf.readString();else if (tag === 2) obj.features.push(Tile.Feature.read(pbf, pbf.readVarint() + pbf.pos));else if (tag === 5) obj.extent = pbf.readVarint();
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WikimediaVectorCoverage = exports.MultiLayer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _tiledDataLoader = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiLayer = _leaflet2.default.Layer.extend({
	    initialize: function initialize(layers) {
	        this.layers = layers;
	    },
	
	    setLayersVisibility: function setLayersVisibility(e) {
	        if (!this._map) {
	            return;
	        }
	
	        var newZoom = void 0;
	        if (e && e.zoom !== undefined) {
	            newZoom = e.zoom;
	        } else {
	            newZoom = this._map.getZoom();
	        }
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this.layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var layer = _step.value;
	
	                if (layer.minZoom <= newZoom && newZoom <= layer.maxZoom) {
	                    this._map.addLayer(layer.layer);
	                } else {
	                    this._map.removeLayer(layer.layer);
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        this.setLayersVisibility();
	        map.on('zoomend', this.setLayersVisibility, this);
	    },
	
	    onRemove: function onRemove() {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = this.layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var layer = _step2.value;
	
	                this._map.removeLayer(layer.layer);
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        this._map.off('zoomend', this.setLayersVisibility, this);
	        this._map.off('zoomanim', this.setLayersVisibility, this);
	        this._map = null;
	    }
	
	});
	
	var WikimediaLoader = function (_TiledDataLoader) {
	    _inherits(WikimediaLoader, _TiledDataLoader);
	
	    function WikimediaLoader(urlTemplate, zoom) {
	        _classCallCheck(this, WikimediaLoader);
	
	        var _this = _possibleConstructorReturn(this, (WikimediaLoader.__proto__ || Object.getPrototypeOf(WikimediaLoader)).call(this));
	
	        _this.url = urlTemplate;
	        _this.maxZoom = zoom;
	        return _this;
	    }
	
	    _createClass(WikimediaLoader, [{
	        key: 'getTileUrl',
	        value: function getTileUrl(coords) {
	            var data = {
	                x: coords.x,
	                z: coords.z,
	                y: Math.pow(2, coords.z) - 1 - coords.y
	            };
	            return _leaflet2.default.Util.template(this.url, data);
	        }
	    }, {
	        key: 'layerTileToDataTileCoords',
	        value: function layerTileToDataTileCoords(layerTileCoords) {
	            var z = layerTileCoords.z;
	            var z2 = null;
	            if (z > this.maxZoom) {
	                z2 = this.maxZoom;
	            } else {
	                return { z: z, x: layerTileCoords.x, y: layerTileCoords.y };
	            }
	
	            var multiplier = 1 << z - z2;
	            return {
	                x: Math.floor(layerTileCoords.x / multiplier),
	                y: Math.floor(layerTileCoords.y / multiplier),
	                z: z2
	            };
	        }
	    }, {
	        key: 'makeRequestData',
	        value: function makeRequestData(dataTileCoords) {
	            return {
	                url: this.getTileUrl(dataTileCoords),
	                options: {
	                    responseType: 'arraybuffer',
	                    timeout: 5000,
	                    isResponseSuccess: function isResponseSuccess(xhr) {
	                        return xhr.status === 200 || xhr.status === 404;
	                    }
	                }
	            };
	        }
	    }, {
	        key: 'processResponse',
	        value: function () {
	            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(xhr, originalDataTileCoords) {
	                var tileData;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                tileData = void 0;
	
	                                if (originalDataTileCoords.z >= this.maxZoom && xhr.status === 200 && xhr.response) {
	                                    tileData = new Uint16Array(xhr.response);
	                                } else {
	                                    tileData = null;
	                                }
	
	                                return _context.abrupt('return', {
	                                    tileData: tileData,
	                                    coords: originalDataTileCoords
	                                });
	
	                            case 3:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function processResponse(_x, _x2) {
	                return _ref.apply(this, arguments);
	            }
	
	            return processResponse;
	        }()
	    }]);
	
	    return WikimediaLoader;
	}(_tiledDataLoader.TiledDataLoader);
	
	var WikimediaVectorCoverage = _leaflet2.default.GridLayer.extend({
	    options: {
	        tileSize: 256,
	        // updateWhenIdle: true,
	        color: '#ff00ff'
	    },
	
	    initialize: function initialize(url, options) {
	        _leaflet2.default.GridLayer.prototype.initialize.call(this, options);
	        this.loader = new WikimediaLoader(url, 11);
	    },
	
	    onAdd: function onAdd(map) {
	        _leaflet2.default.GridLayer.prototype.onAdd.call(this, map);
	        this.on('tileunload', this.onTileUnload, this);
	    },
	
	    onRemove: function onRemove(map) {
	        _leaflet2.default.GridLayer.prototype.onRemove.call(this, map);
	        this.off('tileunload', this.onTileUnload, this);
	    },
	
	    onTileUnload: function onTileUnload(e) {
	        var tile = e.tile;
	        tile._abortLoading();
	        delete tile._tileData;
	        delete tile._adjustment;
	    },
	
	    drawTile: function drawTile(canvas, coords) {
	        if (!this._map) {
	            return;
	        }
	        if (!canvas._tileData) {
	            return;
	        }
	        var dataOffset = 5000;
	        var dataExtent = 65535 - 2 * dataOffset;
	        var tileData = canvas._tileData;
	        var _canvas$_adjustment = canvas._adjustment,
	            multiplier = _canvas$_adjustment.multiplier,
	            offsetX = _canvas$_adjustment.offsetX,
	            offsetY = _canvas$_adjustment.offsetY;
	
	        var canvasCtx = canvas.getContext('2d');
	        var pixelScale = multiplier * 256 / dataExtent;
	        canvasCtx.fillStyle = this.options.color;
	        for (var i = 0, l = tileData.length; i < l; i += 2) {
	            var x = (tileData[i] - dataOffset) * pixelScale - offsetX * 256;
	            var y = (tileData[i + 1] - dataOffset) * pixelScale - offsetY * 256;
	            canvasCtx.beginPath();
	            canvasCtx.arc(x, y, 5, 0, 2 * Math.PI);
	            canvasCtx.fill();
	        }
	    },
	
	    createTile: function createTile(coords, done) {
	        var _this2 = this;
	
	        var canvas = _leaflet2.default.DomUtil.create('canvas', 'leaflet-tile');
	        canvas.width = this.options.tileSize;
	        canvas.height = this.options.tileSize;
	
	        var _loader$requestTileDa = this.loader.requestTileData(coords),
	            dataPromise = _loader$requestTileDa.dataPromise,
	            abortLoading = _loader$requestTileDa.abortLoading;
	
	        dataPromise.then(function (data) {
	            canvas._tileData = data.tileData;
	            canvas._adjustment = data.adjustment || { multiplier: 1, offsetX: 0, offsetY: 0 };
	            setTimeout(function () {
	                _this2.drawTile(canvas, coords);
	                done(null, canvas);
	            }, 1);
	        });
	
	        canvas._abortLoading = abortLoading;
	        return canvas;
	    }
	});
	
	exports.MultiLayer = MultiLayer;
	exports.WikimediaVectorCoverage = WikimediaVectorCoverage;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var getPanoramaAtPos = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(latlng, searchRadiusMeters) {
	        var clusterSize, urlTemplate, url, resp, photos;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        clusterSize = 10;
	                        urlTemplate = 'https://commons.wikimedia.org/w/api.php?' + 'origin=*&format=json&action=query&generator=geosearch&' + 'ggsprimary=all&ggsnamespace=6&ggslimit=10&iilimit=1&' + 'ggsradius={radius}&ggscoord={lat}|{lng}&' + 'iiurlwidth=134&' + 'prop=imageinfo|coordinates&' + 'iiprop=url|mime|size|extmetadata|commonmetadata|metadata';
	
	                        searchRadiusMeters += clusterSize;
	                        if (searchRadiusMeters < 10) {
	                            searchRadiusMeters = 10;
	                        }
	                        if (searchRadiusMeters > 10000) {
	                            searchRadiusMeters = 10000;
	                        }
	                        url = _leaflet2.default.Util.template(urlTemplate, { lat: latlng.lat, lng: latlng.lng, radius: searchRadiusMeters });
	                        _context.next = 8;
	                        return (0, _xhrPromise.fetch)(url, { responseType: 'json', timeout: 10000 });
	
	                    case 8:
	                        resp = _context.sent;
	
	                        if (!(resp.status === 200)) {
	                            _context.next = 20;
	                            break;
	                        }
	
	                        photos = parseSearchResponse(resp.responseJSON);
	
	                        if (!photos) {
	                            _context.next = 19;
	                            break;
	                        }
	
	                        latlng = _leaflet2.default.latLng(latlng.lat, latlng.lng);
	                        photos.sort(isCloser.bind(null, latlng));
	                        latlng = _leaflet2.default.latLng(photos[0].lat, photos[0].lng);
	                        photos = photos.filter(function (photo) {
	                            return latlng.distanceTo(_leaflet2.default.latLng(photo.lat, photo.lng)) <= clusterSize;
	                        }, latlng);
	                        return _context.abrupt('return', {
	                            found: true,
	                            data: photos
	                        });
	
	                    case 19:
	                        return _context.abrupt('return', { found: false });
	
	                    case 20:
	                        return _context.abrupt('return', { found: false });
	
	                    case 21:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function getPanoramaAtPos(_x, _x2) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _coverageLayer = __webpack_require__(198);
	
	var _xhrPromise = __webpack_require__(24);
	
	__webpack_require__(456);
	
	__webpack_require__(166);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function getCoverageLayer(options) {
	    var url = _config2.default.wikimediaCommonsCoverageUrl;
	    return new _coverageLayer.MultiLayer([{ layer: _leaflet2.default.tileLayer(url, _leaflet2.default.extend({}, options, { tms: true })),
	        minZoom: 0, maxZoom: 10 }, { layer: new _coverageLayer.WikimediaVectorCoverage(url, options),
	        minZoom: 11, maxZoom: 18 }]);
	}
	
	function parseSearchResponse(resp) {
	    var images = [];
	    if (resp && resp.query && resp.query.pages && resp.query.pages) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = Object.values(resp.query.pages)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var page = _step.value;
	
	                var iinfo = page.imageinfo[0];
	                var imageDescription = iinfo.extmetadata.ImageDescription ? iinfo.extmetadata.ImageDescription.value : null;
	                var objectDescription = iinfo.extmetadata.ObjectName ? iinfo.extmetadata.ObjectName.value : null;
	                if (imageDescription && /^<table (.|\n)+<\/table>$/.test(imageDescription)) {
	                    imageDescription = null;
	                }
	                if (imageDescription) {
	                    imageDescription = imageDescription.replace(/<[^>]+>/g, '');
	                    imageDescription = imageDescription.replace(/[\n\r]/g, '');
	                }
	                if (imageDescription && objectDescription && objectDescription.toLowerCase().includes(imageDescription.toLowerCase())) {
	                    imageDescription = null;
	                }
	                if (objectDescription && imageDescription && imageDescription.toLowerCase().includes(objectDescription.toLowerCase())) {
	                    objectDescription = null;
	                }
	                var description = 'Wikimedia commons';
	                if (objectDescription || imageDescription) {
	                    description = '';
	                    if (objectDescription) {
	                        description = objectDescription;
	                    }
	                    if (imageDescription) {
	                        if (objectDescription) {
	                            description += '</br>';
	                        }
	                        description += imageDescription;
	                    }
	                }
	
	                var author = iinfo.extmetadata.Artist ? iinfo.extmetadata.Artist.value : null;
	                if (author && /^<table (.|\n)+<\/table>$/.test(author)) {
	                    author = 'See author info at <a href="' + iinfo.descriptionurl + '">Wikimedia commons</a>';
	                }
	
	                // original images can be rotated, 90 degrees
	                // thumbnails are always oriented right
	                // so we request thumbnail of original image size
	                var url = iinfo.thumburl.replace('134px', iinfo.width + 'px');
	                images.push({
	                    url: url,
	                    width: iinfo.width,
	                    height: iinfo.height,
	                    lat: page.coordinates[0].lat,
	                    lng: page.coordinates[0].lon,
	                    author: author,
	                    timeOriginal: iinfo.extmetadata.DateTimeOriginal ? iinfo.extmetadata.DateTimeOriginal.value : null,
	                    time: iinfo.extmetadata.DateTime ? iinfo.extmetadata.DateTime.value : null,
	                    description: description,
	                    pageUrl: iinfo.descriptionurl,
	                    pageId: page.pageid.toString()
	                });
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        if (images.length) {
	            return images;
	        }
	    }
	    return null;
	}
	
	function isCloser(target, a, b) {
	    var d1 = target.distanceTo(a);
	    var d2 = target.distanceTo(b);
	    if (d1 < d2) {
	        return -1;
	    } else if (d1 === d2) {
	        return 0;
	    } else {
	        return 1;
	    }
	}
	
	function formatDateTime(dateStr) {
	    var m = /^(\d+)-(\d+)-(\d+)/.exec(dateStr);
	    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    if (m) {
	        var _m$slice = m.slice(1),
	            _m$slice2 = _slicedToArray(_m$slice, 3),
	            year = _m$slice2[0],
	            month = _m$slice2[1],
	            day = _m$slice2[2];
	
	        return day + ' ' + months[month - 1] + ' ' + year;
	    } else {
	        return dateStr;
	    }
	}
	
	var Viewer = _leaflet2.default.Evented.extend({
	    initialize: function initialize(container) {
	        var _this = this;
	
	        container = _leaflet2.default.DomUtil.create('div', 'wikimedia-viewer-container', container);
	        var mapContainer = this.mapContainer = _leaflet2.default.DomUtil.create('div', 'wikimedia-viewer-map-container', container);
	        this.pageButtonContainer = _leaflet2.default.DomUtil.create('div', 'wikimedia-viewer-page-buttons-container', container);
	
	        this.map = _leaflet2.default.map(mapContainer, {
	            maxBoundsViscosity: 1,
	            crs: _leaflet2.default.CRS.Simple,
	            zoomControl: false,
	            attributionControl: false,
	            zoomSnap: 0
	        });
	
	        this.map.on('zoomend', this.notifyChange, this);
	        this.map.on('moveend', this.notifyChange, this);
	
	        this.infoLabel = _leaflet2.default.DomUtil.create('div', 'wikimedia-viewer-info-overlay', mapContainer);
	        this.closeButton = _leaflet2.default.DomUtil.create('div', 'photo-viewer-button-close', container);
	        this.prevPhotoButton = _leaflet2.default.DomUtil.create('div', 'wikimedia-viewer-button-prev', mapContainer);
	        this.nextPhotoButton = _leaflet2.default.DomUtil.create('div', 'wikimedia-viewer-button-next', mapContainer);
	        _leaflet2.default.DomEvent.on(this.prevPhotoButton, 'click', function () {
	            _this.switchPhoto(_this._imageIdx - 1);
	        });
	        _leaflet2.default.DomEvent.on(this.nextPhotoButton, 'click', function () {
	            _this.switchPhoto(_this._imageIdx + 1);
	        });
	        _leaflet2.default.DomEvent.on(this.closeButton, 'click', this.onCloseClick, this);
	    },
	
	    setupPageButtons: function setupPageButtons(count) {
	        var _this2 = this;
	
	        if (this._buttons) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = this._buttons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var button = _step2.value;
	
	                    this.pageButtonContainer.removeChild(button);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	        this._buttons = [];
	        if (count > 1) {
	            _leaflet2.default.DomUtil.addClass(this.pageButtonContainer, 'enabled');
	
	            var _loop = function _loop(i) {
	                var button = _leaflet2.default.DomUtil.create('div', 'wikimedia-viewer-page-button', _this2.pageButtonContainer);
	                button.innerHTML = '' + (i + 1);
	                _this2._buttons.push(button);
	                _leaflet2.default.DomEvent.on(button, 'click', function () {
	                    return _this2.switchPhoto(i);
	                });
	            };
	
	            for (var i = 0; i < count; i++) {
	                _loop(i);
	            }
	        } else {
	            _leaflet2.default.DomUtil.removeClass(this.pageButtonContainer, 'enabled');
	        }
	    },
	
	    switchPhoto: function switchPhoto(imageIdx) {
	        var _this3 = this;
	
	        var imagePos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        this._imageIdx = imageIdx;
	        if (this.imageLayer) {
	            this.map.removeLayer(this.imageLayer);
	        }
	        var image = this.images[imageIdx];
	        var mapSize = this.map.getSize();
	        if (!mapSize.x || !mapSize.y) {
	            mapSize = { x: 500, y: 500 };
	        }
	        var maxZoom = Math.log2(Math.max(image.width / mapSize.x, image.height / mapSize.y)) + 2;
	        if (maxZoom < 1) {
	            maxZoom = 1;
	        }
	        var southWest = this.map.unproject([0, image.height], maxZoom - 2),
	            northEast = this.map.unproject([image.width, 0], maxZoom - 2);
	        var bounds = new _leaflet2.default.LatLngBounds(southWest, northEast);
	        this.map.setMaxZoom(maxZoom);
	        this.map.setMaxBounds(bounds);
	        if (imagePos) {
	            this.map.setView(imagePos.center, imagePos.zoom, { animate: false });
	        } else {
	            this.map.fitBounds(bounds, { animate: false });
	        }
	
	        this.imageLayer = _leaflet2.default.imageOverlay(null, bounds);
	        _leaflet2.default.DomUtil.addClass(this.mapContainer, 'loading');
	        this.imageLayer.on('load', function () {
	            _leaflet2.default.DomUtil.removeClass(_this3.mapContainer, 'loading');
	        });
	        this.imageLayer.setUrl(image.url);
	        this.imageLayer.addTo(this.map);
	        var caption = [];
	
	        if (image.timeOriginal) {
	            caption.push(formatDateTime(image.timeOriginal));
	        }
	        if (image.author) {
	            caption.push(image.author);
	        }
	        caption.push('<a href="' + image.pageUrl + '">' + image.description + '</a>');
	        caption = caption.join('</br>');
	        this.infoLabel.innerHTML = caption;
	
	        if (imageIdx > 0) {
	            _leaflet2.default.DomUtil.addClass(this.prevPhotoButton, 'enabled');
	        } else {
	            _leaflet2.default.DomUtil.removeClass(this.prevPhotoButton, 'enabled');
	        }
	        if (imageIdx < this.images.length - 1) {
	            _leaflet2.default.DomUtil.addClass(this.nextPhotoButton, 'enabled');
	        } else {
	            _leaflet2.default.DomUtil.removeClass(this.nextPhotoButton, 'enabled');
	        }
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = this._buttons.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _step3$value = _slicedToArray(_step3.value, 2),
	                    i = _step3$value[0],
	                    button = _step3$value[1];
	
	                (i === imageIdx ? _leaflet2.default.DomUtil.addClass : _leaflet2.default.DomUtil.removeClass)(button, 'active');
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        this.notifyChange();
	    },
	
	    notifyChange: function notifyChange() {
	        if (this.images && this._active) {
	            var image = this.images[this._imageIdx];
	            this.fire('change', {
	                latlng: _leaflet2.default.latLng(image.lat, image.lng),
	                latlngs: this.images.map(function (image) {
	                    return _leaflet2.default.latLng(image.lat, image.lng);
	                })
	
	            });
	        }
	    },
	
	    _showPano: function _showPano(images) {
	        var imageIdx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var imagePos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        this.images = images;
	        this.setupPageButtons(images.length);
	        this.switchPhoto(imageIdx, imagePos);
	    },
	
	    showPano: function showPano(images) {
	        this._showPano(images);
	    },
	
	    onCloseClick: function onCloseClick() {
	        this.fire('closeclick');
	    },
	
	    activate: function activate() {
	        this._active = true;
	    },
	
	    deactivate: function deactivate() {
	        this._active = false;
	    },
	
	    setState: function setState(state) {
	        var _this4 = this;
	
	        var lat = parseFloat(state[0]);
	        var lng = parseFloat(state[1]);
	        var pageId = state[2];
	        var y = parseFloat(state[3]);
	        var x = parseFloat(state[4]);
	        var zoom = parseFloat(state[5]);
	        if (!isNaN(lat) && !isNaN(lng) && !isNaN(x) && !isNaN(y) && !isNaN(zoom)) {
	            var imageIdx = -1;
	            getPanoramaAtPos({ lat: lat, lng: lng }, 0).then(function (resp) {
	                if (!resp.found) {
	                    return false;
	                }
	                var _iteratorNormalCompletion4 = true;
	                var _didIteratorError4 = false;
	                var _iteratorError4 = undefined;
	
	                try {
	                    for (var _iterator4 = resp.data.entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                        var _step4$value = _slicedToArray(_step4.value, 2),
	                            i = _step4$value[0],
	                            image = _step4$value[1];
	
	                        if (image.pageId === pageId) {
	                            imageIdx = i;
	                            break;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError4 = true;
	                    _iteratorError4 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                            _iterator4.return();
	                        }
	                    } finally {
	                        if (_didIteratorError4) {
	                            throw _iteratorError4;
	                        }
	                    }
	                }
	
	                if (imageIdx > -1) {
	                    _this4._showPano(resp.data, imageIdx, { center: _leaflet2.default.latLng(y, x), zoom: zoom });
	                }
	            });
	            return true;
	        }
	        return false;
	    },
	
	    getState: function getState() {
	        if (!this.images) {
	            return [];
	        }
	        var center = this.map.getCenter();
	        return [this.images[0].lat.toFixed(6), this.images[0].lng.toFixed(6), this.images[this._imageIdx].pageId, center.lat.toFixed(2), center.lng.toFixed(2), this.map.getZoom().toFixed(1)];
	    }
	});
	
	function getViewer(container) {
	    return new Viewer(container);
	}
	
	exports.default = {
	    getCoverageLayer: getCoverageLayer,
	    getPanoramaAtPos: getPanoramaAtPos,
	    getViewer: getViewer
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _knockout = __webpack_require__(51);
	
	var _knockout2 = _interopRequireDefault(_knockout);
	
	__webpack_require__(113);
	
	__webpack_require__(38);
	
	__webpack_require__(458);
	
	var _pageFeature = __webpack_require__(205);
	
	var _pageFeature2 = _interopRequireDefault(_pageFeature);
	
	var _contextmenu = __webpack_require__(56);
	
	var _contextmenu2 = _interopRequireDefault(_contextmenu);
	
	var _mapRender = __webpack_require__(204);
	
	var _form = __webpack_require__(487);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _notifications = __webpack_require__(35);
	
	var _pdf = __webpack_require__(206);
	
	var _browserFilesaver = __webpack_require__(64);
	
	var _binaryStrings = __webpack_require__(50);
	
	__webpack_require__(61);
	
	__webpack_require__(31);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	var _decoration = __webpack_require__(202);
	
	var _decoration2 = __webpack_require__(203);
	
	var _decoration3 = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	_knockout2.default.extenders.checkNumberRange = function (target, range) {
	    return _knockout2.default.pureComputed({
	        read: target, //always return the original observables value
	        write: function write(newValue) {
	            newValue = parseFloat(newValue);
	            if (newValue >= range[0] && newValue <= range[1]) {
	                target(newValue);
	            } else {
	                target.notifySubscribers(target());
	            }
	        }
	    }).extend({ notify: 'always' });
	};
	
	function savePagesPdf(imagesInfo, resolution) {
	    var pdf = (0, _pdf.makePdf)(imagesInfo, resolution);
	    pdf = (0, _binaryStrings.blobFromString)(pdf);
	    (0, _browserFilesaver.saveAs)(pdf, 'map.pdf', true);
	}
	
	function _savePageJpg(page) {
	    (0, _browserFilesaver.saveAs)((0, _binaryStrings.blobFromString)(page.data), 'map.jpg', true);
	}
	
	_leaflet2.default.Control.PrintPages = _leaflet2.default.Control.extend({
	    options: { position: 'bottomleft' },
	
	    includes: [_leaflet2.default.Mixin.Events, _leaflet2.default.Mixin.HashState],
	
	    stateChangeEvents: ['change'],
	
	    pageSizes: [{ 'name': 'A1', width: 594, height: 841 }, { 'name': 'A2', width: 420, height: 594 }, { 'name': 'A3', width: 297, height: 420 }, { 'name': 'A4', width: 210, height: 297 }, { 'name': 'A5', width: 148, height: 210 }],
	
	    initialize: function initialize(options) {
	        _leaflet2.default.Control.prototype.initialize.call(this, options);
	        this.pages = [];
	        this.scale = _knockout2.default.observable(500).extend({ checkNumberRange: [1, 1000000] });
	        this.resolution = _knockout2.default.observable(300).extend({ checkNumberRange: [10, 9999] });
	        this.zoomLevel = _knockout2.default.observable('auto');
	        this.pageWidth = _knockout2.default.observable(210).extend({ checkNumberRange: [10, 9999] });
	        this.pageHeight = _knockout2.default.observable(297).extend({ checkNumberRange: [10, 9999] });
	        this.settingsExpanded = _knockout2.default.observable(false);
	        this.makingPdf = _knockout2.default.observable(false);
	        this.downloadProgressRange = _knockout2.default.observable();
	        this.downloadProgressDone = _knockout2.default.observable();
	        this.marginLeft = _knockout2.default.observable(3).extend({ checkNumberRange: [0, 99] });
	        this.marginRight = _knockout2.default.observable(3).extend({ checkNumberRange: [0, 99] });
	        this.marginTop = _knockout2.default.observable(3).extend({ checkNumberRange: [0, 99] });
	        this.marginBottom = _knockout2.default.observable(3).extend({ checkNumberRange: [0, 99] });
	        this.autoZoomLevels = _knockout2.default.observable({});
	        this.printSize = _knockout2.default.pureComputed(this._printSize, this);
	        this.printSize.subscribe(this.onPageSizeChanged, this);
	        this.scale.subscribe(this.onPageSizeChanged, this);
	        this.resolution.subscribe(this.onPageSizeChanged, this);
	        this.pageSizeDescription = _knockout2.default.pureComputed(this._displayPageSize, this);
	        this.pagesNum = _knockout2.default.observable(0);
	        this.pagesNumLabel = _knockout2.default.pureComputed(this._pagesNumLabel, this);
	        this.gridOn = _knockout2.default.observable(false);
	        this.magneticMerisiansdOn = _knockout2.default.observable(false);
	
	        //hash state notifications
	        this.scale.subscribe(this.notifyChange, this);
	        this.printSize.subscribe(this.notifyChange, this);
	        this.resolution.subscribe(this.notifyChange, this);
	        this.zoomLevel.subscribe(this.notifyChange, this);
	        this.gridOn.subscribe(this.notifyChange, this);
	        this.magneticMerisiansdOn.subscribe(this.notifyChange, this);
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control control-form control-print-pages');
	        this._stopContainerEvents();
	
	        map.on('move', this.updateFormZooms, this);
	        container.innerHTML = _form2.default;
	        _knockout2.default.applyBindings(this, container);
	        this.updateFormZooms();
	        return container;
	    },
	
	    setExpanded: function setExpanded() {
	        _leaflet2.default.DomUtil.removeClass(this._container, 'minimized');
	    },
	
	    setMinimized: function setMinimized() {
	        _leaflet2.default.DomUtil.addClass(this._container, 'minimized');
	    },
	
	    addPage: function addPage(isLandsacape, center) {
	        var _printSize = this.printSize(),
	            _printSize2 = _slicedToArray(_printSize, 2),
	            pageWidth = _printSize2[0],
	            pageHeight = _printSize2[1];
	
	        if (isLandsacape) {
	            var _ref = [pageHeight, pageWidth];
	            pageWidth = _ref[0];
	            pageHeight = _ref[1];
	        }
	        if (!center) {
	            center = this._map.getCenter();
	        }
	        var page = new _pageFeature2.default(center, [pageWidth, pageHeight], this.scale(), (this.pages.length + 1).toString());
	        page._rotated = isLandsacape;
	        page.addTo(this._map);
	        this.pages.push(page);
	        this.pagesNum(this.pages.length);
	        var cm = new _contextmenu2.default(this.makePageContexmenuItems.bind(this, page));
	        page.on('contextmenu', cm.show, cm);
	        page.on('click', this.rotatePage.bind(this, page));
	        page.on('move', this.updateFormZooms, this);
	        page.on('moveend', this.notifyChange, this);
	        this.updateFormZooms();
	        this.notifyChange();
	        return page;
	    },
	
	    addLandscapePage: function addLandscapePage() {
	        this.addPage(true);
	    },
	
	    addPortraitPage: function addPortraitPage() {
	        this.addPage(false);
	    },
	
	    removePage: function removePage(page) {
	        var i = this.pages.indexOf(page);
	        this.pages.splice(i, 1);
	        this.pagesNum(this.pages.length);
	        this._map.removeLayer(page);
	        for (; i < this.pages.length; i++) {
	            this.pages[i].setLabel((i + 1).toString());
	        }
	        this.notifyChange();
	        this.updateFormZooms();
	    },
	
	    removePages: function removePages() {
	        var _this = this;
	
	        this.pages.forEach(function (page) {
	            return page.removeFrom(_this._map);
	        });
	        this.pages = [];
	        this.pagesNum(this.pages.length);
	        this.notifyChange();
	        this.updateFormZooms();
	    },
	
	    onSavePdfClicked: function onSavePdfClicked() {
	        if (!this.pages.length) {
	            (0, _notifications.notify)('Add some pages to print');
	            return;
	        }
	        this.savePdf();
	    },
	
	    zoomForPrint: function zoomForPrint() {
	        var zoom = this.zoomLevel();
	        if (zoom === 'auto') {
	            zoom = this.suggestZooms();
	        } else {
	            zoom = { mapZoom: zoom, satZoom: zoom };
	        }
	        return zoom;
	    },
	
	    incrementProgress: function incrementProgress(inc, range) {
	        this.downloadProgressRange(range);
	        this.downloadProgressDone((this.downloadProgressDone() || 0) + inc);
	    },
	
	    savePdf: function savePdf() {
	        var _this2 = this;
	
	        _logging2.default.captureBreadcrumbWithUrl({ message: 'start save pdf' });
	        if (!this._map) {
	            return;
	        }
	        this.downloadProgressRange(1000);
	        this.downloadProgressDone(undefined);
	        this.makingPdf(true);
	        var pages = this.pages.map(function (page) {
	            return {
	                latLngBounds: page.getLatLngBounds(),
	                printSize: page.getPrintSize(),
	                label: page.getLabel()
	            };
	        });
	        var resolution = this.resolution();
	        var decorationLayers = [];
	        if (this.gridOn()) {
	            decorationLayers.push(new _decoration3.Grid());
	        }
	        if (this.magneticMerisiansdOn()) {
	            decorationLayers.push(new _decoration.MagneticMeridians());
	        }
	        decorationLayers.push(new _decoration2.OverlayScale());
	        (0, _mapRender.renderPages)({
	            map: this._map,
	            pages: pages,
	            zooms: this.zoomForPrint(),
	            resolution: resolution,
	            scale: this.scale(),
	            decorationLayers: decorationLayers,
	            progressCallback: this.incrementProgress.bind(this)
	        }).then(function (images) {
	            if (images) {
	                savePagesPdf(images, resolution);
	            }
	        }).catch(function (e) {
	            _logging2.default.captureException(e);
	            (0, _notifications.notify)('Failed to create PDF: ' + e.message);
	        }).then(function () {
	            return _this2.makingPdf(false);
	        });
	    },
	
	    savePageJpg: function savePageJpg(page) {
	        var _this3 = this;
	
	        _logging2.default.captureBreadcrumbWithUrl({ message: 'start save page jpg', data: { pageNumber: page.getLabel() } });
	        var pages = [{
	            latLngBounds: page.getLatLngBounds(),
	            printSize: page.getPrintSize(),
	            label: page.getLabel()
	        }];
	        var decorationLayers = [];
	        if (this.gridOn()) {
	            decorationLayers.push(new _decoration3.Grid());
	        }
	        if (this.magneticMerisiansdOn()) {
	            decorationLayers.push(new _decoration.MagneticMeridians());
	        }
	        decorationLayers.push(new _decoration2.OverlayScale());
	        this.downloadProgressRange(1000);
	        this.downloadProgressDone(undefined);
	        this.makingPdf(true);
	        (0, _mapRender.renderPages)({
	            map: this._map,
	            pages: pages,
	            zooms: this.zoomForPrint(),
	            resolution: this.resolution(),
	            scale: this.scale(),
	            decorationLayers: decorationLayers,
	            progressCallback: this.incrementProgress.bind(this)
	        }).then(function (images) {
	            return _savePageJpg(images[0]);
	        }).catch(function (e) {
	            _logging2.default.captureException(e);
	            (0, _notifications.notify)('Failed to create JPEG from page: ' + e.message);
	        }).then(function () {
	            return _this3.makingPdf(false);
	        });
	    },
	
	    onPageSizeChanged: function onPageSizeChanged() {
	        var _this4 = this;
	
	        var _printSize3 = this.printSize(),
	            _printSize4 = _slicedToArray(_printSize3, 2),
	            pageWidth = _printSize4[0],
	            pageHeight = _printSize4[1];
	
	        this.pages.forEach(function (page) {
	            var w = pageWidth,
	                h = pageHeight;
	
	            if (page._rotated) {
	                var _ref2 = [h, w];
	                w = _ref2[0];
	                h = _ref2[1];
	            }
	            page.setSize([w, h], _this4.scale());
	        });
	        this.updateFormZooms();
	    },
	
	    makePageContexmenuItems: function makePageContexmenuItems(page) {
	        var _this5 = this;
	
	        var items = [{ text: 'Rotate', callback: this.rotatePage.bind(this, page) }, '-', { text: 'Delete', callback: this.removePage.bind(this, page) }, '-', { text: 'Save image', callback: this.savePageJpg.bind(this, page), disabled: this.makingPdf() }];
	        if (this.pages.length > 1) {
	            items.push({ text: 'Change order', separator: true });
	            this.pages.forEach(function (p, i) {
	                if (p !== page) {
	                    items.push({
	                        text: (i + 1).toString(),
	                        callback: _this5.renumberPage.bind(_this5, page, i)
	                    });
	                }
	            });
	        }
	        return items;
	    },
	
	    rotatePage: function rotatePage(page) {
	        page._rotated = !page._rotated;
	        page.rotate();
	        this.notifyChange();
	    },
	
	    renumberPage: function renumberPage(page, newIndex) {
	        var oldIndex = this.pages.indexOf(page);
	        this.pages.splice(oldIndex, 1);
	        this.pages.splice(newIndex, 0, page);
	        for (var i = Math.min(oldIndex, newIndex); i < this.pages.length; i++) {
	            this.pages[i].setLabel((i + 1).toString());
	        }
	        this.notifyChange();
	    },
	
	    _printSize: function _printSize() {
	        return [this.pageWidth() - this.marginLeft() - this.marginRight(), this.pageHeight() - this.marginTop() - this.marginBottom()];
	    },
	
	    suggestZooms: function suggestZooms() {
	        var scale = this.scale(),
	            resolution = this.resolution();
	        var referenceLat = void 0;
	        if (this.pages.length > 0) {
	            var absLats = this.pages.map(function (page) {
	                return Math.abs(page.getLatLngBounds().getCenter().lat);
	            });
	            referenceLat = Math.min.apply(Math, _toConsumableArray(absLats));
	        } else {
	            if (!this._map) {
	                return [null, null];
	            }
	            referenceLat = this._map.getCenter().lat;
	        }
	        var targetMetersPerPixel = scale / (resolution / 2.54);
	        var mapUnitsPerPixel = targetMetersPerPixel / Math.cos(referenceLat * Math.PI / 180);
	        var satZoom = Math.ceil(Math.log(40075016.4 / 256 / mapUnitsPerPixel) / Math.LN2);
	
	        targetMetersPerPixel = scale / (90 / 2.54) / 1.5;
	        mapUnitsPerPixel = targetMetersPerPixel / Math.cos(referenceLat * Math.PI / 180);
	        var mapZoom = Math.round(Math.log(40075016.4 / 256 / mapUnitsPerPixel) / Math.LN2);
	        mapZoom = Math.min(mapZoom, 18);
	        satZoom = Math.min(satZoom, 18);
	        mapZoom = Math.max(mapZoom, 0);
	        satZoom = Math.max(satZoom, 0);
	        return { mapZoom: mapZoom, satZoom: satZoom };
	    },
	
	    updateFormZooms: function updateFormZooms() {
	        this.autoZoomLevels(this.suggestZooms());
	    },
	
	    _displayPageSize: function _displayPageSize() {
	        var width = this.pageWidth(),
	            height = this.pageHeight();
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this.pageSizes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var size = _step.value;
	
	                if (size.width === width && size.height === height) {
	                    return size.name;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return width + ' x ' + height + ' mm';
	    },
	
	    notifyChange: function notifyChange() {
	        this.fire('change');
	    },
	
	    hasPages: function hasPages() {
	        return !!this.pages.length;
	    },
	
	    _pagesNumLabel: function _pagesNumLabel() {
	        var n = this.pagesNum();
	        var label = '';
	        if (n) {
	            label += n;
	        } else {
	            label = 'No';
	        }
	        label += ' page';
	        if (n === 0 || n > 1) {
	            label += 's';
	        }
	        return label;
	    },
	
	    serializeState: function serializeState() {
	        var pages = this.pages;
	        var state = null;
	        if (pages.length) {
	            state = [];
	            state.push(this.scale().toString());
	            state.push(this.resolution().toString());
	            state.push(this.zoomLevel().toString());
	            state.push(this.pageWidth().toString());
	            state.push(this.pageHeight().toString());
	            state.push(this.marginLeft().toString());
	            state.push(this.marginRight().toString());
	            state.push(this.marginTop().toString());
	            state.push(this.marginBottom().toString());
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = pages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var page = _step2.value;
	
	                    var latLng = page.getLatLng();
	                    state.push(latLng.lat.toFixed(5));
	                    state.push(latLng.lng.toFixed(5));
	                    state.push(page._rotated ? '1' : '0');
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            var flags = (this.magneticMerisiansdOn() ? 1 : 0) | (this.gridOn() ? 2 : 0);
	            state.push(flags);
	        }
	        return state;
	    },
	
	    unserializeState: function unserializeState(state) {
	        if (!state || !state.length) {
	            return false;
	        }
	        this.removePages();
	        state = [].concat(_toConsumableArray(state));
	        this.scale(state.shift());
	        this.resolution(state.shift());
	        this.zoomLevel(state.shift());
	        this.pageWidth(state.shift());
	        this.pageHeight(state.shift());
	        this.marginLeft(state.shift());
	        this.marginRight(state.shift());
	        this.marginTop(state.shift());
	        this.marginBottom(state.shift());
	        var lat = void 0,
	            lng = void 0,
	            rotated = void 0;
	        while (state.length >= 3) {
	            lat = parseFloat(state.shift());
	            lng = parseFloat(state.shift());
	            rotated = parseInt(state.shift(), 10);
	            if (isNaN(lat) || isNaN(lng) || lat < -85 || lat > 85 || lng < -180 || lng > 180) {
	                break;
	            }
	            this.addPage(!!rotated, _leaflet2.default.latLng(lat, lng));
	        }
	        if (state.length) {
	            var flags = parseInt(state.shift(), 10);
	            if (flags >= 0 && flags <= 3) {
	                this.magneticMerisiansdOn(!!(flags & 1));
	                this.gridOn(!!(flags & 2));
	            }
	        }
	        return true;
	    }
	});

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Grid = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _decorations = __webpack_require__(80);
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function radians(degrees) {
	    return degrees * Math.PI / 180;
	}
	
	var Grid = function (_PrintStaticLayer) {
	    _inherits(Grid, _PrintStaticLayer);
	
	    function Grid() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Grid);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Grid.__proto__ || Object.getPrototypeOf(Grid)).call.apply(_ref, [this].concat(args))), _this), _this.minGridIntervalMm = 15, _this.fontSizeMm = 3, _this.font = 'verdana', _this.paddingMm = 1, _this.intervals = [1, 1.5, 2, 3.3, 5, 7.5, 10, 15, 20, 33, 50, 75, 100, 150, 200, 333, 500, 750, 1000, 1500, 2000, 4000, 5000, 7500, 10000, 15000, 20000, 40000, 50000, 75000, 100000, 150000, 200000, 400000, 500000, 750000, 1000000, 1500000, 2000000, 4000000, 5000000, 7500000], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Grid, [{
	        key: 'getGridInterval',
	        value: function getGridInterval(printOptions) {
	            var minGridIntervalM = this.minGridIntervalMm / 10 * printOptions.scale;
	            var intervalM = void 0;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.intervals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    intervalM = _step.value;
	
	                    if (intervalM > minGridIntervalM) {
	                        break;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return intervalM;
	        }
	    }, {
	        key: 'formatDistance',
	        value: function formatDistance(x) {
	            var unit = void 0;
	            if (x < 1000) {
	                unit = 'm';
	            } else {
	                x /= 1000;
	                unit = 'km';
	            }
	            if (x % 1) {
	                x = x.toFixed(1);
	            }
	            return x + ' ' + unit;
	        }
	    }, {
	        key: '_drawGrid',
	        value: function _drawGrid(canvas, printOptions) {
	            var metersPerDegree = _leaflet2.default.Projection.SphericalMercator.R * Math.PI / 180;
	            var ctx = canvas.getContext('2d');
	            ctx.beginPath();
	            var pixelsPerMm = 1 / 25.4 * printOptions.resolution;
	            var intervalM = this.getGridInterval(printOptions);
	            var width = printOptions.destPixelSize.x;
	            var height = printOptions.destPixelSize.y;
	            var mercatorBounds = _leaflet2.default.bounds(_leaflet2.default.Projection.SphericalMercator.project(printOptions.latLngBounds.getNorthWest()), _leaflet2.default.Projection.SphericalMercator.project(printOptions.latLngBounds.getSouthEast()));
	            var canvasToMercatorScale = mercatorBounds.getSize().unscaleBy(printOptions.destPixelSize);
	            var rows = [];
	            var y = height;
	            while (true) {
	                var yMerc = mercatorBounds.max.y - y * canvasToMercatorScale.y;
	                var lat = _leaflet2.default.Projection.SphericalMercator.unproject(_leaflet2.default.point(0, yMerc)).lat;
	                rows.push({ lat: lat, y: y });
	                if (y < 0) {
	                    break;
	                }
	                var lat2 = lat + intervalM / metersPerDegree;
	                var yMerc2 = _leaflet2.default.Projection.SphericalMercator.project(_leaflet2.default.latLng(lat2, 0)).y;
	                y = (mercatorBounds.max.y - yMerc2) / canvasToMercatorScale.y;
	            }
	            var lineWidthMm = 0.15;
	            var lineWidthPx = lineWidthMm * pixelsPerMm;
	            var _arr = [{ color: '#D9D9D9', offset: lineWidthPx / 2 }, { color: '#8C8C8C', offset: -lineWidthPx / 2 }];
	            for (var _i = 0; _i < _arr.length; _i++) {
	                var _arr$_i = _arr[_i],
	                    color = _arr$_i.color,
	                    offset = _arr$_i.offset;
	
	                ctx.beginPath();
	
	                ctx.lineWidth = lineWidthPx;
	                ctx.strokeStyle = color;
	
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        y = _step2.value.y;
	
	                        ctx.moveTo(0, y + offset);
	                        ctx.lineTo(width, y + offset);
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	
	                var pageCanvasCenterX = printOptions.destPixelSize.x / 2;
	                var _arr2 = [-1, 1];
	                for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	                    var direction = _arr2[_i2];
	                    var colN = 0;
	                    while (true) {
	                        var firstRow = true;
	                        var hasPointInPage = false;
	                        var _iteratorNormalCompletion3 = true;
	                        var _didIteratorError3 = false;
	                        var _iteratorError3 = undefined;
	
	                        try {
	                            for (var _iterator3 = rows[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                                var _step3$value = _step3.value,
	                                    _lat = _step3$value.lat,
	                                    _y = _step3$value.y;
	
	                                var dx = colN * intervalM / Math.cos(radians(_lat)) / canvasToMercatorScale.x;
	                                if (dx < pageCanvasCenterX) {
	                                    hasPointInPage = true;
	                                }
	                                if (firstRow) {
	                                    ctx.moveTo(pageCanvasCenterX + dx * direction + offset, _y);
	                                } else {
	                                    ctx.lineTo(pageCanvasCenterX + dx * direction + offset, _y);
	                                }
	                                firstRow = false;
	                            }
	                        } catch (err) {
	                            _didIteratorError3 = true;
	                            _iteratorError3 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                    _iterator3.return();
	                                }
	                            } finally {
	                                if (_didIteratorError3) {
	                                    throw _iteratorError3;
	                                }
	                            }
	                        }
	
	                        if (!hasPointInPage) {
	                            break;
	                        }
	                        colN += 1;
	                    }
	                }
	                ctx.stroke();
	            }
	        }
	    }, {
	        key: '_drawLabel',
	        value: function _drawLabel(canvas, printOptions) {
	            var intervalM = this.getGridInterval(printOptions);
	            var height = printOptions.destPixelSize.y;
	            var ctx = canvas.getContext('2d');
	            var caption = 'Grid ' + this.formatDistance(intervalM);
	            var fontSize = this.fontSizeMm / 25.4 * printOptions.resolution;
	            var padding = this.paddingMm / 25.4 * printOptions.resolution;
	            ctx.font = fontSize + 'px ' + this.font;
	            var textWidth = ctx.measureText(caption).width;
	            ctx.textBaseline = 'bottom';
	            ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
	            ctx.fillRect(0, height - fontSize - 2 * padding, textWidth + 2 * padding, fontSize + 2 * padding);
	            ctx.fillStyle = '#000000';
	            ctx.fillText(caption, padding, height - padding);
	        }
	    }, {
	        key: 'getTilesInfo',
	        value: function () {
	            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(printOptions) {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                return _context2.abrupt('return', {
	                                    iterateTilePromises: /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                                        var _this2 = this;
	
	                                        return regeneratorRuntime.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        _context.next = 2;
	                                                        return {
	                                                            tilePromise: Promise.resolve({
	                                                                draw: function draw(canvas) {
	                                                                    return _this2._drawGrid(canvas, printOptions);
	                                                                },
	                                                                isOverlay: true,
	                                                                overlaySolid: false
	                                                            }),
	                                                            abortLoading: function abortLoading() {}
	                                                        };
	
	                                                    case 2:
	                                                        _context.next = 4;
	                                                        return {
	                                                            tilePromise: Promise.resolve({
	                                                                draw: function draw(canvas) {
	                                                                    return _this2._drawLabel(canvas, printOptions);
	                                                                },
	                                                                isOverlay: true,
	                                                                overlaySolid: true
	                                                            }),
	                                                            abortLoading: function abortLoading() {}
	                                                        };
	
	                                                    case 4:
	                                                    case 'end':
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, this);
	                                    }).bind(this),
	                                    count: 2
	                                });
	
	                            case 1:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function getTilesInfo(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return getTilesInfo;
	        }()
	    }]);
	
	    return Grid;
	}(_decorations.PrintStaticLayer);
	
	exports.Grid = Grid;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MagneticMeridians = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _magneticDeclination = __webpack_require__(127);
	
	var _decorations = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function radians(degrees) {
	    return degrees * Math.PI / 180;
	}
	
	function movePoint(p, angle, dist) {
	    angle = radians(angle);
	    return new _leaflet2.default.point(p.x + Math.sin(angle) * dist, p.y - Math.cos(angle) * dist);
	}
	
	var MagneticMeridians = function (_PrintStaticLayer) {
	    _inherits(MagneticMeridians, _PrintStaticLayer);
	
	    function MagneticMeridians() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MagneticMeridians);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MagneticMeridians.__proto__ || Object.getPrototypeOf(MagneticMeridians)).call.apply(_ref, [this].concat(args))), _this), _this.lineThicknessMm = 0.2, _this.lineIntervalMm = 50, _this.samplingIntervalMm = 15, _this.color = '#66c2ff', _this.overlaySolid = false, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MagneticMeridians, [{
	        key: '_makeCanvasToLatLngTransformer',
	        value: function _makeCanvasToLatLngTransformer(printOptions) {
	            var projectedBounds = printOptions.pixelBounds;
	            var scale = projectedBounds.getSize().unscaleBy(printOptions.destPixelSize);
	            var origin = projectedBounds.min;
	            return function (pixel) {
	                return _leaflet2.default.CRS.EPSG3857.pointToLatLng(pixel.scaleBy(scale).add(origin), printOptions.zoom);
	            };
	        }
	    }, {
	        key: '_drawRaster',
	        value: function _drawRaster(canvas, printOptions) {
	            var toLatLng = this._makeCanvasToLatLngTransformer(printOptions);
	            var ctx = canvas.getContext('2d');
	            ctx.beginPath();
	            ctx.strokeStyle = this.color;
	            ctx.lineWidth = this.lineThicknessMm / 25.4 * printOptions.resolution;
	            var intervalPx = this.lineIntervalMm / 25.4 * printOptions.resolution;
	            var samplingPx = this.samplingIntervalMm / 25.4 * printOptions.resolution;
	            var pageDiagonal = Math.sqrt(printOptions.destPixelSize.x * printOptions.destPixelSize.x + printOptions.destPixelSize.y * printOptions.destPixelSize.y);
	            var maxSegments = pageDiagonal / 2 / samplingPx;
	
	            function drawLine(p, directionDown) {
	                ctx.moveTo(p.x, p.y);
	
	                for (var i = 0; i <= maxSegments; i++) {
	                    var latLng = toLatLng(p);
	                    var declination = (0, _magneticDeclination.getDeclination)(latLng.lat, latLng.lng);
	                    if (declination === null) {
	                        break;
	                    }
	                    if (directionDown) {
	                        declination += 180;
	                    }
	                    p = movePoint(p, declination, samplingPx);
	                    ctx.lineTo(p.x, p.y);
	                }
	            }
	
	            var center = printOptions.destPixelSize.divideBy(2);
	            var maxLines = pageDiagonal / 2 / intervalPx;
	
	            drawLine(center);
	            drawLine(center, true);
	
	            var p = center;
	            for (var i = 0; i <= maxLines; i++) {
	                var latLng = toLatLng(p);
	                var declination = (0, _magneticDeclination.getDeclination)(latLng.lat, latLng.lng);
	                if (declination === null) {
	                    declination = 0;
	                }
	                p = movePoint(p, declination + 90, intervalPx);
	                drawLine(p);
	                drawLine(p, true);
	            }
	            p = center;
	            for (var _i = 0; _i <= maxLines; _i++) {
	                var _latLng = toLatLng(p);
	                var _declination = (0, _magneticDeclination.getDeclination)(_latLng.lat, _latLng.lng);
	                if (_declination === null) {
	                    _declination = 0;
	                }
	                p = movePoint(p, _declination - 90, intervalPx);
	                drawLine(p);
	                drawLine(p, true);
	            }
	
	            ctx.stroke();
	        }
	    }]);
	
	    return MagneticMeridians;
	}(_decorations.PrintStaticLayer);
	
	exports.MagneticMeridians = MagneticMeridians;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OverlayScale = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _decorations = __webpack_require__(80);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function pageScaleRange(printOptions) {
	    var pageSize = printOptions.destPixelSize.divideBy(printOptions.resolution / 25.4);
	    var bounds = printOptions.latLngBounds;
	    var southLen = bounds.getSouthEast().distanceTo(bounds.getSouthWest());
	    var northLen = bounds.getNorthEast().distanceTo(bounds.getNorthWest());
	    var nScale = Math.round(northLen / pageSize.x * 10);
	    var sScale = Math.round(southLen / pageSize.x * 10);
	    return {
	        min: Math.min(nScale, sScale, printOptions.scale),
	        max: Math.max(nScale, sScale, printOptions.scale)
	    };
	}
	
	function formatScale(nominalScale, scaleRange) {
	    var threshold = 0.05;
	    if (Math.abs(nominalScale - scaleRange.min) / nominalScale > threshold || Math.abs(nominalScale - scaleRange.max) / nominalScale > threshold) {
	        var unit = void 0;
	        scaleRange = Object.assign({}, scaleRange);
	        if (scaleRange.min >= 1000) {
	            scaleRange.min /= 1000;
	            scaleRange.max /= 1000;
	            unit = 'km';
	        } else {
	            unit = 'm';
	        }
	        return scaleRange.min + ' \u2013 ' + scaleRange.max + ' ' + unit + ' in 1 cm';
	    } else {
	        var _unit = void 0;
	        if (nominalScale >= 1000) {
	            nominalScale /= 1000;
	            _unit = 'km';
	        } else {
	            _unit = 'm';
	        }
	        return nominalScale + ' ' + _unit + ' in 1 cm';
	    }
	}
	
	var OverlayScale = function (_PrintStaticLayer) {
	    _inherits(OverlayScale, _PrintStaticLayer);
	
	    function OverlayScale() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, OverlayScale);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OverlayScale.__proto__ || Object.getPrototypeOf(OverlayScale)).call.apply(_ref, [this].concat(args))), _this), _this.fontSizeMm = 3, _this.font = 'verdana', _this.paddingMm = 1, _this.overlaySolid = true, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(OverlayScale, [{
	        key: '_drawRaster',
	        value: function _drawRaster(canvas, printOptions) {
	            var ctx = canvas.getContext('2d');
	            var caption = formatScale(printOptions.scale, pageScaleRange(printOptions));
	            if (printOptions.pagesCount > 1) {
	                caption += ' | Page ' + printOptions.pageLabel + ' / ' + printOptions.pagesCount;
	            }
	            var fontSize = this.fontSizeMm / 25.4 * printOptions.resolution;
	            var padding = this.paddingMm / 25.4 * printOptions.resolution;
	            ctx.font = fontSize + 'px ' + this.font;
	            var textWidth = ctx.measureText(caption).width;
	            ctx.textBaseline = 'bottom';
	            ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
	            ctx.fillRect(0, 0, textWidth + 2 * padding, fontSize + 2 * padding);
	            ctx.fillStyle = '#000000';
	            ctx.fillText(caption, padding, fontSize + padding);
	        }
	    }]);
	
	    return OverlayScale;
	}(_decorations.PrintStaticLayer);
	
	exports.OverlayScale = OverlayScale;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.renderPages = undefined;
	
	var _asyncGenerator = function () { function AwaitValue(value) { this.value = value; } function AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; if (value instanceof AwaitValue) { Promise.resolve(value.value).then(function (arg) { resume("next", arg); }, function (arg) { resume("throw", arg); }); } else { settle(result.done ? "return" : "normal", result.value); } } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } } if (typeof Symbol === "function" && Symbol.asyncIterator) { AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; }; } AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }; AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }; AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); }; return { wrap: function wrap(fn) { return function () { return new AsyncGenerator(fn.apply(this, arguments)); }; }, await: function _await(value) { return new AwaitValue(value); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var iterateLayersTiles = function () {
	    var _ref = _asyncGenerator.wrap( /*#__PURE__*/regeneratorRuntime.mark(function _callee(layers, latLngBounds, destPixelSize, resolution, scale, zooms, pageLabel, pagesCount) {
	        var _this = this;
	
	        var defaultXHROptions, doStop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret;
	
	        return regeneratorRuntime.wrap(function _callee$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        defaultXHROptions = {
	                            responseType: 'blob',
	                            timeout: 20000,
	                            isResponseSuccess: function isResponseSuccess(xhr) {
	                                return xhr.status === 200 || xhr.status === 404;
	                            }
	                        };
	                        doStop = void 0;
	                        _iteratorNormalCompletion = true;
	                        _didIteratorError = false;
	                        _iteratorError = undefined;
	                        _context3.prev = 5;
	                        _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
	                            var layer, zoom, pixelBounds, map, _ref2, iterateTilePromises, count, layerPromises, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop2, _iterator2, _step2, _ret2;
	
	                            return regeneratorRuntime.wrap(function _loop$(_context2) {
	                                while (1) {
	                                    switch (_context2.prev = _context2.next) {
	                                        case 0:
	                                            layer = _step.value;
	                                            zoom = void 0;
	
	                                            if (layer.options && layer.options.scaleDependent) {
	                                                zoom = zooms.mapZoom;
	                                            } else {
	                                                zoom = zooms.satZoom;
	                                            }
	                                            pixelBounds = _leaflet2.default.bounds(_leaflet2.default.CRS.EPSG3857.latLngToPoint(latLngBounds.getNorthWest(), zoom).round(), _leaflet2.default.CRS.EPSG3857.latLngToPoint(latLngBounds.getSouthEast(), zoom).round());
	                                            map = void 0;
	
	                                            if (!layer._layerDummy) {
	                                                map = (0, _leafletLayer.getTempMap)(zoom, layer._rasterizeNeedsFullSizeMap, pixelBounds);
	                                                map.addLayer(layer);
	                                            }
	                                            _context2.next = 8;
	                                            return _asyncGenerator.await(layer.getTilesInfo({
	                                                xhrOptions: defaultXHROptions,
	                                                pixelBounds: pixelBounds,
	                                                latLngBounds: latLngBounds,
	                                                destPixelSize: destPixelSize,
	                                                resolution: resolution,
	                                                scale: scale,
	                                                zoom: zoom,
	                                                pageLabel: pageLabel,
	                                                pagesCount: pagesCount
	                                            }));
	
	                                        case 8:
	                                            _ref2 = _context2.sent;
	                                            iterateTilePromises = _ref2.iterateTilePromises;
	                                            count = _ref2.count;
	                                            layerPromises = [];
	                                            _iteratorNormalCompletion2 = true;
	                                            _didIteratorError2 = false;
	                                            _iteratorError2 = undefined;
	                                            _context2.prev = 15;
	                                            _loop2 = /*#__PURE__*/regeneratorRuntime.mark(function _loop2() {
	                                                var tilePromise, progressInc;
	                                                return regeneratorRuntime.wrap(function _loop2$(_context) {
	                                                    while (1) {
	                                                        switch (_context.prev = _context.next) {
	                                                            case 0:
	                                                                tilePromise = _step2.value;
	
	                                                                layerPromises.push(tilePromise.tilePromise);
	                                                                progressInc = (layer._printProgressWeight || 1) / count;
	
	                                                                tilePromise.tilePromise = tilePromise.tilePromise.then(function (tileInfo) {
	                                                                    return Object.assign({ zoom: zoom, progressInc: progressInc }, tileInfo);
	                                                                });
	                                                                _context.next = 6;
	                                                                return tilePromise;
	
	                                                            case 6:
	                                                                doStop = _context.sent;
	
	                                                                if (!doStop) {
	                                                                    _context.next = 10;
	                                                                    break;
	                                                                }
	
	                                                                tilePromise.abortLoading();
	                                                                return _context.abrupt('return', 'break');
	
	                                                            case 10:
	                                                            case 'end':
	                                                                return _context.stop();
	                                                        }
	                                                    }
	                                                }, _loop2, _this);
	                                            });
	                                            _iterator2 = iterateTilePromises()[Symbol.iterator]();
	
	                                        case 18:
	                                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                                                _context2.next = 26;
	                                                break;
	                                            }
	
	                                            return _context2.delegateYield(_loop2(), 't0', 20);
	
	                                        case 20:
	                                            _ret2 = _context2.t0;
	
	                                            if (!(_ret2 === 'break')) {
	                                                _context2.next = 23;
	                                                break;
	                                            }
	
	                                            return _context2.abrupt('break', 26);
	
	                                        case 23:
	                                            _iteratorNormalCompletion2 = true;
	                                            _context2.next = 18;
	                                            break;
	
	                                        case 26:
	                                            _context2.next = 32;
	                                            break;
	
	                                        case 28:
	                                            _context2.prev = 28;
	                                            _context2.t1 = _context2['catch'](15);
	                                            _didIteratorError2 = true;
	                                            _iteratorError2 = _context2.t1;
	
	                                        case 32:
	                                            _context2.prev = 32;
	                                            _context2.prev = 33;
	
	                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                                _iterator2.return();
	                                            }
	
	                                        case 35:
	                                            _context2.prev = 35;
	
	                                            if (!_didIteratorError2) {
	                                                _context2.next = 38;
	                                                break;
	                                            }
	
	                                            throw _iteratorError2;
	
	                                        case 38:
	                                            return _context2.finish(35);
	
	                                        case 39:
	                                            return _context2.finish(32);
	
	                                        case 40:
	                                            if (layer._layerDummy) {
	                                                _context2.next = 47;
	                                                break;
	                                            }
	
	                                            if (!doStop) {
	                                                _context2.next = 46;
	                                                break;
	                                            }
	
	                                            (0, _leafletLayer.disposeMap)(map);
	                                            return _context2.abrupt('return', 'break');
	
	                                        case 46:
	                                            Promise.all(layerPromises).then(function () {
	                                                return (0, _leafletLayer.disposeMap)(map);
	                                            });
	
	                                        case 47:
	                                        case 'end':
	                                            return _context2.stop();
	                                    }
	                                }
	                            }, _loop, _this, [[15, 28, 32, 40], [33,, 35, 39]]);
	                        });
	                        _iterator = layers[Symbol.iterator]();
	
	                    case 8:
	                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                            _context3.next = 16;
	                            break;
	                        }
	
	                        return _context3.delegateYield(_loop(), 't0', 10);
	
	                    case 10:
	                        _ret = _context3.t0;
	
	                        if (!(_ret === 'break')) {
	                            _context3.next = 13;
	                            break;
	                        }
	
	                        return _context3.abrupt('break', 16);
	
	                    case 13:
	                        _iteratorNormalCompletion = true;
	                        _context3.next = 8;
	                        break;
	
	                    case 16:
	                        _context3.next = 22;
	                        break;
	
	                    case 18:
	                        _context3.prev = 18;
	                        _context3.t1 = _context3['catch'](5);
	                        _didIteratorError = true;
	                        _iteratorError = _context3.t1;
	
	                    case 22:
	                        _context3.prev = 22;
	                        _context3.prev = 23;
	
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	
	                    case 25:
	                        _context3.prev = 25;
	
	                        if (!_didIteratorError) {
	                            _context3.next = 28;
	                            break;
	                        }
	
	                        throw _iteratorError;
	
	                    case 28:
	                        return _context3.finish(25);
	
	                    case 29:
	                        return _context3.finish(22);
	
	                    case 30:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee, this, [[5, 18, 22, 30], [23,, 25, 29]]);
	    }));
	
	    return function iterateLayersTiles(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var promiseQueueBuffer = function () {
	    var _ref3 = _asyncGenerator.wrap( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(source, maxActive) {
	        var queue, _ref4, value, done, doStop, _ref5, _value, _done, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, abortLoading, _ref6;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        queue = [];
	
	                    case 1:
	                        if (!(queue.length < maxActive)) {
	                            _context4.next = 12;
	                            break;
	                        }
	
	                        _context4.next = 4;
	                        return _asyncGenerator.await(source.next());
	
	                    case 4:
	                        _ref4 = _context4.sent;
	                        value = _ref4.value;
	                        done = _ref4.done;
	
	                        if (!done) {
	                            _context4.next = 9;
	                            break;
	                        }
	
	                        return _context4.abrupt('break', 12);
	
	                    case 9:
	                        queue.push(value);
	                        _context4.next = 1;
	                        break;
	
	                    case 12:
	                        if (!queue.length) {
	                            _context4.next = 51;
	                            break;
	                        }
	
	                        _context4.next = 15;
	                        return queue.shift();
	
	                    case 15:
	                        doStop = _context4.sent;
	
	                        if (!doStop) {
	                            _context4.next = 43;
	                            break;
	                        }
	
	                        _context4.next = 19;
	                        return _asyncGenerator.await(source.next(true));
	
	                    case 19:
	                        _ref5 = _context4.sent;
	                        _value = _ref5.value;
	                        _done = _ref5.done;
	
	                        if (!_done) {
	                            queue.push(_value);
	                        }
	                        _iteratorNormalCompletion3 = true;
	                        _didIteratorError3 = false;
	                        _iteratorError3 = undefined;
	                        _context4.prev = 26;
	                        for (_iterator3 = queue[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                            abortLoading = _step3.value.abortLoading;
	
	                            abortLoading();
	                        }
	
	                        _context4.next = 34;
	                        break;
	
	                    case 30:
	                        _context4.prev = 30;
	                        _context4.t0 = _context4['catch'](26);
	                        _didIteratorError3 = true;
	                        _iteratorError3 = _context4.t0;
	
	                    case 34:
	                        _context4.prev = 34;
	                        _context4.prev = 35;
	
	                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                            _iterator3.return();
	                        }
	
	                    case 37:
	                        _context4.prev = 37;
	
	                        if (!_didIteratorError3) {
	                            _context4.next = 40;
	                            break;
	                        }
	
	                        throw _iteratorError3;
	
	                    case 40:
	                        return _context4.finish(37);
	
	                    case 41:
	                        return _context4.finish(34);
	
	                    case 42:
	                        return _context4.abrupt('return');
	
	                    case 43:
	                        _context4.next = 45;
	                        return _asyncGenerator.await(source.next());
	
	                    case 45:
	                        _ref6 = _context4.sent;
	                        value = _ref6.value;
	                        done = _ref6.done;
	
	                        if (!done) {
	                            queue.push(value);
	                        }
	                        _context4.next = 12;
	                        break;
	
	                    case 51:
	                    case 'end':
	                        return _context4.stop();
	                }
	            }
	        }, _callee2, this, [[26, 30, 34, 42], [35,, 37, 41]]);
	    }));
	
	    return function promiseQueueBuffer(_x9, _x10) {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	var renderPages = function () {
	    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref8) {
	        var map = _ref8.map,
	            pages = _ref8.pages,
	            zooms = _ref8.zooms,
	            resolution = _ref8.resolution,
	            scale = _ref8.scale,
	            progressCallback = _ref8.progressCallback,
	            decorationLayers = _ref8.decorationLayers;
	
	        var xhrQueue, layers, progressRange, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _layer, pageImagesInfo, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, page, destPixelSize, _pixelBounds, composer, tilesIterator, queuedTilesIterator, _ref9, _tilePromise, done, tileInfo, dataUrl, data;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	                        xhrQueue = new _xhrPromise.XHRQueue();
	                        layers = getLayersForPrint(map, xhrQueue);
	
	                        layers.push.apply(layers, _toConsumableArray(decorationLayers));
	                        progressRange = 0;
	                        _iteratorNormalCompletion4 = true;
	                        _didIteratorError4 = false;
	                        _iteratorError4 = undefined;
	                        _context5.prev = 7;
	
	                        for (_iterator4 = layers[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                            _layer = _step4.value;
	
	                            progressRange += _layer._printProgressWeight || 1;
	                        }
	                        _context5.next = 15;
	                        break;
	
	                    case 11:
	                        _context5.prev = 11;
	                        _context5.t0 = _context5['catch'](7);
	                        _didIteratorError4 = true;
	                        _iteratorError4 = _context5.t0;
	
	                    case 15:
	                        _context5.prev = 15;
	                        _context5.prev = 16;
	
	                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                            _iterator4.return();
	                        }
	
	                    case 18:
	                        _context5.prev = 18;
	
	                        if (!_didIteratorError4) {
	                            _context5.next = 21;
	                            break;
	                        }
	
	                        throw _iteratorError4;
	
	                    case 21:
	                        return _context5.finish(18);
	
	                    case 22:
	                        return _context5.finish(15);
	
	                    case 23:
	                        progressRange *= pages.length;
	                        pageImagesInfo = [];
	                        _iteratorNormalCompletion5 = true;
	                        _didIteratorError5 = false;
	                        _iteratorError5 = undefined;
	                        _context5.prev = 28;
	                        _iterator5 = pages[Symbol.iterator]();
	
	                    case 30:
	                        if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
	                            _context5.next = 69;
	                            break;
	                        }
	
	                        page = _step5.value;
	                        destPixelSize = page.printSize.multiplyBy(resolution / 25.4).round();
	                        _pixelBounds = _leaflet2.default.bounds(map.project(page.latLngBounds.getNorthWest(), 24).round(), map.project(page.latLngBounds.getSouthEast(), 24).round());
	                        composer = new PageComposer(destPixelSize, _pixelBounds);
	                        _context5.next = 37;
	                        return iterateLayersTiles(layers, page.latLngBounds, destPixelSize, resolution, scale, zooms, page.label, pages.length);
	
	                    case 37:
	                        tilesIterator = _context5.sent;
	                        queuedTilesIterator = promiseQueueBuffer(tilesIterator, 20);
	
	                    case 39:
	                        if (false) {
	                            _context5.next = 62;
	                            break;
	                        }
	
	                        _context5.next = 42;
	                        return queuedTilesIterator.next();
	
	                    case 42:
	                        _ref9 = _context5.sent;
	                        _tilePromise = _ref9.value;
	                        done = _ref9.done;
	
	                        if (!done) {
	                            _context5.next = 47;
	                            break;
	                        }
	
	                        return _context5.abrupt('break', 62);
	
	                    case 47:
	                        tileInfo = void 0;
	                        _context5.prev = 48;
	                        _context5.next = 51;
	                        return _tilePromise.tilePromise;
	
	                    case 51:
	                        tileInfo = _context5.sent;
	                        _context5.next = 58;
	                        break;
	
	                    case 54:
	                        _context5.prev = 54;
	                        _context5.t1 = _context5['catch'](48);
	
	                        queuedTilesIterator.next(true);
	                        throw _context5.t1;
	
	                    case 58:
	                        progressCallback(tileInfo.progressInc, progressRange);
	                        composer.putTile(tileInfo);
	                        _context5.next = 39;
	                        break;
	
	                    case 62:
	                        dataUrl = composer.getDataUrl();
	                        data = dataUrl.substring(dataUrl.indexOf(',') + 1);
	
	                        data = atob(data);
	                        pageImagesInfo.push({
	                            data: data,
	                            width: destPixelSize.x,
	                            height: destPixelSize.y
	                        });
	
	                    case 66:
	                        _iteratorNormalCompletion5 = true;
	                        _context5.next = 30;
	                        break;
	
	                    case 69:
	                        _context5.next = 75;
	                        break;
	
	                    case 71:
	                        _context5.prev = 71;
	                        _context5.t2 = _context5['catch'](28);
	                        _didIteratorError5 = true;
	                        _iteratorError5 = _context5.t2;
	
	                    case 75:
	                        _context5.prev = 75;
	                        _context5.prev = 76;
	
	                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                            _iterator5.return();
	                        }
	
	                    case 78:
	                        _context5.prev = 78;
	
	                        if (!_didIteratorError5) {
	                            _context5.next = 81;
	                            break;
	                        }
	
	                        throw _iteratorError5;
	
	                    case 81:
	                        return _context5.finish(78);
	
	                    case 82:
	                        return _context5.finish(75);
	
	                    case 83:
	                        return _context5.abrupt('return', pageImagesInfo);
	
	                    case 84:
	                    case 'end':
	                        return _context5.stop();
	                }
	            }
	        }, _callee3, this, [[7, 11, 15, 23], [16,, 18, 22], [28, 71, 75, 83], [48, 54], [76,, 78, 82]]);
	    }));
	
	    return function renderPages(_x11) {
	        return _ref7.apply(this, arguments);
	    };
	}();
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _leafletLayer = __webpack_require__(122);
	
	var _xhrPromise = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getLayersForPrint(map, xhrQueue) {
	    function getZIndex(el) {
	        return parseInt(window.getComputedStyle(el).zIndex, 10) || 0;
	    }
	
	    function compare(i1, i2) {
	        if (i1 < i2) {
	            return -1;
	        } else if (i1 > i2) {
	            return 1;
	        }
	        return 0;
	    }
	
	    function compareLayersOrder(layer1, layer2) {
	        return compareArrays(getLayerZOrder(layer1), getLayerZOrder(layer2));
	    }
	
	    function getLayerZOrder(layer) {
	        var el = layer._container || layer._path;
	        if (!el) {
	            throw TypeError('Unsupported layer type');
	        }
	        var order = [];
	        while (el !== layer._map._container) {
	            order.push(getZIndex(el));
	            el = el.parentNode;
	        }
	        return order.reverse();
	    }
	
	    function compareArrays(ar1, ar2) {
	        var len = Math.min(ar1.length, ar2.length);
	        for (var i = 0; i < len; i++) {
	            var c = compare(ar1[i], ar2[i]);
	            if (c) {
	                return c;
	            }
	        }
	        return compare(ar1.length, ar2.length);
	    }
	
	    var layers = [];
	    map.eachLayer(function (layer) {
	        if (layer.options.print) {
	            layers.push(layer);
	        }
	    });
	    layers.sort(compareLayersOrder);
	    layers = layers.map(function (l) {
	        return l.cloneForPrint({ xhrQueue: xhrQueue });
	    });
	    return layers;
	}
	
	function blendMultiplyCanvas(src, dest) {
	    if (src.width !== dest.width || src.height !== dest.height) {
	        throw new Error('Canvas size mismatch');
	    }
	    var s_data = src.getContext('2d').getImageData(0, 0, src.width, src.height).data;
	    src.width = 0;
	    src.height = 0;
	    var d_image_data = dest.getContext('2d').getImageData(0, 0, dest.width, dest.height);
	    var d_data = d_image_data.data;
	    var data_length = s_data.length,
	        sr,
	        sg,
	        sb,
	        sa,
	        sa1,
	        dr,
	        dg,
	        db,
	        l;
	    for (var i = 0; i < data_length; i += 4) {
	        sa = s_data[i + 3] / 255;
	        if (sa) {
	            sr = s_data[i];
	            sg = s_data[i + 1];
	            sb = s_data[i + 2];
	            dr = d_data[i];
	            dg = d_data[i + 1];
	            db = d_data[i + 2];
	
	            l = (dr + dg + db) / 3;
	            l = l / 255 * 0.5 + 0.5;
	            sa1 = 1 - sa;
	            dr = sr * l * sa + sa1 * dr;
	            dg = sg * l * sa + sa1 * dg;
	            db = sb * l * sa + sa1 * db;
	
	            d_data[i] = dr;
	            d_data[i + 1] = dg;
	            d_data[i + 2] = db;
	        }
	    }
	    s_data = null;
	    dest.getContext('2d').putImageData(d_image_data, 0, 0);
	}
	
	var PageComposer = function () {
	    function PageComposer(destSize, pixelBoundsAtZoom24) {
	        _classCallCheck(this, PageComposer);
	
	        this.destSize = destSize;
	        this.projectedBounds = pixelBoundsAtZoom24;
	        this.currentCanvas = null;
	        this.currentZoom = null;
	        this.targetCanvas = this.createCanvas(destSize);
	    }
	
	    _createClass(PageComposer, [{
	        key: 'createCanvas',
	        value: function createCanvas(size) {
	            var canvas = _leaflet2.default.DomUtil.create('canvas');
	            canvas.width = size.x;
	            canvas.height = size.y;
	            return canvas;
	        }
	    }, {
	        key: 'putTile',
	        value: function putTile(tileInfo) {
	            if (!tileInfo.isOverlay && !tileInfo.image) {
	                return;
	            }
	            var zoom = void 0;
	            if (tileInfo.isOverlay) {
	                zoom = tileInfo.overlaySolid ? 'solidOverlay' : 'overlay';
	            } else {
	                zoom = tileInfo.zoom;
	            }
	            if (zoom !== this.currentZoom) {
	                this.mergeCurrentCanvas();
	                this.setupCurrentCanvas(zoom);
	            }
	            if (tileInfo.isOverlay) {
	                tileInfo.draw(this.currentCanvas);
	            } else {
	                var ctx = this.currentCanvas.getContext('2d');
	                var tilePos = tileInfo.tilePos,
	                    tileSize = tileInfo.tileSize;
	
	                ctx.drawImage(tileInfo.image, tilePos.x, tilePos.y, tileSize.x, tileSize.y);
	            }
	        }
	    }, {
	        key: 'setupCurrentCanvas',
	        value: function setupCurrentCanvas(zoom) {
	            var size = void 0;
	            if (zoom === 'overlay' || zoom === 'solidOverlay') {
	                size = this.destSize;
	            } else {
	                var q = 1 << 24 - zoom;
	                var topLeft = this.projectedBounds.min.divideBy(q).round(),
	                    bottomRight = this.projectedBounds.max.divideBy(q).round();
	                size = bottomRight.subtract(topLeft);
	            }
	            this.currentCanvas = this.createCanvas(size);
	            this.currentZoom = zoom;
	        }
	    }, {
	        key: 'mergeCurrentCanvas',
	        value: function mergeCurrentCanvas() {
	            if (!this.currentCanvas) {
	                return;
	            }
	            if (this.currentZoom === 'overlay') {
	                blendMultiplyCanvas(this.currentCanvas, this.targetCanvas);
	            } else {
	                this.targetCanvas.getContext('2d').drawImage(this.currentCanvas, 0, 0, this.destSize.x, this.destSize.y);
	            }
	            this.currentCanvas.width = 0;
	            this.currentCanvas.height = 0;
	            this.currentCanvas = null;
	        }
	    }, {
	        key: 'getDataUrl',
	        value: function getDataUrl() {
	            this.mergeCurrentCanvas();
	            var dataUrl = this.targetCanvas.toDataURL("image/jpeg");
	            this.targetCanvas.width = 0;
	            this.targetCanvas.height = 0;
	            this.targetCanvas = null;
	            return dataUrl;
	        }
	    }]);
	
	    return PageComposer;
	}();
	
	exports.renderPages = renderPages;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PageFeature = _leaflet2.default.Marker.extend({
	    initialize: function initialize(centerLatLng, paperSize, scale, label) {
	        this.paperSize = paperSize;
	        this.scale = scale;
	        var icon = _leaflet2.default.divIcon({ className: "print-page-marker", html: label });
	        _leaflet2.default.Marker.prototype.initialize.call(this, centerLatLng, {
	            icon: icon,
	            draggable: true,
	            title: 'Left click to rotate, right click for menu'
	        });
	        this.on('drag', this.updateView.bind(this, undefined));
	    },
	
	    onAdd: function onAdd(map) {
	        var _this = this;
	
	        _leaflet2.default.Marker.prototype.onAdd.call(this, map);
	        map.on('viewreset', function () {
	            return _this.updateView();
	        });
	        this.rectangle = _leaflet2.default.rectangle([[0, 0], [0, 0]], { color: '#ff7800', weight: 2, opacity: 0.7, fillOpacity: 0.2 }).addTo(map);
	        this.updateView();
	    },
	
	    onRemove: function onRemove(map) {
	        map.off('viewreset', this.updateView, this);
	        _leaflet2.default.Marker.prototype.onRemove.call(this, map);
	        this.rectangle.removeFrom(map);
	    },
	
	    getLatLngBounds: function getLatLngBounds() {
	        return this.latLngBounds;
	    },
	
	    _getLatLngBounds: function _getLatLngBounds() {
	
	        var centerLatLng = this.getLatLng();
	        var centerMerc = _leaflet2.default.Projection.SphericalMercator.project(centerLatLng);
	        var mercatorScale = Math.cos(centerLatLng.lat * Math.PI / 180) * _leaflet2.default.CRS.Earth.R / _leaflet2.default.Projection.SphericalMercator.R;
	        var mercatorPageSize = _leaflet2.default.point.apply(_leaflet2.default, _toConsumableArray(this.paperSize)).multiplyBy(this.scale / 10 / mercatorScale);
	        var sw = centerMerc.subtract(mercatorPageSize.divideBy(2));
	        var ne = centerMerc.add(mercatorPageSize.divideBy(2));
	        sw = _leaflet2.default.Projection.SphericalMercator.unproject(sw);
	        ne = _leaflet2.default.Projection.SphericalMercator.unproject(ne);
	        return _leaflet2.default.latLngBounds([sw, ne]);
	    },
	
	    _animateZoom: function _animateZoom(e) {
	        _leaflet2.default.Marker.prototype._animateZoom.call(this, e);
	        this.updateView(e.zoom);
	    },
	
	    updateView: function updateView(newZoom) {
	        if (!this._map) {
	            return;
	        }
	        if (newZoom === undefined) {
	            newZoom = this._map.getZoom();
	        }
	        var bounds = this.latLngBounds = this._getLatLngBounds();
	        var pixel_sw = this._map.project(bounds.getSouthWest(), newZoom);
	        var pixel_ne = this._map.project(bounds.getNorthEast(), newZoom);
	        var pixel_center = this._map.project(this.getLatLng(), newZoom);
	        var st = this._icon.style;
	        var pixel_width = pixel_ne.x - pixel_sw.x;
	        var pixel_height = pixel_sw.y - pixel_ne.y;
	        st.width = pixel_width + 'px';
	        st.height = pixel_height + 'px';
	        st.marginLeft = pixel_sw.x - pixel_center.x + 'px';
	        st.marginTop = pixel_ne.y - pixel_center.y + 'px';
	        st.fontSize = Math.min(pixel_width, pixel_height, 500) / 2 + 'px';
	        st.lineHeight = pixel_height + 'px';
	        this.rectangle.setBounds(bounds);
	    },
	
	    setLabel: function setLabel(s) {
	        this._icon.innerHTML = s;
	    },
	
	    getLabel: function getLabel() {
	        return this._icon.innerHTML;
	    },
	
	    setSize: function setSize(paperSize, scale) {
	        this.paperSize = paperSize;
	        this.scale = scale;
	        this.updateView();
	    },
	
	    getPrintSize: function getPrintSize() {
	        return _leaflet2.default.point.apply(_leaflet2.default, _toConsumableArray(this.paperSize));
	    },
	
	    rotate: function rotate(e) {
	        this.paperSize = [this.paperSize[1], this.paperSize[0]];
	        this.updateView();
	    }
	
	});
	
	exports.default = PageFeature;

/***/ },
/* 206 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function header() {
	    return '%PDF-1.3';
	}
	
	function eof() {
	    return '%%EOF\n';
	}
	
	function recCatalog() {
	    return '1 0 obj\n<< /Type /Catalog\n/Pages 2 0 R\n>>\nendobj';
	}
	
	function recPages(count) {
	    var kidsIds = [];
	    for (var i = 0; i < count; i++) {
	        kidsIds.push(i * 3 + 3 + ' 0 R');
	    }
	    kidsIds = kidsIds.join(' ');
	    return '2 0 obj\n<< /Type /Pages        \n/Kids [ ' + kidsIds + ' ]\n/Count ' + count + '\n>>\nendobj';
	}
	
	function recPage(serialNum, width, height) {
	    var pageRecId = serialNum * 3 + 3;
	    var contentRecId = pageRecId + 1;
	    var imageRecId = pageRecId + 2;
	    return pageRecId + ' 0 obj\n<< /Type /Page\n/Parent 2 0 R\n/MediaBox [0 0 ' + width + ' ' + height + ']\n/Contents ' + contentRecId + ' 0 R\n/Resources <<\n    /XObject << /Im' + serialNum + ' ' + imageRecId + ' 0 R >>\n    /ProcSet [ /PDF /Text /ImageC ] \n    >>\n>>\nendobj';
	}
	
	function recContent(serialNum, width, height) {
	    var pageRecId = serialNum * 3 + 3;
	    var contentRecId = pageRecId + 1;
	    var contents = 'q\n' + width + ' 0 0 ' + height + ' 0 0 cm\n/Im' + serialNum + ' Do\nQ   ';
	    return contentRecId + ' 0 obj\n<<\n/Length ' + (contents.length + 1) + '\n>>\nstream\n' + contents + '   \nendstream\nendobj';
	}
	
	function recImage(serialNum, widthPixels, heightPixels, data) {
	    var pageRecId = serialNum * 3 + 3;
	    var imageRecId = pageRecId + 2;
	
	    return imageRecId + ' 0 obj\n<< /Type /XObject\n/Subtype /Image\n/Name /Im' + serialNum + '\n/Filter [ /DCTDecode ]\n/Width ' + widthPixels + '\n/Height ' + heightPixels + '\n/ColorSpace /DeviceRGB\n/BitsPerComponent 8\n/Length ' + data.length + '\n>>\nstream\n' + data + '\nendstream\nendobj';
	}
	
	function recTrailer(recOffsets, currentOffset) {
	    var trailer = [];
	    trailer.push('xref\n0 ' + (recOffsets.length + 1) + '\n0000000000 65535 f ');
	    var zeroes = '0000000000';
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = recOffsets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var offset = _step.value;
	
	            offset = offset.toString();
	            var padding = zeroes.substr(offset.length);
	            trailer.push('' + padding + offset + ' 00000 n ');
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    trailer.push('trailer\n<< /Root 1 0 R\n/Size ' + (recOffsets.length + 1) + '\n>>\nstartxref\n' + currentOffset);
	    return trailer.join('\n');
	}
	
	function makePdf(imagesInfo, resolution) {
	    var offset = 0;
	    var offsets = [];
	    var pdf = [];
	
	    function addRec(s, skipOffset) {
	        pdf.push(s);
	        if (!skipOffset) {
	            offsets.push(offset);
	        }
	        offset += s.length;
	    }
	
	    addRec(header(), true);
	    addRec(recCatalog());
	    addRec(recPages(imagesInfo.length));
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = imagesInfo.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _step2$value = _slicedToArray(_step2.value, 2),
	                i = _step2$value[0],
	                _step2$value$ = _step2$value[1],
	                data = _step2$value$.data,
	                width = _step2$value$.width,
	                height = _step2$value$.height;
	
	            var widthPoints = width / resolution * 72,
	                heightPoints = height / resolution * 72;
	            addRec(recPage(i, widthPoints, heightPoints));
	            addRec(recContent(i, widthPoints, heightPoints));
	            addRec(recImage(i, width, height, data));
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    addRec(recTrailer(offsets, offset), true);
	    addRec(eof(), true);
	
	    pdf = pdf.join('\n');
	    return pdf;
	}
	
	exports.makePdf = makePdf;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(82);
	
	__webpack_require__(460);
	
	__webpack_require__(38);
	
	__webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.TrackList.Ruler = _leaflet2.default.Control.extend({
	    options: {
	        position: 'topleft'
	    },
	
	    initialize: function initialize(trackList, options) {
	        _leaflet2.default.Control.prototype.initialize.call(this, options);
	        this._trackList = trackList;
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        var container = this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control leaflet-control-button leaflet-control-ruler');
	        container.title = "Measure distance";
	        this._stopContainerEvents();
	        _leaflet2.default.DomEvent.on(container, 'click', this.onClick, this);
	        return container;
	    },
	
	    onClick: function onClick() {
	        this._trackList.setExpanded();
	        this._trackList.addNewTrack('Ruler').measureTicksShown(true);
	    }
	
	});

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utf = __webpack_require__(110);
	
	var _utf2 = _interopRequireDefault(_utf);
	
	var _escapeHtml = __webpack_require__(164);
	
	var _escapeHtml2 = _interopRequireDefault(_escapeHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function saveGpx(segments, name, points) {
	    var gpx = [],
	        x,
	        y;
	
	    gpx.push('<?xml version="1.0" encoding="UTF-8" standalone="no" ?>');
	    gpx.push('<gpx xmlns="http://www.topografix.com/GPX/1/1" creator="http://nakarte.tk" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd">');
	    if (segments.length) {
	        name = name || 'Track';
	        name = (0, _escapeHtml2.default)(name);
	        name = _utf2.default.encode(name);
	        gpx.push('\t<trk>');
	        gpx.push('\t\t<name>' + name + '</name>');
	
	        segments.forEach(function (points) {
	            if (points.length > 1) {
	                gpx.push('\t\t<trkseg>');
	                points.forEach(function (p) {
	                    x = p.lng.toFixed(6);
	                    y = p.lat.toFixed(6);
	                    gpx.push('\t\t\t<trkpt lat="' + y + '" lon="' + x + '"></trkpt>');
	                });
	                gpx.push('\t\t</trkseg>');
	            }
	        });
	        gpx.push('\t</trk>');
	    }
	    points.forEach(function (marker) {
	        var label = marker.label;
	        label = (0, _escapeHtml2.default)(label);
	        label = _utf2.default.encode(label);
	        gpx.push('\t<wpt lat="' + marker.latlng.lat.toFixed(6) + '" lon="' + marker.latlng.lng.toFixed(6) + '">');
	        gpx.push('\t\t<name>' + label + '</name>');
	        gpx.push('\t</wpt>');
	    });
	    gpx.push('</gpx>');
	    gpx = gpx.join('\n');
	    return gpx;
	}
	
	function saveKml(segments, name, points) {
	    var kml = [],
	        x,
	        y;
	
	    name = name || 'Track';
	    name = (0, _escapeHtml2.default)(name);
	    name = _utf2.default.encode(name);
	
	    kml.push('<?xml version="1.0" encoding="UTF-8"?>');
	    kml.push('<kml xmlns="http://earth.google.com/kml/2.2">');
	    kml.push('\t<Document>');
	    kml.push('\t\t<name>' + name + '</name>');
	
	    segments.forEach(function (points, i) {
	        if (points.length > 1) {
	            kml.push('\t\t<Placemark>', '\t\t\t<name>Line ' + (i + 1) + '</name>', '\t\t\t<LineString>', '\t\t\t\t<tessellate>1</tessellate>', '\t\t\t\t<coordinates>');
	            points.forEach(function (p) {
	                x = p.lng.toFixed(6);
	                y = p.lat.toFixed(6);
	                kml.push('\t\t\t\t\t' + x + ',' + y);
	            });
	            kml.push('\t\t\t\t</coordinates>', '\t\t\t</LineString>', '\t\t</Placemark>');
	        }
	    });
	    points.forEach(function (marker) {
	        var label = marker.label;
	        label = (0, _escapeHtml2.default)(label);
	        label = _utf2.default.encode(label);
	        var coordinates = marker.latlng.lng.toFixed(6) + ',' + marker.latlng.lat.toFixed(6) + ',0';
	
	        kml.push('\t\t<Placemark>');
	        kml.push('\t\t\t<name>' + label + '</name>');
	        kml.push('\t\t\t<Point>');
	        kml.push('\t\t\t\t<coordinates>' + coordinates + '</coordinates>');
	        kml.push('\t\t\t</Point>');
	        kml.push('\t\t</Placemark>');
	    });
	
	    kml.push('\t</Document>');
	    kml.push('\t</kml>');
	
	    kml = kml.join('\n');
	    return kml;
	}
	
	function packNumber(n) {
	    var bytes = [];
	    if (n >= -64 && n <= 63) {
	        n += 64;
	        bytes.push(n);
	    } else if (n >= -8192 && n <= 8191) {
	        n += 8192;
	        bytes.push(n & 0x7f | 0x80);
	        bytes.push(n >> 7);
	        /*        } else if (n >= -2097152 && n <= 2097151) {
	         n += 2097152;
	         bytes.push((n & 0x7f) | 0x80);
	         bytes.push(((n >> 7) & 0x7f) | 0x80);
	         bytes.push(n >> 14);
	         */
	    } else if (n >= -1048576 && n <= 1048575) {
	        n += 1048576;
	        bytes.push(n & 0x7f | 0x80);
	        bytes.push(n >> 7 & 0x7f | 0x80);
	        bytes.push(n >> 14);
	    } else if (n >= -268435456 && n <= 268435455) {
	        n += 268435456;
	        bytes.push(n & 0x7f | 0x80);
	        bytes.push(n >> 7 & 0x7f | 0x80);
	        bytes.push(n >> 14 & 0x7f | 0x80);
	        bytes.push(n >> 21);
	    } else {
	        throw new Error('Number ' + n + ' too big to pack in 29 bits');
	    }
	    return String.fromCharCode.apply(null, bytes);
	}
	
	function encodeUrlSafeBase64(s) {
	    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
	}
	
	function saveToString(segments, name, color, measureTicksShown, wayPoints, trackHidden) {
	    var stringified = [];
	    stringified.push(packNumber(3)); // version
	    name = _utf2.default.encode(name);
	    stringified.push(packNumber(name.length));
	    stringified.push(name);
	
	    var arcUnit = ((1 << 24) - 1) / 360;
	    segments = segments.filter(function (segment) {
	        return segment.length > 1;
	    });
	
	    stringified.push(packNumber(segments.length));
	    segments.forEach(function (points) {
	        var lastX = 0,
	            lastY = 0,
	            x,
	            y,
	            deltaX,
	            deltaY,
	            p;
	        stringified.push(packNumber(points.length));
	        for (var i = 0, len = points.length; i < len; i++) {
	            p = points[i];
	            x = Math.round(p.lng * arcUnit);
	            y = Math.round(p.lat * arcUnit);
	            deltaX = x - lastX;
	            deltaY = y - lastY;
	            stringified.push(packNumber(deltaX));
	            stringified.push(packNumber(deltaY));
	            lastX = x;
	            lastY = y;
	        }
	    });
	    stringified.push(packNumber(+color || 0));
	    stringified.push(packNumber(measureTicksShown ? 1 : 0));
	    stringified.push(packNumber(trackHidden ? 1 : 0));
	
	    stringified.push(packNumber(wayPoints.length));
	    if (wayPoints.length) {
	        var midX = 0,
	            midY = 0;
	        wayPoints.forEach(function (p) {
	            midX += p.latlng.lng;
	            midY += p.latlng.lat;
	        });
	        midX = Math.round(midX * arcUnit / wayPoints.length);
	        midY = Math.round(midY * arcUnit / wayPoints.length);
	        stringified.push(packNumber(midX));
	        stringified.push(packNumber(midY));
	        wayPoints.forEach(function (p) {
	            var deltaX = Math.round(p.latlng.lng * arcUnit) - midX,
	                deltaY = Math.round(p.latlng.lat * arcUnit) - midY,
	                symbol = 1,
	                name = _utf2.default.encode(p.label);
	            stringified.push(packNumber(name.length));
	            stringified.push(name);
	            stringified.push(packNumber(symbol));
	            stringified.push(packNumber(deltaX));
	            stringified.push(packNumber(deltaY));
	        });
	    }
	
	    return encodeUrlSafeBase64(stringified.join(''));
	}
	
	exports.default = { saveGpx: saveGpx, saveKml: saveKml, saveToString: saveToString };

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isGpsiesUrl = exports.gpsiesXhrOptions = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _CORSProxy = __webpack_require__(60);
	
	var _CORSProxy2 = _interopRequireDefault(_CORSProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function urlEncode(d) {
	    return Object.entries(d).map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            k = _ref2[0],
	            v = _ref2[1];
	
	        return k + '=' + encodeURIComponent(v);
	    }).join('&');
	}
	
	var re = /^https?:\/\/www\.gpsies\.com\/map\.do\?fileId=([a-z]+)/;
	
	function isGpsiesUrl(url) {
	    return re.test(url);
	}
	
	function gpsiesXhrOptions(url, options) {
	    var m = re.exec(url);
	    if (!m) {
	        throw new Error('Invalid gpsies url');
	    }
	    var trackId = m[1];
	    var newUrl = (0, _CORSProxy2.default)('http://www.gpsies.com/download.do');
	    return [newUrl, {
	        method: 'POST',
	        data: urlEncode({
	            fileId: trackId,
	            speed: '10',
	            dataType: '3',
	            filetype: 'gpxTrk',
	            submitButton: '',
	            inappropriate: ''
	        }),
	        headers: [["Content-type", "application/x-www-form-urlencoded"]],
	        responseType: 'binarystring'
	    }];
	}
	
	exports.gpsiesXhrOptions = gpsiesXhrOptions;
	exports.isGpsiesUrl = isGpsiesUrl;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _geo_file_formats = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.TrackList.include(_leaflet2.default.Mixin.HashState);
	_leaflet2.default.Control.TrackList.include({
	    stateChangeEvents: [],
	
	    serializeState: function serializeState(e) {
	        return null;
	    },
	
	    unserializeState: function unserializeState(values) {
	        if (values && values.length) {
	            var geodata = (0, _geo_file_formats.parseGeoFile)('', window.location.href);
	            var notEmpty = this.addTracksFromGeodataArray(geodata);
	            if (notEmpty) {
	                this.setExpanded();
	            }
	        }
	        return false;
	    }
	});

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(82);
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _geo_file_formats = __webpack_require__(81);
	
	var _safeLocalstorage = __webpack_require__(63);
	
	var _safeLocalstorage2 = _interopRequireDefault(_safeLocalstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.TrackList.include({
	    maxLocalStorageSessions: 5,
	
	    saveTracksToStorage: function saveTracksToStorage() {
	        var tracks = this.tracks(),
	            serialized = [],
	            maxKey = -1,
	            i,
	            track,
	            s,
	            key,
	            m,
	            keys = [];
	
	        for (i = 0; i < _safeLocalstorage2.default.length; i++) {
	            key = _safeLocalstorage2.default.key(i);
	            m = key.match(/^trackList_(\d+)$/);
	            if (m && m[1] !== undefined) {
	                if (+m[1] > maxKey) {
	                    maxKey = +m[1];
	                }
	            }
	        }
	        key = 'trackList_' + (maxKey + 1);
	
	        if (tracks.length === 0) {
	            _safeLocalstorage2.default.setItem(key, '');
	            return;
	        }
	        for (i = 0; i < tracks.length; i++) {
	            track = tracks[i];
	            s = this.trackToString(track);
	            serialized.push(s);
	        }
	        if (serialized.length === 0) {
	            return;
	        }
	        s = '#nktk=' + serialized.join('/');
	
	        _safeLocalstorage2.default.setItem(key, s);
	
	        //cleanup stale records
	        for (i = 0; i < _safeLocalstorage2.default.length; i++) {
	            key = _safeLocalstorage2.default.key(i);
	            m = key.match(/^trackList_(\d+)$/);
	            if (m && m[1] !== undefined) {
	                keys.push(+m[1]);
	            }
	        }
	        if (keys.length > this.maxLocalStorageSessions) {
	            keys.sort(function (a, b) {
	                return a - b;
	            });
	            for (i = 0; i < keys.length - this.maxLocalStorageSessions; i++) {
	                key = 'trackList_' + keys[i];
	                _safeLocalstorage2.default.removeItem(key);
	            }
	        }
	    },
	
	    loadTracksFromStorage: function loadTracksFromStorage() {
	        var i,
	            key,
	            m,
	            s,
	            geodata,
	            maxKey = -1;
	
	        for (i = 0; i < _safeLocalstorage2.default.length; i++) {
	            key = _safeLocalstorage2.default.key(i);
	            m = key.match(/^trackList_(\d+)$/);
	            if (m && m[1] !== undefined) {
	                if (+m[1] > maxKey) {
	                    maxKey = +m[1];
	                }
	            }
	        }
	        if (maxKey > -1) {
	            key = 'trackList_' + maxKey;
	            s = _safeLocalstorage2.default.getItem(key);
	            _safeLocalstorage2.default.removeItem(key);
	            if (s) {
	                geodata = (0, _geo_file_formats.parseGeoFile)('', s);
	                this.addTracksFromGeodataArray(geodata);
	            }
	        }
	    }
	});

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(462);
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function raiseControlsOnFocus(map) {
	    var selectors = ['.leaflet-top.leaflet-right', '.leaflet-bottom.leaflet-right', '.leaflet-top.leaflet-left', '.leaflet-bottom.leaflet-left'];
	    var elements = map._container.querySelectorAll(selectors.join(','));
	
	    function raise(target) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var cornerDiv = _step.value;
	
	                if (cornerDiv === target) {
	                    _leaflet2.default.DomUtil.addClass(cornerDiv, 'leaflet-controls-corner-raised');
	                } else {
	                    _leaflet2.default.DomUtil.removeClass(cornerDiv, 'leaflet-controls-corner-raised');
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    }
	
	    [].concat(_toConsumableArray(elements)).forEach(function (el) {
	        return _leaflet2.default.DomEvent.on(el, 'mouseenter', raise.bind(null, el));
	    });
	}
	
	exports.default = raiseControlsOnFocus;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fixAll = undefined;
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fixAll() {
	    fixPanAnimationBug();
	    fixTouchDetection();
	    fixMapKeypressEvent();
	}
	
	// https://github.com/Leaflet/Leaflet/issues/3575
	function fixPanAnimationBug() {
	    if (!_leaflet2.default.Browser.chrome) {
	        return;
	    }
	    if (_leaflet2.default.PosAnimation.prototype.__panAnimationFixed) {
	        return;
	    }
	
	    var originalStep = _leaflet2.default.PosAnimation.prototype._step;
	    _leaflet2.default.PosAnimation.prototype._step = function () {
	        return originalStep.call(this, true);
	    };
	    _leaflet2.default.PosAnimation.prototype.__panAnimationFixed = true;
	}
	
	function fixTouchDetection() {
	    _leaflet2.default.Browser.touch &= navigator.pointerEnabled && !_leaflet2.default.Browser.ie || navigator.maxTouchPoints;
	}
	
	function fixMapKeypressEvent() {
	    var originalHandleDOMEvent = _leaflet2.default.Map.prototype._handleDOMEvent;
	    _leaflet2.default.Map.prototype._handleDOMEvent = function (e) {
	        if (e.type === 'keypress' && e.keyCode === 13) {
	            this._fireDOMEvent(e, e.type);
	        } else {
	            originalHandleDOMEvent.call(this, e);
	        }
	    };
	}
	
	exports.fixAll = fixAll;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.Layers.include(_leaflet2.default.Mixin.HashState);
	
	_leaflet2.default.Control.Layers.include({
	    stateChangeEvents: ['baselayerchange', 'overlayadd', 'overlayremove'],
	    stateChangeEventsSource: '_map',
	
	    serializeState: function serializeState(e) {
	
	        var keys = [];
	        this._map.eachLayer(function (layer) {
	            var key = layer.options.code;
	            if (key) {
	                keys.push([key, layer.options.zIndex]);
	            }
	        });
	        keys.sort(function (k1, k2) {
	            return k1[1] - k2[1];
	        });
	        var state = keys.map(function (k) {
	            return k[0];
	        });
	        return state;
	    },
	
	    unserializeState: function unserializeState(values) {
	        if (!values || values.length === 0) {
	            return false;
	        }
	
	        var hasBaselayer = void 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = this._layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var layer = _step.value;
	
	                if (layer.layer.options && values.includes(layer.layer.options.code) && !layer.overlay) {
	                    hasBaselayer = true;
	                    break;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        if (!hasBaselayer) {
	            return false;
	        }
	
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = this._layers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _layer = _step2.value;
	
	                if (_layer.layer.options && values.includes(_layer.layer.options.code)) {
	                    this._map.addLayer(_layer.layer);
	                } else {
	                    this._map.removeLayer(_layer.layer);
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        return true;
	    }
	});

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Map.include(_leaflet2.default.Mixin.HashState);
	
	_leaflet2.default.Map.include({
	    stateChangeEvents: ['moveend'],
	
	    serializeState: function serializeState() {
	        var center = this.getCenter();
	        var zoom = this.getZoom();
	        var precision = 5;
	        var state = [zoom.toString(), center.lat.toFixed(precision), center.lng.toFixed(precision)];
	        return state;
	    },
	
	    unserializeState: function unserializeState(values) {
	        if (!values || values.length !== 3) {
	            return false;
	        }
	        var zoom = parseInt(values[0], 10),
	            lat = parseFloat(values[1]),
	            lng = parseFloat(values[2]);
	        if (isNaN(zoom) || isNaN(lat) || isNaN(lng) || zoom < 0 || zoom > 32 || lat < -90 || lat > 90) {
	            return false;
	        }
	        this.setView([lat, lng], zoom);
	        return true;
	    }
	});

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _xhrPromise = __webpack_require__(24);
	
	var _notifications = __webpack_require__(35);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Layer.GeoJSONAjax = _leaflet2.default.GeoJSON.extend({
	    options: {
	        requestTimeout: 30000
	    },
	
	    initialize: function initialize(url, options) {
	        _leaflet2.default.GeoJSON.prototype.initialize.call(this, null, options);
	        this.url = url;
	    },
	
	    // Promise can be rejected if json invalid or addData fails
	    loadData: function loadData() {
	        var _this = this;
	
	        if (this._loadStarted) {
	            return;
	        }
	        this._loadStarted = true;
	        (0, _xhrPromise.fetch)(this.url, { timeout: this.options.requestTimeout }).then(function (xhr) {
	            _this.addData(JSON.parse(xhr.response));
	        }, function (e) {
	            _logging2.default.captureException(e, { extra: {
	                    description: 'failed to get geojson',
	                    url: _this.url,
	                    status: e.xhr.status
	                } });
	            (0, _notifications.notify)('Failed to get GeoJSON data from ' + _this.url + ': ' + e.message);
	        });
	    },
	
	    onAdd: function onAdd(map) {
	        _leaflet2.default.GeoJSON.prototype.onAdd.call(this, map);
	        this.loadData();
	    }
	});

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _xhrPromise = __webpack_require__(24);
	
	var _notifications = __webpack_require__(35);
	
	var _logging = __webpack_require__(23);
	
	var _logging2 = _interopRequireDefault(_logging);
	
	var _safeLocalstorage = __webpack_require__(63);
	
	var _safeLocalstorage2 = _interopRequireDefault(_safeLocalstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseResponse(s) {
	    var data = void 0;
	    data = JSON.parse(s);
	    if (!data.token) {
	        throw new Error('no token in response');
	    }
	    return data.token;
	}
	
	function getToken() {
	    return (0, _xhrPromise.fetch)('https://www.ut.no/kart/HentBaatToken/', { timeout: 10000 }).then(function (xhr) {
	        try {
	            return { token: parseResponse(xhr.responseText) };
	        } catch (e) {
	            _logging2.default.captureException(e, { extra: {
	                    description: 'Invalid baat token',
	                    response: xhr.responseText.toString().slice(0, 100) } });
	            return { error: 'Server returned invalid token for Norway map' };
	        }
	    }, function (e) {
	        _logging2.default.captureException(e, { extra: { description: 'failed to download baat token' } });
	        return { error: 'Failed to token for Norway map: ' + e.message };
	    });
	}
	
	_leaflet2.default.TileLayer.Nordeskart = _leaflet2.default.TileLayer.extend({
	    options: {
	        tokenUpdateInterval: 5 * 60 * 1000
	    },
	
	    initialize: function initialize(url, options) {
	        this.__url = url;
	        _leaflet2.default.TileLayer.prototype.initialize.call(this, '', options);
	    },
	
	    baatTokenUpToDate: function baatTokenUpToDate() {
	        var nextUpdate = 0;
	        nextUpdate = parseInt(_safeLocalstorage2.default.getItem('baatTokenNextUpdate'), 10) || 0;
	        return Date.now() < nextUpdate && _safeLocalstorage2.default.getItem('baatToken');
	    },
	
	    storeBaatToken: function storeBaatToken(token) {
	        _safeLocalstorage2.default.setItem('baatToken', token);
	        _safeLocalstorage2.default.setItem('baatTokenNextUpdate', Date.now().toString() + this.options.tokenUpdateInterval);
	    },
	
	    periodicTokenUpdate: function periodicTokenUpdate() {
	        var _this = this;
	
	        if (!this._map) {
	            return;
	        }
	        getToken().then(function (data) {
	            if (data.error) {
	                (0, _notifications.notify)(data.error);
	            } else {
	                if (data.token !== _this.options.baatToken) {
	                    _this.options.baatToken = data.token;
	                    if (!_this._url) {
	                        _this.setUrl(_this.__url);
	                    }
	                }
	                _this.storeBaatToken(data.token);
	            }
	            setTimeout(function () {
	                return _this.periodicTokenUpdate();
	            }, _this.options.tokenUpdateInterval);
	        });
	    },
	
	    onAdd: function onAdd(map) {
	        var token = this.baatTokenUpToDate();
	        if (token) {
	            this.options.baatToken = token;
	            this.setUrl(this.__url);
	        }
	        this.periodicTokenUpdate();
	        return _leaflet2.default.TileLayer.prototype.onAdd.call(this, map);
	    }
	});

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.BingLayer.include({
	    waitTilesReadyToGrab: function waitTilesReadyToGrab() {
	        var _this = this;
	
	        if (this._url) {
	            return Promise.resolve();
	        } else {
	            return new Promise(function (resolve) {
	                var i = setInterval(function () {
	                    if (_this._url) {
	                        clearInterval(i);
	                        resolve();
	                    }
	                }, 50);
	            });
	        }
	    },
	
	    cloneForPrint: function cloneForPrint(options) {
	        return new _leaflet2.default.BingLayer(this._key, _leaflet2.default.Util.extend({}, this.options, options));
	    }
	});

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(119);
	
	var _TileLayer = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePrint = _leaflet2.default.Layer.Google.extend({
	    includes: _TileLayer.TileLayerGrabMixin,
	
	    _rasterizeNeedsFullSizeMap: true,
	
	    _dummyTile: _leaflet2.default.DomUtil.create('div'),
	
	    onAdd: function onAdd(map) {
	        var _this = this;
	
	        this._waitTilesReadyToGrab = new Promise(function (resolve) {
	            _this._tilesReadyToGrab = resolve;
	        });
	        _leaflet2.default.Layer.Google.prototype.onAdd.call(this, map);
	    },
	
	    waitTilesReadyToGrab: function waitTilesReadyToGrab() {
	        return this._waitTilesReadyToGrab;
	    },
	
	    createTile: function createTile() {
	        return this._dummyTile;
	    },
	
	    _fullfillPendingTiles: function _fullfillPendingTiles() {
	        if (!Object.keys(this._readyTiles).length) {
	            return;
	        }
	        this._tilesReadyToGrab();
	    },
	
	    getTileUrl: function getTileUrl(coords) {
	        return this._readyTiles[this._tileCoordsToKey(coords)] || null;
	    }
	});
	
	_leaflet2.default.Layer.Google.include({
	    cloneForPrint: function cloneForPrint(options) {
	        return new GooglePrint(this.mapType, _leaflet2.default.Util.extend({}, this.options, options));
	    }
	});

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	_leaflet2.default.Polyline.include({
	    _printProgressWeight: 0.1,
	    printWidthMm: 1,
	
	    cloneForPrint: function cloneForPrint(options) {
	        options = _leaflet2.default.Util.extend({}, this.options, options);
	        var latlngs = this.getLatLngs().map(function (latlng) {
	            return latlng.clone();
	        });
	        return new _leaflet2.default.Polyline(latlngs, options);
	    },
	
	    _makelatLngToCanvasPixelTransformer: function _makelatLngToCanvasPixelTransformer(printOptions) {
	        var projectedBounds = printOptions.pixelBounds;
	        var scale = projectedBounds.getSize().unscaleBy(printOptions.destPixelSize);
	        var origin = projectedBounds.min;
	        return function (latlng) {
	            return _leaflet2.default.CRS.EPSG3857.latLngToPoint(latlng, printOptions.zoom).subtract(origin).unscaleBy(scale);
	        };
	    },
	
	    _drawRaster: function _drawRaster(canvas, printOptions) {
	        var latlngs = this.getLatLngs();
	        if (!latlngs.length || !this.getBounds().intersects(printOptions.latLngBounds)) {
	            return;
	        }
	
	        var ctx = canvas.getContext('2d');
	        ctx.lineWidth = this.printWidthMm / 25.4 * printOptions.resolution;
	        ctx.lineJoin = 'round';
	        ctx.strokeStyle = this.options.color;
	        var transform = this._makelatLngToCanvasPixelTransformer(printOptions);
	        var point = void 0;
	        ctx.beginPath();
	
	        point = transform(latlngs[0]);
	        ctx.moveTo(point.x, point.y);
	        for (var i = 1; i < latlngs.length; i++) {
	            point = transform(latlngs[i]);
	            ctx.lineTo(point.x, point.y);
	        }
	        ctx.stroke();
	        return true;
	    },
	
	    getTilesInfo: function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(printOptions) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            return _context2.abrupt('return', {
	                                iterateTilePromises: /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                                    var _this = this;
	
	                                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                                        while (1) {
	                                            switch (_context.prev = _context.next) {
	                                                case 0:
	                                                    _context.next = 2;
	                                                    return {
	                                                        tilePromise: Promise.resolve({
	                                                            draw: function draw(canvas) {
	                                                                return _this._drawRaster(canvas, printOptions);
	                                                            },
	                                                            isOverlay: true
	                                                        }),
	                                                        abortLoading: function abortLoading() {}
	                                                    };
	
	                                                case 2:
	                                                case 'end':
	                                                    return _context.stop();
	                                            }
	                                        }
	                                    }, _callee, this);
	                                }).bind(this),
	                                count: 1
	                            });
	
	                        case 1:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function getTilesInfo(_x) {
	            return _ref.apply(this, arguments);
	        }
	
	        return getTilesInfo;
	    }()
	});
	
	_leaflet2.default.MeasuredLine.include({
	    tickFontSizeMm: 2.5,
	
	    cloneForPrint: function cloneForPrint(options) {
	        options = _leaflet2.default.Util.extend({}, this.options, options);
	        var latlngs = this.getLatLngs().map(function (latlng) {
	            return latlng.clone();
	        });
	        return new _leaflet2.default.MeasuredLine(latlngs, options);
	    },
	
	    _drawRaster: function _drawRaster(canvas, printOptions) {
	        if (!_leaflet2.default.Polyline.prototype._drawRaster.call(this, canvas, printOptions)) {
	            return;
	        }
	        if (!this.options.measureTicksShown) {
	            return;
	        }
	        var minTicksIntervalMeters = printOptions.scale * 1.5;
	        var ctx = canvas.getContext('2d');
	        var ticks = this.getTicksPositions(minTicksIntervalMeters);
	        var ticksPixelSize = this.tickFontSizeMm / 25.4 * printOptions.resolution;
	        var transform = this._makelatLngToCanvasPixelTransformer(printOptions);
	        ctx.font = 'bold ' + ticksPixelSize + 'px verdana';
	        ctx.fillStyle = this.options.color;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = ticks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var tick = _step.value;
	
	                var m = tick.transformMatrix;
	                var label = '\u2501\u2501 ' + Math.round(tick.distanceValue / 10) / 100 + ' km';
	                var position = transform(tick.position);
	                ctx.setTransform(m[0], m[1], m[2], m[3], position.x, position.y);
	                ctx.fillText(label, 0, ticksPixelSize * 0.3);
	                ctx.setTransform(1, 0, 0, 1, 0, 0);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    }
	});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(123);
	
	var _westraPassesMarkers = __webpack_require__(124);
	
	__webpack_require__(62);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	_leaflet2.default.Layer.WestraPasses.addInitHook(function () {
	    this.markers.options.print = this.options.print;
	    this.options.print = false;
	});
	
	_westraPassesMarkers.WestraPassesMarkers.include({
	    waitDataReady: function waitDataReady() {
	        var _this = this;
	
	        if (this._dataLoaded) {
	            return Promise.resolve();
	        }
	        return new Promise(function (resolve) {
	            _this.on('data-loaded', resolve);
	        });
	    },
	
	    cloneForPrint: function cloneForPrint(options) {
	        options = _leaflet2.default.Util.extend({}, options);
	        return new _westraPassesMarkers.WestraPassesMarkers(this._baseUrl, options);
	    },
	
	    getTilesInfo: function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(printOptions) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return this.waitDataReady();
	
	                        case 2:
	                            _context.next = 4;
	                            return _leaflet2.default.Layer.CanvasMarkers.prototype.getTilesInfo.call(this, printOptions);
	
	                        case 4:
	                            return _context.abrupt('return', _context.sent);
	
	                        case 5:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	
	        function getTilesInfo(_x) {
	            return _ref.apply(this, arguments);
	        }
	
	        return getTilesInfo;
	    }()
	});

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Layer.Yandex.include({
	    cloneForPrint: function cloneForPrint(options) {
	        return new _leaflet2.default.Layer.Yandex(this._mapType, _leaflet2.default.Util.extend({}, this.options, options));
	    }
	});

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function imgFromDataString(xhr) {
	    if (xhr.status === 200 && xhr.response.size) {
	        var image = new Image();
	        var blobUrl = window.URL.createObjectURL(xhr.response);
	        var promise = new Promise(function (resolve, reject) {
	            image.onload = function () {
	                resolve(image);
	                window.URL.revokeObjectURL(blobUrl);
	            };
	            image.onerror = function () {
	                reject(new Error('Image corrupt'));
	            };
	        });
	        image.src = blobUrl;
	        return promise;
	    } else {
	        return null;
	    }
	}
	
	exports.imgFromDataString = imgFromDataString;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(465);
	
	var _contextmenu = __webpack_require__(56);
	
	var _contextmenu2 = _interopRequireDefault(_contextmenu);
	
	var _clipboardCopy = __webpack_require__(79);
	
	var _clipboardCopy2 = _interopRequireDefault(_clipboardCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function zeroPad(num, size) {
	    var s = num + "";
	    while (s.length < size) {
	        s = "0" + s;
	    }
	    return s;
	}
	
	var bigLetterReplacers = [{
	    '1': 'А',
	    '2': 'Б',
	    '3': 'В',
	    '4': 'Г'
	}, {
	    '1': 'A',
	    '2': 'B',
	    '3': 'C',
	    '4': 'D'
	}];
	
	var Nomenclature = {
	    getQuadName1m: function getQuadName1m(column, row, join) {
	        var name = '';
	        if (row < 0) {
	            row = -row - 1;
	            name += 'x';
	        }
	        column += 31;
	        name += 'ABCDEFGHIJKLMNOPQRSTUV'[row] + '-' + zeroPad(column, 2);
	        for (var n = 1; n <= join - 1; n++) {
	            name += ',' + zeroPad(column + n, 2);
	        }
	        return [name];
	    },
	
	    getQuadName500k: function getQuadName500k(column, row, join) {
	        var name1 = this.getQuadName1m(Math.floor(column / 2), Math.floor(row / 2), 1)[0];
	        var subquad = 2 - (row & 1) * 2 + (column & 1) + 1;
	        var name2 = '-' + subquad;
	        if (join > 1) {
	            name2 += ',' + (subquad + 1);
	        }
	        if (join === 4) {
	            name2 += ',' + this.getQuadName1m(Math.floor((column + 2) / 2), Math.floor(row / 2), 1) + '-' + subquad + ',' + (subquad + 1);
	        }
	        var names = [name1 + name2];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            var _loop = function _loop() {
	                var replacer = _step.value;
	
	                var name3 = name2.replace(/\b[1-4]\b/g, function (s) {
	                    return replacer[s];
	                });
	                names.push(name1 + name3);
	            };
	
	            for (var _iterator = bigLetterReplacers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                _loop();
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return names;
	    },
	
	    getQuadName100k: function getQuadName100k(column, row, join) {
	        var name = this.getQuadName1m(Math.floor(column / 12), Math.floor(row / 12), 1);
	        var subRow = row - Math.floor(row / 12) * 12;
	        var subColumn = column - Math.floor(column / 12) * 12;
	        var subquad = 132 - subRow * 12 + subColumn + 1;
	        name = name + '-' + zeroPad(subquad, 3);
	        if (join > 1) {
	            name += ',' + zeroPad(subquad + 1, 3);
	        }
	        if (join === 4) {
	            name += ',' + zeroPad(subquad + 2, 3) + ',' + zeroPad(subquad + 3, 3);
	        }
	
	        return [name];
	    },
	
	    getQuadName050k: function getQuadName050k(column, row, join) {
	        var name1 = this.getQuadName100k(Math.floor(column / 2), Math.floor(row / 2), 1);
	        var subquad = 2 - (row & 1) * 2 + (column & 1) + 1;
	        var name2 = '-' + subquad;
	        if (join > 1) {
	            name2 += ',' + (subquad + 1);
	        }
	        if (join === 4) {
	            name2 += ',' + this.getQuadName100k(Math.floor((column + 2) / 2), Math.floor(row / 2), 1) + '-' + subquad + ',' + (subquad + 1);
	        }
	        var names = [name1 + name2];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            var _loop2 = function _loop2() {
	                var replacer = _step2.value;
	
	                var name3 = name2.replace(/\b[1-4]\b/g, function (s) {
	                    return replacer[s];
	                });
	                names.push(name1 + name3);
	            };
	
	            for (var _iterator2 = bigLetterReplacers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                _loop2();
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        return names;
	    },
	
	    _getQuads: function _getQuads(bounds, row_height, column_width, name_factory) {
	        bounds = _leaflet2.default.latLngBounds(bounds);
	        var quads = [];
	        var min_lat = Math.max(bounds.getSouth(), -84);
	        var max_lat = Math.min(bounds.getNorth(), 84);
	        var min_row = Math.floor(min_lat / row_height);
	        for (var row = min_row; row * row_height < max_lat; row++) {
	            var row_south = row * row_height;
	            var row_north = row_south + row_height;
	            var joined_quads;
	            if (row_south >= 76 || row_north <= -76) {
	                joined_quads = 4;
	            } else if (row_south >= 60 || row_north <= -60) {
	                joined_quads = 2;
	            } else {
	                joined_quads = 1;
	            }
	            var min_lon = Math.max(bounds.getWest(), -180);
	            var max_lon = Math.min(bounds.getEast(), 180);
	            var min_column = Math.floor((min_lon + 180) / column_width / joined_quads) * joined_quads - Math.round(180 / column_width);
	            for (var column = min_column; column * column_width < max_lon; column += joined_quads) {
	                var column_west = column * column_width;
	                var column_east = column_west + column_width * joined_quads;
	                var quad_bounds = _leaflet2.default.latLngBounds([[row_south, column_west], [row_north, column_east]]);
	                var names = name_factory(column, row, joined_quads);
	                quads.push({ 'names': names, 'bounds': quad_bounds });
	            }
	        }
	        return quads;
	    },
	
	    getQuads1m: function getQuads1m(bounds) {
	        return this._getQuads(bounds, 4, 6, this.getQuadName1m);
	    },
	
	    getQuads500k: function getQuads500k(bounds) {
	        return this._getQuads(bounds, 2, 3, this.getQuadName500k.bind(this));
	    },
	
	    getQuads100k: function getQuads100k(bounds) {
	        return this._getQuads(bounds, 4 / 12, 6 / 12, this.getQuadName100k.bind(this));
	    },
	
	    getQuads050k: function getQuads050k(bounds) {
	        return this._getQuads(bounds, 4 / 12 / 2, 6 / 12 / 2, this.getQuadName050k.bind(this));
	    }
	
	};
	
	_leaflet2.default.Layer.SovietTopoGrid = _leaflet2.default.LayerGroup.extend({
	    options: {},
	
	    initialize: function initialize(options) {
	        _leaflet2.default.LayerGroup.prototype.initialize.call(this);
	        _leaflet2.default.Util.setOptions(this, options);
	        this.renderer = _leaflet2.default.svg({ padding: 0.5 });
	        this._quads = {};
	        this._updateRenderer = _leaflet2.default.Util.throttle(this._updateRenderer, 100, this);
	    },
	
	    onAdd: function onAdd(map) {
	        this._map = map;
	        map.on('zoomend', this._reset, this);
	        map.on('move', this._update, this);
	        map.on('move', this._updateRenderer, this);
	        this._update();
	    },
	
	    onRemove: function onRemove(map) {
	        map.off('zoomend', this._reset, this);
	        map.off('move', this._update, this);
	        this._cleanupQuads(true);
	    },
	
	    _addQuad: function _addQuad(bounds, id, titles, color, layer, scale) {
	        if (id in this._quads) {
	            return;
	        }
	        var rect_options = {
	            smoothFactor: 0,
	            noClip: true,
	            clickable: false,
	            fill: false,
	            opacity: { 1: 0.7, 2: 0.4 }[layer],
	            color: color,
	            weight: { 1: 1, 2: 3 }[layer],
	            renderer: this.renderer
	        };
	
	        var rect = _leaflet2.default.rectangle(bounds, rect_options);
	        this.addLayer(rect);
	        if (layer === 1) {
	            rect.bringToBack();
	        }
	        var objects = [rect];
	        var title = titles[0].replace(/-/g, ' &ndash; ');
	        var html = _leaflet2.default.Util.template('<span style="color:{color}">{title}</span>', { color: color, title: title });
	        var icon = _leaflet2.default.divIcon({ html: html, className: 'leaflet-sovietgrid-quadtitle-' + layer, iconSize: null });
	        var marker = _leaflet2.default.marker(_leaflet2.default.latLngBounds(bounds).getCenter(), { icon: icon });
	        this.addLayer(marker);
	        objects.push(marker);
	        this._quads[id] = objects;
	        marker.on('click contextmenu', this._showContextMenu.bind(this, scale, titles));
	    },
	
	    _showContextMenu: function _showContextMenu(scale, titles, e) {
	        var scaleString = {
	            '1m': '1:1 000 000',
	            '500k': '1:500 000',
	            '100k': '1:100 000',
	            '050k': '1:50 000'
	        }[scale];
	        var items = [{ 'text': scaleString, disabled: true }, { 'text': 'Click name to copy to clibpoard', disabled: true }, {
	            'text': titles[0], callback: function callback() {
	                (0, _clipboardCopy2.default)(titles[0], e.originalEvent);
	            }
	        }];
	        if (titles.length > 1) {
	            items.push({
	                'text': titles[1] + ' <span class="leaflet-sovietgrid-lang">RUS</span>', callback: function callback() {
	                    (0, _clipboardCopy2.default)(titles[1], e.originalEvent);
	                }
	            });
	            items.push({
	                'text': titles[2] + ' <span class="leaflet-sovietgrid-lang">LAT</span>', callback: function callback() {
	                    (0, _clipboardCopy2.default)(titles[2], e.originalEvent);
	                }
	            });
	        }
	        var menu = new _contextmenu2.default(items);
	        menu.show(e);
	    },
	
	    _removeQuad: function _removeQuad(id) {
	        this._quads[id].forEach(this.removeLayer.bind(this));
	        delete this._quads[id];
	    },
	
	    _addQuads: function _addQuads(quads, scale, color, layer) {
	        quads.forEach(function (quad) {
	            var id = scale + quad.names[0];
	            this._addQuad(quad.bounds, id, quad.names, color, layer, scale);
	        }.bind(this));
	    },
	
	    _addGrid: function _addGrid() {
	        var quads;
	        var layer;
	        var map_bbox = this._map.getBounds();
	        var zoom = this._map.getZoom();
	
	        if (zoom >= 10) {
	            quads = Nomenclature.getQuads050k(map_bbox);
	            layer = zoom >= 12 ? 2 : 1;
	            this._addQuads(quads, '050k', '#50d', layer);
	        }
	
	        if (zoom >= 8 && zoom < 12) {
	            quads = Nomenclature.getQuads100k(map_bbox);
	            layer = zoom >= 10 ? 2 : 1;
	            this._addQuads(quads, '100k', '#d50', layer);
	        }
	
	        if (zoom >= 6 && zoom < 10) {
	            quads = Nomenclature.getQuads500k(map_bbox);
	            layer = zoom >= 8 ? 2 : 1;
	            this._addQuads(quads, '500k', '#099', layer);
	        }
	
	        if (zoom >= 4 && zoom < 8) {
	            layer = zoom >= 6 ? 2 : 1;
	            quads = Nomenclature.getQuads1m(map_bbox);
	            this._addQuads(quads, '1m', 'blue', layer);
	        }
	    },
	
	    _reset: function _reset() {
	        this._update(true);
	    },
	
	    _cleanupQuads: function _cleanupQuads(reset) {
	        if (reset === true) {
	            this.clearLayers();
	            this._quads = {};
	        } else {
	            var map_bbox = this._map.getBounds();
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = Object.keys(this._quads)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var quad_id = _step3.value;
	
	                    var rect = this._quads[quad_id][0];
	                    if (!map_bbox.intersects(rect.getBounds())) {
	                        this._removeQuad(quad_id);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	        }
	    },
	
	    _updateRenderer: function _updateRenderer() {
	        if (this.renderer._map) {
	            this.renderer._update();
	        }
	    },
	
	    _update: function _update(reset) {
	        this._cleanupQuads(reset);
	        this._addGrid();
	    }
	});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _wikimapiaLoader = __webpack_require__(226);
	
	__webpack_require__(467);
	
	var _popupWindow = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPointInPolygon(polygon, p) {
	    var inside = false;
	    var prevNode = polygon[polygon.length - 1],
	        node,
	        i;
	    for (i = 0; i < polygon.length; i++) {
	        node = polygon[i];
	        if ((node[0] <= p[0] && p[0] < prevNode[0] || prevNode[0] <= p[0] && p[0] < node[0]) && p[1] < (prevNode[1] - node[1]) * (p[0] - node[0]) / (prevNode[0] - node[0]) + node[1]) {
	            inside = !inside;
	        }
	        prevNode = node;
	    }
	    return inside;
	}
	
	_leaflet2.default.Wikimapia = _leaflet2.default.GridLayer.extend({
	    options: {
	        tileSize: 1024,
	        updateWhenIdle: true
	    },
	
	    initialize: function initialize(options) {
	        _leaflet2.default.GridLayer.prototype.initialize.call(this, options);
	        this.loader = null;
	    },
	
	    onAdd: function onAdd(map) {
	        if (!this.loader) {
	            this.loader = new _wikimapiaLoader.WikimapiaLoader(map);
	        }
	        _leaflet2.default.GridLayer.prototype.onAdd.call(this, map);
	        this.on('tileunload', this.onTileUnload, this);
	        map.on('mousemove', this.onMouseMove, this);
	        map.on('click', this.onClick, this);
	    },
	
	    onRemove: function onRemove(map) {
	        map.off('mousemove', this.onMouseMove, this);
	        map.off('click', this.onClick, this);
	        if (this.highlightedPlace) {
	            this._map.removeLayer(this.highlightedPlace.polygon);
	            this._map.removeLayer(this.highlightedPlace.label);
	            this.highlightedPlace = null;
	        }
	        _leaflet2.default.TileLayer.prototype.onRemove.call(this, map);
	        this.off('tileunload', this.onTileUnload, this);
	    },
	
	    drawTile: function drawTile(canvas) {
	        if (!this._map) {
	            return;
	        }
	        var tileData = canvas._tileData,
	            adjustment = canvas._adjustment;
	        if (!tileData) {
	            return;
	        }
	
	        var canvasCtx = canvas.getContext('2d');
	        canvasCtx.beginPath();
	        canvasCtx.strokeStyle = '#CFA600';
	        canvasCtx.lineWidth = 1;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = tileData.places[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var place = _step.value;
	
	                var polygon = place.localPolygon;
	                if (!polygon) {
	                    continue;
	                }
	                if (adjustment) {
	                    var multiplier = adjustment.multiplier,
	                        offsetX = adjustment.offsetX,
	                        offsetY = adjustment.offsetY,
	                        polygon2 = [];
	
	                    for (var i = 0; i < polygon.length; i++) {
	                        var _p = polygon[i];
	                        polygon2.push({
	                            x: _p.x * multiplier - offsetX,
	                            y: _p.y * multiplier - offsetY
	                        });
	                    }
	                    polygon = polygon2;
	                }
	                canvasCtx.moveTo(polygon[0].x, polygon[0].y);
	                var p = void 0;
	                for (var _i = 1; _i < polygon.length; _i++) {
	                    p = polygon[_i];
	                    canvasCtx.lineTo(p.x, p.y);
	                }
	                canvasCtx.lineTo(polygon[0].x, polygon[0].y);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        canvasCtx.stroke();
	    },
	
	    createTile: function createTile(coords, done) {
	        var _this = this;
	
	        var canvas = _leaflet2.default.DomUtil.create('canvas', 'leaflet-tile');
	        canvas.width = this.options.tileSize;
	        canvas.height = this.options.tileSize;
	
	        var _loader$requestTileDa = this.loader.requestTileData(coords),
	            dataPromise = _loader$requestTileDa.dataPromise,
	            abortLoading = _loader$requestTileDa.abortLoading;
	
	        dataPromise.then(function (data) {
	            canvas._tileData = data.tileData;
	            canvas._adjustment = data.adjustment;
	            _this.drawTile(canvas);
	            _this._tileOnLoad(done, canvas);
	        });
	
	        canvas._abortLoading = abortLoading;
	        return canvas;
	    },
	
	    _tileOnLoad: function _tileOnLoad(done, tile) {
	        // For https://github.com/Leaflet/Leaflet/issues/3332
	        if (_leaflet2.default.Browser.ielt9) {
	            setTimeout(_leaflet2.default.bind(done, this, null, tile), 0);
	        } else {
	            done(null, tile);
	        }
	    },
	
	    onTileUnload: function onTileUnload(e) {
	        var tile = e.tile;
	        tile._abortLoading();
	        delete tile._tileData;
	        delete tile._adjustment;
	    },
	
	    _tileCoordsFromEvent: function _tileCoordsFromEvent(e) {
	        var layerPoint = this._map.getPixelOrigin().add(e.layerPoint);
	        var tileSize = this.options.tileSize;
	        var coords = {
	            x: Math.floor(layerPoint.x / tileSize),
	            y: Math.floor(layerPoint.y / tileSize),
	            z: this._map.getZoom()
	        };
	
	        return coords;
	    },
	
	    getPlaceAtMousePos: function getPlaceAtMousePos(e) {
	        var tileCoords = this._tileCoordsFromEvent(e);
	        var tile = this._tiles[this._tileCoordsToKey(tileCoords)];
	        if (!tile) {
	            return null;
	        }
	        var tileData = tile.el._tileData;
	        if (!tileData) {
	            return null;
	        }
	        return this.getPlaceAtLatlng(e.latlng, tileData.places);
	    },
	
	    onMouseMove: function onMouseMove(e) {
	        var place = this.getPlaceAtMousePos(e);
	        if (this.highlightedPlace && (!place || this.highlightedPlace.id !== place.id)) {
	            this._map.removeLayer(this.highlightedPlace.polygon);
	            this._map.removeLayer(this.highlightedPlace.label);
	            this.highlightedPlace = null;
	        }
	
	        if (place && !this.highlightedPlace) {
	            this.highlightedPlace = {
	                id: place.id,
	                polygon: _leaflet2.default.polygon(place.polygon, {
	                    weight: 0,
	                    color: '#E6B800'
	                }),
	                label: _leaflet2.default.tooltip({ className: 'wikimapia-tooltip-wrapper' }, null)
	            };
	            this.highlightedPlace.label.setLatLng(e.latlng);
	            this.highlightedPlace.polygon.addTo(this._map).bringToBack();
	            this.highlightedPlace.label.setContent('<div class="wikimapia-tooltip">' + place.title + '</div>');
	            this._map.addLayer(this.highlightedPlace.label);
	        }
	        if (this.highlightedPlace) {
	            this.highlightedPlace.label.setLatLng(e.latlng);
	        }
	    },
	
	    onClick: function onClick(e) {
	        if (this._map.clickLocked) {
	            return;
	        }
	        var place = this.getPlaceAtMousePos(e);
	        if (place) {
	            var url = 'http://wikimapia.org/' + place.id + '/ru/';
	            (0, _popupWindow.openPopupWindow)(url, 564, 'wikimapia-details');
	        }
	    },
	
	    getPlaceAtLatlng: function getPlaceAtLatlng(latlng, places) {
	        var lat = latlng.lat,
	            lng = latlng.lng,
	            bounds = void 0,
	            place = void 0;
	
	        for (var i = places.length - 1; i >= 0; i--) {
	            place = places[i];
	            bounds = place.boundsWESN;
	            if (lng >= bounds[0] && lng <= bounds[1] && lat >= bounds[2] && lat <= bounds[3] && isPointInPolygon(place.polygon, [lat, lng])) {
	                return place;
	            }
	        }
	    }
	
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WikimapiaLoader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _tiledDataLoader = __webpack_require__(83);
	
	var _wmUtils = __webpack_require__(227);
	
	var _wmUtils2 = _interopRequireDefault(_wmUtils);
	
	var _CORSProxy = __webpack_require__(60);
	
	var _CORSProxy2 = _interopRequireDefault(_CORSProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WikimapiaLoader = function (_TiledDataLoader) {
	    _inherits(WikimapiaLoader, _TiledDataLoader);
	
	    function WikimapiaLoader(projectObj) {
	        _classCallCheck(this, WikimapiaLoader);
	
	        var _this = _possibleConstructorReturn(this, (WikimapiaLoader.__proto__ || Object.getPrototypeOf(WikimapiaLoader)).call(this));
	
	        _this.maxZoom = 15;
	        _this.tileSize = 1024;
	
	        _this._projectObj = projectObj;
	
	        return _this;
	    }
	
	    _createClass(WikimapiaLoader, [{
	        key: 'getFromCache',
	        value: function getFromCache(dataTileCoords) {
	            dataTileCoords = Object.assign({}, dataTileCoords);
	            var exactMatch = true;
	            while (dataTileCoords.z >= 0) {
	                var key = this.makeTileKey(dataTileCoords);
	                var res = this._cache.get(key);
	                if (res.found) {
	                    if (exactMatch || !res.value.hasChildren) {
	                        res['coords'] = dataTileCoords;
	                        return res;
	                    }
	                    break;
	                }
	                dataTileCoords.z -= 1;
	                dataTileCoords.x = Math.floor(dataTileCoords.x / 2);
	                dataTileCoords.y = Math.floor(dataTileCoords.y / 2);
	                exactMatch = false;
	            }
	            return { found: false };
	        }
	    }, {
	        key: 'layerTileToDataTileCoords',
	        value: function layerTileToDataTileCoords(layerTileCoords) {
	            var z = layerTileCoords.z - 2;
	            if (z > this.maxZoom) {
	                var z2 = this.maxZoom,
	                    multiplier = 1 << z - z2;
	                return {
	                    x: Math.floor(layerTileCoords.x / multiplier),
	                    y: Math.floor(layerTileCoords.y / multiplier),
	                    z: z2
	                };
	            } else {
	                if (z < 0) {
	                    return { z: 0, x: 0, y: 0 };
	                }
	                return { z: z, x: layerTileCoords.x, y: layerTileCoords.y };
	            }
	        }
	    }, {
	        key: 'makeRequestData',
	        value: function makeRequestData(dataTileCoords) {
	            var url = _wmUtils2.default.makeTileUrl(dataTileCoords);
	            url = (0, _CORSProxy2.default)(url);
	            return {
	                url: url,
	                options: { timeout: 20000 }
	            };
	        }
	    }, {
	        key: 'processResponse',
	        value: function processResponse(xhr) {
	            return _wmUtils2.default.parseTile(xhr.response, this._projectObj).then(function (tileData) {
	                return {
	                    tileData: tileData,
	                    coords: tileData.coords
	                };
	            });
	        }
	    }, {
	        key: 'calcAdjustment',
	        value: function calcAdjustment(layerTileCoords, dataTileCoords) {
	            var adjustment = _get(WikimapiaLoader.prototype.__proto__ || Object.getPrototypeOf(WikimapiaLoader.prototype), 'calcAdjustment', this).call(this, { x: layerTileCoords.x, y: layerTileCoords.y, z: layerTileCoords.z - 2 }, dataTileCoords);
	            if (adjustment) {
	                adjustment.offsetX *= 1024;
	                adjustment.offsetY *= 1024;
	            }
	            return adjustment;
	        }
	    }]);
	
	    return WikimapiaLoader;
	}(_tiledDataLoader.TiledDataLoader);
	
	exports.WikimapiaLoader = WikimapiaLoader;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var parseTile = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(s, projectObj) {
	        var tile, places, lines, fields, tileId, prevTime, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, line, curTime, place, _fields, placeId, bounds, coords, polygon;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        tile = {};
	                        places = tile.places = [];
	                        lines = s.split('\n');
	
	                        if (!(lines.length < 1)) {
	                            _context.next = 5;
	                            break;
	                        }
	
	                        throw new Error('No data in tile');
	
	                    case 5:
	                        fields = lines[0].split('|');
	                        tileId = fields[0];
	
	                        if (!(!tileId || !tileId.match(/^[0-3]+$/))) {
	                            _context.next = 9;
	                            break;
	                        }
	
	                        throw new Error('Invalid tile header');
	
	                    case 9:
	                        tile.tileId = tileId;
	                        tile.coords = tileIdToCoords(tileId);
	                        tile.hasChildren = fields[1] === '1';
	
	                        //FIXME: ignore some errors
	                        prevTime = Date.now();
	                        _iteratorNormalCompletion4 = true;
	                        _didIteratorError4 = false;
	                        _iteratorError4 = undefined;
	                        _context.prev = 16;
	                        _iterator4 = lines.slice(2)[Symbol.iterator]();
	
	                    case 18:
	                        if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
	                            _context.next = 51;
	                            break;
	                        }
	
	                        line = _step4.value;
	                        curTime = Date.now();
	
	                        if (!(curTime - prevTime > 20)) {
	                            _context.next = 25;
	                            break;
	                        }
	
	                        _context.next = 24;
	                        return asap();
	
	                    case 24:
	                        prevTime = Date.now();
	
	                    case 25:
	                        place = {};
	                        _fields = line.split('|');
	
	                        if (!(_fields.length < 6)) {
	                            _context.next = 29;
	                            break;
	                        }
	
	                        return _context.abrupt('continue', 48);
	
	                    case 29:
	                        placeId = _fields[0];
	
	                        if (placeId.match(/^\d+$/)) {
	                            _context.next = 32;
	                            break;
	                        }
	
	                        return _context.abrupt('continue', 48);
	
	                    case 32:
	                        place.id = parseInt(placeId, 10);
	                        place.title = chooseTitle(decodeTitles(_fields[5]));
	
	                        if (!(_fields[6] !== '1')) {
	                            _context.next = 36;
	                            break;
	                        }
	
	                        throw new Error('Unknown wikimapia polygon encoding type: "' + _fields[6] + '"');
	
	                    case 36:
	                        bounds = _fields[2].match(/^([-\d]+),([-\d]+),([-\d]+),([-\d]+)$/);
	
	                        if (bounds) {
	                            _context.next = 39;
	                            break;
	                        }
	
	                        throw new Error('Invalid place bounds');
	
	                    case 39:
	                        place.boundsWESN = bounds.slice(1).map(function (x) {
	                            return parseInt(x, 10) / 1e7;
	                        });
	
	                        coords = _fields.slice(7).join('|');
	
	
	                        coords = decodePolygon(coords);
	
	                        if (!(coords.length < 3)) {
	                            _context.next = 44;
	                            break;
	                        }
	
	                        throw new Error('Polygon has ' + coords.length + ' points');
	
	                    case 44:
	                        polygon = simplifyPolygon(coords, tile.coords, tile.hasChildren, projectObj);
	
	                        place.polygon = polygon;
	                        place.localPolygon = makeCoordsLocal(polygon, tile.coords, projectObj);
	                        places.push(place);
	
	                    case 48:
	                        _iteratorNormalCompletion4 = true;
	                        _context.next = 18;
	                        break;
	
	                    case 51:
	                        _context.next = 57;
	                        break;
	
	                    case 53:
	                        _context.prev = 53;
	                        _context.t0 = _context['catch'](16);
	                        _didIteratorError4 = true;
	                        _iteratorError4 = _context.t0;
	
	                    case 57:
	                        _context.prev = 57;
	                        _context.prev = 58;
	
	                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                            _iterator4.return();
	                        }
	
	                    case 60:
	                        _context.prev = 60;
	
	                        if (!_didIteratorError4) {
	                            _context.next = 63;
	                            break;
	                        }
	
	                        throw _iteratorError4;
	
	                    case 63:
	                        return _context.finish(60);
	
	                    case 64:
	                        return _context.finish(57);
	
	                    case 65:
	                        return _context.abrupt('return', tile);
	
	                    case 66:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[16, 53, 57, 65], [58,, 60, 64]]);
	    }));
	
	    return function parseTile(_x, _x2) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	// быстрое проектирование полигонов
	// TODO: каждые 50-100 мс отдавать управление
	// projectPlacesForZoom: function(tile, viewZoom) {
	//     if (viewZoom < tile.coords.z) {
	//         throw new Error('viewZoom < tile.zoom');
	//     }
	//     if (tile.places && tile.places[0] && tile.places[0].projectedPolygons &&
	//         tile.places[0].projectedPolygons[viewZoom]) {
	//         return;
	//     }
	//     const virtualTileSize = 256 * (2 ** (viewZoom - tile.coords.z));
	//     const p1 = L.point([tile.coords.x * virtualTileSize, tile.coords.y * virtualTileSize]),
	//         p2 = L.point([(tile.coords.x + 1) * virtualTileSize, (tile.coords.y + 1) * virtualTileSize]),
	//         latlng1 = this._map.unproject(p1, viewZoom),
	//         latlng2 = this._map.unproject(p2, viewZoom),
	//         lat0 = latlng1.lat,
	//         lng0 = latlng1.lng;
	//     const qx = (p2.x - p1.x) / (latlng2.lng - latlng1.lng),
	//         qy = (p2.y - p1.y) / (latlng2.lat - latlng1.lat);
	//
	//     const offsets = [],
	//         offsetsStep = virtualTileSize / 64;
	//     const y0 = p1.y;
	//     for (let y = -virtualTileSize; y <= 2 * virtualTileSize; y += offsetsStep) {
	//         let lat = y / qy + lat0;
	//         let offset = this._map.project([lat, lng0], viewZoom).y - y0 - y;
	//         offsets.push(offset);
	//     }
	//
	//     let ll, offset, offsetPos, offsetIndex, offsetIndexDelta, x, y;
	//     const x0 = p1.x;
	//     for (let place of tile.places) {
	//         let polygon = place.polygon;
	//         if (polygon.length < 3) {
	//             continue;
	//         }
	//         let projectedPolygon = [];
	//         for (let i = 0; i < polygon.length; i++) {
	//             ll = polygon[i];
	//             x = (ll[1] - lng0) * qx;
	//             y = (ll[0] - lat0) * qy;
	//             offsetPos = (y + virtualTileSize) / offsetsStep;
	//             offsetIndex = Math.floor(offsetPos);
	//             offsetIndexDelta = offsetPos - offsetIndex;
	//             offset = offsets[offsetIndex] * (1 - offsetIndexDelta) + offsets[offsetIndex + 1] * offsetIndexDelta;
	//             projectedPolygon.push([x + x0, y + offset + y0]);
	//         }
	//         projectedPolygon = projectedPolygon.map(L.point);
	//         projectedPolygon = L.LineUtil.simplify(projectedPolygon, 1.5);
	//         if (!place.projectedPolygons) {
	//             place.projectedPolygons = [];
	//         }
	//         place.projectedPolygons[viewZoom] = projectedPolygon;
	//     }
	// },
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// (1233,130,5) -> "032203"
	function getTileId(_ref) {
	    var x = _ref.x,
	        y = _ref.y,
	        z = _ref.z;
	
	    var id = [];
	    y = (1 << z) - y - 1;
	    z += 1;
	    while (z) {
	        id.push((x & 1) + (y & 1) * 2);
	        x >>= 1;
	        y >>= 1;
	        z--;
	    }
	    return id.reverse().join('');
	}
	
	function makeTileUrl(coords) {
	    var tileId = getTileId(coords),
	        urlPath = tileId.replace(/(\d{3})(?!$)/g, '$1/'); // "033331022" -> "033/331/022"
	    return 'http://wikimapia.org/z1/itiles/' + urlPath + '.xy?342342';
	}
	
	function tileIdToCoords(tileId) {
	    var z = tileId.length - 1;
	    var x = 0,
	        y = 0;
	    for (var i = 0; i < tileId.length; i++) {
	        var c = parseInt(tileId[i], 10);
	        x <<= 1;
	        y <<= 1;
	        x += c & 1;
	        y += c >> 1;
	    }
	    y = (1 << z) - y - 1;
	    return { x: x, y: y, z: z };
	}
	
	function getWikimapiaTileCoords(coords, viewTileSize) {
	    var z = coords.z - 2;
	    if (z < 0) {
	        z = 0;
	    }
	    if (z > 15) {
	        z = 15;
	    }
	    var q = Math.pow(2, z - coords.z + Math.log2(viewTileSize / 256));
	    var x = Math.floor(coords.x * q),
	        y = Math.floor(coords.y * q);
	    return { x: x, y: y, z: z };
	}
	
	function decodeTitles(s) {
	    var titles = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = s.split('\x1f')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var title = _step.value;
	
	            if (title.length > 2) {
	                var langCode = title.charCodeAt(0) - 32;
	                titles[langCode.toString()] = title.substring(1);
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return titles;
	}
	
	function chooseTitle(titles) {
	    var popularLanguages = ['1', '0', '3', '2', '5', '4', '9', '28', '17', '27'];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = popularLanguages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var langCode = _step2.value;
	
	            if (langCode in titles) {
	                return titles[langCode];
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = Object.keys(titles)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _langCode = _step3.value;
	
	            return titles[_langCode];
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	}
	
	function decodePolygon(s) {
	    var i = 0,
	        coords = [],
	        lat = 0,
	        lng = 0;
	    while (i < s.length) {
	        var p,
	            l = 0,
	            c = 0;
	        do {
	            p = s.charCodeAt(i++) - 63;
	            c |= (p & 31) << l;
	            l += 5;
	        } while (p >= 32);
	        lng += c & 1 ? ~(c >> 1) : c >> 1;
	        l = 0;
	        c = 0;
	        do {
	            p = s.charCodeAt(i++) - 63;
	            c |= (p & 31) << l;
	            l += 5;
	        } while (p >= 32);
	        lat += c & 1 ? ~(c >> 1) : c >> 1;
	        coords.push([lat / 1e6, lng / 1e6]);
	    }
	    return coords;
	}
	
	function makeCoordsLocal(line, tileCoords, projectObj) {
	    var tileX = tileCoords.x,
	        tileY = tileCoords.y,
	        tileZ = tileCoords.z,
	        x0 = tileX * 1024,
	        y0 = tileY * 1024,
	        localCoords = [];
	
	    var latlon = void 0,
	        p = void 0;
	    for (var i = 0; i < line.length; i++) {
	        latlon = line[i];
	        p = projectObj.project(latlon, tileZ + 2);
	        p.x -= x0;
	        p.y -= y0;
	        localCoords.push(p);
	    }
	    return localCoords;
	}
	
	function asap() {
	    return new Promise(function (resolve) {
	        return setTimeout(resolve, 0);
	    });
	}
	
	function simplifyPolygon(latlngs, tileCoords, tileHasChildren, projectObj) {
	    var x = tileCoords.x * 1024,
	        y = tileCoords.y * 1024,
	        p0 = projectObj.unproject([x, y]),
	        p1 = projectObj.unproject([x + 1, y + 1]);
	    var pixelDegSize = p0.lat - p1.lat;
	    if (!tileHasChildren && tileCoords.z < 15) {
	        pixelDegSize /= 1 << 15 - tileCoords.z;
	    }
	    var points = [];
	    for (var i = 0; i < latlngs.length; i++) {
	        var ll = latlngs[i];
	        points.push({ x: ll[0], y: ll[1] });
	    }
	    points = _leaflet2.default.LineUtil.simplify(points, pixelDegSize * 2);
	    latlngs = [];
	    for (var _i = 0; _i < points.length; _i++) {
	        var p = points[_i];
	        latlngs.push([p.x, p.y]);
	    }
	    return latlngs;
	}
	
	exports.default = { getTileId: getTileId, getWikimapiaTileCoords: getWikimapiaTileCoords, parseTile: parseTile, makeTileUrl: makeTileUrl };

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.LineUtil.simplifyLatlngs = function simplifyLatlngs(points, tolerance) {
	    function latlngToXy(p) {
	        return {
	            x: p.lng,
	            y: p.lat
	        };
	    }
	
	    function xyToLatlng(p) {
	        return {
	            lat: p.y,
	            lng: p.x
	        };
	    }
	
	    points = points.map(latlngToXy);
	    points = _leaflet2.default.LineUtil.simplify(points, tolerance);
	    points = points.map(xyToLatlng);
	    return points;
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _leaflet = __webpack_require__(2);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Polyline.EditMixinOptions = {
	    className: 'leaflet-editable-line'
	};
	
	_leaflet2.default.Polyline.EditMixin = {
	    _nodeMarkersZOffset: 10000,
	
	    startEdit: function startEdit() {
	        if (this._map && !this._editing) {
	            this._editing = true;
	            this._drawingDirection = 0;
	            this.setupMarkers();
	            this.on('remove', this.stopEdit.bind(this));
	            this._map.on('click', this.onMapClick, this).on('dragend', this.onMapEndDrag, this);
	            _leaflet2.default.DomEvent.on(document, 'keyup', this.onKeyPress, this);
	            this._storedStyle = { weight: this.options.weight, opacity: this.options.opacity };
	            this.setStyle({ weight: 1.5, opacity: 1 });
	            _leaflet2.default.DomUtil.addClass(this._map._container, 'leaflet-line-editing');
	        }
	    },
	
	    stopEdit: function stopEdit(userCancelled) {
	        if (this._editing) {
	            this.stopDrawingLine();
	            this._editing = false;
	            this.removeMarkers();
	            _leaflet2.default.DomEvent.off(document, 'keyup', this.onKeyPress, this);
	            this.off('remove', this.stopEdit.bind(this));
	            this._map.off('click', this.onMapClick, this).off('dragend', this.onMapEndDrag, this);
	            this.setStyle(this._storedStyle);
	            _leaflet2.default.DomUtil.removeClass(this._map._container, 'leaflet-line-editing');
	            this.fire('editend', { target: this, userCancelled: userCancelled });
	        }
	    },
	
	    removeMarkers: function removeMarkers() {
	        this.getLatLngs().forEach(function (node) {
	            if (node._nodeMarker) {
	                this._map.removeLayer(node._nodeMarker);
	                delete node._nodeMarker._lineNode;
	                delete node._nodeMarker;
	            }
	            if (node._segmentOverlay) {
	                this._map.removeLayer(node._segmentOverlay);
	                delete node._segmentOverlay._lineNode;
	                delete node._segmentOverlay;
	            }
	        }.bind(this));
	    },
	
	    onNodeMarkerDragEnd: function onNodeMarkerDragEnd(e) {
	        var marker = e.target,
	            nodeIndex = this.getLatLngs().indexOf(marker._lineNode);
	        this.replaceNode(nodeIndex, marker.getLatLng());
	    },
	
	    onNodeMarkerMovedChangeNode: function onNodeMarkerMovedChangeNode(e) {
	        var marker = e.target,
	            latlng = marker.getLatLng(),
	
	        //nodeIndex = this.getLatLngs().indexOf(marker._lineNode);
	        node = marker._lineNode;
	        node.lat = latlng.lat;
	        node.lng = latlng.lng;
	        this.redraw();
	        this.fire('nodeschanged');
	    },
	
	    onNodeMarkerDblClickedRemoveNode: function onNodeMarkerDblClickedRemoveNode(e) {
	        if (this.getLatLngs().length < 2 || this._drawingDirection && this.getLatLngs().length === 2) {
	            return;
	        }
	        var marker = e.target,
	            nodeIndex = this.getLatLngs().indexOf(marker._lineNode);
	        this.removeNode(nodeIndex);
	        this.fire('nodeschanged');
	    },
	
	    onMapClick: function onMapClick(e) {
	        if (this._drawingDirection) {
	            var newNodeIndex = this._drawingDirection === -1 ? 1 : this.getLatLngs().length - 1;
	            this.addNode(newNodeIndex, e.latlng);
	        } else {
	            if (!this.preventStopEdit) {
	                this.stopEdit(true);
	            }
	        }
	    },
	
	    onMapEndDrag: function onMapEndDrag(e) {
	        if (e.distance < 15) {
	            // get mouse position from map drag handler
	            var handler = e.target.dragging._draggable;
	            var mousePos = handler._startPoint.add(handler._newPos).subtract(handler._startPos);
	            var latlng = e.target.mouseEventToLatLng({ clientX: mousePos.x, clientY: mousePos.y });
	            this.onMapClick({ latlng: latlng });
	        }
	    },
	
	    startDrawingLine: function startDrawingLine(direction, e) {
	        if (!this._editing) {
	            return;
	        }
	        if (direction === undefined) {
	            direction = 1;
	        }
	        if (this._drawingDirection === direction) {
	            return;
	        }
	        this.stopDrawingLine();
	        this._drawingDirection = direction;
	
	        if (e) {
	            var newNodeIndex = this._drawingDirection === -1 ? 0 : this.getLatLngs().length;
	            this.spliceLatLngs(newNodeIndex, 0, e.latlng);
	            this.fire('nodeschanged');
	        }
	
	        this._map.on('mousemove', this.onMouseMoveFollowEndNode, this);
	        _leaflet2.default.DomUtil.addClass(this._map._container, 'leaflet-line-drawing');
	        this._map.clickLocked = true;
	    },
	
	    stopDrawingLine: function stopDrawingLine() {
	        if (!this._drawingDirection) {
	            return;
	        }
	        this._map.off('mousemove', this.onMouseMoveFollowEndNode, this);
	        var nodeIndex = this._drawingDirection === -1 ? 0 : this.getLatLngs().length - 1;
	        this.spliceLatLngs(nodeIndex, 1);
	        this.fire('nodeschanged');
	        this._drawingDirection = 0;
	        _leaflet2.default.DomUtil.removeClass(this._map._container, 'leaflet-line-drawing');
	        this._map.clickLocked = false;
	        this.fire('drawend');
	    },
	
	    onKeyPress: function onKeyPress(e) {
	        if ('input' === e.target.tagName.toLowerCase()) {
	            return;
	        }
	        var code = e.keyCode;
	        switch (code) {
	            case 27:
	            case 13:
	                if (this._drawingDirection) {
	                    this.stopDrawingLine();
	                } else {
	                    if (!this.preventStopEdit) {
	                        this.stopEdit(true);
	                    }
	                }
	                _leaflet2.default.DomEvent.stop(e);
	                break;
	            case 8:
	            case 46:
	                if (this._drawingDirection && this.getLatLngs().length > 2) {
	                    var nodeIndex = this._drawingDirection === 1 ? this.getLatLngs().length - 2 : 1;
	                    this.removeNode(nodeIndex);
	                    this.fire('nodeschanged');
	                    _leaflet2.default.DomEvent.preventDefault(e);
	                }
	                break;
	
	            default:
	        }
	    },
	
	    onMouseMoveFollowEndNode: function onMouseMoveFollowEndNode(e) {
	        var nodeIndex = this._drawingDirection === -1 ? 0 : this.getLatLngs().length - 1;
	        this.spliceLatLngs(nodeIndex, 1, e.latlng);
	        this.fire('nodeschanged');
	    },
	
	    makeNodeMarker: function makeNodeMarker(nodeIndex) {
	        var node = this.getLatLngs()[nodeIndex],
	            marker = _leaflet2.default.marker(node.clone(), {
	            icon: _leaflet2.default.divIcon({ className: 'line-editor-node-marker-halo', 'html': '<div class="line-editor-node-marker"></div>' }),
	            draggable: true,
	            zIndexOffset: this._nodeMarkersZOffset
	        });
	        marker.on('drag', this.onNodeMarkerMovedChangeNode, this)
	        //.on('dragstart', this.fire.bind(this, 'editingstart'))
	        .on('dragend', this.onNodeMarkerDragEnd, this).on('dblclick', this.onNodeMarkerDblClickedRemoveNode, this).on('click', this.onNodeMarkerClickStartStopDrawing, this).on('contextmenu', function (e) {
	            this.stopDrawingLine();
	            this.fire('noderightclick', {
	                nodeIndex: this.getLatLngs().indexOf(marker._lineNode),
	                line: this,
	                mouseEvent: e
	            });
	        }, this);
	        marker._lineNode = node;
	        node._nodeMarker = marker;
	        marker.addTo(this._map);
	    },
	
	    onNodeMarkerClickStartStopDrawing: function onNodeMarkerClickStartStopDrawing(e) {
	        var marker = e.target,
	            latlngs = this.getLatLngs(),
	            latlngs_n = latlngs.length,
	            nodeIndex = latlngs.indexOf(marker._lineNode);
	        if (this._drawingDirection === -1 && nodeIndex === 1 || this._drawingDirection === 1 && nodeIndex === latlngs_n - 2) {
	            this.stopDrawingLine();
	        } else if (nodeIndex === 0) {
	            this.startDrawingLine(-1, e);
	        } else if (nodeIndex === this.getLatLngs().length - 1) {
	            this.startDrawingLine(1, e);
	        }
	    },
	
	    makeSegmentOverlay: function makeSegmentOverlay(nodeIndex) {
	        var latlngs = this.getLatLngs(),
	            p1 = latlngs[nodeIndex],
	            p2 = latlngs[nodeIndex + 1];
	        if (!p2) {
	            return;
	        }
	        var segmentOverlay = _leaflet2.default.polyline([p1, p2], { weight: 10, opacity: 0.0 });
	        segmentOverlay.on('mousedown', this.onSegmentMouseDownAddNode, this);
	        segmentOverlay.on('contextmenu', function (e) {
	            this.stopDrawingLine();
	            this.fire('segmentrightclick', {
	                nodeIndex: this.getLatLngs().indexOf(segmentOverlay._lineNode),
	                mouseEvent: e,
	                line: this
	            });
	        }, this);
	        segmentOverlay._lineNode = p1;
	        p1._segmentOverlay = segmentOverlay;
	        segmentOverlay.addTo(this._map);
	    },
	
	    onSegmentMouseDownAddNode: function onSegmentMouseDownAddNode(e) {
	        if (e.originalEvent.button !== 0) {
	            return;
	        }
	        var segmentOverlay = e.target,
	            latlngs = this.getLatLngs(),
	            nodeIndex = latlngs.indexOf(segmentOverlay._lineNode) + 1;
	        this.addNode(nodeIndex, e.latlng);
	        if (_leaflet2.default.Draggable._dragging) {
	            _leaflet2.default.Draggable._dragging.finishDrag();
	        }
	        latlngs[nodeIndex]._nodeMarker.dragging._draggable._onDown(e.originalEvent);
	        this.fire('nodeschanged');
	    },
	
	    addNode: function addNode(index, latlng) {
	        var nodes = this.getLatLngs(),
	            isAddingLeft = index === 1 && this._drawingDirection === -1,
	            isAddingRight = index === nodes.length - 1 && this._drawingDirection === 1;
	        latlng = latlng.clone();
	        this.spliceLatLngs(index, 0, latlng);
	        this.makeNodeMarker(index);
	        if (!isAddingLeft && index >= 1) {
	            if (!isAddingRight) {
	                var prevNode = nodes[index - 1];
	                this._map.removeLayer(prevNode._segmentOverlay);
	                delete prevNode._segmentOverlay._lineNode;
	                delete prevNode._segmentOverlay;
	            }
	            this.makeSegmentOverlay(index - 1);
	        }
	        if (!isAddingRight) {
	            this.makeSegmentOverlay(index);
	        }
	    },
	
	    removeNode: function removeNode(index) {
	        var nodes = this.getLatLngs(),
	            node = nodes[index],
	            marker = node._nodeMarker;
	        delete node._nodeMarker;
	        delete marker._lineNode;
	        this.spliceLatLngs(index, 1);
	        this._map.removeLayer(marker);
	        if (node._segmentOverlay) {
	            this._map.removeLayer(node._segmentOverlay);
	            delete node._segmentOverlay._lineNode;
	            delete node._segmentOverlay;
	        }
	        var prevNode = nodes[index - 1];
	        if (prevNode && prevNode._segmentOverlay) {
	            this._map.removeLayer(prevNode._segmentOverlay);
	            delete prevNode._segmentOverlay._lineNode;
	            delete prevNode._segmentOverlay;
	            if (index < nodes.length - 1 || index < nodes.length && this._drawingDirection !== 1) {
	                this.makeSegmentOverlay(index - 1);
	            }
	        }
	    },
	
	    replaceNode: function replaceNode(index, latlng) {
	        var nodes = this.getLatLngs(),
	            oldNode = nodes[index],
	            oldMarker = oldNode._nodeMarker;
	        this._map.removeLayer(oldNode._nodeMarker);
	        delete oldNode._nodeMarker;
	        delete oldMarker._lineNode;
	        latlng = latlng.clone();
	        this.spliceLatLngs(index, 1, latlng);
	        this.makeNodeMarker(index);
	        if (oldNode._segmentOverlay) {
	            this._map.removeLayer(oldNode._segmentOverlay);
	            delete oldNode._segmentOverlay._lineNode;
	            delete oldNode._segmentOverlay;
	            this.makeSegmentOverlay(index);
	        }
	        var prevNode = nodes[index - 1];
	        if (prevNode && prevNode._segmentOverlay) {
	            this._map.removeLayer(prevNode._segmentOverlay);
	            delete prevNode._segmentOverlay._lineNode;
	            delete prevNode._segmentOverlay;
	            this.makeSegmentOverlay(index - 1);
	        }
	    },
	
	    setupMarkers: function setupMarkers() {
	        this.removeMarkers();
	        var latlngs = this.getLatLngs(),
	            startNode = 0,
	            endNode = latlngs.length - 1;
	        if (this._drawingDirection === -1) {
	            startNode += 1;
	        }
	        if (this._drawingDirection === 1) {
	            endNode -= 1;
	        }
	        for (var i = startNode; i <= endNode; i++) {
	            this.makeNodeMarker(i);
	            if (i < endNode) {
	                this.makeSegmentOverlay(i);
	            }
	        }
	    },
	
	    spliceLatLngs: function spliceLatLngs() {
	        var latlngs = this.getLatLngs();
	        var res = latlngs.splice.apply(latlngs, arguments);
	        this.setLatLngs(latlngs);
	        return res;
	        // this._latlngs.splice(...args);
	        // this.redraw();
	    }
	
	};

/***/ },
/* 230 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stripBom;
	function stripBom(s) {
	    if (s.substr(0, 3) === '\xef\xbb\xbf') {
	        s = s.substr(3);
	    }
	    return s;
	}

/***/ },
/* 231 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    bingKey: 'ArTkP-DmMk_eLjH_bqre-RDkN7_9JZ2QikvOTgD7NcePeL4ARw3CLRnzalMJQn32',
	    thunderforestKey: 'b8f914c789fc4c09a44f394941e39629',
	    sentryDSN: '',
	    mapillary: 'azJWOG1CVHUtUjdlSkVTMUF2WG91dzoyZmNhZmFjMzMyMmU2YzNi'
	};

/***/ },
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */
437,
/* 439 */
437,
/* 440 */
437,
/* 441 */
437,
/* 442 */
437,
/* 443 */
437,
/* 444 */
437,
/* 445 */
437,
/* 446 */
437,
/* 447 */
437,
/* 448 */
437,
/* 449 */
437,
/* 450 */
437,
/* 451 */
437,
/* 452 */
437,
/* 453 */
437,
/* 454 */
437,
/* 455 */
437,
/* 456 */
437,
/* 457 */
437,
/* 458 */
437,
/* 459 */
437,
/* 460 */
437,
/* 461 */
437,
/* 462 */
437,
/* 463 */
437,
/* 464 */
437,
/* 465 */
437,
/* 466 */
437,
/* 467 */
437,
/* 468 */
437,
/* 469 */
437,
/* 470 */
437,
/* 471 */,
/* 472 */,
/* 473 */
/***/ function(module, exports) {

	module.exports = {
		"minLat": -58,
		"step": 2,
		"rowsCount": 69,
		"maxLat": 78,
		"valueOffset": 76,
		"array": "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",
		"colsCount": 180,
		"valueScale": 2
	};

/***/ },
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ function(module, exports) {

	module.exports = "<div class=\"contents\">\n    <div class=\"left-buttons\">\n        <div class=\"button-minimize\" data-bind=\"click: onMinimizeButtonClick\"\n             title=\"Minimize\"></div>\n        <div class=\"button-minimize icon-on-off\"\n             data-bind=\"click: onEnableButtonClick, css: {'state-on': _enabled()}\"\n             title=\"Switch draw by click on/off\"></div>\n    </div>\n    <table>\n        <tr>\n            <td>True azimuth</td>\n            <td data-bind=\"text: trueAzimuth() !== null ? Math.round(trueAzimuth()) + '&deg;' : '--'\"></td>\n        </tr>\n        <tr>\n            <td>Magnetic azimuth</td>\n            <td data-bind=\"text: magneticAzimuth() !== null ? magneticAzimuth() + '&deg;' : '--'\"></td>\n        </tr>\n        <tr>\n            <td>Distance</td>\n            <td data-bind=\"text: distance() === null ? '--' :\n                distance() > 2000 ? (distance() / 1000).toFixed(2) + ' km' : Math.round(distance()) + ' m'\"></td>\n        </tr>\n    </table>\n\n    <div class=\"buttons\">\n        <div class=\"button\" data-bind=\"click: onReverseButtonClick\">Reverse</div>\n        <div class=\"button\" data-bind=\"click: onProfileButtonClick\">Elevation / Sightline</div>\n    </div>\n</div>"

/***/ },
/* 487 */
/***/ function(module, exports) {

	module.exports = "<div class=\"leaflet-control-button-toggle\" title=\"Print map\"\n     data-bind=\"click: setExpanded, css: {'icon-spinner-nuclear': makingPdf, 'icon-printer': !makingPdf()}\">\n    </div>\n<div class=\"leaflet-control-content\">\n<table class=\"layout\">\n    <tbody>\n    <tr><td colspan=\"2\">\n        <a title=\"Add page in portrait orientation\" class=\"button-add-page-vert image-button\"\n           data-bind=\"click: addPortraitPage\"></a>\n        <a title=\"Add page in landscape orientation\" class=\"button-add-page-horiz image-button\"\n           data-bind=\"click: addLandscapePage\"></a>\n        <span class=\"pages-num\" data-bind=\"text: pagesNumLabel\"></span>\n        <a title=\"Remove all pages\" class=\"button-remove-pages image-button\"\n           data-bind=\"click: removePages\"></a>\n    </td></tr>\n    <tr>\n        <td class=\"label\">Print scale</td>\n        <td>\n            <div class=\"preset-values\" >\n                <a data-bind=\"click: function() {scale(100)}, css: {selected: scale() === 100}\">100 m</a>\n                <a data-bind=\"click: function() {scale(500)}, css: {selected: scale() === 500}\">500 m</a>\n                <a data-bind=\"click: function() {scale(1000)}, css: {selected: scale() === 1000}\">1 km</a>\n            </div>\n            <input type=\"text\" class=\"scale\" maxlength=\"6\" data-bind=\"value: scale\">&nbsp;m in 1 cm\n        </td>\n    </tr>\n    <tr data-bind=\"visible: settingsExpanded\">\n        <td class=\"label\">Page size</td>\n        <td>\n            <div class=\"preset-values\" data-bind=\"foreach: {data: pageSizes, as: 'size'}\">\n                <a data-bind=\"click: function() {$root.pageWidth(size.width); $root.pageHeight(size.height)},\n                              text: size.name,\n                              css: {selected: size.name === $root.pageSizeDescription() }\"></a>\n            </div>\n            <input type=\"text\" maxlength=\"4\" title=\"width\" placeholder=\"width\" class=\"page-size\" data-bind=\"value: pageWidth\">\n            x <input type=\"text\" maxlength=\"4\" title=\"height\" placeholder=\"height\" class=\"page-size\" data-bind=\"value: pageHeight\"> mm\n        </td>\n    </tr>\n    <tr data-bind=\"visible: settingsExpanded\">\n        <td class=\"label-high\">Margins</td>\n        <td>\n            <table class=\"margins\">\n                <tr>\n                    <td></td>\n                    <td><input type=\"text\" maxlength=\"2\" value=\"3\" data-bind=\"value: marginTop\"></td>\n                    <td></td>\n                </tr>\n                <tr>\n                    <td><input type=\"text\" maxlength=\"2\" value=\"3\" data-bind=\"value: marginLeft\"></td>\n                    <td></td><td><input type=\"text\" maxlength=\"2\" value=\"3\" data-bind=\"value: marginRight\"> mm</td>\n                </tr>\n                <tr><td></td><td><input type=\"text\" maxlength=\"2\" value=\"3\" data-bind=\"value: marginBottom\"></td><td></td></tr>\n            </table>\n        </td>\n    </tr>\n    <tr data-bind=\"visible: settingsExpanded\">\n        <td class=\"label\">Resolution</td>\n        <td><input type=\"text\" maxlength=\"4\" class=\"resolution\" data-bind=\"value: resolution\"> dpi</td>\n    </tr>\n    <tr data-bind=\"visible: settingsExpanded\">\n        <td class=\"label\">Source zoom<br />level</td>\n        <td>\n            <select name=\"srczoom\"\n                    data-bind=\"options: ['auto', 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18], value: zoomLevel\">\n            </select>\n        </td>\n    </tr>\n    <tr>\n        <td colspan=\"2\">\n            <label><input type=\"checkbox\" data-bind=\"checked: magneticMerisiansdOn\"> Magnetic meridians</label>\n            <label><input type=\"checkbox\" data-bind=\"checked: gridOn\"> Kilometers grid</label>\n        </td>\n    </tr>\n    <tr><td colspan=\"2\">\n        <a class=\"button-settings image-button\" data-bind=\"click: function() {settingsExpanded(!settingsExpanded())}\"\n            title=\"More settings\"></a>\n        <div class=\"settings-summary\">\n            <span data-bind=\"text: pageSizeDescription\"></span><br/>\n            <span data-bind=\"text: resolution\"></span>&nbsp;dpi,\n            zoom&nbsp;<span data-bind=\"text: zoomLevel\"></span>\n            <!-- ko if: zoomLevel()=== \"auto\" -->\n            (<span title=\"Zoom for satellite and scanned imagery\" data-bind=\"text: autoZoomLevels().satZoom\"></span>&nbsp;\n            /&nbsp;<span title=\"Zoom for maps like OSM and Google\" data-bind=\"text: autoZoomLevels().mapZoom\"></span>)\n            <!-- /ko -->\n        </div>\n    </td></tr>\n    <tr><td colspan=\"2\">\n        <div class=\"download-button-row\">\n            <div class=\"button-minimize\" data-bind=\"click: setMinimized\"></div>\n            <a class=\"text-button button-save\" data-bind=\"\n                                click: onSavePdfClicked,\n                                visible: !makingPdf()\">Save PDF</a>\n            <div data-bind=\"\n                                component: { \n                                    name: 'progress-indicator',\n                                    params: {progressRange: downloadProgressRange, progressDone: downloadProgressDone}\n                                },\n                                visible: makingPdf()\"></div>\n        </div>\n    </td></tr>\n    </tbody>\n</table>\n</div>"

/***/ },
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDQwIDQwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4KICAgIDxnPgogICAgICAgIDxlbGxpcHNlIHJ5PSIxNSIgcng9IjE1IiBpZD0ic3ZnXzEiICBjeT0iMjQuNSIgY3g9IjIwIiBmaWxsPSIjNzc3IiBmaWxsLW9wYWNpdHk9IjAuNSIvPgogICAgICAgIDxsaW5lIHgxPSIyMCIgeTE9IjIwIiB4Mj0iMjUiIHkyPSIzMCIgc3Ryb2tlPSIjMzM4OGZmIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgICAgICA8bGluZSB4MT0iMjAiIHkxPSIyMCIgeDI9IjE1IiB5Mj0iMzAiIHN0cm9rZT0iIzMzODhmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgICAgPGxpbmUgeDE9IjIwIiB5MT0iMjAiIHgyPSIyMCIgeTI9IjM4IiBzdHJva2U9IiMzMzg4ZmYiIHN0cm9rZS13aWR0aD0iMS4yIi8+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ },
/* 504 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDQwIDQwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4KICAgIDxnPgogICAgICAgIDxlbGxpcHNlIHJ5PSIxNSIgcng9IjE1IiBpZD0ic3ZnXzEiIGN5PSIyMiIgY3g9IjIwIiBmaWxsPSIjNzc3IiBmaWxsLW9wYWNpdHk9IjAuNSIvPgoKICAgICAgICA8bGluZSB4MT0iMjAiIHkxPSIyMCIgeDI9IjIzIiB5Mj0iMjQiIHN0cm9rZT0iIzMzODhmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgICAgICA8bGluZSB4MT0iMjAiIHkxPSIyMCIgeDI9IjE3IiB5Mj0iMjQiIHN0cm9rZT0iIzMzODhmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KCiAgICAgICAgPGxpbmUgeDE9IjIwIiB5MT0iMjAiIHgyPSIyMCIgeTI9IjciIHN0cm9rZT0iIzMzODhmZiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDwvZz4KPC9zdmc+"

/***/ },
/* 505 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDMwIDMwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4KICAgIDxnPgogICAgICAgIDxlbGxpcHNlIHJ5PSIxNSIgcng9IjE1IiBpZD0ic3ZnXzEiIGN5PSIxNSIgY3g9IjE1IiBmaWxsPSIjNzc3IiBmaWxsLW9wYWNpdHk9IjAuNSIvPgogICAgICAgIDxsaW5lIHgxPSIxMiIgeTE9IjEyIiB4Mj0iMTgiIHkyPSIxOCIgc3Ryb2tlPSIjMzM4OGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgICAgIDxsaW5lIHgxPSIxMiIgeTE9IjE4IiB4Mj0iMTgiIHkyPSIxMiIgc3Ryb2tlPSIjMzM4OGZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPC9nPgo8L3N2Zz4="

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/main.ca67ed9b.js
 **/